(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.kk.eQ === region.hP.eQ)
	{
		return 'on line ' + region.kk.eQ;
	}
	return 'on lines ' + region.kk.eQ + ' through ' + region.hP.eQ;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ir,
		impl.kX,
		impl.kq,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		e_: func(record.e_),
		cu: record.cu,
		cc: record.cc
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.e_;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cu;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.cc) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ir,
		impl.kX,
		impl.kq,
		function(sendToApp, initialModel) {
			var view = impl.k7;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ir,
		impl.kX,
		impl.kq,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ck && impl.ck(sendToApp)
			var view = impl.k7;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dj);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.kB) && (_VirtualDom_doc.title = title = doc.kB);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.jh;
	var onUrlRequest = impl.ji;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ck: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.fz === next.fz
							&& curr.eu === next.eu
							&& curr.ft.a === next.ft.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ir: function(flags)
		{
			return A3(impl.ir, flags, _Browser_getUrl(), key);
		},
		k7: impl.k7,
		kX: impl.kX,
		kq: impl.kq
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ig: 'hidden', ds: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ig: 'mozHidden', ds: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ig: 'msHidden', ds: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ig: 'webkitHidden', ds: 'webkitvisibilitychange' }
		: { ig: 'hidden', ds: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fU: _Browser_getScene(),
		gB: {
			cR: _Browser_window.pageXOffset,
			cS: _Browser_window.pageYOffset,
			ll: _Browser_doc.documentElement.clientWidth,
			$8: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ll: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		$8: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fU: {
				ll: node.scrollWidth,
				$8: node.scrollHeight
			},
			gB: {
				cR: node.scrollLeft,
				cS: node.scrollTop,
				ll: node.clientWidth,
				$8: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fU: _Browser_getScene(),
			gB: {
				cR: x,
				cS: y,
				ll: _Browser_doc.documentElement.clientWidth,
				$8: _Browser_doc.documentElement.clientHeight
			},
			hO: {
				cR: x + rect.left,
				cS: y + rect.top,
				ll: rect.width,
				$8: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.bF.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.bF.b, xhr)); });
		$elm$core$Maybe$isJust(request.kR) && _Http_track(router, xhr, request.kR.a);

		try {
			xhr.open(request.iX, request.cN, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.cN));
		}

		_Http_configureRequest(xhr, request);

		request.dj.a && xhr.setRequestHeader('Content-Type', request.dj.a);
		xhr.send(request.dj.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ie; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.kz.a || 0;
	xhr.responseType = request.bF.d;
	xhr.withCredentials = request.gY;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		cN: xhr.responseURL,
		kn: xhr.status,
		ko: xhr.statusText,
		ie: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			j7: event.loaded,
			ke: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			jK: event.loaded,
			ke: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.i6) { flags += 'm'; }
	if (options.he) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$LinkClicked = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Msg$RouteChanged = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.j) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.k);
		} else {
			var treeLen = builder.j * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.m) : builder.m;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.j);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.k);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{m: nodeList, j: (len / $elm$core$Array$branchFactor) | 0, k: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {h7: fragment, eu: host, fo: path, ft: port_, fz: protocol, fB: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Shared$Api$Model$Api = $elm$core$Basics$identity;
var $author$project$Shared$Blockchain$Model$Block = $elm$core$Basics$identity;
var $author$project$Page$Empty = {$: 4};
var $author$project$Route$Empty = {$: 4};
var $author$project$Msg$GotConfig = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$GotHistoricalHeight = function (a) {
	return {$: 34, a: a};
};
var $author$project$Msg$GotLocalTimeZone = function (a) {
	return {$: 32, a: a};
};
var $author$project$Msg$GotLocalTimeZoneName = function (a) {
	return {$: 33, a: a};
};
var $author$project$Governance$Model$HalfLife = $elm$core$Basics$identity;
var $elm$browser$Browser$Events$Hidden = 1;
var $author$project$Shared$Language$Language = $elm$core$Basics$identity;
var $author$project$Shared$Settings$LockByDefault = $elm$core$Basics$identity;
var $author$project$Shared$Api$Model$NodeApi = $elm$core$Basics$identity;
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$UpdateActiveVoting = {$: 39};
var $author$project$Msg$User = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$UserAgent$UserAgent = $elm$core$Basics$identity;
var $elm$browser$Browser$Events$Visible = 0;
var $author$project$Shared$Waves$Address$WavesAddress = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Shared$Asset$Model$Asset = F5(
	function (id, name, longName, decimals, minSponsoredAssetFee) {
		return {hC: decimals, bP: id, iP: longName, e0: minSponsoredAssetFee, ac: name};
	});
var $author$project$Model$Config = F4(
	function (accountHealthThreshold, accountHealthOverlap, halfLife, withdrawLimitTimeframe) {
		return {gQ: accountHealthOverlap, gR: accountHealthThreshold, id: halfLife, ln: withdrawLimitTimeframe};
	});
var $author$project$Shared$Market$Model$Market = function (marketId) {
	return function (reserveAddress) {
		return function (aTokenId) {
			return function (limits) {
				return function (threshold) {
					return function (legacy) {
						return function (prohibitedSupply) {
							return function (state) {
								return function (info) {
									return function (asset) {
										return {gO: aTokenId, bh: asset, ip: info, iB: legacy, iC: limits, iT: marketId, jx: prohibitedSupply, jT: reserveAddress, f6: state, kw: threshold};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Shared$Market$Model$MarketInfo = F9(
	function (collateralFactor, reserveFactor, liquidationThreshold, liquidationPenalty, interestRateModel, leasingAprBase, stakingAprBase, protectedStaked, minLockLP) {
		return {hm: collateralFactor, eG: interestRateModel, eM: leasingAprBase, iE: liquidationPenalty, iF: liquidationThreshold, i$: minLockLP, jC: protectedStaked, jU: reserveFactor, ct: stakingAprBase};
	});
var $author$project$Shared$Market$Model$Threshold = F3(
	function (borrow, import_, redeem) {
		return {dk: borrow, $9: import_, jL: redeem};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Shared$Json$bigInt = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		$elm$core$Maybe$withDefault(0)),
	$elm$json$Json$Decode$string);
var $author$project$Shared$Json$base1000 = A2(
	$elm$json$Json$Decode$map,
	function (i) {
		return i / 1000;
	},
	$author$project$Shared$Json$bigInt);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Common$List$desc = $elm$core$Basics$sub(0);
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Cmd$Config$emptyState = {dk: 0, hG: 0, iK: 0, iL: 0, iM: 0, jD: 0, jS: 0, gb: 0, k4: 0};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.kn));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Shared$Json$floatK = A2(
	$elm$json$Json$Decode$map,
	function (i) {
		return i / 1000;
	},
	$author$project$Shared$Json$bigInt);
var $author$project$Shared$Apy$Increment = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$Apy$Segments = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Shared$Apy$Ray = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$Apy$ray = F2(
	function (dx, dy) {
		return $author$project$Shared$Apy$Ray(dy / dx);
	});
var $author$project$Shared$Apy$fromAbcd_ = F5(
	function (scale, a, b, c, d) {
		return A3(
			$author$project$Shared$Apy$Segments,
			A3(
				$author$project$Shared$Apy$Segments,
				$author$project$Shared$Apy$Increment(a),
				0,
				A2($author$project$Shared$Apy$ray, b, c - a)),
			b,
			A2($author$project$Shared$Apy$ray, scale - b, d - c));
	});
var $author$project$Shared$Apy$fromAbcd = $author$project$Shared$Apy$fromAbcd_(1);
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {fL: reqs, f8: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.kR;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.fL));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.f8)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					gY: r.gY,
					dj: r.dj,
					bF: A2(_Http_mapExpect, func, r.bF),
					ie: r.ie,
					iX: r.iX,
					kz: r.kz,
					kR: r.kR,
					cN: r.cN
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{gY: false, dj: r.dj, bF: r.bF, ie: r.ie, iX: r.iX, kz: r.kz, kR: r.kR, cN: r.cN}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{dj: $elm$http$Http$emptyBody, bF: r.bF, ie: _List_Nil, iX: 'GET', kz: $elm$core$Maybe$Nothing, kR: $elm$core$Maybe$Nothing, cN: r.cN});
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Common$Maybe$nothingIfZero = function (i) {
	return (!i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
};
var $author$project$Shared$Json$maybeBlock = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$andThen($author$project$Common$Maybe$nothingIfZero),
			$elm$core$Maybe$map($elm$core$Basics$identity))),
	$elm$json$Json$Decode$string);
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Shared$Text$nonBreakingHyphen = '‑';
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Shared$Json$strFloat = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		$elm$core$Maybe$withDefault(0)),
	$elm$json$Json$Decode$string);
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Cmd$Config$wxgTokens = _List_fromArray(
	['USDT', 'USDC', 'DAI', 'BUSD', 'ETH', 'BTC']);
var $author$project$Cmd$Config$config = F2(
	function (api, msg) {
		var reserveDecoder = function (assets) {
			var threshold = A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'redeem',
				$elm$json$Json$Decode$maybe($author$project$Shared$Json$base1000),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'import',
					$elm$json$Json$Decode$maybe($author$project$Shared$Json$base1000),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'borrow',
						$elm$json$Json$Decode$maybe($author$project$Shared$Json$base1000),
						$elm$core$Maybe$Nothing,
						$elm$json$Json$Decode$succeed($author$project$Shared$Market$Model$Threshold))));
			var mapLimit = function (_v8) {
				var k = _v8.a;
				var v = _v8.b;
				var _v7 = $elm$core$String$toInt(k);
				if (!_v7.$) {
					var l = _v7.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(l / 1000, v));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			};
			var limits = A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap(mapLimit),
						$elm$core$List$sortBy(
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Common$List$desc)))),
				$elm$json$Json$Decode$dict($author$project$Shared$Json$bigInt));
			var infoDecoder = function () {
				var toAbcd = function (lst) {
					if ((((lst.b && lst.b.b) && lst.b.b.b) && lst.b.b.b.b) && (!lst.b.b.b.b.b)) {
						var a = lst.a;
						var _v4 = lst.b;
						var b = _v4.a;
						var _v5 = _v4.b;
						var c = _v5.a;
						var _v6 = _v5.b;
						var d = _v6.a;
						return $elm$json$Json$Decode$succeed(
							A4($author$project$Shared$Apy$fromAbcd, a, b, c, d));
					} else {
						return $elm$json$Json$Decode$fail('expected [a,b,c,d]');
					}
				};
				var maybeNoZero = A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$andThen($author$project$Common$Maybe$nothingIfZero),
					$elm$json$Json$Decode$maybe($author$project$Shared$Json$strFloat));
				var interestRateModelDecoder = A2(
					$elm$json$Json$Decode$andThen,
					toAbcd,
					$elm$json$Json$Decode$list($author$project$Shared$Json$floatK));
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'minLockLP',
					$author$project$Shared$Json$bigInt,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'protectedStaking',
						$elm$json$Json$Decode$bool,
						true,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'leasingAprBase',
								maybeNoZero,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ABCD',
									interestRateModelDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'liquidationPenalty',
										$author$project$Shared$Json$floatK,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'liquidationThreshold',
											$author$project$Shared$Json$floatK,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'reserveFactor',
												$author$project$Shared$Json$floatK,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'collateralFactor',
													$author$project$Shared$Json$floatK,
													$elm$json$Json$Decode$succeed($author$project$Shared$Market$Model$MarketInfo))))))))));
			}();
			var reserve = function (marketId) {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, assets),
					$elm$core$List$head(
						A2($elm$core$String$split, '_', marketId)));
				if (!_v2.$) {
					var asset = _v2.a;
					return A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						asset,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							infoDecoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								$author$project$Cmd$Config$emptyState,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'prohibitedSupply',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'legacy',
										$elm$json$Json$Decode$bool,
										false,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'threshold',
											$elm$json$Json$Decode$maybe(threshold),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'limit',
												limits,
												_List_Nil,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'aTokenId',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'reserveAddress',
														$elm$json$Json$Decode$string,
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
															marketId,
															$elm$json$Json$Decode$succeed($author$project$Shared$Market$Model$Market)))))))))));
				} else {
					return $elm$json$Json$Decode$fail('reserve asset not found');
				}
			};
			return A2(
				$elm$json$Json$Decode$andThen,
				reserve,
				A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
		};
		var configDecoder = A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'withdraw_limit_timeframe',
			$author$project$Shared$Json$maybeBlock,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vires_lock_half_life',
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Shared$Json$bigInt),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'account_health_overlap',
					$author$project$Shared$Json$floatK,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'account_health_threshold',
						$author$project$Shared$Json$floatK,
						$elm$json$Json$Decode$succeed($author$project$Model$Config)))));
		var assetDecoder = function () {
			var xtn = function (a) {
				return (a.ac === 'USDN') ? _Utils_update(
					a,
					{iP: 'Neutrino Index', ac: 'XTN'}) : a;
			};
			var wxg = function (a) {
				return A2($elm$core$List$member, a.ac, $author$project$Cmd$Config$wxgTokens) ? _Utils_update(
					a,
					{ac: a.ac + ($author$project$Shared$Text$nonBreakingHyphen + 'WXG')}) : a;
			};
			var sponsorFees = $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('WAVES', 100000),
						_Utils_Tuple2('XTN', 150000),
						_Utils_Tuple2('USDT', 200000),
						_Utils_Tuple2('USDC', 200000),
						_Utils_Tuple2('DAI', 100000),
						_Utils_Tuple2('BUSD', 200000),
						_Utils_Tuple2('EURN', 130000),
						_Utils_Tuple2('BTC', 460),
						_Utils_Tuple2('ETH', 7500)
					]));
			var setFee = function (a) {
				var _v1 = _Utils_Tuple2(
					a.e0,
					A2($elm$core$Dict$get, a.ac, sponsorFees));
				if ((!_v1.a) && (!_v1.b.$)) {
					var fee = _v1.b.a;
					return _Utils_update(
						a,
						{e0: fee});
				} else {
					return a;
				}
			};
			return A2(
				$elm$json$Json$Decode$map,
				wxg,
				A2(
					$elm$json$Json$Decode$map,
					xtn,
					A2(
						$elm$json$Json$Decode$map,
						setFee,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'minSponsoredAssetFee',
							$elm$json$Json$Decode$int,
							0,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'decimals',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'longName',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Shared$Asset$Model$Asset)))))))));
		}();
		var assetAndMarketDecoder = A2(
			$elm$json$Json$Decode$andThen,
			function (assets) {
				return A2(
					$elm$json$Json$Decode$map,
					function (m) {
						return _Utils_Tuple2(
							$elm$core$Dict$values(assets),
							$elm$core$Dict$values(m));
					},
					A2(
						$elm$json$Json$Decode$field,
						'reserves',
						$elm$json$Json$Decode$dict(
							reserveDecoder(assets))));
			},
			A2(
				$elm$json$Json$Decode$field,
				'assets',
				$elm$json$Json$Decode$dict(assetDecoder)));
		var decoder = A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			assetAndMarketDecoder,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				configDecoder,
				$elm$json$Json$Decode$succeed(
					F2(
						function (c, _v0) {
							var a = _v0.a;
							var m = _v0.b;
							return _Utils_Tuple3(c, a, m);
						}))));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, decoder),
				cN: api + '/v3/config'
			});
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$getZoneName = _Time_getZoneName(0);
var $author$project$Shared$Json$block = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Shared$Json$bigInt);
var $author$project$Shared$Blockchain$Cmd$height = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'height', $author$project$Shared$Json$block)),
				cN: api + '/height'
			});
	});
var $elm$time$Time$here = _Time_here(0);
var $author$project$Common$Base$iff = F3(
	function (ifTrue, ifFalse, condition) {
		return condition ? ifTrue : ifFalse;
	});
var $author$project$Common$Screen$Width = $elm$core$Basics$identity;
var $author$project$Common$Screen$init = $elm$core$Basics$identity;
var $author$project$Shared$Webpack$Resources = $elm$core$Basics$identity;
var $author$project$Shared$Webpack$init = $elm$core$Basics$identity;
var $author$project$User$Msg$Wallet = function (a) {
	return {$: 6, a: a};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Port$getItem = _Platform_outgoingPort('getItem', $elm$json$Json$Encode$string);
var $author$project$Shared$Wallet$Model$empty = {g6: $elm$core$Dict$empty, iG: 0, fG: 0, gF: $elm$core$Maybe$Nothing};
var $author$project$Shared$Wallet$Msg$GotAssetBalance = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$Wallet$Msg$GotWavesBalance = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Shared$Wallet$Cmd$assetBalanceDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int));
var $author$project$Shared$Wallet$Cmd$walletsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A2(
		$elm$json$Json$Decode$field,
		'balances',
		$elm$json$Json$Decode$list($author$project$Shared$Wallet$Cmd$assetBalanceDecoder)));
var $author$project$Shared$Wallet$Cmd$assetsBalance = F3(
	function (_v0, msg, address) {
		var nodeApi = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Shared$Wallet$Cmd$walletsDecoder),
				cN: nodeApi + ('/assets/balance/' + address)
			});
	});
var $author$project$Shared$Wallet$Cmd$balanceDecoder = A2($elm$json$Json$Decode$field, 'available', $elm$json$Json$Decode$int);
var $author$project$Shared$Wallet$Cmd$wavesBalance = F3(
	function (_v0, msg, address) {
		var nodeApi = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Shared$Wallet$Cmd$balanceDecoder),
				cN: nodeApi + ('/addresses/balance/details/' + address)
			});
	});
var $author$project$Shared$Wallet$Cmd$balance = F2(
	function (nodeApi, _v0) {
		var address = _v0;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Shared$Wallet$Cmd$assetsBalance, nodeApi, $author$project$Shared$Wallet$Msg$GotAssetBalance, address),
					A3($author$project$Shared$Wallet$Cmd$wavesBalance, nodeApi, $author$project$Shared$Wallet$Msg$GotWavesBalance, address)
				]));
	});
var $author$project$Shared$Wallet$Msg$Refresh = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$Msg$Scheduled = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $andrewMacmurray$elm_delay$Delay$after = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $andrewMacmurray$elm_delay$Delay$seconds = function (millis) {
	return millis * 1000;
};
var $author$project$Shared$Wallet$Cmd$scheduleRefresh = function (nonce) {
	return A2(
		$andrewMacmurray$elm_delay$Delay$after,
		$andrewMacmurray$elm_delay$Delay$seconds(20),
		$author$project$Shared$Wallet$Msg$Refresh(
			$author$project$Shared$Msg$Scheduled(nonce)));
};
var $author$project$Shared$Wallet$Cmd$loadUserDataAndScheduleRefresh = F3(
	function (nodeApi, address, model) {
		var nonce = model.fG + 1;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iG: 1, fG: nonce}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Shared$Wallet$Cmd$scheduleRefresh(nonce),
						A2($author$project$Shared$Wallet$Cmd$balance, nodeApi, address)
					])));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Common$Cmd$no = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Shared$Wallet$Init$init = F2(
	function (nodeApi, address) {
		if (!address.$) {
			var a = address.a;
			return A3($author$project$Shared$Wallet$Cmd$loadUserDataAndScheduleRefresh, nodeApi, a, $author$project$Shared$Wallet$Model$empty);
		} else {
			return $author$project$Common$Cmd$no($author$project$Shared$Wallet$Model$empty);
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Common$Cmd$try = function (map) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(map),
		$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
};
var $author$project$User$Msg$GotEbRewards = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$Msg$GotRevenue = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$User$Msg$GotUserGovernance = function (a) {
	return {$: 8, a: a};
};
var $author$project$Shared$Cmd$cache = F2(
	function (useCache, url) {
		return useCache ? url : (url + '?_vercel_no_cache=1');
	});
var $author$project$Governance$Revenue$Shared$MarketRevenue = F3(
	function (claimed, claimable, nonClaimable) {
		return {hj: claimable, bm: claimed, aZ: nonClaimable};
	});
var $author$project$Governance$Revenue$Cmd$revenueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nonClaimable',
	$author$project$Shared$Json$bigInt,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'claimable',
		$author$project$Shared$Json$bigInt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'claimed',
			$author$project$Shared$Json$bigInt,
			$elm$json$Json$Decode$succeed($author$project$Governance$Revenue$Shared$MarketRevenue))));
var $author$project$Governance$Revenue$Cmd$revenue = F4(
	function (_v0, msg, useCache, _v1) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$dict($author$project$Governance$Revenue$Cmd$revenueDecoder)),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/v2/user/' + (address + '/revenue')))
			});
	});
var $author$project$Shared$EarlyBird$Model$EarlyBirdRewards = F4(
	function (claimed, available, vesting, staked) {
		return {c8: available, bm: claimed, f3: staked, k6: vesting};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Shared$EarlyBird$Cmd$rewardsDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Shared$EarlyBird$Model$EarlyBirdRewards,
	A2($elm$json$Json$Decode$field, 'ebAlreadyClaimed', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'ebAvailable', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'ebTotalVesting', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'viresStaked', $author$project$Shared$Json$bigInt));
var $author$project$Shared$EarlyBird$Cmd$rewards = F4(
	function (_v0, msg, useCache, _v1) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Shared$EarlyBird$Cmd$rewardsDecoder),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/user/' + (address + '/vires')))
			});
	});
var $author$project$Governance$Model$UserGovernance = F4(
	function (weight, entryHeight, staked, locked) {
		return {hQ: entryHeight, iJ: locked, f3: staked, lj: weight};
	});
var $author$project$Shared$Json$float10K = A2(
	$elm$json$Json$Decode$map,
	function (i) {
		return i / 10000;
	},
	$author$project$Shared$Json$bigInt);
var $author$project$Governance$Cmd$decodeUserGovernance = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Governance$Model$UserGovernance,
	A2($elm$json$Json$Decode$field, 'power', $author$project$Shared$Json$float10K),
	A2($elm$json$Json$Decode$field, 'entryHeight', $author$project$Shared$Json$block),
	A2($elm$json$Json$Decode$field, 'inProtocol', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'locked', $author$project$Shared$Json$bigInt));
var $author$project$Governance$Cmd$userGovernance = F4(
	function (_v0, msg, useCache, _v1) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Governance$Cmd$decodeUserGovernance),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/v2/user/' + (address + '/gov')))
			});
	});
var $author$project$User$Cmd$userRelatedInfo = F3(
	function (api, useCache, address) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4($author$project$Governance$Cmd$userGovernance, api, $author$project$User$Msg$GotUserGovernance, useCache, address),
					A4($author$project$Shared$EarlyBird$Cmd$rewards, api, $author$project$User$Msg$GotEbRewards, useCache, address),
					A4(
					$author$project$Governance$Revenue$Cmd$revenue,
					api,
					$author$project$User$Msg$GotRevenue(address),
					useCache,
					address)
				]));
	});
var $author$project$User$Init$init = F2(
	function (_v0, address) {
		var nodeApi = _v0.a;
		var api = _v0.b;
		var _v1 = A2($author$project$Shared$Wallet$Init$init, nodeApi, address);
		var wallet = _v1.a;
		var walletCmd = _v1.b;
		return _Utils_Tuple2(
			{gV: address, hN: $elm$core$Maybe$Nothing, ic: $elm$core$Maybe$Nothing, iN: $elm$core$Maybe$Nothing, jk: false, jZ: $elm$core$Dict$empty, lh: wallet},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$User$Msg$Wallet, walletCmd),
						A2(
						$author$project$Common$Cmd$try,
						A2($author$project$User$Cmd$userRelatedInfo, api, true),
						address),
						$author$project$Port$getItem('loginWith')
					])));
	});
var $pablen$toasty$Toasty$Stack = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $pablen$toasty$Toasty$initialState = A2(
	$pablen$toasty$Toasty$Stack,
	_List_Nil,
	$elm$random$Random$initialSeed(0));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$not = _Basics_not;
var $ChristophP$elm_i18next$I18Next$tf = F2(
	function (translationsList, key) {
		if (translationsList.b) {
			var translations = translationsList.a;
			var rest = translationsList.b;
			return A2(
				$elm$core$Maybe$withDefault,
				A2($ChristophP$elm_i18next$I18Next$tf, rest, key),
				A2($elm$core$Dict$get, key, translations));
		} else {
			return key;
		}
	});
var $author$project$Translations$notificationBarMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'notificationBarMD');
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $ChristophP$elm_i18next$I18Next$Translations = $elm$core$Basics$identity;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
	return $ChristophP$elm_i18next$I18Next$treeDecoder;
};
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $elm$core$Basics$identity),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$Common$Cmd$update = A2(
	$elm$core$Basics$composeR,
	$elm$core$Task$succeed,
	$elm$core$Task$perform($elm$core$Basics$identity));
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Init$init = F2(
	function (flags, key) {
		var translations = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue($ChristophP$elm_i18next$I18Next$translationsDecoder),
				$elm$core$Result$toMaybe),
			flags.kT);
		var showNotification = (!flags.hM) && (!$elm$core$String$isEmpty(
			$author$project$Translations$notificationBarMD(translations)));
		var _v0 = A2(
			$author$project$User$Init$init,
			_Utils_Tuple2(flags.jb, flags.g_),
			A2($elm$core$Maybe$map, $elm$core$Basics$identity, flags.gV));
		var user = _v0.a;
		var userCmd = _v0.b;
		return _Utils_Tuple2(
			{
				cZ: $elm$core$Maybe$Nothing,
				g6: _List_Nil,
				hn: {gQ: 0, gR: 0, id: 262800, ln: $elm$core$Maybe$Nothing},
				hT: _List_Nil,
				h3: flags,
				ic: $elm$core$Maybe$Nothing,
				$8: $elm$core$Maybe$Nothing,
				ii: _Utils_Tuple2(
					$elm$time$Time$millisToPosix(1645536480000),
					3000000),
				iq: false,
				iw: key,
				iz: flags.iz,
				iG: 3,
				iI: false,
				eY: _List_Nil,
				i7: false,
				i9: $elm$core$Dict$empty,
				je: showNotification,
				jo: $author$project$Page$Empty,
				jv: $elm$core$Maybe$Nothing,
				jI: $elm$core$Dict$empty,
				jP: _List_Nil,
				jW: $author$project$Shared$Webpack$init(
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Dict$empty,
						$elm$core$Result$toMaybe(
							A2(
								$elm$json$Json$Decode$decodeValue,
								$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
								flags.jq)))),
				j2: $author$project$Route$Empty,
				j3: $author$project$Common$Screen$init(flags.ll),
				kx: $elm$time$Time$utc,
				ky: $elm$time$Time$Offset(0),
				kJ: $pablen$toasty$Toasty$initialState,
				kT: translations,
				kZ: user,
				k_: flags.k_,
				k9: $elm$core$Maybe$Nothing,
				la: A3($author$project$Common$Base$iff, 1, 0, flags.ig)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Cmd$Config$config, flags.g_, $author$project$Msg$GotConfig),
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$User, userCmd),
						A2($elm$core$Task$perform, $author$project$Msg$GotLocalTimeZone, $elm$time$Time$here),
						A2($elm$core$Task$perform, $author$project$Msg$GotLocalTimeZoneName, $elm$time$Time$getZoneName),
						A2($author$project$Shared$Blockchain$Cmd$height, flags.g_, $author$project$Msg$GotHistoricalHeight),
						$author$project$Common$Cmd$update($author$project$Msg$UpdateActiveVoting)
					])));
	});
var $author$project$Msg$Connect = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Connect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$Gateway = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Gateway = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$Governance = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Governance = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$Home = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Home = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$Market = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Market = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$RaF = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$VToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$VToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Gateway$Msg$Send = function (a) {
	return {$: 2, a: a};
};
var $author$project$Gateway$Msg$Topup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gateway$Port$getStoredGatewayCredentials = _Platform_outgoingPort('getStoredGatewayCredentials', $elm$json$Json$Encode$string);
var $author$project$Gateway$Movements$Init$init = {hd: true, iG: 0, i5: _List_Nil};
var $author$project$Gateway$Send$Msg$GotCurrencies = function (a) {
	return {$: 4, a: a};
};
var $author$project$Gateway$Send$Cmd$action = 'withdraw';
var $author$project$Gateway$Shared$Cmd$api = 'https://api.waves.exchange/v1';
var $author$project$Gateway$Shared$Model$Currency = F7(
	function (id, assetId, platform, decimals, limits, fees, status) {
		return {g5: assetId, hC: decimals, h2: fees, bP: id, iC: limits, ju: platform, km: status};
	});
var $author$project$Gateway$Shared$Model$Fees = F2(
	function (flat, rate) {
		return {h4: flat, jH: rate};
	});
var $author$project$Gateway$Shared$Model$Limits = F2(
	function (min, max) {
		return {iU: max, i_: min};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Gateway$Shared$Cmd$decodeCurrencies = function () {
	var limits = A3(
		$elm$json$Json$Decode$map2,
		$author$project$Gateway$Shared$Model$Limits,
		A2($elm$json$Json$Decode$field, 'min', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'max', $elm$json$Json$Decode$float));
	var fees = A3(
		$elm$json$Json$Decode$map2,
		$author$project$Gateway$Shared$Model$Fees,
		A2($elm$json$Json$Decode$field, 'flat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'rate', $elm$json$Json$Decode$float));
	var currency = function () {
		var id = A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string);
		return A8(
			$elm$json$Json$Decode$map7,
			$author$project$Gateway$Shared$Model$Currency,
			id,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'waves_asset_id', $elm$json$Json$Decode$string),
						id
					])),
			A2($elm$json$Json$Decode$field, 'platform_id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'allowed_amount', limits),
			A2($elm$json$Json$Decode$field, 'fees', fees),
			A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
	}();
	return A2(
		$elm$json$Json$Decode$field,
		'items',
		$elm$json$Json$Decode$list(currency));
}();
var $author$project$Gateway$Shared$Cmd$currencies = F2(
	function (action, msg) {
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Gateway$Shared$Cmd$decodeCurrencies),
				cN: $author$project$Gateway$Shared$Cmd$api + ('/' + (action + '/currencies?limit=1000'))
			});
	});
var $author$project$Gateway$Send$Cmd$currencies = $author$project$Gateway$Shared$Cmd$currencies($author$project$Gateway$Send$Cmd$action);
var $author$project$Gateway$Send$Init$init = _Utils_Tuple2(
	{gZ: '', hc: $elm$core$Maybe$Nothing, hu: _List_Nil, hv: $elm$core$Maybe$Nothing, hK: false, h1: $elm$core$Maybe$Nothing, iG: 1, jE: $elm$core$Maybe$Nothing, k0: ''},
	$author$project$Gateway$Send$Cmd$currencies($author$project$Gateway$Send$Msg$GotCurrencies));
var $author$project$Gateway$Topup$Msg$GotCurrencies = function (a) {
	return {$: 4, a: a};
};
var $author$project$Gateway$Topup$Cmd$action = 'deposit';
var $author$project$Gateway$Topup$Cmd$currencies = $author$project$Gateway$Shared$Cmd$currencies($author$project$Gateway$Topup$Cmd$action);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Shared$Etherium$Port$getEthereumWalletInstalled = _Platform_outgoingPort(
	'getEthereumWalletInstalled',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Gateway$Topup$Init$init = _Utils_Tuple2(
	{gZ: '', hu: _List_Nil, hv: $elm$core$Maybe$Nothing, hK: false, hU: 0, hV: $elm$core$Maybe$Nothing, ib: _List_Nil, iG: 1, iV: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Gateway$Topup$Cmd$currencies($author$project$Gateway$Topup$Msg$GotCurrencies),
				$author$project$Shared$Etherium$Port$getEthereumWalletInstalled(0)
			])));
var $author$project$Gateway$Init$init = F2(
	function (activeTab, user) {
		var cmd = function () {
			var _v2 = user.gV;
			if (!_v2.$) {
				var address = _v2.a;
				return $author$project$Gateway$Port$getStoredGatewayCredentials(address);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = $author$project$Gateway$Topup$Init$init;
		var tm = _v0.a;
		var tc = _v0.b;
		var _v1 = $author$project$Gateway$Send$Init$init;
		var sm = _v1.a;
		var sc = _v1.b;
		return _Utils_Tuple2(
			{gT: activeTab, hs: $elm$core$Maybe$Nothing, i5: $author$project$Gateway$Movements$Init$init, j5: sm, kK: tm},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Gateway$Msg$Topup, tc),
						A2($elm$core$Platform$Cmd$map, $author$project$Gateway$Msg$Send, sc)
					])));
	});
var $author$project$Home$Msg$Vesting = function (a) {
	return {$: 17, a: a};
};
var $author$project$Home$Vesting$Model$None = {$: 0};
var $author$project$Home$Vesting$Msg$VestingLoaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$Home$Vesting$Msg$RegularLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Home$Vesting$Msg$WhaleLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Home$Vesting$Shared$Model$RegularVested = F4(
	function (total, availableNow, dailyLimit, stakingRewards) {
		return {bi: availableNow, hz: dailyLimit, f4: stakingRewards, kL: total};
	});
var $author$project$Home$Vesting$Shared$Model$StakingRewards = F2(
	function (total, claimed) {
		return {bm: claimed, kL: total};
	});
var $author$project$Home$Vesting$Shared$Cmd$hasStartedAndNotFinished = F3(
	function (startHeight, isFinished, dec) {
		var finished = function (v) {
			return isFinished(v) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(v);
		};
		var started = function (h) {
			return (h === '-1') ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : A2($elm$json$Json$Decode$map, finished, dec);
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			started,
			A2($elm$json$Json$Decode$field, startHeight, $elm$json$Json$Decode$string));
	});
var $author$project$Cmd$NewApi$newApi = 'https://api-retry.vercel.app/api';
var $author$project$Home$Vesting$Shared$Logic$stillInVesting = function (vested) {
	return vested.kL;
};
var $author$project$Home$Vesting$Shared$Cmd$vestingComplete = function (v) {
	return !$author$project$Home$Vesting$Shared$Logic$stillInVesting(v);
};
var $author$project$Home$Vesting$Shared$Cmd$regular = F4(
	function (msg, _v0, useCache, _v1) {
		var api = _v0;
		var a = _v1;
		var stakingRewards = A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'markets_staking_rewards_claimed',
			$author$project$Shared$Json$bigInt,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'markets_staking_rewards_total',
				$author$project$Shared$Json$bigInt,
				$elm$json$Json$Decode$succeed($author$project$Home$Vesting$Shared$Model$StakingRewards)));
		var decoder = A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			stakingRewards,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'markets_perDay',
				$author$project$Shared$Json$bigInt,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'markets_availableNow',
					$author$project$Shared$Json$bigInt,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'markets_totalVesting',
						$author$project$Shared$Json$bigInt,
						$elm$json$Json$Decode$succeed($author$project$Home$Vesting$Shared$Model$RegularVested)))));
		var claimed = function (v) {
			return _Utils_eq(v.f4.kL, v.f4.bm);
		};
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A3(
						$author$project$Home$Vesting$Shared$Cmd$hasStartedAndNotFinished,
						'markets_startHeight',
						function (v) {
							return $author$project$Home$Vesting$Shared$Cmd$vestingComplete(v) && claimed(v);
						},
						decoder)),
				cN: A2($author$project$Shared$Cmd$cache, useCache, $author$project$Cmd$NewApi$newApi + ('/evaluate/3PKZk5TdPCLP2GZviipLFfK46ExTnwkRCBd/adviseUser/' + a))
			});
	});
var $author$project$Home$Vesting$Shared$Model$WhaleVested = F2(
	function (total, availableToday) {
		return {g8: availableToday, kL: total};
	});
var $author$project$Home$Vesting$Shared$Cmd$whale = F4(
	function (msg, _v0, useCache, _v1) {
		var api = _v0;
		var a = _v1;
		var vested = function () {
			var total = A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'convertedToLP',
				$author$project$Shared$Json$bigInt,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'alreadyClaimed',
					$author$project$Shared$Json$bigInt,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'totalVesting',
						$author$project$Shared$Json$bigInt,
						$elm$json$Json$Decode$succeed(
							F3(
								function (t, claimed, converted) {
									return (t - claimed) - converted;
								})))));
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'availableToday',
				$author$project$Shared$Json$bigInt,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					total,
					$elm$json$Json$Decode$succeed($author$project$Home$Vesting$Shared$Model$WhaleVested)));
		}();
		var decoder = A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($author$project$Home$Vesting$Shared$Cmd$hasStartedAndNotFinished, 'startHeight', $author$project$Home$Vesting$Shared$Cmd$vestingComplete, vested),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'migrated',
				$elm$json$Json$Decode$dict($author$project$Shared$Json$bigInt),
				$elm$core$Dict$empty,
				$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, decoder),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/user/' + (a + '/vesting')))
			});
	});
var $author$project$Home$Vesting$Cmd$load = F3(
	function (api, useCache, adr) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4($author$project$Home$Vesting$Shared$Cmd$whale, $author$project$Home$Vesting$Msg$WhaleLoaded, api, useCache, adr),
					A4($author$project$Home$Vesting$Shared$Cmd$regular, $author$project$Home$Vesting$Msg$RegularLoaded, api, useCache, adr)
				]));
	});
var $author$project$Home$Vesting$Cmd$vesting = F2(
	function (_v0, msg) {
		var api = _v0;
		var decoder = A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'liquidaoPaused',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'liquidaoAllPaused',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed(
						F3(
							function (a, b, c) {
								return _Utils_Tuple3(a, b, c);
							})))));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, decoder),
				cN: api + '/vesting'
			});
	});
var $author$project$Home$Vesting$Init$init = F2(
	function (api, user) {
		return _Utils_Tuple2(
			{dQ: $author$project$Home$Vesting$Model$None, iZ: $elm$core$Dict$empty, js: false, jN: $elm$core$Maybe$Nothing, lk: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Common$Cmd$try,
						A2($author$project$Home$Vesting$Cmd$load, api, true),
						user.gV),
						A2($author$project$Home$Vesting$Cmd$vesting, api, $author$project$Home$Vesting$Msg$VestingLoaded)
					])));
	});
var $author$project$Markets$Init$init = {ka: false};
var $author$project$Home$Msg$GotUserInfoAndRewards = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Common$Dict$filterByValue = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $elm$core$Dict$filter);
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Common$Dict$split = function (data) {
	return _Utils_Tuple2(
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, v) {
					return v.a;
				}),
			data),
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, v) {
					return v.b;
				}),
			data));
};
var $author$project$Shared$User$Model$UserRewards = F3(
	function (accumulated, available, claimed) {
		return {gS: accumulated, c8: available, bm: claimed};
	});
var $author$project$Shared$User$Cmd$rewardsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rewardsClaimed',
	$author$project$Shared$Json$bigInt,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rewardsAvailable',
		$author$project$Shared$Json$bigInt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rewardsAccumulated',
			$author$project$Shared$Json$bigInt,
			$elm$json$Json$Decode$succeed($author$project$Shared$User$Model$UserRewards))));
var $author$project$Shared$User$Model$UserInfo = F2(
	function (supply, borrow) {
		return {dk: borrow, gb: supply};
	});
var $author$project$Shared$Json$maybeBigInt = A2($elm$json$Json$Decode$map, $author$project$Common$Maybe$nothingIfZero, $author$project$Shared$Json$bigInt);
var $author$project$Shared$User$Model$Borrowable = 0;
var $author$project$Shared$User$Model$Locked = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Shared$User$Model$Protected = 1;
var $author$project$Shared$User$Model$Supply = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Shared$User$Model$Weight = $elm$core$Basics$identity;
var $author$project$Shared$Json$bigIntNonZero = function () {
	var nonZero = function (i) {
		return (!i) ? $elm$json$Json$Decode$fail('zero is invalid value') : $elm$json$Json$Decode$succeed(i);
	};
	return A2($elm$json$Json$Decode$andThen, nonZero, $author$project$Shared$Json$bigInt);
}();
var $author$project$Shared$User$Cmd$supplyDecoder = function () {
	var supply = A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'useAsCollateral',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'supply',
				$author$project$Shared$Json$bigIntNonZero,
				$elm$json$Json$Decode$succeed($author$project$Shared$User$Model$Supply))));
	var _protected = A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		1,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			true,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'protectedSupply',
				$author$project$Shared$Json$bigIntNonZero,
				$elm$json$Json$Decode$succeed($author$project$Shared$User$Model$Supply))));
	var locked = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lpUserFactor',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Shared$Json$bigInt),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lpUnlockHeight',
			$author$project$Shared$Json$block,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lpLocked',
				$author$project$Shared$Json$bigIntNonZero,
				$elm$json$Json$Decode$succeed($author$project$Shared$User$Model$Locked))));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[locked, supply, _protected]));
}();
var $author$project$Shared$User$Cmd$userDateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'borrow',
	$author$project$Shared$Json$maybeBigInt,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$maybe($author$project$Shared$User$Cmd$supplyDecoder),
		$elm$json$Json$Decode$succeed($author$project$Shared$User$Model$UserInfo)));
var $author$project$Shared$User$Cmd$userDateAndRewardsDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Shared$User$Cmd$userDateDecoder, $author$project$Shared$User$Cmd$rewardsDecoder);
var $author$project$Shared$User$Cmd$userState = F4(
	function (_v0, useCache, _v1, msg) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Common$Dict$split,
							function (_v2) {
								var user = _v2.a;
								var rewards = _v2.b;
								return _Utils_Tuple2(
									A2(
										$author$project$Common$Dict$filterByValue,
										function (v) {
											return (!_Utils_eq(v.gb, $elm$core$Maybe$Nothing)) || (!_Utils_eq(v.dk, $elm$core$Maybe$Nothing));
										},
										user),
									A2(
										$author$project$Common$Dict$filterByValue,
										function (v) {
											return v.gS > 0;
										},
										rewards));
							}),
						$elm$json$Json$Decode$dict($author$project$Shared$User$Cmd$userDateAndRewardsDecoder))),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/user/' + address))
			});
	});
var $author$project$Home$Cmd$refreshCommand = F3(
	function (api, fromCache, address) {
		return A4($author$project$Shared$User$Cmd$userState, api, fromCache, address, $author$project$Home$Msg$GotUserInfoAndRewards);
	});
var $author$project$Home$Msg$Refresh = function (a) {
	return {$: 6, a: a};
};
var $author$project$Home$Cmd$scheduleRefresh = function (nonce) {
	return A2(
		$andrewMacmurray$elm_delay$Delay$after,
		$andrewMacmurray$elm_delay$Delay$seconds(120),
		$author$project$Home$Msg$Refresh(
			$author$project$Shared$Msg$Scheduled(nonce)));
};
var $author$project$Home$Cmd$loadUserDataAndScheduleRefresh = F3(
	function (api, address, model) {
		var nonce = model.fG + 1;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iG: 1, fG: nonce}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Home$Cmd$scheduleRefresh(nonce),
						A3($author$project$Home$Cmd$refreshCommand, api, true, address)
					])));
	});
var $author$project$Home$Init$init = F2(
	function (api, user) {
		var _v0 = A2($author$project$Home$Vesting$Init$init, api, user);
		var vesting = _v0.a;
		var vestingCmd = _v0.b;
		var model = {iA: $elm$core$Maybe$Nothing, iG: 0, iH: $elm$core$Maybe$Nothing, eY: $author$project$Markets$Init$init, jf: $elm$core$Maybe$Nothing, jl: $elm$core$Maybe$Nothing, fG: 1, jP: _List_Nil, j$: $elm$core$Dict$empty, ah: 0, cl: 20000, gl: 2, k$: $elm$core$Dict$empty, k6: vesting};
		var _v1 = function () {
			var _v2 = user.gV;
			if (!_v2.$) {
				var address = _v2.a;
				return A3($author$project$Home$Cmd$loadUserDataAndScheduleRefresh, api, address, model);
			} else {
				return $author$project$Common$Cmd$no(model);
			}
		}();
		var m = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			m,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Vesting, vestingCmd)
					])));
	});
var $author$project$Port$scrollToTop = _Platform_outgoingPort(
	'scrollToTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$MarketDetail$Init$init = _Utils_Tuple2(
	{j9: false, k3: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Port$scrollToTop(0),
				$author$project$Port$getItem('Compound')
			])));
var $author$project$RaF$Init$init = {};
var $author$project$User$Connect$Msg$CheckKeeper = {$: 6};
var $author$project$User$Connect$Msg$CheckMetamask = {$: 7};
var $author$project$User$Connect$Init$init = _Utils_Tuple2(
	{iv: false, iW: false, ku: false, li: _List_Nil},
	$elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Port$getItem('termsAccepted'),
				$author$project$Common$Cmd$update($author$project$User$Connect$Msg$CheckKeeper),
				$author$project$Common$Cmd$update($author$project$User$Connect$Msg$CheckMetamask)
			])));
var $author$project$VToken$Msg$GotFaq = function (a) {
	return {$: 7, a: a};
};
var $author$project$VToken$Msg$GotUserStake = function (a) {
	return {$: 0, a: a};
};
var $author$project$VToken$Msg$Vesting = function (a) {
	return {$: 10, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Shared$Language$english = 'en';
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Shared$Webpack$get = F2(
	function (_v0, url) {
		var mapping = _v0;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('/'),
			A2($elm$core$Dict$get, url, mapping));
	});
var $author$project$Shared$FAQ$Cmd$faq = F4(
	function (file, lang, fileMapping, msg) {
		var url = function () {
			var res = function (_v0) {
				var l = _v0;
				return $elm$core$String$concat(
					_List_fromArray(
						['faq/', file, '.', l, '.md']));
			};
			return A2(
				$elm$core$Maybe$withDefault,
				'webpack: FAQ not found: ' + file,
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						A2(
							$elm$core$Basics$composeR,
							res,
							$author$project$Shared$Webpack$get(fileMapping)),
						_List_fromArray(
							[lang, $author$project$Shared$Language$english]))));
		}();
		return $elm$http$Http$get(
			{
				bF: $elm$http$Http$expectString(msg),
				cN: url
			});
	});
var $author$project$VToken$Cmd$faq = $author$project$Shared$FAQ$Cmd$faq('vToken');
var $author$project$VToken$Vesting$Msg$RegularLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Vesting$Msg$WhaleLoaded = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$VToken$Vesting$Cmd$load = F3(
	function (api, useCache, adr) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Home$Vesting$Shared$Cmd$whale,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$map($elm$core$Tuple$second),
						$author$project$VToken$Vesting$Msg$WhaleLoaded),
					api,
					useCache,
					adr),
					A4($author$project$Home$Vesting$Shared$Cmd$regular, $author$project$VToken$Vesting$Msg$RegularLoaded, api, useCache, adr)
				]));
	});
var $author$project$VToken$Vesting$Init$init = F2(
	function (api, user) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jN: $elm$core$Maybe$Nothing, lk: $elm$core$Maybe$Nothing},
			A2(
				$author$project$Common$Cmd$try,
				A2($author$project$VToken$Vesting$Cmd$load, api, true),
				user.gV));
	});
var $author$project$Common$Markdown$Spoilers = $elm$core$Basics$identity;
var $author$project$Common$Markdown$initSpoilers = $elm$core$Dict$empty;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$VToken$Cmd$userStake = F3(
	function (_v0, msg, _v1) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Dict$filter(
							$elm$core$Basics$always(
								$elm$core$Basics$neq(0))),
						$elm$json$Json$Decode$dict(
							A2($elm$json$Json$Decode$field, 'vTokenContractBalance', $author$project$Shared$Json$bigInt)))),
				cN: api + ('/user/' + address)
			});
	});
var $author$project$VToken$Init$init = F4(
	function (api, res, lang, user) {
		var userStakeCmd = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$VToken$Cmd$userStake, api, $author$project$VToken$Msg$GotUserStake),
					$elm$core$List$singleton),
				user.gV));
		var _v0 = A2($author$project$VToken$Vesting$Init$init, api, user);
		var vestingModel = _v0.a;
		var vestingCmd = _v0.b;
		var model = {
			gT: $elm$core$Maybe$Nothing,
			h$: $elm$core$Maybe$Nothing,
			iG: $elm$core$List$length(userStakeCmd),
			kc: false,
			kf: $author$project$Common$Markdown$initSpoilers,
			kh: $elm$core$Dict$empty,
			k6: vestingModel
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					A3($author$project$VToken$Cmd$faq, lang, res, $author$project$VToken$Msg$GotFaq),
					A2(
						$elm$core$List$cons,
						$author$project$Port$getItem('vTokens:activeOnly'),
						A2(
							$elm$core$List$cons,
							$author$project$Port$scrollToTop(0),
							A2(
								$elm$core$List$cons,
								A2($elm$core$Platform$Cmd$map, $author$project$VToken$Msg$Vesting, vestingCmd),
								userStakeCmd))))));
	});
var $author$project$Governance$Model$Info = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Msg$Info = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Model$MyVires = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Msg$MyVires = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Model$Voting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Msg$Voting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Info$Msg$GotFaq = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$Time$monthsInYear = 12;
var $author$project$Governance$Info$Init$init = F2(
	function (resources, lang) {
		return _Utils_Tuple2(
			{gZ: $elm$core$Maybe$Nothing, h$: $elm$core$Maybe$Nothing, kf: $author$project$Common$Markdown$initSpoilers, k1: $elm$core$Maybe$Nothing, lq: $author$project$Common$Time$monthsInYear},
			A4($author$project$Shared$FAQ$Cmd$faq, 'governance', lang, resources, $author$project$Governance$Info$Msg$GotFaq));
	});
var $author$project$Governance$Model$None = {$: 0};
var $author$project$Governance$Init$init = function (_v0) {
	var tab_ = _v0.a;
	var tabCmd = _v0.b;
	return _Utils_Tuple2(
		{dQ: $author$project$Governance$Model$None, kt: tab_},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					tabCmd,
					$author$project$Port$scrollToTop(0)
				])));
};
var $author$project$Governance$MyVires$Msg$GotDelegation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$MyVires$Msg$Revenue = function (a) {
	return {$: 9, a: a};
};
var $author$project$Governance$MyVires$Cmd$delegate = F4(
	function (_v0, msg, useCache, _v1) {
		var api = _v0;
		var address = _v1;
		var decoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$map($elm$core$Basics$identity),
			A2(
				$elm$json$Json$Decode$field,
				'claimDelegate',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, decoder),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/v2/user/' + (address + '/delegate')))
			});
	});
var $author$project$Governance$Revenue$Msg$GotDelegators = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Revenue$Logic$claimFromKey = function (_v0) {
	var a = _v0;
	return 'claimFrom_' + a;
};
var $author$project$Governance$Revenue$Cmd$delegators = F3(
	function (_v0, msg, _v1) {
		var api = _v0;
		var address = _v1;
		var decoder = A2(
			$elm$json$Json$Decode$field,
			'claimDelegators',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, decoder),
				cN: A2($author$project$Shared$Cmd$cache, true, api + ('/v2/user/' + (address + '/delegators')))
			});
	});
var $author$project$Governance$Revenue$Cmd$getAllDelegators = F3(
	function (api, msg, address) {
		return _List_fromArray(
			[
				A3($author$project$Governance$Revenue$Cmd$delegators, api, msg, address),
				$author$project$Port$getItem(
				$author$project$Governance$Revenue$Logic$claimFromKey(address))
			]);
	});
var $author$project$Governance$Revenue$Init$init = F2(
	function (api, user) {
		var commands = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Governance$Revenue$Cmd$getAllDelegators, api, $author$project$Governance$Revenue$Msg$GotDelegators),
				user.gV));
		return _Utils_Tuple2(
			{
				hh: $elm$core$Maybe$Nothing,
				hx: $elm$core$Maybe$Nothing,
				hF: _List_Nil,
				hK: false,
				h8: user.gV,
				iG: $elm$core$List$length(commands),
				iQ: _List_Nil,
				j_: $elm$core$Dict$empty
			},
			$elm$core$Platform$Cmd$batch(commands));
	});
var $author$project$Governance$MyVires$Init$init = F2(
	function (api, user) {
		var _v0 = A2($author$project$Governance$Revenue$Init$init, api, user);
		var revenue = _v0.a;
		var revenueCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dP: $elm$core$Maybe$Nothing,
				hE: $elm$core$Maybe$Nothing,
				iG: A3(
					$author$project$Common$Base$iff,
					0,
					1,
					_Utils_eq(user.gV, $elm$core$Maybe$Nothing)),
				jZ: revenue
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Common$Cmd$try,
						A3($author$project$Governance$MyVires$Cmd$delegate, api, $author$project$Governance$MyVires$Msg$GotDelegation, true),
						user.gV),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$MyVires$Msg$Revenue, revenueCmd)
					])));
	});
var $author$project$Governance$Voting$Model$New = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$Msg$New = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Voting$Model$Proposal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Msg$Proposal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$Model$Proposals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$Msg$Proposals = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Msg$GotConfig = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$Model$Config = F7(
	function (quorumRatio, passedRatio, min_gViresToPropose, votingStartOffset, votingEndOffset, applyStartOffset, applyEndOffset) {
		return {g1: applyEndOffset, g2: applyStartOffset, i0: min_gViresToPropose, jp: passedRatio, jG: quorumRatio, le: votingEndOffset, lf: votingStartOffset};
	});
var $author$project$Governance$Voting$Cmd$config = F2(
	function (_v0, msg) {
		var api = _v0;
		var configDecoder = A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'proposal_applyend_offset',
			$author$project$Shared$Json$block,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'proposal_applystart_offset',
				$author$project$Shared$Json$block,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposal_votingend_offset',
					$author$project$Shared$Json$block,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'proposal_votingstart_offset',
						$author$project$Shared$Json$block,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'proposal_min_vires_required',
							$author$project$Shared$Json$bigInt,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'proposal_passed_ratio',
								$author$project$Shared$Json$base1000,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'proposal_quorum_ratio',
									$author$project$Shared$Json$base1000,
									$elm$json$Json$Decode$succeed($author$project$Governance$Voting$Model$Config))))))));
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, configDecoder),
				cN: api + '/voting/config'
			});
	});
var $author$project$Governance$Voting$Init$init = F2(
	function (api, _v0) {
		var pageModel = _v0.a;
		var pageCmd = _v0.b;
		return _Utils_Tuple2(
			{hn: $elm$core$Maybe$Nothing, jo: pageModel},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Governance$Voting$Cmd$config, api, $author$project$Governance$Voting$Msg$GotConfig),
						pageCmd
					])));
	});
var $author$project$Governance$Voting$New$Init$init = _Utils_Tuple2(
	{hH: '', hK: false, iG: 0, jt: '', jB: $elm$core$Maybe$Nothing, kB: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Governance$Voting$Proposal$Msg$GotProposal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$Proposal$Msg$GotVotes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Voting$Proposal$Model$Proposal = function (proposalId) {
	return function (status) {
		return function (title) {
			return function (description) {
				return function (payload) {
					return function (url) {
						return function (created) {
							return function (voting) {
								return function (apply) {
									return function (gViresTotalHistorical) {
										return function (votes) {
											return function (appliedAt) {
												return function (author) {
													return {g$: appliedAt, g0: apply, g7: author, hr: created, hH: description, ia: gViresTotalHistorical, jt: payload, jz: proposalId, km: status, kB: title, cN: url, lb: votes, lc: voting};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Governance$Voting$Shared$Model$StartEnd = F2(
	function (start, end) {
		return {hP: end, kk: start};
	});
var $author$project$Governance$Voting$Shared$Cmd$startEndDecoder_ = function (prefix) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'proposal_' + (prefix + 'end'),
		$author$project$Shared$Json$block,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'proposal_' + (prefix + 'start'),
			$author$project$Shared$Json$block,
			$elm$json$Json$Decode$succeed($author$project$Governance$Voting$Shared$Model$StartEnd)));
};
var $author$project$Governance$Voting$Shared$Cmd$applyDecoder = $author$project$Governance$Voting$Shared$Cmd$startEndDecoder_('apply');
var $author$project$Governance$Voting$New$Data$Bool = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$New$Data$Data = F3(
	function (key, type_, value) {
		return {iw: key, cL: type_, gA: value};
	});
var $author$project$Governance$Voting$New$Data$DataList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$New$Data$Int = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$New$Data$Null = {$: 3};
var $author$project$Governance$Voting$New$Data$Payload = F7(
	function (type_, version, senderPublicKey, fee, feeAssetId, timestamp, info) {
		return {h0: fee, h1: feeAssetId, ip: info, j6: senderPublicKey, kA: timestamp, cL: type_, k5: version};
	});
var $author$project$Governance$Voting$New$Data$Script = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$New$Data$Str = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$New$Data$when = F3(
	function (check, error, passDecoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : $elm$json$Json$Decode$fail(error);
			},
			passDecoder);
	});
var $author$project$Governance$Voting$New$Data$payloadDecoder = function () {
	var value = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$Governance$Voting$New$Data$Str, $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$map, $author$project$Governance$Voting$New$Data$Int, $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$map, $author$project$Governance$Voting$New$Data$Bool, $elm$json$Json$Decode$bool),
				$elm$json$Json$Decode$null($author$project$Governance$Voting$New$Data$Null)
			]));
	var data = function () {
		var checkTypeAndValue = function (d) {
			var _v0 = _Utils_Tuple2(d.cL, d.gA);
			_v0$4:
			while (true) {
				if (!_v0.a.$) {
					switch (_v0.a.a) {
						case 'string':
							if (!_v0.b.$) {
								return $elm$json$Json$Decode$succeed(d);
							} else {
								break _v0$4;
							}
						case 'boolean':
							if (_v0.b.$ === 2) {
								return $elm$json$Json$Decode$succeed(d);
							} else {
								break _v0$4;
							}
						case 'integer':
							if (_v0.b.$ === 1) {
								return $elm$json$Json$Decode$succeed(d);
							} else {
								break _v0$4;
							}
						default:
							break _v0$4;
					}
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$json$Json$Decode$succeed(d);
					} else {
						var _v3 = _v0.a;
						return $elm$json$Json$Decode$fail('Type of value is not specified');
					}
				}
			}
			var t = _v0.a.a;
			return $elm$json$Json$Decode$fail('Incorrect value for type ' + t);
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			checkTypeAndValue,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				value,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'type',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'key',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Governance$Voting$New$Data$Data)))));
	}();
	var dataOrScript = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Governance$Voting$New$Data$DataList,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list(data))),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Governance$Voting$New$Data$Script,
				A2($elm$json$Json$Decode$field, 'script', $elm$json$Json$Decode$string))
			]));
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		dataOrScript,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timestamp',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'feeAssetId',
				A3(
					$author$project$Governance$Voting$New$Data$when,
					$elm$core$Basics$eq(
						$elm$core$Maybe$Just('WAVES')),
					'feeAssetId should be \"WAVES\"',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'fee',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'senderPublicKey',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							A3(
								$author$project$Governance$Voting$New$Data$when,
								$elm$core$Basics$eq(2),
								'version should equals to 2',
								$elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								A3(
									$author$project$Governance$Voting$New$Data$when,
									function (v) {
										return (v === 12) || (v === 13);
									},
									'type 12 or 13 are only supported types',
									$elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed($author$project$Governance$Voting$New$Data$Payload))))))));
}();
var $author$project$Governance$Voting$Shared$Model$Defeated = 3;
var $author$project$Governance$Voting$Shared$Model$Discussion = 0;
var $author$project$Governance$Voting$Shared$Model$Failed = 7;
var $author$project$Governance$Voting$Shared$Model$InBlockchain = 6;
var $author$project$Governance$Voting$Shared$Model$NoQuorum = 2;
var $author$project$Governance$Voting$Shared$Model$Passed = 4;
var $author$project$Governance$Voting$Shared$Model$Retracted = 8;
var $author$project$Governance$Voting$Shared$Model$Voting = 1;
var $author$project$Governance$Voting$Shared$Model$WaitingForTx = 5;
var $author$project$Governance$Voting$Shared$Cmd$statusDecoder = function () {
	var map = function (s) {
		switch (s) {
			case 'discussion':
				return $elm$json$Json$Decode$succeed(0);
			case 'voting':
				return $elm$json$Json$Decode$succeed(1);
			case 'noQuorum':
				return $elm$json$Json$Decode$succeed(2);
			case 'votingFailed':
				return $elm$json$Json$Decode$succeed(3);
			case 'votingPassed':
				return $elm$json$Json$Decode$succeed(4);
			case 'waitingForTx':
				return $elm$json$Json$Decode$succeed(5);
			case 'inBlockchain':
				return $elm$json$Json$Decode$succeed(6);
			case 'failed':
				return $elm$json$Json$Decode$succeed(7);
			case 'retracted':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Unknown \'proposal_status\' value: ' + s);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		map,
		A2($elm$json$Json$Decode$field, 'proposal_status', $elm$json$Json$Decode$string));
}();
var $author$project$Governance$Voting$Shared$Model$Votes = F2(
	function (yes, no) {
		return {ja: no, lr: yes};
	});
var $author$project$Governance$Voting$Shared$Cmd$votesDecoder_ = function (prefix) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		prefix + 'no',
		$author$project$Shared$Json$bigInt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			prefix + 'yes',
			$author$project$Shared$Json$bigInt,
			$elm$json$Json$Decode$succeed($author$project$Governance$Voting$Shared$Model$Votes)));
};
var $author$project$Governance$Voting$Shared$Cmd$votesDecoder = $author$project$Governance$Voting$Shared$Cmd$votesDecoder_('proposal_');
var $author$project$Governance$Voting$Shared$Cmd$votingDecoder = $author$project$Governance$Voting$Shared$Cmd$startEndDecoder_('voting');
var $author$project$Governance$Voting$Proposal$Cmd$proposalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'proposal_by',
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'proposal_txheight',
		$elm$json$Json$Decode$maybe($author$project$Shared$Json$block),
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Governance$Voting$Shared$Cmd$votesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'proposal_gvires',
				$author$project$Shared$Json$bigInt,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Governance$Voting$Shared$Cmd$applyDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Governance$Voting$Shared$Cmd$votingDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'proposal_height',
							$author$project$Shared$Json$block,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'proposalUrl',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'proposedTx',
									$elm$json$Json$Decode$maybe($author$project$Governance$Voting$New$Data$payloadDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'title',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Governance$Voting$Shared$Cmd$statusDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'proposalId',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Governance$Voting$Proposal$Model$Proposal))))))))))))));
var $author$project$Governance$Voting$Proposal$Cmd$proposal = F3(
	function (_v0, msg, proposalId) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Governance$Voting$Proposal$Cmd$proposalDecoder),
				cN: api + ('/voting/proposal/' + proposalId)
			});
	});
var $author$project$Governance$Voting$Shared$Cmd$userVotesDecoder = $author$project$Governance$Voting$Shared$Cmd$votesDecoder_('');
var $author$project$Governance$Voting$Proposal$Cmd$votes = F4(
	function (_v0, msg, proposalId, _v1) {
		var api = _v0;
		var adr = _v1;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Governance$Voting$Shared$Cmd$userVotesDecoder),
				cN: api + ('/v2/user/' + (adr + ('/votes/' + proposalId)))
			});
	});
var $author$project$Governance$Voting$Proposal$Data$load = F3(
	function (api, user, proposalId) {
		var proposal = A3($author$project$Governance$Voting$Proposal$Cmd$proposal, api, $author$project$Governance$Voting$Proposal$Msg$GotProposal, proposalId);
		var _v0 = user.gV;
		if (!_v0.$) {
			var a = _v0.a;
			return _List_fromArray(
				[
					proposal,
					A4($author$project$Governance$Voting$Proposal$Cmd$votes, api, $author$project$Governance$Voting$Proposal$Msg$GotVotes, proposalId, a)
				]);
		} else {
			return _List_fromArray(
				[proposal]);
		}
	});
var $author$project$Governance$Voting$Proposal$Init$init = F3(
	function (api, user, proposalId) {
		var commands = A3($author$project$Governance$Voting$Proposal$Data$load, api, user, proposalId);
		return _Utils_Tuple2(
			{
				iG: $elm$core$List$length(commands),
				jy: $elm$core$Maybe$Nothing,
				jz: proposalId,
				k2: $elm$core$Maybe$Nothing,
				ld: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					$author$project$Port$scrollToTop(0),
					commands)));
	});
var $author$project$Governance$Voting$Proposals$Msg$GotFaq = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Voting$Proposals$Msg$GotProposals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$Proposals$Msg$GotVotes = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Logic$isLoggedIn = function (user) {
	return !_Utils_eq(user.gV, $elm$core$Maybe$Nothing);
};
var $author$project$Governance$Voting$Proposals$Model$Proposal = function (proposalId) {
	return function (status) {
		return function (title) {
			return function (url) {
				return function (height) {
					return function (voting) {
						return function (apply) {
							return function (gViresTotalHistorical) {
								return function (votes) {
									return function (appliedAt) {
										return {g$: appliedAt, g0: apply, ia: gViresTotalHistorical, $8: height, jz: proposalId, km: status, kB: title, cN: url, lb: votes, lc: voting};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Governance$Voting$Proposals$Cmd$decodeProposal = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'proposal_txheight',
	$elm$json$Json$Decode$maybe($author$project$Shared$Json$block),
	$elm$core$Maybe$Nothing,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Governance$Voting$Shared$Cmd$votesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'proposal_gvires',
			$author$project$Shared$Json$bigInt,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Governance$Voting$Shared$Cmd$applyDecoder,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Governance$Voting$Shared$Cmd$votingDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'proposal_height',
						$author$project$Shared$Json$block,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'proposalUrl',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'title',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$author$project$Governance$Voting$Shared$Cmd$statusDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'proposalId',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Governance$Voting$Proposals$Model$Proposal)))))))))));
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Governance$Voting$Proposals$Cmd$proposals = F2(
	function (_v0, msg) {
		var api = _v0;
		var blackList = $elm$core$List$filter(
			function (p) {
				return (p.jz !== '33aY4JdmoBcrmLUj6RugcgWuZUh23vq2852kZUMPJcSt') && (p.jz !== 'ExGZXLTvuu5eofZcFxQbw23cwvZ7cdnizZYhqziMVziX');
			});
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$map,
						blackList,
						$elm$json$Json$Decode$list($author$project$Governance$Voting$Proposals$Cmd$decodeProposal))),
				cN: api + '/voting/proposals'
			});
	});
var $author$project$Governance$Voting$Proposals$Cmd$votes = F3(
	function (_v0, msg, _v1) {
		var api = _v0;
		var adr = _v1;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$dict($author$project$Governance$Voting$Shared$Cmd$userVotesDecoder)),
				cN: api + ('/v2/user/' + (adr + '/votes'))
			});
	});
var $author$project$Governance$Voting$Proposals$Init$init = F4(
	function (api, resources, lang, user) {
		return _Utils_Tuple2(
			{
				h$: $elm$core$Maybe$Nothing,
				iG: A3(
					$author$project$Common$Base$iff,
					2,
					1,
					$author$project$User$Logic$isLoggedIn(user)),
				jA: _List_Nil,
				kb: false,
				k2: $elm$core$Dict$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Governance$Voting$Proposals$Cmd$proposals, api, $author$project$Governance$Voting$Proposals$Msg$GotProposals),
						A2(
						$author$project$Common$Cmd$try,
						A2($author$project$Governance$Voting$Proposals$Cmd$votes, api, $author$project$Governance$Voting$Proposals$Msg$GotVotes),
						user.gV),
						$author$project$Port$scrollToTop(0),
						A4($author$project$Shared$FAQ$Cmd$faq, 'voting', lang, resources, $author$project$Governance$Voting$Proposals$Msg$GotFaq)
					])));
	});
var $author$project$Governance$Voting$Navigation$navigate = F6(
	function (_v0, resources, lang, user, model, route) {
		var api = _v0.a;
		var nodeApi = _v0.b;
		var page = function () {
			switch (route.$) {
				case 0:
					var _v2 = A4($author$project$Governance$Voting$Proposals$Init$init, api, resources, lang, user);
					var m = _v2.a;
					var c = _v2.b;
					return _Utils_Tuple2(
						$author$project$Governance$Voting$Model$Proposals(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Voting$Msg$Proposals, c));
				case 1:
					var proposalId = route.a;
					var _v3 = A3($author$project$Governance$Voting$Proposal$Init$init, api, user, proposalId);
					var m = _v3.a;
					var c = _v3.b;
					return _Utils_Tuple2(
						$author$project$Governance$Voting$Model$Proposal(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Voting$Msg$Proposal, c));
				default:
					var _v4 = $author$project$Governance$Voting$New$Init$init;
					var m = _v4.a;
					var c = _v4.b;
					return _Utils_Tuple2(
						$author$project$Governance$Voting$Model$New(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Voting$Msg$New, c));
			}
		}();
		var pageModel = page.a;
		var pageCmd = page.b;
		if (!model.$) {
			var m = model.a;
			return _Utils_Tuple2(
				_Utils_update(
					m,
					{jo: pageModel}),
				pageCmd);
		} else {
			return A2($author$project$Governance$Voting$Init$init, api, page);
		}
	});
var $author$project$Governance$Navigation$navigate = F6(
	function (_v0, resources, lang, user, route, model) {
		var api = _v0.a;
		var nodeApi = _v0.b;
		var tab = function () {
			switch (route.$) {
				case 1:
					var _v2 = A2($author$project$Governance$MyVires$Init$init, api, user);
					var m = _v2.a;
					var c = _v2.b;
					return _Utils_Tuple2(
						$author$project$Governance$Model$MyVires(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Msg$MyVires, c));
				case 2:
					var r = route.a;
					var voting = function () {
						var _v4 = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.kt;
							},
							model);
						if ((!_v4.$) && (_v4.a.$ === 2)) {
							var v = _v4.a.a;
							return $elm$core$Maybe$Just(v);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var _v3 = A6(
						$author$project$Governance$Voting$Navigation$navigate,
						_Utils_Tuple2(api, nodeApi),
						resources,
						lang,
						user,
						voting,
						r);
					var m = _v3.a;
					var c = _v3.b;
					return _Utils_Tuple2(
						$author$project$Governance$Model$Voting(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Msg$Voting, c));
				default:
					var _v5 = A2($author$project$Governance$Info$Init$init, resources, lang);
					var m = _v5.a;
					var c = _v5.b;
					return _Utils_Tuple2(
						$author$project$Governance$Model$Info(m),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$Msg$Info, c));
			}
		}();
		var tabModel = tab.a;
		var tabCmd = tab.b;
		if (!model.$) {
			var m = model.a;
			return _Utils_Tuple2(
				_Utils_update(
					m,
					{kt: tabModel}),
				tabCmd);
		} else {
			return $author$project$Governance$Init$init(tab);
		}
	});
var $author$project$Navigation$navigate = F2(
	function (_v0, _v1) {
		var route = _v0.a;
		var fragment = _v0.b;
		var model = _v1.a;
		var cmd = _v1.b;
		var popup = function (f) {
			switch (f.$) {
				case 1:
					return _Utils_Tuple2(
						$author$project$Page$RaF($author$project$RaF$Init$init),
						$elm$core$Platform$Cmd$none);
				case 2:
					var activeTab = f.a;
					var _v9 = A2($author$project$Gateway$Init$init, activeTab, model.kZ);
					var p1 = _v9.a;
					var c1 = _v9.b;
					return _Utils_Tuple2(
						$author$project$Page$Gateway(p1),
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$Gateway, c1));
				default:
					var _v10 = $author$project$User$Connect$Init$init;
					var p1 = _v10.a;
					var c1 = _v10.b;
					return _Utils_Tuple2(
						$author$project$Page$Connect(p1),
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$Connect, c1));
			}
		};
		var page = F3(
			function (mapPage, mapMsg, _v7) {
				var m = _v7.a;
				var c = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jo: mapPage(m),
							j2: route
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, mapMsg, c),
								cmd
							])));
			});
		var nodeApi = model.h3.jb;
		var api = model.h3.g_;
		var home = A2(
			$elm$core$Basics$composeR,
			$author$project$Home$Init$init(api),
			A2(page, $author$project$Page$Home, $author$project$Msg$Home));
		var result = function () {
			if (_Utils_eq(model.j2, route)) {
				return $author$project$Common$Cmd$no(model);
			} else {
				switch (route.$) {
					case 0:
						return home(model.kZ);
					case 1:
						var address = route.a;
						var user = model.kZ;
						var userAs = _Utils_update(
							user,
							{
								gV: $elm$core$Maybe$Just(address)
							});
						var _v3 = home(userAs);
						var m = _v3.a;
						var c = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								m,
								{kZ: userAs}),
							c);
					case 2:
						var id = route.a;
						return A3(
							page,
							$author$project$Page$Market(id),
							$author$project$Msg$Market,
							$author$project$MarketDetail$Init$init);
					case 3:
						return A3(
							page,
							$author$project$Page$VToken,
							$author$project$Msg$VToken,
							A4($author$project$VToken$Init$init, api, model.jW, model.iz, model.kZ));
					case 4:
						return $author$project$Common$Cmd$no(model);
					default:
						var tabRoute = route.a;
						return A3(
							page,
							$author$project$Page$Governance,
							$author$project$Msg$Governance,
							A6(
								$author$project$Governance$Navigation$navigate,
								_Utils_Tuple2(api, nodeApi),
								model.jW,
								model.iz,
								model.kZ,
								tabRoute,
								function () {
									var _v4 = model.jo;
									if (_v4.$ === 3) {
										var g = _v4.a;
										return $elm$core$Maybe$Just(g);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()));
				}
			}
		}();
		var newModel = result.a;
		var commands = result.b;
		var _v5 = A2($elm$core$Maybe$map, popup, fragment);
		if (!_v5.$) {
			var _v6 = _v5.a;
			var p = _v6.a;
			var c = _v6.b;
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{
						jv: $elm$core$Maybe$Just(p)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[commands, c])));
		} else {
			return result;
		}
	});
var $author$project$Route$Home = {$: 0};
var $author$project$Route$As = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Governance = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$Market = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$VTokens = {$: 3};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {Q: frag, e: params, N: unvisited, gA: value, X: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.X;
		var unvisited = _v0.N;
		var params = _v0.e;
		var frag = _v0.Q;
		var value = _v0.gA;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.X;
			var unvisited = _v1.N;
			var params = _v1.e;
			var frag = _v1.Q;
			var value = _v1.gA;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Governance$Route$Info = {$: 0};
var $author$project$Governance$Route$My = {$: 1};
var $author$project$Governance$Route$Voting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$Route$New = {$: 2};
var $author$project$Governance$Voting$Route$Proposal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Route$Proposals = {$: 0};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.X;
		var unvisited = _v0.N;
		var params = _v0.e;
		var frag = _v0.Q;
		var value = _v0.gA;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.X;
			var unvisited = _v0.N;
			var params = _v0.e;
			var frag = _v0.Q;
			var value = _v0.gA;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Governance$Voting$Route$page = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Governance$Voting$Route$Proposals, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Governance$Voting$Route$New,
			$elm$url$Url$Parser$s('new')),
			A2($elm$url$Url$Parser$map, $author$project$Governance$Voting$Route$Proposal, $elm$url$Url$Parser$string)
		]));
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Governance$Route$page = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Governance$Route$Info, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Governance$Route$My,
			$elm$url$Url$Parser$s('my')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Governance$Route$Voting,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('vote'),
				$author$project$Governance$Voting$Route$page))
		]));
var $author$project$Route$url = {ic: 'governance', ij: '/', b0: 'markets', gD: 'vtokens'};
var $author$project$Route$page = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$As,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('prozor'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$VTokens,
			$elm$url$Url$Parser$s($author$project$Route$url.gD)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Market,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$url.b0),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Governance,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$url.ic),
				$author$project$Governance$Route$page))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.N;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.gA);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.gA);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.fo),
					$elm$url$Url$Parser$prepareQuery(url.fB),
					url.h7,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Connect = {$: 0};
var $author$project$Route$Gateway = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$RaF = {$: 1};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Route$popup = function (frag) {
	var _v0 = $elm$core$String$toLower(frag);
	switch (_v0) {
		case 'connect':
			return $elm$core$Maybe$Just($author$project$Route$Connect);
		case 'raf':
			return $elm$core$Maybe$Just($author$project$Route$RaF);
		case 'gateway':
			return $elm$core$Maybe$Just(
				$author$project$Route$Gateway(0));
		case 'gateway_history':
			return $elm$core$Maybe$Just(
				$author$project$Route$Gateway(3));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$route = function (u) {
	return _Utils_Tuple2(
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$Route$Home,
			A2($elm$url$Url$Parser$parse, $author$project$Route$page, u)),
		A2($elm$core$Maybe$andThen, $author$project$Route$popup, u.h7));
};
var $author$project$Msg$Broadcast = function (a) {
	return {$: 25, a: a};
};
var $author$project$Msg$Copied = function (a) {
	return {$: 23, a: a};
};
var $author$project$Msg$Error = function (a) {
	return {$: 16, a: a};
};
var $author$project$Msg$GotScreen = function (a) {
	return {$: 24, a: a};
};
var $author$project$Msg$Notify = function (a) {
	return {$: 26, a: a};
};
var $author$project$Msg$OperationSucceed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Msg$Refresh = {$: 15};
var $author$project$Msg$UpdateCollateralSucceed = function (a) {
	return {$: 18, a: a};
};
var $author$project$Msg$UpdateHeight = {$: 37};
var $author$project$Msg$VisibilityChange = function (a) {
	return {$: 31, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Port$broadcasted = _Platform_incomingPort('broadcasted', $elm$json$Json$Decode$string);
var $author$project$Common$Screen$gotWidth = _Platform_incomingPort('gotWidth', $elm$json$Json$Decode$int);
var $author$project$Common$Screen$changed = function (msg) {
	return $author$project$Common$Screen$gotWidth(
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, msg));
};
var $author$project$Port$copied = _Platform_incomingPort('copied', $elm$json$Json$Decode$string);
var $author$project$Port$error = _Platform_incomingPort('error', $elm$json$Json$Decode$string);
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {fy: processes, gg: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.fy;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.gg);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$User$Msg$GotItem = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$User$Msg$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$Msg$LoggedOut = {$: 2};
var $author$project$User$Msg$Succeed = {$: 9};
var $author$project$Port$gotItem = _Platform_incomingPort(
	'gotItem',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return $elm$json$Json$Decode$succeed(
						{iw: key, gA: value});
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'value',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $author$project$Port$gotItem2 = function (msg) {
	return $author$project$Port$gotItem(
		function (_v0) {
			var key = _v0.iw;
			var value = _v0.gA;
			return A2(msg, key, value);
		});
};
var $author$project$Port$loggedIn = _Platform_incomingPort('loggedIn', $elm$json$Json$Decode$string);
var $author$project$Port$loggedIn2 = function (msg) {
	return $author$project$Port$loggedIn(
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, msg));
};
var $author$project$Port$loggedOut = _Platform_incomingPort(
	'loggedOut',
	$elm$json$Json$Decode$null(0));
var $author$project$Shared$Wallet$Msg$LoggedIn = function (a) {
	return {$: 3, a: a};
};
var $author$project$Shared$Wallet$Msg$LoggedOut = {$: 4};
var $author$project$Shared$Wallet$Msg$NoOp = {$: 5};
var $author$project$Shared$Msg$Once = {$: 0};
var $author$project$Port$succeed = _Platform_incomingPort(
	'succeed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (command) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (assetId) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (amount) {
									return $elm$json$Json$Decode$succeed(
										{gZ: amount, g5: assetId, dD: command, bP: id});
								},
								A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int));
						},
						A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'command', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)));
var $author$project$Port$walletBalanceChanged = _Platform_incomingPort(
	'walletBalanceChanged',
	$elm$json$Json$Decode$null(0));
var $author$project$Shared$Wallet$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always(
				$author$project$Shared$Wallet$Msg$Refresh($author$project$Shared$Msg$Once))),
			$author$project$Port$loggedIn($author$project$Shared$Wallet$Msg$LoggedIn),
			$author$project$Port$walletBalanceChanged(
			$elm$core$Basics$always(
				$author$project$Shared$Wallet$Msg$Refresh($author$project$Shared$Msg$Once))),
			$author$project$Port$broadcasted(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$eq('wallet.refresh'),
				A2(
					$author$project$Common$Base$iff,
					$author$project$Shared$Wallet$Msg$Refresh($author$project$Shared$Msg$Once),
					$author$project$Shared$Wallet$Msg$NoOp))),
			$author$project$Port$loggedOut(
			$elm$core$Basics$always($author$project$Shared$Wallet$Msg$LoggedOut))
		]));
var $author$project$User$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$User$Msg$Succeed)),
			$author$project$Port$loggedIn2(
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$User$Msg$LoggedIn)),
			$author$project$Port$error(
			A2($elm$core$Basics$composeR, $elm$core$Result$Err, $author$project$User$Msg$LoggedIn)),
			$author$project$Port$loggedOut(
			$elm$core$Basics$always($author$project$User$Msg$LoggedOut)),
			A2($elm$core$Platform$Sub$map, $author$project$User$Msg$Wallet, $author$project$Shared$Wallet$Sub$subscriptions),
			$author$project$Port$gotItem2($author$project$User$Msg$GotItem)
		]));
var $author$project$Sub$layout = A2($elm$core$Platform$Sub$map, $author$project$Msg$User, $author$project$User$Sub$subscriptions);
var $Gizra$elm_compat_019$Time018$millisecond = 1;
var $Gizra$elm_compat_019$Time018$second = 1000 * $Gizra$elm_compat_019$Time018$millisecond;
var $Gizra$elm_compat_019$Time018$minute = 60 * $Gizra$elm_compat_019$Time018$second;
var $author$project$Port$notify = _Platform_incomingPort('notify', $elm$json$Json$Decode$string);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {fs: pids, f8: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {d3: event, iw: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.fs,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.iw;
		var event = _v0.d3;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.f8);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$withHidden = F2(
	function (func, isHidden) {
		return func(
			isHidden ? 1 : 0);
	});
var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
	var info = _Browser_visibilityInfo(0);
	return A3(
		$elm$browser$Browser$Events$on,
		0,
		info.ds,
		A2(
			$elm$json$Json$Decode$map,
			$elm$browser$Browser$Events$withHidden(func),
			A2(
				$elm$json$Json$Decode$field,
				'target',
				A2($elm$json$Json$Decode$field, info.ig, $elm$json$Json$Decode$bool))));
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Governance$Msg$Succeed = {$: 4};
var $author$project$Governance$MyVires$Msg$Delegate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$MyVires$Msg$LoggedIn = function (a) {
	return {$: 7, a: a};
};
var $author$project$Governance$MyVires$Msg$LoggedOut = {$: 6};
var $author$project$Governance$MyVires$Msg$Succeed = {$: 5};
var $author$project$Governance$MyVires$Delegate$Msg$AddressVerified = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Governance$MyVires$Delegate$Msg$Close = {$: 4};
var $author$project$Shared$Waves$Port$wavesAddressCorrect = _Platform_incomingPort('wavesAddressCorrect', $elm$json$Json$Decode$string);
var $author$project$Shared$Waves$Port$wavesAddressIncorrect = _Platform_incomingPort('wavesAddressIncorrect', $elm$json$Json$Decode$string);
var $author$project$Shared$Waves$Port$wavesAddressValidationResult = function (msg) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Shared$Waves$Port$wavesAddressCorrect(
				msg(true)),
				$author$project$Shared$Waves$Port$wavesAddressIncorrect(
				msg(false))
			]));
};
var $author$project$Governance$MyVires$Delegate$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Shared$Waves$Port$wavesAddressValidationResult($author$project$Governance$MyVires$Delegate$Msg$AddressVerified),
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$Governance$MyVires$Delegate$Msg$Close)),
			$author$project$Port$error(
			$elm$core$Basics$always($author$project$Governance$MyVires$Delegate$Msg$Close))
		]));
var $author$project$Governance$Revenue$Msg$AddressVerified = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Governance$Revenue$Msg$GotLsDelegators = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Governance$Revenue$Msg$LoggedIn = function (a) {
	return {$: 6, a: a};
};
var $author$project$Governance$Revenue$Msg$LoggedOut = {$: 5};
var $author$project$Governance$Revenue$Msg$Succeed = {$: 2};
var $author$project$Governance$Revenue$Msg$Update = {$: 11};
var $Gizra$elm_compat_019$Time018$hour = 60 * $Gizra$elm_compat_019$Time018$minute;
var $author$project$Governance$Revenue$Sub$updateInterval = $Gizra$elm_compat_019$Time018$hour;
var $author$project$Governance$Revenue$Sub$subscriptions = F2(
	function (visibility, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Port$succeed(
					$elm$core$Basics$always($author$project$Governance$Revenue$Msg$Succeed)),
					$author$project$Port$loggedOut(
					$elm$core$Basics$always($author$project$Governance$Revenue$Msg$LoggedOut)),
					$author$project$Port$loggedIn2($author$project$Governance$Revenue$Msg$LoggedIn),
					$author$project$Shared$Waves$Port$wavesAddressValidationResult($author$project$Governance$Revenue$Msg$AddressVerified),
					$author$project$Port$gotItem2($author$project$Governance$Revenue$Msg$GotLsDelegators),
					_Utils_eq(model.h8, $elm$core$Maybe$Nothing) ? $elm$core$Platform$Sub$none : ((visibility === 1) ? $elm$browser$Browser$Events$onVisibilityChange(
					$elm$core$Basics$always($author$project$Governance$Revenue$Msg$Update)) : A2(
					$elm$time$Time$every,
					$author$project$Governance$Revenue$Sub$updateInterval,
					$elm$core$Basics$always($author$project$Governance$Revenue$Msg$Update)))
				]));
	});
var $author$project$Governance$MyVires$Sub$subscriptions = F2(
	function (visibility, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Sub$map, $author$project$Governance$MyVires$Msg$Delegate, $author$project$Governance$MyVires$Delegate$Sub$subscriptions),
					$author$project$Port$succeed(
					$elm$core$Basics$always($author$project$Governance$MyVires$Msg$Succeed)),
					$author$project$Port$loggedOut(
					$elm$core$Basics$always($author$project$Governance$MyVires$Msg$LoggedOut)),
					$author$project$Port$loggedIn($author$project$Governance$MyVires$Msg$LoggedIn),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Governance$MyVires$Msg$Revenue,
					A2($author$project$Governance$Revenue$Sub$subscriptions, visibility, model.jZ))
				]));
	});
var $author$project$Governance$Voting$New$Msg$Error = {$: 5};
var $author$project$Governance$Voting$New$Msg$GotTxId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Governance$Voting$New$Msg$Propose = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$Voting$New$Port$gotDataTxId = _Platform_incomingPort('gotDataTxId', $elm$json$Json$Decode$string);
var $author$project$Governance$Voting$New$Propose$Msg$Succeed = {$: 2};
var $author$project$Governance$Voting$New$Propose$Sub$subscriptions = $author$project$Port$succeed(
	$elm$core$Basics$always($author$project$Governance$Voting$New$Propose$Msg$Succeed));
var $author$project$Common$Sub$try = function (map) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(map),
		$elm$core$Maybe$withDefault($elm$core$Platform$Sub$none));
};
var $author$project$Governance$Voting$New$Sub$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Governance$Voting$New$Msg$Propose,
				A2(
					$author$project$Common$Sub$try,
					$elm$core$Basics$always($author$project$Governance$Voting$New$Propose$Sub$subscriptions),
					model.jB)),
				$author$project$Port$error(
				$elm$core$Basics$always($author$project$Governance$Voting$New$Msg$Error)),
				$author$project$Governance$Voting$New$Port$gotDataTxId($author$project$Governance$Voting$New$Msg$GotTxId)
			]));
};
var $author$project$Governance$Voting$Proposal$Msg$Succeed = {$: 4};
var $author$project$Governance$Voting$Proposal$Msg$Vote = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$Msg$Error = {$: 3};
var $author$project$Governance$Voting$Proposal$Vote$Sub$subscriptions = $author$project$Port$error(
	$elm$core$Basics$always($author$project$Governance$Voting$Proposal$Vote$Msg$Error));
var $author$project$Governance$Voting$Proposal$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$Governance$Voting$Proposal$Msg$Succeed)),
			A2($elm$core$Platform$Sub$map, $author$project$Governance$Voting$Proposal$Msg$Vote, $author$project$Governance$Voting$Proposal$Vote$Sub$subscriptions)
		]));
var $author$project$Governance$Voting$Sub$subscriptions = function (model) {
	var _v0 = model.jo;
	switch (_v0.$) {
		case 1:
			return A2($elm$core$Platform$Sub$map, $author$project$Governance$Voting$Msg$Proposal, $author$project$Governance$Voting$Proposal$Sub$subscriptions);
		case 2:
			var m = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Governance$Voting$Msg$New,
				$author$project$Governance$Voting$New$Sub$subscriptions(m));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Governance$Sub$subscriptions = F2(
	function (visibility, model) {
		var tab = function () {
			var _v0 = model.kt;
			switch (_v0.$) {
				case 1:
					var v = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Governance$Msg$MyVires,
						A2($author$project$Governance$MyVires$Sub$subscriptions, visibility, v));
				case 2:
					var v = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Governance$Msg$Voting,
						$author$project$Governance$Voting$Sub$subscriptions(v));
				default:
					return $elm$core$Platform$Sub$none;
			}
		}();
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Port$succeed(
					$elm$core$Basics$always($author$project$Governance$Msg$Succeed)),
					tab
				]));
	});
var $author$project$Home$Msg$ChangeCollateral = function (a) {
	return {$: 9, a: a};
};
var $author$project$Home$Msg$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Home$Msg$LoggedOut = {$: 1};
var $author$project$Home$Msg$VisibilityChange = function (a) {
	return {$: 16, a: a};
};
var $author$project$Home$Msg$Error = {$: 12};
var $author$project$Home$Msg$Succeed = {$: 11};
var $author$project$Home$Sub$anyOperation = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$Home$Msg$Succeed)),
			$author$project$Port$error(
			$elm$core$Basics$always($author$project$Home$Msg$Error))
		]));
var $author$project$Home$ChangeCollateral$UpdateCollateralSucceed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$Model$isLoading = function (model) {
	return model.iG > 0;
};
var $author$project$Home$ChangeCollateral$updateCollateralSucceed = _Platform_incomingPort(
	'updateCollateralSucceed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (collateral) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (assetId) {
							return $elm$json$Json$Decode$succeed(
								{g5: assetId, r: collateral, bP: id});
						},
						A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'collateral', $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)));
var $author$project$Home$ChangeCollateral$subscriptions = function (model) {
	return $author$project$Shared$Model$isLoading(model) ? $author$project$Home$ChangeCollateral$updateCollateralSucceed($author$project$Home$ChangeCollateral$UpdateCollateralSucceed) : $elm$core$Platform$Sub$none;
};
var $author$project$Home$Vesting$Msg$Failed = {$: 9};
var $author$project$Home$Vesting$Msg$LoggedIn = function (a) {
	return {$: 10, a: a};
};
var $author$project$Home$Vesting$Msg$LoggedOut = {$: 11};
var $author$project$Home$Vesting$Msg$Succeed = {$: 8};
var $author$project$Home$Vesting$Msg$VisibilityChange = function (a) {
	return {$: 13, a: a};
};
var $author$project$Home$Vesting$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$Home$Vesting$Msg$Succeed)),
			$author$project$Port$loggedIn2($author$project$Home$Vesting$Msg$LoggedIn),
			$author$project$Port$loggedOut(
			$elm$core$Basics$always($author$project$Home$Vesting$Msg$LoggedOut)),
			$author$project$Port$error(
			$elm$core$Basics$always($author$project$Home$Vesting$Msg$Failed)),
			$elm$browser$Browser$Events$onVisibilityChange($author$project$Home$Vesting$Msg$VisibilityChange)
		]));
var $author$project$Home$Msg$Slides = function (a) {
	return {$: 7, a: a};
};
var $author$project$Home$Msg$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Common$Slides$NextFrom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Slides$subscriptions = function (model) {
	return (model.cl > 0) ? A2(
		$elm$time$Time$every,
		model.cl,
		$elm$core$Basics$always(
			$author$project$Common$Slides$NextFrom(model.ah))) : $elm$core$Platform$Sub$none;
};
var $author$project$Home$Sub$visible = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 15000, $author$project$Home$Msg$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Home$Msg$Slides,
				$author$project$Common$Slides$subscriptions(model))
			]));
};
var $author$project$Home$Sub$subscriptions = F2(
	function (visibility, model) {
		var operation = function () {
			var _v0 = model.jl;
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				var _v1 = _v0.a;
				var m = _v1.b;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Home$Msg$ChangeCollateral,
					$author$project$Home$ChangeCollateral$subscriptions(m));
			} else {
				return $elm$core$Platform$Sub$none;
			}
		}();
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Port$loggedIn(
					A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Home$Msg$LoggedIn)),
					$author$project$Port$loggedOut(
					$elm$core$Basics$always($author$project$Home$Msg$LoggedOut)),
					$author$project$Port$succeed(
					$elm$core$Basics$always(
						$author$project$Home$Msg$Refresh($author$project$Shared$Msg$Once))),
					operation,
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always($author$project$Home$Sub$anyOperation),
						model.jl)),
					A3(
					$author$project$Common$Base$iff,
					$author$project$Home$Sub$visible(model),
					$elm$core$Platform$Sub$none,
					!visibility),
					$elm$browser$Browser$Events$onVisibilityChange($author$project$Home$Msg$VisibilityChange),
					A2($elm$core$Platform$Sub$map, $author$project$Home$Msg$Vesting, $author$project$Home$Vesting$Sub$subscriptions)
				]));
	});
var $author$project$MarketDetail$Msg$GotValue = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$MarketDetail$Sub$subscriptions = $author$project$Port$gotItem2($author$project$MarketDetail$Msg$GotValue);
var $author$project$VToken$Msg$GotItem = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$VToken$Msg$LoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Msg$LoggedOut = {$: 2};
var $author$project$VToken$Msg$OperationSucceed = {$: 5};
var $author$project$VToken$Vesting$Msg$OperationSucceed = {$: 4};
var $author$project$VToken$Vesting$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$VToken$Vesting$Msg$OperationSucceed))
		]));
var $author$project$VToken$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$loggedIn(
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$VToken$Msg$LoggedIn)),
			$author$project$Port$loggedOut(
			$elm$core$Basics$always($author$project$VToken$Msg$LoggedOut)),
			$author$project$Port$succeed(
			$elm$core$Basics$always($author$project$VToken$Msg$OperationSucceed)),
			$author$project$Port$gotItem2($author$project$VToken$Msg$GotItem),
			A2($elm$core$Platform$Sub$map, $author$project$VToken$Msg$Vesting, $author$project$VToken$Vesting$Sub$subscriptions)
		]));
var $author$project$Sub$page = function (model) {
	var _v0 = model.jo;
	switch (_v0.$) {
		case 0:
			var m = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$Home,
				A2($author$project$Home$Sub$subscriptions, model.la, m));
		case 2:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$VToken, $author$project$VToken$Sub$subscriptions);
		case 1:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$Market, $author$project$MarketDetail$Sub$subscriptions);
		case 3:
			var m = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$Governance,
				A2($author$project$Governance$Sub$subscriptions, model.la, m));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Gateway$Shared$Model$GatewayAccessTokens = $elm$core$Basics$identity;
var $author$project$Gateway$Msg$GotGatewayCredentials = function (a) {
	return {$: 5, a: a};
};
var $author$project$Gateway$Port$gotGatewayCredentials = _Platform_incomingPort('gotGatewayCredentials', $elm$json$Json$Decode$string);
var $author$project$Gateway$Send$Msg$GotBitcoinValidation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Gateway$Send$Msg$GotError = {$: 9};
var $author$project$Gateway$Send$Msg$SendStarted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Gateway$Send$Port$gatewayWithdrawSucceed = _Platform_incomingPort(
	'gatewayWithdrawSucceed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (platform) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (assetId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (amount) {
							return $elm$json$Json$Decode$succeed(
								{gZ: amount, g5: assetId, ju: platform});
						},
						A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'platform', $elm$json$Json$Decode$string)));
var $author$project$Gateway$Send$Port$gotBitcoinAddressValidationResult = _Platform_incomingPort(
	'gotBitcoinAddressValidationResult',
	A2(
		$elm$json$Json$Decode$andThen,
		function (valid) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (address) {
					return $elm$json$Json$Decode$succeed(
						{gV: address, gz: valid});
				},
				A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'valid', $elm$json$Json$Decode$bool)));
var $author$project$Gateway$Send$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Gateway$Send$Port$gotBitcoinAddressValidationResult($author$project$Gateway$Send$Msg$GotBitcoinValidation),
			$author$project$Gateway$Send$Port$gatewayWithdrawSucceed($author$project$Gateway$Send$Msg$SendStarted),
			$author$project$Port$error(
			$elm$core$Basics$always($author$project$Gateway$Send$Msg$GotError))
		]));
var $author$project$Gateway$Topup$Msg$GotError = {$: 11};
var $author$project$Gateway$Topup$Msg$GotEthereumWalletBalance = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Gateway$Topup$Msg$GotEthereumWalletInstalled = function (a) {
	return {$: 8, a: a};
};
var $author$project$Gateway$Topup$Msg$Web3DepositStarted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Gateway$Topup$Port$gotEthereumWalletBalance = _Platform_incomingPort(
	'gotEthereumWalletBalance',
	A2(
		$elm$json$Json$Decode$andThen,
		function (currency) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (balance) {
					return $elm$json$Json$Decode$succeed(
						{db: balance, hv: currency});
				},
				A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int));
		},
		A2(
			$elm$json$Json$Decode$field,
			'currency',
			A2(
				$elm$json$Json$Decode$andThen,
				function (status) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (platform) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (limits) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (id) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (fees) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (decimals) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (assetId) {
																	return $elm$json$Json$Decode$succeed(
																		{g5: assetId, hC: decimals, h2: fees, bP: id, iC: limits, ju: platform, km: status});
																},
																A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int));
												},
												A2(
													$elm$json$Json$Decode$field,
													'fees',
													A2(
														$elm$json$Json$Decode$andThen,
														function (rate) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (flat) {
																	return $elm$json$Json$Decode$succeed(
																		{h4: flat, jH: rate});
																},
																A2($elm$json$Json$Decode$field, 'flat', $elm$json$Json$Decode$float));
														},
														A2($elm$json$Json$Decode$field, 'rate', $elm$json$Json$Decode$float))));
										},
										A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
								},
								A2(
									$elm$json$Json$Decode$field,
									'limits',
									A2(
										$elm$json$Json$Decode$andThen,
										function (min) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (max) {
													return $elm$json$Json$Decode$succeed(
														{iU: max, i_: min});
												},
												A2($elm$json$Json$Decode$field, 'max', $elm$json$Json$Decode$float));
										},
										A2($elm$json$Json$Decode$field, 'min', $elm$json$Json$Decode$float))));
						},
						A2($elm$json$Json$Decode$field, 'platform', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)))));
var $author$project$Shared$Etherium$Port$gotEthereumWalletInstalled = _Platform_incomingPort('gotEthereumWalletInstalled', $elm$json$Json$Decode$bool);
var $author$project$Gateway$Topup$Port$web3DepositSucceed = _Platform_incomingPort(
	'web3DepositSucceed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (platform) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (assetId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (amount) {
							return $elm$json$Json$Decode$succeed(
								{gZ: amount, g5: assetId, ju: platform});
						},
						A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'assetId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'platform', $elm$json$Json$Decode$string)));
var $author$project$Gateway$Topup$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Shared$Etherium$Port$gotEthereumWalletInstalled($author$project$Gateway$Topup$Msg$GotEthereumWalletInstalled),
			$author$project$Gateway$Topup$Port$gotEthereumWalletBalance(
			function (b) {
				return A2($author$project$Gateway$Topup$Msg$GotEthereumWalletBalance, b.hv.g5, b.db);
			}),
			$author$project$Gateway$Topup$Port$web3DepositSucceed($author$project$Gateway$Topup$Msg$Web3DepositStarted),
			$author$project$Port$error(
			$elm$core$Basics$always($author$project$Gateway$Topup$Msg$GotError))
		]));
var $author$project$Gateway$Sub$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Gateway$Port$gotGatewayCredentials(
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Gateway$Msg$GotGatewayCredentials)),
			A2($elm$core$Platform$Sub$map, $author$project$Gateway$Msg$Send, $author$project$Gateway$Send$Sub$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Gateway$Msg$Topup, $author$project$Gateway$Topup$Sub$subscriptions)
		]));
var $author$project$User$Connect$Msg$GotTermsAccepted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$User$Connect$Msg$KeeperInstalled = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Connect$Msg$MetaMaskInstalled = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Connect$Port$keeperInstalled = _Platform_incomingPort('keeperInstalled', $elm$json$Json$Decode$bool);
var $author$project$User$Connect$Sub$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Port$gotItem2($author$project$User$Connect$Msg$GotTermsAccepted),
				model.iv ? $elm$core$Platform$Sub$none : $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$time$Time$every,
						$Gizra$elm_compat_019$Time018$second,
						$elm$core$Basics$always($author$project$User$Connect$Msg$CheckKeeper)),
						$author$project$User$Connect$Port$keeperInstalled($author$project$User$Connect$Msg$KeeperInstalled)
					])),
				model.iW ? $elm$core$Platform$Sub$none : $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$time$Time$every,
						1.2 * $Gizra$elm_compat_019$Time018$second,
						$elm$core$Basics$always($author$project$User$Connect$Msg$CheckMetamask)),
						$author$project$Shared$Etherium$Port$gotEthereumWalletInstalled($author$project$User$Connect$Msg$MetaMaskInstalled)
					]))
			]));
};
var $author$project$Sub$popup = function (model) {
	var _v0 = model.jv;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 2:
					return A2($elm$core$Platform$Sub$map, $author$project$Msg$Gateway, $author$project$Gateway$Sub$subscriptions);
				case 0:
					var m = _v0.a.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Msg$Connect,
						$author$project$User$Connect$Sub$subscriptions(m));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Platform$Sub$none;
};
var $author$project$Sub$subscriptions = function (model) {
	var refreshHeight = $elm$core$Basics$always($author$project$Msg$UpdateHeight);
	var refreshActiveVoting = $elm$core$Basics$always($author$project$Msg$UpdateActiveVoting);
	var refresh = $elm$core$Basics$always($author$project$Msg$Refresh);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Port$error($author$project$Msg$Error),
				$author$project$Sub$layout,
				$author$project$Sub$page(model),
				$author$project$Sub$popup(model),
				$author$project$Port$succeed($author$project$Msg$OperationSucceed),
				$author$project$Home$ChangeCollateral$updateCollateralSucceed($author$project$Msg$UpdateCollateralSucceed),
				$author$project$Port$copied($author$project$Msg$Copied),
				$author$project$Common$Screen$changed($author$project$Msg$GotScreen),
				$author$project$Port$broadcasted($author$project$Msg$Broadcast),
				$author$project$Port$notify($author$project$Msg$Notify),
				$elm$browser$Browser$Events$onVisibilityChange($author$project$Msg$VisibilityChange),
				(!model.la) ? $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$time$Time$every, $Gizra$elm_compat_019$Time018$minute, refresh),
						A2($elm$time$Time$every, $Gizra$elm_compat_019$Time018$minute, refreshHeight),
						A2($elm$time$Time$every, $Gizra$elm_compat_019$Time018$minute * 5, refreshActiveVoting)
					])) : $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onVisibilityChange(refresh),
						$elm$browser$Browser$Events$onVisibilityChange(refreshHeight),
						$elm$browser$Browser$Events$onVisibilityChange(refreshActiveVoting)
					]))
			]));
};
var $author$project$Toast$Copied = function (a) {
	return {$: 5, a: a};
};
var $author$project$Toast$Error = function (a) {
	return {$: 4, a: a};
};
var $author$project$Toast$Gateway = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$GotActiveVoting = function (a) {
	return {$: 38, a: a};
};
var $author$project$Msg$GotGovernance = function (a) {
	return {$: 29, a: a};
};
var $author$project$Msg$GotHeight = function (a) {
	return {$: 36, a: a};
};
var $author$project$Msg$GotHistoricalHeightTime = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Msg$GotMarketsStates = function (a) {
	return {$: 14, a: a};
};
var $author$project$Msg$GotNewRates = function (a) {
	return {$: 13, a: a};
};
var $author$project$Msg$GotRates = function (a) {
	return {$: 12, a: a};
};
var $author$project$Msg$GotViresMarket = function (a) {
	return {$: 11, a: a};
};
var $author$project$Toast$Info = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$LanguageLoaded = function (a) {
	return {$: 28, a: a};
};
var $author$project$Msg$RaF = function (a) {
	return {$: 22, a: a};
};
var $author$project$Gateway$Toast$SentFromWaves = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$ToastyMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Gateway$Toast$TopUpWaves = function (a) {
	return {$: 0, a: a};
};
var $author$project$Toast$TransactionSucceed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Toast$UpdatedCollateralSucceed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Cmd$active = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2($elm$json$Json$Decode$map, $author$project$Common$Maybe$nothingIfZero, $elm$json$Json$Decode$int)),
				cN: api + '/voting/active'
			});
	});
var $pablen$toasty$Toasty$Temporary = 0;
var $pablen$toasty$Toasty$Entered = 0;
var $pablen$toasty$Toasty$TransitionOut = function (a) {
	return {$: 2, a: a};
};
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $pablen$toasty$Toasty$getNewId = function (seed) {
	return A2(
		$elm$random$Random$step,
		A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt),
		seed);
};
var $pablen$toasty$Toasty$addToast_ = F5(
	function (removeBehaviour, _v0, tagger, toast, _v1) {
		var cfg = _v0;
		var model = _v1.a;
		var cmd = _v1.b;
		var _v2 = model.kJ;
		var toasts = _v2.a;
		var seed = _v2.b;
		var _v3 = $pablen$toasty$Toasty$getNewId(seed);
		var newId = _v3.a;
		var newSeed = _v3.b;
		var task = function () {
			if (!removeBehaviour) {
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return tagger(
							$pablen$toasty$Toasty$TransitionOut(newId));
					},
					$elm$core$Process$sleep(cfg.bC));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					kJ: A2(
						$pablen$toasty$Toasty$Stack,
						_Utils_ap(
							toasts,
							_List_fromArray(
								[
									_Utils_Tuple3(newId, 0, toast)
								])),
						newSeed)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, task])));
	});
var $pablen$toasty$Toasty$addToast = $pablen$toasty$Toasty$addToast_(0);
var $author$project$Port$closeDucks = _Platform_outgoingPort(
	'closeDucks',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $pablen$toasty$Toasty$Config = $elm$core$Basics$identity;
var $pablen$toasty$Toasty$config = {br: _List_Nil, bC: 5000, bY: _List_Nil, cI: _List_Nil, cJ: _List_Nil, cK: 0};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Common$Toast$containerAttrs = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
		A2($elm$html$Html$Attributes$style, 'top', '0'),
		A2($elm$html$Html$Attributes$style, 'right', '0'),
		A2($elm$html$Html$Attributes$style, 'width', '350px'),
		A2($elm$html$Html$Attributes$style, 'list-style-type', 'none'),
		A2($elm$html$Html$Attributes$style, 'padding', '0'),
		A2($elm$html$Html$Attributes$style, 'margin', '0'),
		A2($elm$html$Html$Attributes$style, 'z-index', '1000')
	]);
var $pablen$toasty$Toasty$containerAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{br: attrs});
	});
var $pablen$toasty$Toasty$delay = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{bC: time});
	});
var $author$project$Common$Toast$itemAttrs = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'margin', '1em 1em 0 1em'),
		A2($elm$html$Html$Attributes$style, 'max-height', '100px'),
		A2($elm$html$Html$Attributes$style, 'transition', 'max-height 0.6s, margin-top 0.6s')
	]);
var $pablen$toasty$Toasty$itemAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{bY: attrs});
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Common$Toast$transitionInAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated bounceInRight')
	]);
var $pablen$toasty$Toasty$transitionInAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{cI: attrs});
	});
var $author$project$Common$Toast$transitionOutAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated fadeOutRightBig'),
		A2($elm$html$Html$Attributes$style, 'max-height', '0'),
		A2($elm$html$Html$Attributes$style, 'margin-top', '0')
	]);
var $pablen$toasty$Toasty$transitionOutAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{cJ: attrs});
	});
var $pablen$toasty$Toasty$transitionOutDuration = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{cK: time});
	});
var $author$project$Common$Toast$config = A2(
	$pablen$toasty$Toasty$delay,
	10000,
	A2(
		$pablen$toasty$Toasty$itemAttrs,
		$author$project$Common$Toast$itemAttrs,
		A2(
			$pablen$toasty$Toasty$containerAttrs,
			$author$project$Common$Toast$containerAttrs,
			A2(
				$pablen$toasty$Toasty$transitionInAttrs,
				$author$project$Common$Toast$transitionInAttrs,
				A2(
					$pablen$toasty$Toasty$transitionOutAttrs,
					$author$project$Common$Toast$transitionOutAttrs,
					A2($pablen$toasty$Toasty$transitionOutDuration, 700, $pablen$toasty$Toasty$config))))));
var $author$project$Common$List$getBy = F3(
	function (mapKey, key, list) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					mapKey,
					$elm$core$Basics$eq(key)),
				list));
	});
var $author$project$Governance$Model$Governance = F2(
	function (staked, gVires) {
		return {bH: gVires, f3: staked};
	});
var $author$project$Governance$Cmd$decodeGovernance = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Governance$Model$Governance,
	A2($elm$json$Json$Decode$field, 'totalDepositedTokens', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'totalGvires', $author$project$Shared$Json$bigInt));
var $author$project$Governance$Cmd$governance = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Governance$Cmd$decodeGovernance),
				cN: api + '/v2/gov'
			});
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Shared$Update$loaded = function (model) {
	return _Utils_update(
		model,
		{iG: model.iG - 1});
};
var $author$project$Shared$Update$log = F2(
	function (err, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					jP: A2($elm$core$List$cons, err, model.jP)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Shared$Market$Model$MarketState = F9(
	function (supply, protectedSupply, lockedSupplyLP, lockedWeightedLP, borrow, vTokenCirculation, reserve, depositRewardSpeed, lockedRewardSpeed) {
		return {dk: borrow, hG: depositRewardSpeed, iK: lockedRewardSpeed, iL: lockedSupplyLP, iM: lockedWeightedLP, jD: protectedSupply, jS: reserve, gb: supply, k4: vTokenCirculation};
	});
var $author$project$Cmd$marketDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lpRewardSpeed',
	$author$project$Shared$Json$bigInt,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'depositRewardSpeed',
		$author$project$Shared$Json$bigInt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reserve',
			$author$project$Shared$Json$bigInt,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vTokenCirculation',
				$author$project$Shared$Json$bigInt,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'borrow',
					$author$project$Shared$Json$bigInt,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'totalLpLockedWeighted',
						$author$project$Shared$Json$bigInt,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'totalLpLocked',
							$author$project$Shared$Json$bigInt,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'protectedSupply',
								$author$project$Shared$Json$bigInt,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'supply',
									$author$project$Shared$Json$bigInt,
									$elm$json$Json$Decode$succeed($author$project$Shared$Market$Model$MarketState))))))))));
var $author$project$Cmd$markets = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$dict($author$project$Cmd$marketDecoder)),
				cN: api + '/markets'
			});
	});
var $author$project$Cmd$Rate$newRate = function (msg) {
	return $elm$http$Http$get(
		{
			bF: A2(
				$elm$http$Http$expectJson,
				msg,
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$float)),
			cN: $author$project$Cmd$NewApi$newApi + '/rates/waves'
		});
};
var $author$project$Common$Time$now = function (msg) {
	return A2($elm$core$Task$perform, msg, $elm$time$Time$now);
};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Shared$Market$Logic$marketOrder = _List_fromArray(
	['WAVES', 'XTN', 'USDT', 'USDC', 'DAI', 'BUSD', 'EURN', 'BTC', 'ETH']);
var $author$project$Shared$Asset$Logic$simpleName = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split($author$project$Shared$Text$nonBreakingHyphen),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		$elm$core$Maybe$withDefault('')));
var $author$project$Shared$Market$Logic$order = function (m) {
	var asset = A2(
		$elm$core$Maybe$withDefault,
		9999,
		A2(
			$elm_community$list_extra$List$Extra$elemIndex,
			$author$project$Shared$Asset$Logic$simpleName(m.bh.ac),
			$author$project$Shared$Market$Logic$marketOrder));
	return m.iB ? (asset + 99999) : asset;
};
var $author$project$Shared$Update$page = F4(
	function (model, mapPage, mapMsg, _v0) {
		var m = _v0.a;
		var c = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					jo: mapPage(m)
				}),
			A2($elm$core$Platform$Cmd$map, mapMsg, c));
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Cmd$Rate$rate = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$dict($author$project$Shared$Json$bigInt)),
				cN: api + '/rates'
			});
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Port$setItem = _Platform_outgoingPort(
	'setItem',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string($.iw)),
					_Utils_Tuple2(
					'value',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.gA))
				]));
	});
var $author$project$Port$setItem2 = F2(
	function (key, value) {
		return $author$project$Port$setItem(
			{iw: key, gA: value});
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.fz;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.h7,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.fB,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ft,
					_Utils_ap(http, url.eu)),
				url.fo)));
};
var $author$project$Shared$Webpack$map = F2(
	function (mapping, url) {
		return A2(
			$elm$core$Maybe$withDefault,
			url,
			A2($author$project$Shared$Webpack$get, mapping, url));
	});
var $author$project$Cmd$translation = F3(
	function (msg, _v0, webPackMapping) {
		var lang = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $ChristophP$elm_i18next$I18Next$translationsDecoder),
				cN: A2($author$project$Shared$Webpack$map, webPackMapping, 'languages/' + (lang + '.json'))
			});
	});
var $author$project$Gateway$Msg$Movements = function (a) {
	return {$: 3, a: a};
};
var $author$project$Gateway$Msg$TabChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Gateway$Topup$Msg$UpdateGateway = {$: 3};
var $author$project$Gateway$Send$Msg$UpdateProxy = {$: 1};
var $author$project$Gateway$Port$authorizeGateway = _Platform_outgoingPort('authorizeGateway', $elm$json$Json$Encode$string);
var $author$project$Gateway$Movements$Msg$CanRefresh = {$: 2};
var $author$project$Gateway$Movements$Msg$GotMovements = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Time$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time)));
	});
var $author$project$Shared$Update$loading = function (model) {
	return _Utils_update(
		model,
		{iG: model.iG + 1});
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Common$Http$bearer = function (accessToken) {
	return A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken);
};
var $author$project$Gateway$Movements$Model$Movement = function (id) {
	return function (direction) {
		return function (status) {
			return function (from) {
				return function (to) {
					return function (currency) {
						return function (amount) {
							return function (fee) {
								return function (transactions) {
									return function (created) {
										return {gZ: amount, hr: created, hv: currency, hJ: direction, h0: fee, h8: from, bP: id, km: status, kC: to, kS: transactions};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.jw) + (' at row ' + ($elm$core$String$fromInt(deadend.fP) + (', col ' + $elm$core$String$fromInt(deadend.dB))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {dB: col, hp: contextStack, jw: problem, fP: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.fP, s.dB, x, s.g));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.cs),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.cs);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{dB: col, g: s0.g, h: s0.h, c: offset, fP: row, cs: s0.cs});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.fP, s.dB, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.cs),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.cs);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dB: 1, g: s.g, h: s.h, c: s.c + 1, fP: s.fP + 1, cs: s.cs}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dB: s.dB + 1, g: s.g, h: s.h, c: newOffset, fP: s.fP, cs: s.cs}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.fP, s.dB, s.cs);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dB: newCol, g: s.g, h: s.h, c: newOffset, fP: newRow, cs: s.cs});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dB: col, jw: problem, fP: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.fP, p.dB, p.jw);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dB: 1, g: _List_Nil, h: 1, c: 0, fP: 1, cs: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gateway$Movements$Cmd$decodeMovement = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'transactions',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'transaction_id', $elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fee',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'currency_id',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'destination_platform_id',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'source_platform_id',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'direction',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Gateway$Movements$Model$Movement)))))))))));
var $author$project$Gateway$Movements$Cmd$movements = F2(
	function (msg, _v0) {
		var accessToken = _v0;
		return $elm$http$Http$request(
			{
				dj: $elm$http$Http$emptyBody,
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'items',
						$elm$json$Json$Decode$list($author$project$Gateway$Movements$Cmd$decodeMovement))),
				ie: _List_fromArray(
					[
						$author$project$Common$Http$bearer(accessToken)
					]),
				iX: 'GET',
				kz: $elm$core$Maybe$Nothing,
				kR: $elm$core$Maybe$Nothing,
				cN: $author$project$Gateway$Shared$Cmd$api + '/movements?limit=100'
			});
	});
var $author$project$Gateway$Movements$Update$update = F3(
	function (credentials, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var movements = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loaded(
							_Utils_update(
								model,
								{hd: false, i5: movements})),
						A2($author$project$Common$Time$delay, 10000, $author$project$Gateway$Movements$Msg$CanRefresh));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 2:
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{hd: true}));
			default:
				return _Utils_Tuple2(
					$author$project$Shared$Update$loading(
						_Utils_update(
							model,
							{i5: _List_Nil})),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							$author$project$Gateway$Movements$Cmd$movements($author$project$Gateway$Movements$Msg$GotMovements),
							credentials)));
		}
	});
var $author$project$Gateway$Send$Msg$GotProxyAddress = function (a) {
	return {$: 2, a: a};
};
var $ChristophP$elm_i18next$I18Next$Curly = {$: 0};
var $ChristophP$elm_i18next$I18Next$delimsToTuple = function (delims) {
	switch (delims.$) {
		case 0:
			return _Utils_Tuple2('{{', '}}');
		case 1:
			return _Utils_Tuple2('__', '__');
		default:
			var tuple = delims.a;
			return tuple;
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $ChristophP$elm_i18next$I18Next$replacePlaceholders = F3(
	function (replacements, delims, str) {
		var _v0 = $ChristophP$elm_i18next$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			str,
			replacements);
	});
var $ChristophP$elm_i18next$I18Next$trf = F4(
	function (translationsList, delims, key, replacements) {
		trf:
		while (true) {
			if (translationsList.b) {
				var translations = translationsList.a;
				var rest = translationsList.b;
				var _v1 = A2($elm$core$Dict$get, key, translations);
				if (!_v1.$) {
					var str = _v1.a;
					return A3($ChristophP$elm_i18next$I18Next$replacePlaceholders, replacements, delims, str);
				} else {
					var $temp$translationsList = rest,
						$temp$delims = delims,
						$temp$key = key,
						$temp$replacements = replacements;
					translationsList = $temp$translationsList;
					delims = $temp$delims;
					key = $temp$key;
					replacements = $temp$replacements;
					continue trf;
				}
			} else {
				return key;
			}
		}
	});
var $author$project$Translations$Validation$addressIsInvalid = F2(
	function (translations, platform) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'validation.addressIsInvalid',
			_List_fromArray(
				[
					_Utils_Tuple2('platform', platform)
				]));
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {io: index, ar: match, jg: number, cy: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{he: false, i6: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $cmditch$elm_ethereum$Eth$Utils$isAddress = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^((0[Xx]){1})?[0-9A-Fa-f]{40}$')));
var $author$project$Translations$Gateway$Withdraw$noDestinationAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'gateway.withdraw.noDestinationAddress');
};
var $author$project$Gateway$Shared$View$platformName = function (platform) {
	switch (platform) {
		case 'ETH':
			return 'Ethereum blockchain';
		case 'BTC':
			return 'Bitcoin blockchain';
		case 'BSC':
			return 'Binance Smart Chain';
		default:
			return platform;
	}
};
var $elm$core$String$trim = _String_trim;
var $author$project$Translations$Gateway$validating = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'gateway.validating');
};
var $author$project$Gateway$Send$Validate$address = F2(
	function (t, model) {
		if ($elm$core$String$isEmpty(
			$elm$core$String$trim(model.k0))) {
			return $elm$core$Maybe$Just(
				$author$project$Translations$Gateway$Withdraw$noDestinationAddress(t));
		} else {
			var _v0 = model.hv;
			if (!_v0.$) {
				var platform = _v0.a.ju;
				var invalid = function (_v3) {
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Translations$Validation$addressIsInvalid,
							t,
							$author$project$Gateway$Shared$View$platformName(platform)));
				};
				var isEthAddress = function (adr) {
					return $cmditch$elm_ethereum$Eth$Utils$isAddress(adr) ? $elm$core$Maybe$Nothing : invalid(0);
				};
				switch (platform) {
					case 'ETH':
						return isEthAddress(model.k0);
					case 'BSC':
						return isEthAddress(model.k0);
					case 'BTC':
						var _v2 = model.hc;
						if (!_v2.$) {
							if (_v2.a) {
								return $elm$core$Maybe$Nothing;
							} else {
								return invalid(0);
							}
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Translations$Gateway$validating(t));
						}
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Shared$Update$dirty = function (model) {
	return _Utils_update(
		model,
		{hK: true});
};
var $author$project$Shared$Asset$Model$waves = {hC: 8, bP: 'WAVES', iP: 'WAVES', e0: 100000, ac: 'WAVES'};
var $author$project$Shared$Transaction$Logic$fee = {dJ: 10, fT: $author$project$Shared$Asset$Model$waves.e0 * 5, gq: $author$project$Shared$Asset$Model$waves.e0};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Shared$Asset$Model$isWaves = $elm$core$Basics$eq($author$project$Shared$Asset$Model$waves.bP);
var $author$project$Shared$Transaction$Logic$feeInAsset = F2(
	function (asset, feeInWaves) {
		return $author$project$Shared$Asset$Model$isWaves(asset.bP) ? feeInWaves : $elm$core$Basics$round((feeInWaves / $author$project$Shared$Asset$Model$waves.e0) * asset.e0);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Shared$Wallet$Logic$wallet = F2(
	function (assetId, walletData) {
		return _Utils_eq(assetId, $author$project$Shared$Asset$Model$waves.bP) ? walletData.gF : A2($elm$core$Dict$get, assetId, walletData.g6);
	});
var $author$project$Shared$Transaction$Logic$isEnoughFee = F3(
	function (wallets, feeInWaves, asset) {
		var _v0 = A2($author$project$Shared$Wallet$Logic$wallet, asset.bP, wallets);
		if (!_v0.$) {
			var b = _v0.a;
			return _Utils_cmp(
				b,
				A2($author$project$Shared$Transaction$Logic$feeInAsset, asset, feeInWaves)) > -1;
		} else {
			return false;
		}
	});
var $author$project$User$Logic$isMetaMask = function (_v0) {
	var s = _v0;
	return s === 'metamask';
};
var $author$project$Shared$Transaction$Logic$defaultAssetForFee = F4(
	function (assets, user, preferredAsset, feeInWaves) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2($author$project$Shared$Transaction$Logic$isEnoughFee, user.lh, feeInWaves),
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, user.iN)) ? _List_fromArray(
				[$author$project$Shared$Asset$Model$waves]) : A2(
				$elm$core$List$cons,
				$author$project$Shared$Asset$Model$waves,
				A2($elm$core$List$cons, preferredAsset, assets)));
	});
var $Gizra$elm_compat_019$Basics018$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Common$List$getById = $author$project$Common$List$getBy(
	function ($) {
		return $.bP;
	});
var $author$project$Shared$Transaction$Logic$feeAsset = F5(
	function (assets, user, preferredAsset, feeInWaves, userSelectedFeeAssetId) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			A2($Gizra$elm_compat_019$Basics018$flip, $author$project$Common$List$getById, assets),
			userSelectedFeeAssetId);
		if (_v0.$ === 1) {
			return A4($author$project$Shared$Transaction$Logic$defaultAssetForFee, assets, user, preferredAsset, feeInWaves);
		} else {
			var userSelected = _v0;
			return userSelected;
		}
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Shared$Market$Logic$inOrigNoCheck = F2(
	function (a, notDenominated) {
		return notDenominated / A2($elm$core$Basics$pow, 10, a.hC);
	});
var $author$project$Shared$Market$Logic$inOrig = F2(
	function (a, notDenominated) {
		return (!notDenominated) ? 0 : A2($author$project$Shared$Market$Logic$inOrigNoCheck, a, notDenominated);
	});
var $ChristophP$elm_i18next$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$Gateway$Send$Logic$preferredFeeAsset = F2(
	function (assets, currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Shared$Asset$Model$waves,
			A2($author$project$Common$List$getById, currency.g5, assets));
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Gateway$Send$Port$send = _Platform_outgoingPort(
	'send',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmount',
					$elm$json$Json$Encode$float($.eg)),
					_Utils_Tuple2(
					'gaAsset',
					$elm$json$Json$Encode$string($.eh)),
					_Utils_Tuple2(
					'platform',
					$elm$json$Json$Encode$string($.ju)),
					_Utils_Tuple2(
					'recipient',
					$elm$json$Json$Encode$string($.fE))
				]));
	});
var $author$project$Shared$Asset$Logic$toSatoshi = function (a) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$mul(
			A2($elm$core$Basics$pow, 10, a.hC)),
		$elm$core$Basics$round);
};
var $author$project$Shared$Asset$Logic$tryToSatoshi = function (a) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		$elm$core$Maybe$map(
			$author$project$Shared$Asset$Logic$toSatoshi(a)));
};
var $author$project$Gateway$Send$Port$validateBitcoinAddress = _Platform_outgoingPort('validateBitcoinAddress', $elm$json$Json$Encode$string);
var $author$project$Gateway$Shared$Cmd$decodeAddress = function (fieldName) {
	return A2(
		$elm$json$Json$Decode$field,
		fieldName,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
};
var $author$project$Gateway$Send$Cmd$withdraw = F4(
	function (userExternalAddress, _v0, msg, _v1) {
		var accessToken = _v0;
		var id = _v1.bP;
		var platform = _v1.ju;
		return $elm$http$Http$request(
			{
				dj: $elm$http$Http$emptyBody,
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							$elm$core$Maybe$withDefault('(error)')),
						$author$project$Gateway$Shared$Cmd$decodeAddress('proxy_addresses'))),
				ie: _List_fromArray(
					[
						$author$project$Common$Http$bearer(accessToken)
					]),
				iX: 'GET',
				kz: $elm$core$Maybe$Nothing,
				kR: $elm$core$Maybe$Nothing,
				cN: $author$project$Gateway$Shared$Cmd$api + ('/' + ($author$project$Gateway$Send$Cmd$action + ('/addresses/' + (id + ('/' + (userExternalAddress + ('/' + platform)))))))
			});
	});
var $author$project$Gateway$Send$Update$update = F5(
	function (assets, user, credentials, msg, model) {
		var getProxy = function (m) {
			var _v4 = _Utils_Tuple2(credentials, m.hv);
			if ((!_v4.a.$) && (!_v4.b.$)) {
				var accessToken = _v4.a.a;
				var currency = _v4.b.a;
				return _Utils_Tuple2(
					m,
					A4($author$project$Gateway$Send$Cmd$withdraw, m.k0, accessToken, $author$project$Gateway$Send$Msg$GotProxyAddress, currency));
			} else {
				return $author$project$Common$Cmd$no(m);
			}
		};
		var validateAddressOrGetProxy = function (m) {
			var _v3 = m.hv;
			if (!_v3.$) {
				var platform = _v3.a.ju;
				return ((platform === 'BTC') && ($elm$core$String$length(m.k0) >= 26)) ? _Utils_Tuple2(
					$author$project$Shared$Update$loading(m),
					$author$project$Gateway$Send$Port$validateBitcoinAddress(m.k0)) : (_Utils_eq(
					A2(
						$author$project$Gateway$Send$Validate$address,
						_List_fromArray(
							[$ChristophP$elm_i18next$I18Next$initialTranslations]),
						m),
					$elm$core$Maybe$Nothing) ? getProxy(m) : $author$project$Common$Cmd$no(m));
			} else {
				return $author$project$Common$Cmd$no(m);
			}
		};
		var changed = function (m) {
			return _Utils_update(
				m,
				{hc: $elm$core$Maybe$Nothing, jE: $elm$core$Maybe$Nothing});
		};
		_v0$10:
		while (true) {
			switch (msg.$) {
				case 4:
					if (!msg.a.$) {
						var currencies = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{hu: currencies})));
					} else {
						break _v0$10;
					}
				case 0:
					var a = msg.a;
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$dirty(
							_Utils_update(
								model,
								{gZ: a})));
				case 5:
					var currency = msg.a;
					return validateAddressOrGetProxy(
						changed(
							_Utils_update(
								model,
								{
									hv: $elm$core$Maybe$Just(currency)
								})));
				case 7:
					var address = msg.a.gV;
					var valid = msg.a.gz;
					var m1 = $author$project$Shared$Update$loaded(model);
					if (_Utils_eq(m1.k0, address)) {
						var m = _Utils_update(
							m1,
							{
								hc: $elm$core$Maybe$Just(valid)
							});
						return valid ? getProxy(m) : $author$project$Common$Cmd$no(m);
					} else {
						return $author$project$Common$Cmd$no(m1);
					}
				case 3:
					var a = msg.a;
					return validateAddressOrGetProxy(
						changed(
							$author$project$Shared$Update$dirty(
								_Utils_update(
									model,
									{k0: a}))));
				case 1:
					return getProxy(model);
				case 2:
					if (!msg.a.$) {
						var address = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									jE: $elm$core$Maybe$Just(address)
								}));
					} else {
						break _v0$10;
					}
				case 10:
					var id = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								h1: $elm$core$Maybe$Just(id)
							}));
				case 6:
					var _v1 = model.hv;
					if (!_v1.$) {
						var currency = _v1.a;
						var _v2 = _Utils_Tuple3(
							A2($author$project$Shared$Asset$Logic$tryToSatoshi, currency, model.gZ),
							model.jE,
							A5(
								$author$project$Shared$Transaction$Logic$feeAsset,
								assets,
								user,
								A2($author$project$Gateway$Send$Logic$preferredFeeAsset, assets, currency),
								$author$project$Shared$Transaction$Logic$fee.gq,
								model.h1));
						if (((!_v2.a.$) && (!_v2.b.$)) && (!_v2.c.$)) {
							var amount = _v2.a.a;
							var proxy = _v2.b.a;
							var feeAsset = _v2.c.a;
							return _Utils_Tuple2(
								$author$project$Shared$Update$loading(model),
								$author$project$Gateway$Send$Port$send(
									{
										gZ: amount + A2($author$project$Shared$Asset$Logic$toSatoshi, currency, currency.h2.h4),
										g5: currency.g5,
										h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.gq),
										h1: feeAsset.bP,
										eg: A2($author$project$Shared$Market$Logic$inOrig, currency, amount),
										eh: currency.bP,
										ju: currency.ju,
										fE: proxy
									}));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 9:
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(model));
				default:
					break _v0$10;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Gateway$Topup$Model$ExternalAddress = $elm$core$Basics$identity;
var $author$project$Gateway$Topup$Msg$GotDepositAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Port$copy = _Platform_outgoingPort('copy', $elm$json$Json$Encode$string);
var $author$project$Gateway$Topup$Cmd$deposit = F3(
	function (_v0, msg, _v1) {
		var accessToken = _v0;
		var id = _v1.bP;
		var platform = _v1.ju;
		return $elm$http$Http$request(
			{
				dj: $elm$http$Http$emptyBody,
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Gateway$Shared$Cmd$decodeAddress('deposit_addresses')),
				ie: _List_fromArray(
					[
						$author$project$Common$Http$bearer(accessToken)
					]),
				iX: 'GET',
				kz: $elm$core$Maybe$Nothing,
				kR: $elm$core$Maybe$Nothing,
				cN: $author$project$Gateway$Shared$Cmd$api + ('/' + ($author$project$Gateway$Topup$Cmd$action + ('/addresses/' + (id + ('/' + platform)))))
			});
	});
var $author$project$Gateway$Topup$Port$getEthereumWalletBalance = _Platform_outgoingPort(
	'getEthereumWalletBalance',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int($.hC)),
					_Utils_Tuple2(
					'fees',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'flat',
									$elm$json$Json$Encode$float($.h4)),
									_Utils_Tuple2(
									'rate',
									$elm$json$Json$Encode$float($.jH))
								]));
					}($.h2)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.bP)),
					_Utils_Tuple2(
					'limits',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'max',
									$elm$json$Json$Encode$float($.iU)),
									_Utils_Tuple2(
									'min',
									$elm$json$Json$Encode$float($.i_))
								]));
					}($.iC)),
					_Utils_Tuple2(
					'platform',
					$elm$json$Json$Encode$string($.ju)),
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string($.km))
				]));
	});
var $author$project$Gateway$Topup$Port$manualTopUp = _Platform_outgoingPort(
	'manualTopUp',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'platform',
					$elm$json$Json$Encode$string($.ju)),
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.ba))
				]));
	});
var $author$project$Gateway$Topup$Logic$supportedByMetaMask_ = _List_fromArray(
	['POLYGON', 'ETH', 'BSC']);
var $author$project$Gateway$Topup$Logic$supportedByMetaMask = function (platform) {
	return A2($elm$core$List$member, platform, $author$project$Gateway$Topup$Logic$supportedByMetaMask_);
};
var $author$project$Gateway$Topup$Port$web3Deposit = _Platform_outgoingPort(
	'web3Deposit',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.gV)),
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'amountFloat',
					$elm$json$Json$Encode$float($.c3)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int($.hC)),
					_Utils_Tuple2(
					'platform',
					$elm$json$Json$Encode$string($.ju)),
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.ba))
				]));
	});
var $author$project$Gateway$Topup$Update$update = F4(
	function (assets, credentials, msg, model) {
		_v0$12:
		while (true) {
			switch (msg.$) {
				case 8:
					var isInstalled = msg.a;
					var m = _Utils_update(
						model,
						{
							hV: $elm$core$Maybe$Just(isInstalled)
						});
					return $author$project$Common$Cmd$no(
						A3(
							$author$project$Common$Base$iff,
							m,
							_Utils_update(
								m,
								{hU: 1}),
							isInstalled));
				case 4:
					if (!msg.a.$) {
						var currencies = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										hu: A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.ju;
												},
												$elm$core$Basics$neq('MC')),
											currencies)
									})));
					} else {
						break _v0$12;
					}
				case 5:
					var currency = msg.a;
					var result = A4(
						$author$project$Gateway$Topup$Update$update,
						assets,
						credentials,
						$author$project$Gateway$Topup$Msg$UpdateGateway,
						_Utils_update(
							model,
							{
								hv: $elm$core$Maybe$Just(currency),
								iV: $elm$core$Maybe$Nothing
							}));
					var m = result.a;
					var c = result.b;
					return ($author$project$Gateway$Topup$Logic$supportedByMetaMask(currency.ju) && _Utils_eq(
						model.hV,
						$elm$core$Maybe$Just(true))) ? _Utils_Tuple2(
						$author$project$Shared$Update$loading(m),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									c,
									$author$project$Gateway$Topup$Port$getEthereumWalletBalance(currency)
								]))) : result;
				case 0:
					var a = msg.a;
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$dirty(
							_Utils_update(
								model,
								{gZ: a})));
				case 1:
					var s = msg.a;
					var _v1 = model.hv;
					if (!_v1.$) {
						var c = _v1.a;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Port$copy(s),
										$author$project$Gateway$Topup$Port$manualTopUp(
										{ju: c.ju, ba: c.bP})
									])));
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 2:
					if (!msg.a.$) {
						var addresses = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										ib: A2($elm$core$List$map, $elm$core$Basics$identity, addresses)
									})));
					} else {
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(model));
					}
				case 3:
					var m = _Utils_update(
						model,
						{ib: _List_Nil});
					var _v2 = _Utils_Tuple2(model.hv, credentials);
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var currency = _v2.a.a;
						var accessToken = _v2.b.a;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loading(m),
							A3($author$project$Gateway$Topup$Cmd$deposit, accessToken, $author$project$Gateway$Topup$Msg$GotDepositAddress, currency));
					} else {
						return $author$project$Common$Cmd$no(m);
					}
				case 9:
					var id = msg.a;
					var balance = msg.b;
					return A3(
						$elm$core$Basics$composeL,
						$author$project$Common$Cmd$no,
						$author$project$Shared$Update$loaded,
						function () {
							var _v3 = model.hv;
							if (!_v3.$) {
								var assetId = _v3.a.g5;
								return _Utils_eq(assetId, id) ? _Utils_update(
									model,
									{
										iV: A3(
											$author$project$Common$Base$iff,
											$elm$core$Maybe$Just(
												$elm$core$Result$Err(0)),
											$elm$core$Maybe$Just(
												$elm$core$Result$Ok(balance)),
											_Utils_eq(balance, -1))
									}) : model;
							} else {
								return model;
							}
						}());
				case 6:
					var m = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{hU: m}));
				case 7:
					var _v4 = _Utils_Tuple3(
						model.ib,
						$elm$core$String$toFloat(model.gZ),
						model.hv);
					if ((_v4.a.b && (!_v4.b.$)) && (!_v4.c.$)) {
						var _v5 = _v4.a;
						var gateway = _v5.a;
						var amount = _v4.b.a;
						var currency = _v4.c.a;
						var _v6 = A2($author$project$Common$List$getById, currency.g5, assets);
						if (!_v6.$) {
							var asset = _v6.a;
							return _Utils_Tuple2(
								$author$project$Shared$Update$loading(model),
								$author$project$Gateway$Topup$Port$web3Deposit(
									{
										gV: gateway,
										gZ: A2($author$project$Shared$Asset$Logic$toSatoshi, asset, amount),
										c3: amount,
										g5: asset.bP,
										hC: currency.hC,
										ju: currency.ju,
										ba: currency.bP
									}));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 11:
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(model));
				default:
					break _v0$12;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Gateway$Update$update = F5(
	function (assets, nodeApi, user, msg, model) {
		var upd = A3($author$project$Gateway$Update$update, assets, nodeApi, user);
		var updateGateway = function (m) {
			var _v6 = m.gT;
			switch (_v6) {
				case 1:
					return A2(
						upd,
						$author$project$Gateway$Msg$Topup($author$project$Gateway$Topup$Msg$UpdateGateway),
						m);
				case 2:
					return A2(
						upd,
						$author$project$Gateway$Msg$Send($author$project$Gateway$Send$Msg$UpdateProxy),
						m);
				default:
					return $author$project$Common$Cmd$no(m);
			}
		};
		var dropCredentials = function (_v5) {
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{hs: $elm$core$Maybe$Nothing}));
		};
		switch (msg.$) {
			case 0:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{gT: a}));
			case 4:
				return $author$project$Common$Cmd$no(model);
			case 6:
				var _v1 = user.gV;
				if (!_v1.$) {
					var a = _v1.a;
					return _Utils_Tuple2(
						model,
						$author$project$Gateway$Port$authorizeGateway(a));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 5:
				var credentials = msg.a;
				return updateGateway(
					_Utils_update(
						model,
						{
							hs: $elm$core$Maybe$Just(credentials)
						}));
			case 1:
				if ((((msg.a.$ === 2) && (msg.a.a.$ === 1)) && (msg.a.a.a.$ === 3)) && (msg.a.a.a.a === 401)) {
					return dropCredentials(0);
				} else {
					var msg1 = msg.a;
					var _v2 = A4($author$project$Gateway$Topup$Update$update, assets, model.hs, msg1, model.kK);
					var m = _v2.a;
					var c = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kK: m}),
						A2($elm$core$Platform$Cmd$map, $author$project$Gateway$Msg$Topup, c));
				}
			case 2:
				if ((((msg.a.$ === 2) && (msg.a.a.$ === 1)) && (msg.a.a.a.$ === 3)) && (msg.a.a.a.a === 401)) {
					return dropCredentials(0);
				} else {
					var msg1 = msg.a;
					var _v3 = A5($author$project$Gateway$Send$Update$update, assets, user, model.hs, msg1, model.j5);
					var m = _v3.a;
					var c = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{j5: m}),
						A2($elm$core$Platform$Cmd$map, $author$project$Gateway$Msg$Send, c));
				}
			case 3:
				if ((((!msg.a.$) && (msg.a.a.$ === 1)) && (msg.a.a.a.$ === 3)) && (msg.a.a.a.a === 401)) {
					return dropCredentials(0);
				} else {
					var msg1 = msg.a;
					var _v4 = A3($author$project$Gateway$Movements$Update$update, model.hs, msg1, model.i5);
					var m = _v4.a;
					var c = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{i5: m}),
						A2($elm$core$Platform$Cmd$map, $author$project$Gateway$Msg$Movements, c));
				}
			default:
				return A2(
					upd,
					$author$project$Gateway$Msg$TabChanged(1),
					model);
		}
	});
var $author$project$Governance$Msg$Lock = function (a) {
	return {$: 5, a: a};
};
var $author$project$Governance$Model$LockDialog = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Msg$Unstake = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Model$UnstakeDialog = function (a) {
	return {$: 2, a: a};
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Governance$Lock$Init$init = F2(
	function (vires, user) {
		return {
			gZ: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Market$Logic$inOrig(vires),
						$elm$core$String$fromFloat),
					A2($author$project$Shared$Wallet$Logic$wallet, vires.bP, user.lh))),
			hK: true,
			h1: $elm$core$Maybe$Nothing,
			iG: 0,
			iY: true
		};
	});
var $author$project$Governance$Unstake$Init$init = {hK: true, h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$Shared$FAQ$Update$update = F2(
	function (result, model) {
		if (!result.$) {
			var markdown = result.a;
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{
						h$: $elm$core$Maybe$Just(markdown)
					}));
		} else {
			return $author$project$Common$Cmd$no(model);
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Common$Markdown$updateSpoiler = F2(
	function (s, _v0) {
		var spoilers = _v0;
		return A2($elm$core$Dict$member, s, spoilers) ? A2($elm$core$Dict$remove, s, spoilers) : A3($elm$core$Dict$insert, s, 0, spoilers);
	});
var $author$project$Governance$Info$Update$update = F3(
	function (vires, msg, model) {
		switch (msg.$) {
			case 0:
				var p = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							k1: $elm$core$Maybe$Just(p)
						}));
			case 1:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							gZ: $elm$core$Maybe$Just(a)
						}));
			case 2:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							gZ: $elm$core$Maybe$Just(
								$elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, vires, a)))
						}));
			case 3:
				return $author$project$Common$Cmd$no(model);
			case 4:
				var pStr = msg.a;
				var _v1 = $elm$core$String$toFloat(pStr);
				if (!_v1.$) {
					var p = _v1.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{lq: p}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 5:
				var result = msg.a;
				return A2($author$project$Shared$FAQ$Update$update, result, model);
			default:
				var spoiler = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							kf: A2($author$project$Common$Markdown$updateSpoiler, spoiler, model.kf)
						}));
		}
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Governance$Lock$Port$lock = _Platform_outgoingPort(
	'lock',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'factor',
					$elm$json$Json$Encode$int($.d6)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'migrate',
					$elm$json$Json$Encode$bool($.iY))
				]));
	});
var $author$project$Shared$Update$reset = function (model) {
	return _Utils_update(
		model,
		{hK: false});
};
var $author$project$Governance$Lock$Update$update = F5(
	function (vires, assets, user, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.f3;
						},
						user.ic));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var legacyStaked = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Governance$Lock$Port$lock(
							{
								gZ: A2(
									$elm$core$Maybe$withDefault,
									0,
									A2($author$project$Shared$Asset$Logic$tryToSatoshi, vires, model.gZ)),
								d6: 1,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								iY: model.iY && (legacyStaked > 0)
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 4:
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$loaded(
						$author$project$Shared$Update$reset(
							_Utils_update(
								model,
								{gZ: ''}))));
			case 1:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: a})));
			case 2:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{
								gZ: $elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, vires, a))
							})));
			case 3:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			case 5:
				return $author$project$Common$Cmd$no(model);
			default:
				var m = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{iY: m}));
		}
	});
var $author$project$Shared$Waves$Address$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Governance$MyVires$Delegate$Init$init = function (delegate) {
	return {
		gW: $elm$core$Dict$empty,
		hi: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Shared$Waves$Address$toString, delegate)),
		hK: false,
		h1: $elm$core$Maybe$Nothing,
		iG: 0
	};
};
var $author$project$Governance$MyVires$Delegate$Port$removeClaimDelegation = _Platform_outgoingPort(
	'removeClaimDelegation',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Governance$MyVires$Delegate$Port$setClaimDelegation = _Platform_outgoingPort(
	'setClaimDelegation',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.gV)),
					_Utils_Tuple2(
					'allowRelock',
					$elm$json$Json$Encode$bool($.c2)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Shared$Waves$Port$verifyWavesAddress = _Platform_outgoingPort('verifyWavesAddress', $elm$json$Json$Encode$string);
var $author$project$Governance$MyVires$Delegate$Update$update = F4(
	function (assets, user, msg, model) {
		_v0$5:
		while (true) {
			switch (msg.$) {
				case 0:
					var a = msg.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$dirty(
							_Utils_update(
								model,
								{hi: a})),
						$author$project$Shared$Waves$Port$verifyWavesAddress(a));
				case 2:
					var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
					if (!_v1.$) {
						var feeAsset = _v1.a;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loading(model),
							$author$project$Governance$MyVires$Delegate$Port$setClaimDelegation(
								{
									gV: model.hi,
									c2: true,
									h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
									h1: feeAsset.bP
								}));
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 5:
					if (msg.a) {
						var address = msg.b;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									gW: A3($elm$core$Dict$insert, address, true, model.gW)
								}));
					} else {
						break _v0$5;
					}
				case 3:
					var _v2 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
					if (!_v2.$) {
						var feeAsset = _v2.a;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loading(model),
							$author$project$Governance$MyVires$Delegate$Port$removeClaimDelegation(
								{
									h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
									h1: feeAsset.bP
								}));
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 1:
					var id = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								h1: $elm$core$Maybe$Just(id)
							}));
				default:
					break _v0$5;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$Revenue$Msg$Claim = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Revenue$Msg$GotRevenue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Governance$Revenue$Claim$Init$init = function (_v0) {
	var lock = _v0;
	return _Utils_Tuple2(
		{hK: true, h1: $elm$core$Maybe$Nothing, iG: 0, jO: lock},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Governance$Revenue$Claim$Port$claimProtocolProfitFrom = _Platform_outgoingPort(
	'claimProtocolProfitFrom',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'from',
					$elm$json$Json$Encode$string($.h8)),
					_Utils_Tuple2(
					'relock',
					$elm$json$Json$Encode$bool($.jO))
				]));
	});
var $author$project$Governance$Revenue$Claim$Update$update = F5(
	function (assets, user, from, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					from);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var address = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Governance$Revenue$Claim$Port$claimProtocolProfitFrom(
							{
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								h8: address,
								jO: model.jO
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 1:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			case 2:
				var relock = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{jO: relock}));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Governance$Revenue$Update$update = F6(
	function (api, lock, assets, user, msg, model) {
		var claim = function (_v5) {
			var m = _v5.a;
			var c = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hh: $elm$core$Maybe$Just(m)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Governance$Revenue$Msg$Claim, c));
		};
		_v0$14:
		while (true) {
			switch (msg.$) {
				case 10:
					if (!msg.b.$) {
						var key = msg.a;
						var delegators = msg.b.a;
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Governance$Revenue$Logic$claimFromKey,
									$elm$core$Basics$eq(key)),
								user.gV)) ? $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										iQ: A2(
											$elm$core$List$map,
											$elm$core$Basics$identity,
											A2($elm$core$String$split, ',', delegators))
									}))) : $author$project$Common$Cmd$no(model);
					} else {
						break _v0$14;
					}
				case 8:
					if (msg.a) {
						var address = msg.b;
						var _v1 = _Utils_Tuple3(
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$eq(address),
								model.hx),
							user.gV,
							address);
						if (((!_v1.a.$) && _v1.a.a) && (!_v1.b.$)) {
							var userAddress = _v1.b.a;
							var from = _v1.c;
							var lsDelegators = (_Utils_eq(from, userAddress) || A2($elm$core$List$member, from, model.iQ)) ? model.iQ : A2($elm$core$List$cons, from, model.iQ);
							return _Utils_Tuple2(
								$author$project$Shared$Update$loading(
									_Utils_update(
										model,
										{
											h8: $elm$core$Maybe$Just(from),
											iQ: lsDelegators,
											j_: $elm$core$Dict$empty
										})),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A4(
											$author$project$Governance$Revenue$Cmd$revenue,
											api,
											$author$project$Governance$Revenue$Msg$GotRevenue(from),
											true,
											from),
											A2(
											$author$project$Port$setItem2,
											$author$project$Governance$Revenue$Logic$claimFromKey(userAddress),
											$elm$core$Maybe$Just(
												A2(
													$elm$core$String$join,
													',',
													A2($elm$core$List$map, $author$project$Shared$Waves$Address$toString, lsDelegators))))
										])));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					} else {
						break _v0$14;
					}
				case 9:
					var a = msg.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$dirty(
							_Utils_update(
								model,
								{
									hx: $elm$core$Maybe$Just(a)
								})),
						$author$project$Shared$Waves$Port$verifyWavesAddress(a));
				case 1:
					if (!msg.a.$) {
						var d = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{hF: d})));
					} else {
						break _v0$14;
					}
				case 4:
					var _v2 = claim(
						$author$project$Governance$Revenue$Claim$Init$init(lock));
					var m = _v2.a;
					var c = _v2.b;
					return _Utils_Tuple2(
						m,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									c,
									$author$project$Common$Cmd$update($author$project$Governance$Revenue$Msg$Update)
								])));
				case 3:
					if (msg.a.$ === 3) {
						var _v3 = msg.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{hh: $elm$core$Maybe$Nothing}));
					} else {
						var msg1 = msg.a;
						var _v4 = model.hh;
						if (!_v4.$) {
							var c = _v4.a;
							return claim(
								A5($author$project$Governance$Revenue$Claim$Update$update, assets, user, model.h8, msg1, c));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					}
				case 2:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hh: $elm$core$Maybe$Nothing}),
						$author$project$Common$Cmd$update($author$project$Governance$Revenue$Msg$Update));
				case 11:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Common$Cmd$try,
							function (a) {
								return A4(
									$author$project$Governance$Revenue$Cmd$revenue,
									api,
									$author$project$Governance$Revenue$Msg$GotRevenue(a),
									false,
									a);
							},
							model.h8));
				case 5:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{h8: $elm$core$Maybe$Nothing, iQ: _List_Nil, j_: $elm$core$Dict$empty}));
				case 6:
					var address = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h8: $elm$core$Maybe$Just(address)
							}),
						$elm$core$Platform$Cmd$batch(
							A3($author$project$Governance$Revenue$Cmd$getAllDelegators, api, $author$project$Governance$Revenue$Msg$GotDelegators, address)));
				case 7:
					if (msg.a === '') {
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									hx: $elm$core$Maybe$Just('')
								}));
					} else {
						var from = msg.a;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loading(
								_Utils_update(
									model,
									{
										hx: $elm$core$Maybe$Nothing,
										h8: $elm$core$Maybe$Just(from),
										j_: $elm$core$Dict$empty
									})),
							A4(
								$author$project$Governance$Revenue$Cmd$revenue,
								api,
								$author$project$Governance$Revenue$Msg$GotRevenue(from),
								true,
								from));
					}
				default:
					if (!msg.b.$) {
						var adr = msg.a;
						var revenue = msg.b.a;
						return $author$project$Common$Cmd$no(
							_Utils_eq(
								$elm$core$Maybe$Just(adr),
								model.h8) ? _Utils_update(
								model,
								{j_: revenue}) : model);
					} else {
						break _v0$14;
					}
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$MyVires$Update$update = F6(
	function (api, lock, assets, user, msg, model) {
		_v0$9:
		while (true) {
			switch (msg.$) {
				case 6:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{hE: $elm$core$Maybe$Nothing}));
				case 7:
					var a = msg.a;
					return _Utils_Tuple2(
						model,
						A4($author$project$Governance$MyVires$Cmd$delegate, api, $author$project$Governance$MyVires$Msg$GotDelegation, true, a));
				case 5:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Common$Cmd$try,
							A3($author$project$Governance$MyVires$Cmd$delegate, api, $author$project$Governance$MyVires$Msg$GotDelegation, false),
							user.gV));
				case 3:
					if (!msg.a.$) {
						var d = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{hE: d})));
					} else {
						break _v0$9;
					}
				case 2:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								dP: $elm$core$Maybe$Just(
									$author$project$Governance$MyVires$Delegate$Init$init(model.hE))
							}));
				case 4:
					if (msg.a.$ === 4) {
						var _v1 = msg.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{dP: $elm$core$Maybe$Nothing}));
					} else {
						var msg1 = msg.a;
						var _v2 = model.dP;
						if (!_v2.$) {
							var d = _v2.a;
							var _v3 = A4($author$project$Governance$MyVires$Delegate$Update$update, assets, user, msg1, d);
							var m = _v3.a;
							var c = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										dP: $elm$core$Maybe$Just(m)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Governance$MyVires$Msg$Delegate, c));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					}
				case 8:
					var s = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Port$copy(s));
				case 9:
					var msg1 = msg.a;
					var _v4 = A6($author$project$Governance$Revenue$Update$update, api, lock, assets, user, msg1, model.jZ);
					var m = _v4.a;
					var c = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jZ: m}),
						A2($elm$core$Platform$Cmd$map, $author$project$Governance$MyVires$Msg$Revenue, c));
				default:
					break _v0$9;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$Unstake$Port$withdrawAllPossibleVires = _Platform_outgoingPort(
	'withdrawAllPossibleVires',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Governance$Unstake$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 1:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(a)
						}));
			case 0:
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Governance$Unstake$Port$withdrawAllPossibleVires(
							{
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Governance$Voting$New$Port$getDataTx = _Platform_outgoingPort('getDataTx', $elm$core$Basics$identity);
var $author$project$Governance$Voting$New$Propose$Init$init = F2(
	function (payload, proposalId) {
		return {hK: false, h1: $elm$core$Maybe$Nothing, iG: 0, jt: payload, jz: proposalId};
	});
var $author$project$Common$List$just = $elm$core$List$filterMap($elm$core$Basics$identity);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Governance$Voting$Shared$Cmd$payloadEncoder_ = function (payload) {
	var value = function (v) {
		switch (v.$) {
			case 0:
				var s = v.a;
				return $elm$json$Json$Encode$string(s);
			case 1:
				var i = v.a;
				return $elm$json$Json$Encode$int(i);
			case 2:
				var b = v.a;
				return $elm$json$Json$Encode$bool(b);
			default:
				return $elm$json$Json$Encode$null;
		}
	};
	var data = function (d) {
		return $elm$json$Json$Encode$object(
			$author$project$Common$List$just(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'key',
							$elm$json$Json$Encode$string(d.iw))),
						A2(
						$elm$core$Maybe$map,
						function (t) {
							return _Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(t));
						},
						d.cL),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'value',
							value(d.gA)))
					])));
	};
	var dataOrScript = function (info) {
		if (!info.$) {
			var d = info.a;
			return _Utils_Tuple2(
				'data',
				A2($elm$json$Json$Encode$list, data, d));
		} else {
			var s = info.a;
			return _Utils_Tuple2(
				'script',
				$elm$json$Json$Encode$string(s));
		}
	};
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$int(payload.cL)),
			_Utils_Tuple2(
			'version',
			$elm$json$Json$Encode$int(payload.k5)),
			dataOrScript(payload.ip),
			_Utils_Tuple2(
			'senderPublicKey',
			$elm$json$Json$Encode$string(payload.j6)),
			_Utils_Tuple2(
			'fee',
			$elm$json$Json$Encode$int(payload.h0)),
			_Utils_Tuple2(
			'feeAssetId',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, payload.h1))),
			_Utils_Tuple2(
			'timestamp',
			$elm$json$Json$Encode$int(payload.kA))
		]);
};
var $author$project$Governance$Voting$Shared$Cmd$payloadEncoder = A2($elm$core$Basics$composeR, $author$project$Governance$Voting$Shared$Cmd$payloadEncoder_, $elm$json$Json$Encode$object);
var $author$project$Governance$Voting$New$Propose$Msg$AlreadySubmitted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Governance$Voting$New$Propose$Msg$Submitted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Port$broadcastError = _Platform_outgoingPort('broadcastError', $elm$json$Json$Encode$string);
var $author$project$Common$Http$errorToString = function (err) {
	var parseError = A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeString(
			A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)),
		$elm$core$Result$toMaybe);
	switch (err.$) {
		case 1:
			return 'Timeout exceeded';
		case 2:
			return 'Network error';
		case 4:
			var resp = err.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Bad body',
				parseError(resp));
		case 3:
			var code = err.a;
			return 'Bad status code: ' + $elm$core$String$fromInt(code);
		default:
			var url = err.a;
			return 'Malformed url: ' + url;
	}
};
var $author$project$Governance$Voting$New$Propose$Cmd$submittedDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$elm$core$Basics$always(true)),
		$elm$core$Maybe$withDefault(false)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'submitted', $elm$json$Json$Decode$value)));
var $author$project$Governance$Voting$New$Propose$Cmd$exists = F3(
	function (_v0, msg, proposalId) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Governance$Voting$New$Propose$Cmd$submittedDecoder),
				cN: api + ('/voting/proposal/' + proposalId)
			});
	});
var $author$project$Governance$Voting$New$Propose$Data$fee = $author$project$Shared$Asset$Model$waves.e0 * 10;
var $author$project$Governance$Voting$New$Propose$Port$propose = _Platform_outgoingPort(
	'propose',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'txId',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{dj: r.dj, bF: r.bF, ie: _List_Nil, iX: 'POST', kz: $elm$core$Maybe$Nothing, kR: $elm$core$Maybe$Nothing, cN: r.cN});
};
var $author$project$Governance$Voting$New$Propose$Cmd$submitProposal = F6(
	function (_v0, proposalId, title, summary, payload, msg) {
		var api = _v0;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'proposalId',
					$elm$json$Json$Encode$string(proposalId)),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(title)),
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string(summary)),
					_Utils_Tuple2(
					'tx',
					$author$project$Governance$Voting$Shared$Cmd$payloadEncoder(payload))
				]));
		return $elm$http$Http$post(
			{
				dj: $elm$http$Http$jsonBody(body),
				bF: $elm$http$Http$expectWhatever(msg),
				cN: api + '/voting/submitProposal'
			});
	});
var $author$project$Governance$Voting$New$Propose$Update$update = F8(
	function (key, api, assets, user, title, summary, msg, model) {
		var submit = function (m) {
			return _Utils_Tuple2(
				$author$project$Shared$Update$loading(m),
				A6($author$project$Governance$Voting$New$Propose$Cmd$submitProposal, api, m.jz, title, summary, m.jt, $author$project$Governance$Voting$New$Propose$Msg$Submitted));
		};
		var navigateToProposal = function (_v2) {
			return _Utils_Tuple2(
				$author$project$Shared$Update$loaded(model),
				A2($elm$browser$Browser$Navigation$pushUrl, key, '/governance/vote/' + model.jz));
		};
		_v0$9:
		while (true) {
			switch (msg.$) {
				case 4:
					var id = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								h1: $elm$core$Maybe$Just(id)
							}));
				case 0:
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						A3($author$project$Governance$Voting$New$Propose$Cmd$exists, api, $author$project$Governance$Voting$New$Propose$Msg$AlreadySubmitted, model.jz));
				case 5:
					if (msg.a.$ === 1) {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 400)) {
							var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Governance$Voting$New$Propose$Data$fee, model.h1);
							if (!_v1.$) {
								var feeAsset = _v1.a;
								return _Utils_Tuple2(
									model,
									$author$project$Governance$Voting$New$Propose$Port$propose(
										{
											h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Governance$Voting$New$Propose$Data$fee),
											h1: feeAsset.bP,
											kU: model.jz
										}));
							} else {
								return $author$project$Common$Cmd$no(model);
							}
						} else {
							break _v0$9;
						}
					} else {
						if (!msg.a.a) {
							return submit(
								$author$project$Shared$Update$loaded(model));
						} else {
							return navigateToProposal(0);
						}
					}
				case 2:
					return submit(
						$author$project$Shared$Update$loaded(model));
				case 3:
					if (!msg.a.$) {
						return navigateToProposal(0);
					} else {
						var r = msg.a.a;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loaded(model),
							$author$project$Port$broadcastError(
								$author$project$Common$Http$errorToString(r)));
					}
				case 6:
					var p = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Port$copy(p));
				default:
					break _v0$9;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$Voting$New$Update$update = F6(
	function (key, api, assets, user, msg, model) {
		var close = function (_v6) {
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{jB: $elm$core$Maybe$Nothing}));
		};
		switch (msg.$) {
			case 1:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{kB: t})));
			case 2:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{hH: t})));
			case 3:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{jt: t})));
			case 5:
				return close(0);
			case 4:
				if (msg.a.$ === 1) {
					var _v1 = msg.a;
					return close(0);
				} else {
					var msg1 = msg.a;
					var _v2 = model.jB;
					if (!_v2.$) {
						var p = _v2.a;
						var _v3 = A8($author$project$Governance$Voting$New$Propose$Update$update, key, api, assets, user, model.kB, model.hH, msg1, p);
						var m = _v3.a;
						var c = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									jB: $elm$core$Maybe$Just(m)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Governance$Voting$New$Msg$Propose, c));
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				}
			case 0:
				var _v4 = A2($elm$json$Json$Decode$decodeString, $author$project$Governance$Voting$New$Data$payloadDecoder, model.jt);
				if (!_v4.$) {
					var payload = _v4.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Governance$Voting$New$Port$getDataTx(
							$author$project$Governance$Voting$Shared$Cmd$payloadEncoder(payload)));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				var proposalId = msg.a;
				var _v5 = A2($elm$json$Json$Decode$decodeString, $author$project$Governance$Voting$New$Data$payloadDecoder, model.jt);
				if (!_v5.$) {
					var payload = _v5.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								jB: $elm$core$Maybe$Just(
									A2($author$project$Governance$Voting$New$Propose$Init$init, payload, proposalId))
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
		}
	});
var $author$project$Governance$Voting$Proposal$Msg$BroadcastCompleted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Governance$Voting$Proposal$Cmd$nodes = 'http://nodes.wavesnodes.com/transactions/broadcast';
var $author$project$Governance$Voting$Proposal$Cmd$broadcast = F2(
	function (msg, tx) {
		return $elm$http$Http$post(
			{
				dj: $elm$http$Http$jsonBody(tx),
				bF: $elm$http$Http$expectWhatever(msg),
				cN: $author$project$Governance$Voting$Proposal$Cmd$nodes
			});
	});
var $author$project$Governance$Voting$Proposal$Vote$Init$init = {h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$Governance$Voting$Shared$Cmd$payloadEncoderWithProofs = A2(
	$elm$core$Basics$composeR,
	$author$project$Governance$Voting$Shared$Cmd$payloadEncoder_,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$cons(
			_Utils_Tuple2(
				'proofs',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil))),
		$elm$json$Json$Encode$object));
var $author$project$Governance$Voting$Proposal$Vote$Port$retract = _Platform_outgoingPort(
	'retract',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'txId',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $author$project$Governance$Voting$Proposal$Vote$Port$retractProposal = _Platform_outgoingPort(
	'retractProposal',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'txId',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $author$project$Governance$Voting$Proposal$Vote$Port$voteNo = _Platform_outgoingPort(
	'voteNo',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'txId',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $author$project$Governance$Voting$Proposal$Vote$Port$voteYes = _Platform_outgoingPort(
	'voteYes',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'txId',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $author$project$Governance$Voting$Proposal$Vote$Port$vote = function (yesNoRetract) {
	switch (yesNoRetract) {
		case 0:
			return $author$project$Governance$Voting$Proposal$Vote$Port$voteYes;
		case 1:
			return $author$project$Governance$Voting$Proposal$Vote$Port$voteNo;
		case 2:
			return $author$project$Governance$Voting$Proposal$Vote$Port$retract;
		default:
			return $author$project$Governance$Voting$Proposal$Vote$Port$retractProposal;
	}
};
var $author$project$Governance$Voting$Proposal$Vote$Update$update = F5(
	function (assets, user, proposalId, msg, model) {
		switch (msg.$) {
			case 0:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			case 1:
				var yesNo = msg.a;
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						A2(
							$author$project$Governance$Voting$Proposal$Vote$Port$vote,
							yesNo,
							{
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								kU: proposalId
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 3:
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$loaded(model));
			case 4:
				var s = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Port$copy(s));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Governance$Voting$Proposal$Update$update = F5(
	function (api, assets, user, msg, model) {
		var close = function (cmd) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ld: $elm$core$Maybe$Nothing}),
				cmd);
		};
		_v0$10:
		while (true) {
			switch (msg.$) {
				case 0:
					var yesNo = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								ld: $elm$core$Maybe$Just(
									_Utils_Tuple2(yesNo, $author$project$Governance$Voting$Proposal$Vote$Init$init))
							}));
				case 1:
					if (msg.a.$ === 2) {
						var _v1 = msg.a;
						return close($elm$core$Platform$Cmd$none);
					} else {
						var msg1 = msg.a;
						var _v2 = model.ld;
						if (!_v2.$) {
							var _v3 = _v2.a;
							var yesNo = _v3.a;
							var vote = _v3.b;
							var _v4 = A5($author$project$Governance$Voting$Proposal$Vote$Update$update, assets, user, model.jz, msg1, vote);
							var m = _v4.a;
							var c = _v4.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ld: $elm$core$Maybe$Just(
											_Utils_Tuple2(yesNo, m))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Governance$Voting$Proposal$Msg$Vote, c));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					}
				case 2:
					if (!msg.a.$) {
						var p = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										jy: $elm$core$Maybe$Just(p)
									})));
					} else {
						break _v0$10;
					}
				case 3:
					if (!msg.a.$) {
						var v = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										k2: $elm$core$Maybe$Just(v)
									})));
					} else {
						break _v0$10;
					}
				case 4:
					var commands = A3($author$project$Governance$Voting$Proposal$Data$load, api, user, model.jz);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iG: model.iG + $elm$core$List$length(commands),
								ld: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$batch(commands));
				case 5:
					var s = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Port$copy(s));
				case 7:
					var payload = msg.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						A2(
							$author$project$Governance$Voting$Proposal$Cmd$broadcast,
							$author$project$Governance$Voting$Proposal$Msg$BroadcastCompleted,
							$author$project$Governance$Voting$Shared$Cmd$payloadEncoderWithProofs(payload)));
				default:
					if (!msg.a.$) {
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										jy: A2(
											$elm$core$Maybe$map,
											function (p) {
												return _Utils_update(
													p,
													{km: 6});
											},
											model.jy)
									})));
					} else {
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(model));
					}
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$Voting$Proposals$Update$update = F3(
	function (key, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var proposals = msg.a.a;
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(
							_Utils_update(
								model,
								{jA: proposals})));
				} else {
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(model));
				}
			case 1:
				if (!msg.a.$) {
					var votes = msg.a.a;
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(
							_Utils_update(
								model,
								{k2: votes})));
				} else {
					return $author$project$Common$Cmd$no(
						$author$project$Shared$Update$loaded(model));
				}
			case 2:
				var proposalId = msg.a;
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, key, '/governance/vote/' + proposalId));
			case 3:
				if (!msg.a.$) {
					var faq = msg.a.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								h$: $elm$core$Maybe$Just(faq)
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{kb: true}));
		}
	});
var $author$project$Governance$Voting$Update$update = F6(
	function (key, api, assets, user, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.jo);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.a.a.$) {
						var c = _v0.a.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									hn: $elm$core$Maybe$Just(c)
								}));
					} else {
						break _v0$4;
					}
				case 1:
					if (!_v0.b.$) {
						var msg1 = _v0.a.a;
						var m = _v0.b.a;
						return A4(
							$author$project$Shared$Update$page,
							model,
							$author$project$Governance$Voting$Model$Proposals,
							$author$project$Governance$Voting$Msg$Proposals,
							A3($author$project$Governance$Voting$Proposals$Update$update, key, msg1, m));
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 1) {
						var msg1 = _v0.a.a;
						var m = _v0.b.a;
						return A4(
							$author$project$Shared$Update$page,
							model,
							$author$project$Governance$Voting$Model$Proposal,
							$author$project$Governance$Voting$Msg$Proposal,
							A5($author$project$Governance$Voting$Proposal$Update$update, api, assets, user, msg1, m));
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 2) {
						var msg1 = _v0.a.a;
						var m = _v0.b.a;
						return A4(
							$author$project$Shared$Update$page,
							model,
							$author$project$Governance$Voting$Model$New,
							$author$project$Governance$Voting$Msg$New,
							A6($author$project$Governance$Voting$New$Update$update, key, api, assets, user, msg1, m));
					} else {
						break _v0$4;
					}
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Governance$Update$update = F8(
	function (key, api, lock, assets, user, vires, msg, model) {
		var tab = F3(
			function (mapTab, mapCmd, _v10) {
				var m = _v10.a;
				var c = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kt: mapTab(m)
						}),
					A2($elm$core$Platform$Cmd$map, mapCmd, c));
			});
		var openLock = function (_v9) {
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{
						dQ: $author$project$Governance$Model$LockDialog(
							A2($author$project$Governance$Lock$Init$init, vires, user))
					}));
		};
		var dialog = F3(
			function (mapDlg, mapCmd, _v8) {
				var m = _v8.a;
				var c = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: mapDlg(m)
						}),
					A2($elm$core$Platform$Cmd$map, mapCmd, c));
			});
		var closeDialog = function (_v7) {
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{dQ: $author$project$Governance$Model$None}));
		};
		var _v0 = _Utils_Tuple3(msg, model.kt, model.dQ);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					switch (_v0.a.a.$) {
						case 0:
							var _v1 = _v0.a.a;
							return openLock(0);
						case 1:
							var _v3 = _v0.a.a;
							return $author$project$Common$Cmd$no(
								_Utils_update(
									model,
									{
										dQ: $author$project$Governance$Model$UnstakeDialog($author$project$Governance$Unstake$Init$init)
									}));
						default:
							if (_v0.b.$ === 1) {
								var msg1 = _v0.a.a;
								var my = _v0.b.a;
								return A3(
									tab,
									$author$project$Governance$Model$MyVires,
									$author$project$Governance$Msg$MyVires,
									A6($author$project$Governance$MyVires$Update$update, api, lock, assets, user, msg1, my));
							} else {
								break _v0$11;
							}
					}
				case 2:
					if (_v0.a.a.$ === 3) {
						var _v2 = _v0.a.a;
						return openLock(0);
					} else {
						if (!_v0.b.$) {
							var msg1 = _v0.a.a;
							var info = _v0.b.a;
							return A3(
								tab,
								$author$project$Governance$Model$Info,
								$author$project$Governance$Msg$Info,
								A3($author$project$Governance$Info$Update$update, vires, msg1, info));
						} else {
							break _v0$11;
						}
					}
				case 3:
					if (_v0.b.$ === 2) {
						var msg1 = _v0.a.a;
						var vote = _v0.b.a;
						return A3(
							tab,
							$author$project$Governance$Model$Voting,
							$author$project$Governance$Msg$Voting,
							A6($author$project$Governance$Voting$Update$update, key, api, assets, user, msg1, vote));
					} else {
						break _v0$11;
					}
				case 4:
					var _v4 = _v0.a;
					return closeDialog(0);
				case 5:
					if (_v0.a.a.$ === 5) {
						var _v5 = _v0.a.a;
						return closeDialog(0);
					} else {
						if (_v0.c.$ === 1) {
							var msg1 = _v0.a.a;
							var lock_ = _v0.c.a;
							return A3(
								dialog,
								$author$project$Governance$Model$LockDialog,
								$author$project$Governance$Msg$Lock,
								A5($author$project$Governance$Lock$Update$update, vires, assets, user, msg1, lock_));
						} else {
							break _v0$11;
						}
					}
				default:
					if (_v0.a.a.$ === 2) {
						var _v6 = _v0.a.a;
						return closeDialog(0);
					} else {
						if (_v0.c.$ === 2) {
							var msg1 = _v0.a.a;
							var unstake = _v0.c.a;
							return A3(
								dialog,
								$author$project$Governance$Model$UnstakeDialog,
								$author$project$Governance$Msg$Unstake,
								A4($author$project$Governance$Unstake$Update$update, assets, user, msg1, unstake));
						} else {
							break _v0$11;
						}
					}
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Home$Model$ChangeCollateral = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Home$Msg$Claim = function (a) {
	return {$: 10, a: a};
};
var $author$project$Home$Msg$LastUpdateTime = function (a) {
	return {$: 15, a: a};
};
var $author$project$Home$Msg$Markets = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Model$Repay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Home$Msg$Repay = function (a) {
	return {$: 8, a: a};
};
var $author$project$Home$Model$Vires = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Model$Withdraw = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Home$Msg$Withdraw = function (a) {
	return {$: 18, a: a};
};
var $author$project$Port$broadcast = _Platform_outgoingPort('broadcast', $elm$json$Json$Encode$string);
var $author$project$Shared$Update$close0 = function (model) {
	return _Utils_update(
		model,
		{jl: $elm$core$Maybe$Nothing});
};
var $author$project$Shared$Update$close = A2($elm$core$Basics$composeR, $author$project$Shared$Update$close0, $author$project$Common$Cmd$no);
var $author$project$Home$Vesting$Msg$OpenConvert = {$: 0};
var $author$project$Home$Update$openConvertToUSDN = $author$project$Common$Cmd$update(
	$author$project$Home$Msg$Vesting($author$project$Home$Vesting$Msg$OpenConvert));
var $author$project$Home$Update$closeAndOpenConvertToUSDN = function (model) {
	return _Utils_Tuple2(
		$author$project$Shared$Update$close0(model),
		$author$project$Home$Update$openConvertToUSDN);
};
var $elm_community$dict_extra$Dict$Extra$filterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Shared$Suppy$Logic$filterLegacyDust = function (markets) {
	var filter = F2(
		function (reserve, ui) {
			var _v0 = _Utils_Tuple2(
				ui.gb,
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.iB;
						},
						A3(
							$author$project$Common$List$getBy,
							function ($) {
								return $.jT;
							},
							reserve,
							markets))));
			if ((((!_v0.a.$) && (!_v0.a.a.$)) && (_v0.a.a.a === 1)) && _v0.b) {
				var _v1 = _v0.a.a;
				return _Utils_eq(ui.dk, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_update(
						ui,
						{gb: $elm$core$Maybe$Nothing}));
			} else {
				return $elm$core$Maybe$Just(ui);
			}
		});
	return $elm_community$dict_extra$Dict$Extra$filterMap(filter);
};
var $author$project$Home$ChangeCollateral$init = function (collateral) {
	return {r: collateral, hK: true, h1: $elm$core$Maybe$Nothing, iG: 0};
};
var $author$project$Repay$Logic$fromSupply = 'supply';
var $author$project$Shared$User$Logic$ofMarket = F2(
	function (market, dict) {
		return A2($elm$core$Dict$get, market.jT, dict);
	});
var $author$project$Shared$Wallet$Logic$ofWallet = F2(
	function (market, walletData) {
		return A2($author$project$Shared$Wallet$Logic$wallet, market.bh.bP, walletData);
	});
var $author$project$Repay$Init$init = F3(
	function (wallets, userData, m) {
		return {
			gZ: '',
			hK: false,
			h1: $elm$core$Maybe$Nothing,
			iG: 0,
			jR: function () {
				var _v0 = _Utils_Tuple3(
					A2($author$project$Shared$Wallet$Logic$ofWallet, m, wallets),
					A2($author$project$Shared$Wallet$Logic$wallet, m.gO, wallets),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.gb;
						},
						A2($author$project$Shared$User$Logic$ofMarket, m, userData)));
				_v0$0:
				while (true) {
					_v0$5:
					while (true) {
						if (!_v0.c.$) {
							if (!_v0.c.a.$) {
								if (!_v0.b.$) {
									if (_v0.c.a.c === 1) {
										if (!_v0.a.$) {
											break _v0$0;
										} else {
											var _v1 = _v0.c.a;
											var _v2 = _v1.c;
											return m.gO;
										}
									} else {
										if (!_v0.a.$) {
											break _v0$0;
										} else {
											break _v0$5;
										}
									}
								} else {
									if (!_v0.a.$) {
										break _v0$0;
									} else {
										if (_v0.c.a.c === 1) {
											var _v3 = _v0.c.a;
											var _v4 = _v3.c;
											return m.bh.bP;
										} else {
											break _v0$5;
										}
									}
								}
							} else {
								if (!_v0.b.$) {
									if (!_v0.a.$) {
										break _v0$0;
									} else {
										var _v5 = _v0.c.a;
										return m.gO;
									}
								} else {
									if (!_v0.a.$) {
										break _v0$0;
									} else {
										var _v6 = _v0.c.a;
										return m.bh.bP;
									}
								}
							}
						} else {
							if (!_v0.a.$) {
								break _v0$0;
							} else {
								if (!_v0.b.$) {
									return m.gO;
								} else {
									return m.bh.bP;
								}
							}
						}
					}
					return $author$project$Repay$Logic$fromSupply;
				}
				return m.bh.bP;
			}()
		};
	});
var $author$project$Vires$Claim$Init$init = function (_v0) {
	var lock = _v0;
	return {hK: false, h1: $elm$core$Maybe$Nothing, iB: false, iG: 0, iI: lock};
};
var $author$project$Vires$Init$init = function (lock) {
	return {
		hh: $author$project$Vires$Claim$Init$init(lock)
	};
};
var $author$project$Withdraw$Msg$GotWithdrawn = function (a) {
	return {$: 4, a: a};
};
var $author$project$Shared$User$Cmd$withdrawn = F4(
	function (_v0, msg, useCache, _v1) {
		var api = _v0;
		var address = _v1;
		return $elm$http$Http$get(
			{
				bF: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$dict($author$project$Shared$Json$bigInt)),
				cN: A2($author$project$Shared$Cmd$cache, useCache, api + ('/user/' + (address + '/withdrawn')))
			});
	});
var $author$project$Withdraw$Init$init = F2(
	function (api, user) {
		return _Utils_Tuple2(
			{gZ: '', hK: false, h1: $elm$core$Maybe$Nothing, iG: 0, lo: $elm$core$Dict$empty},
			A2(
				$author$project$Common$Cmd$try,
				A3($author$project$Shared$User$Cmd$withdrawn, api, $author$project$Withdraw$Msg$GotWithdrawn, false),
				user.gV));
	});
var $author$project$Home$Update$refreshOnTxSucceed = A2(
	$andrewMacmurray$elm_delay$Delay$after,
	2000,
	$author$project$Home$Msg$Refresh($author$project$Shared$Msg$Once));
var $author$project$Port$scroll = _Platform_outgoingPort('scroll', $elm$json$Json$Encode$string);
var $author$project$Common$Slides$runAnimation = _Platform_outgoingPort(
	'runAnimation',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Common$Slides$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var prevSlide = msg.a;
			return _Utils_eq(model.ah, prevSlide) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ah: A2($elm$core$Basics$modBy, model.gl, prevSlide + 1)
					}),
				$author$project$Common$Slides$runAnimation(0)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var slide = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ah: slide, cl: 0}),
				$author$project$Common$Slides$runAnimation(0));
		}
	});
var $author$project$Home$ChangeCollateral$updateCollateral = _Platform_outgoingPort(
	'updateCollateral',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'collateral',
					$elm$json$Json$Encode$bool($.r)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Home$ChangeCollateral$update = F5(
	function (assets, market, user, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, market.bh, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Home$ChangeCollateral$updateCollateral(
							{
								g5: market.iT,
								r: model.r,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 3:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Vesting$Model$Claim = function (a) {
	return {$: 3, a: a};
};
var $author$project$Home$Vesting$Msg$Claim = function (a) {
	return {$: 7, a: a};
};
var $author$project$Home$Vesting$Model$Convert = function (a) {
	return {$: 1, a: a};
};
var $author$project$Home$Vesting$Msg$Convert = function (a) {
	return {$: 5, a: a};
};
var $author$project$Home$Vesting$Model$Withdraw = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Vesting$Msg$Withdraw = function (a) {
	return {$: 6, a: a};
};
var $author$project$Home$Vesting$Claim$Init$init = {hK: true, h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$Home$Vesting$Convert$Init$init = {h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$Home$Vesting$Withdraw$SURF_Msg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Home$Vesting$Shared$Data$regular = 'Regular';
var $author$project$Home$Vesting$Shared$Data$whale = 'Whale';
var $author$project$Home$Vesting$L2$Init$init = function (regularVested) {
	return _Utils_Tuple2(
		{
			gZ: '',
			g3: $elm$core$Maybe$Just(0.3),
			hK: false,
			h1: $elm$core$Maybe$Nothing,
			h8: A3(
				$author$project$Common$Base$iff,
				$author$project$Home$Vesting$Shared$Data$whale,
				$author$project$Home$Vesting$Shared$Data$regular,
				_Utils_eq(regularVested, $elm$core$Maybe$Nothing)),
			iG: 0,
			kg: true
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Home$Vesting$USDN$Init$init = {h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$Home$Vesting$Withdraw$init = function (regularVested) {
	var _v0 = $author$project$Home$Vesting$L2$Init$init(regularVested);
	var l2Model = _v0.a;
	var l2Cmd = _v0.b;
	return _Utils_Tuple2(
		{Y: 0, ab: l2Model, aC: $author$project$Home$Vesting$USDN$Init$init},
		A2($elm$core$Platform$Cmd$map, $author$project$Home$Vesting$Withdraw$SURF_Msg, l2Cmd));
};
var $author$project$Home$Vesting$Shared$Logic$totalVested = function (model) {
	var _v0 = _Utils_Tuple2(model.jN, model.lk);
	if (_v0.a.$ === 1) {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var w = _v0.b.a;
			return $elm$core$Maybe$Just(
				{
					bi: 0,
					hz: 0,
					f4: {bm: 0, kL: 0},
					kL: w.kL
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		if (_v0.b.$ === 1) {
			var r = _v0.a.a;
			var _v1 = _v0.b;
			return $elm$core$Maybe$Just(r);
		} else {
			var r = _v0.a.a;
			var w = _v0.b.a;
			return $elm$core$Maybe$Just(
				_Utils_update(
					r,
					{bi: r.bi + w.g8, kL: r.kL + w.kL}));
		}
	}
};
var $author$project$Shared$Asset$Logic$getXTN = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ac;
			},
			$elm$core$Basics$eq('XTN'))),
	$elm$core$List$head);
var $author$project$Shared$Fee$Update$update = F2(
	function (feeAssetId, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					h1: $elm$core$Maybe$Just(feeAssetId)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Home$Vesting$Claim$Port$vestingAllClaimRewards = _Platform_outgoingPort(
	'vestingAllClaimRewards',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Home$Vesting$Claim$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 1:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			case 0:
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var usdn = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Home$Vesting$Claim$Port$vestingAllClaimRewards(
							{
								gZ: 100,
								g5: usdn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Vesting$Convert$Port$convertToUSDN = _Platform_outgoingPort(
	'convertToUSDN',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Home$Vesting$Shared$Logic$totalFromMigratedUSDN = A2($elm$core$Basics$composeR, $elm$core$Dict$values, $elm$core$List$sum);
var $author$project$Home$Vesting$Shared$Logic$liquidationBonus = 0.05;
var $author$project$Home$Vesting$Shared$Logic$withLiquidationBonus = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$toFloat,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$mul(1 + $author$project$Home$Vesting$Shared$Logic$liquidationBonus),
		$elm$core$Basics$round));
var $author$project$Home$Vesting$Convert$Update$update = F5(
	function (assets, user, migrated, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var usdn = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Home$Vesting$Convert$Port$convertToUSDN(
							{
								gZ: $author$project$Home$Vesting$Shared$Logic$withLiquidationBonus(
									$author$project$Home$Vesting$Shared$Logic$totalFromMigratedUSDN(migrated)),
								g5: usdn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 2:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Vesting$Withdraw$USDN_Msg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Home$Vesting$L2$Port$withdrawVestedRegularToL2 = _Platform_outgoingPort(
	'withdrawVestedRegularToL2',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'amt',
					$elm$json$Json$Encode$int($.c4)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'stake',
					$elm$json$Json$Encode$bool($.kg))
				]));
	});
var $author$project$Home$Vesting$L2$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 0:
				var amount = msg.a;
				var _v1 = _Utils_Tuple3(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets),
					_Utils_eq(model.h8, $author$project$Home$Vesting$Shared$Data$regular));
				if (((!_v1.a.$) && (!_v1.b.$)) && _v1.c) {
					var feeAsset = _v1.a.a;
					var xtn = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Home$Vesting$L2$Port$withdrawVestedRegularToL2(
							{
								gZ: amount,
								c4: amount,
								g5: xtn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								kg: model.kg
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 1:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			case 2:
				var s = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{kg: s}));
			case 3:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: a})));
			case 5:
				var amount = msg.a;
				var _v2 = $author$project$Shared$Asset$Logic$getXTN(assets);
				if (!_v2.$) {
					var usdn = _v2.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$dirty(
							_Utils_update(
								model,
								{
									gZ: $elm$core$String$fromFloat(
										A2($author$project$Shared$Market$Logic$inOrig, usdn, amount))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				var f = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{h8: f}));
		}
	});
var $author$project$Home$Vesting$USDN$Port$withdrawVestedAllUSDN = _Platform_outgoingPort(
	'withdrawVestedAllUSDN',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'regular',
					$elm$json$Json$Encode$bool($.fH)),
					_Utils_Tuple2(
					'whale',
					$elm$json$Json$Encode$bool($.gI))
				]));
	});
var $author$project$Home$Vesting$USDN$Update$update = F5(
	function (assets, user, vested, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var usdn = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Home$Vesting$USDN$Port$withdrawVestedAllUSDN(
							{
								gZ: vested.bi,
								g5: usdn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								fH: true,
								gI: false
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 2:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Vesting$Withdraw$update = F6(
	function (api, assets, user, vested, msg, model) {
		switch (msg.$) {
			case 2:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{Y: t}));
			case 0:
				var msg1 = msg.a;
				var _v1 = A5($author$project$Home$Vesting$USDN$Update$update, assets, user, vested, msg1, model.aC);
				var m = _v1.a;
				var c = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aC: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$Home$Vesting$Withdraw$USDN_Msg, c));
			case 1:
				var msg1 = msg.a;
				var _v2 = A4($author$project$Home$Vesting$L2$Update$update, assets, user, msg1, model.ab);
				var m = _v2.a;
				var c = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ab: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$Home$Vesting$Withdraw$SURF_Msg, c));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Vesting$Update$update = F5(
	function (api, assets, user, msg, model) {
		var close = function (_v11) {
			return _Utils_update(
				model,
				{dQ: $author$project$Home$Vesting$Model$None});
		};
		var close0 = A2($elm$core$Basics$composeR, close, $author$project$Common$Cmd$no);
		_v0$14:
		while (true) {
			switch (msg.$) {
				case 3:
					if (!msg.a.$) {
						var _v1 = msg.a.a;
						var migrated = _v1.a;
						var vested = _v1.b;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{iZ: migrated, lk: vested}));
					} else {
						break _v0$14;
					}
				case 4:
					if (!msg.a.$) {
						var vested = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{jN: vested}));
					} else {
						break _v0$14;
					}
				case 0:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								dQ: $author$project$Home$Vesting$Model$Convert($author$project$Home$Vesting$Convert$Init$init)
							}));
				case 1:
					var _v2 = $author$project$Home$Vesting$Withdraw$init(model.jN);
					var wd = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dQ: $author$project$Home$Vesting$Model$Withdraw(wd)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Home$Vesting$Msg$Withdraw, cmd),
									A2(
									$author$project$Common$Cmd$try,
									A2($author$project$Home$Vesting$Cmd$load, api, true),
									user.gV)
								])));
				case 2:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								dQ: $author$project$Home$Vesting$Model$Claim($author$project$Home$Vesting$Claim$Init$init)
							}));
				case 8:
					return _Utils_Tuple2(
						close(0),
						A2(
							$author$project$Common$Cmd$try,
							A2($author$project$Home$Vesting$Cmd$load, api, false),
							user.gV));
				case 9:
					return close0(0);
				case 5:
					if (msg.a.$ === 1) {
						var _v3 = msg.a;
						return close0(0);
					} else {
						break _v0$14;
					}
				case 6:
					if (msg.a.$ === 3) {
						var _v4 = msg.a;
						return close0(0);
					} else {
						break _v0$14;
					}
				case 7:
					if (msg.a.$ === 2) {
						var _v5 = msg.a;
						return close0(0);
					} else {
						break _v0$14;
					}
				case 11:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{dQ: $author$project$Home$Vesting$Model$None, iZ: $elm$core$Dict$empty, jN: $elm$core$Maybe$Nothing, lk: $elm$core$Maybe$Nothing}));
				case 10:
					var adr = msg.a;
					return _Utils_Tuple2(
						model,
						A3($author$project$Home$Vesting$Cmd$load, api, true, adr));
				case 13:
					if (!msg.a) {
						var _v6 = msg.a;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Common$Cmd$try,
								A2($author$project$Home$Vesting$Cmd$load, api, true),
								user.gV));
					} else {
						break _v0$14;
					}
				default:
					if (!msg.a.$) {
						var _v7 = msg.a.a;
						var pausedAll = _v7.a;
						var paused = _v7.b;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{js: pausedAll && paused}));
					} else {
						break _v0$14;
					}
			}
		}
		var dialog = F3(
			function (mapDialog, mapCmd, _v10) {
				var m = _v10.a;
				var c = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: mapDialog(m)
						}),
					A2($elm$core$Platform$Cmd$map, mapCmd, c));
			});
		var _v8 = _Utils_Tuple2(model.dQ, msg);
		_v8$3:
		while (true) {
			switch (_v8.a.$) {
				case 1:
					if (_v8.b.$ === 5) {
						var convert = _v8.a.a;
						var msg1 = _v8.b.a;
						return A3(
							dialog,
							$author$project$Home$Vesting$Model$Convert,
							$author$project$Home$Vesting$Msg$Convert,
							A5($author$project$Home$Vesting$Convert$Update$update, assets, user, model.iZ, msg1, convert));
					} else {
						break _v8$3;
					}
				case 2:
					if (_v8.b.$ === 6) {
						var withdraw = _v8.a.a;
						var msg1 = _v8.b.a;
						var _v9 = $author$project$Home$Vesting$Shared$Logic$totalVested(model);
						if (!_v9.$) {
							var vested = _v9.a;
							return A3(
								dialog,
								$author$project$Home$Vesting$Model$Withdraw,
								$author$project$Home$Vesting$Msg$Withdraw,
								A6($author$project$Home$Vesting$Withdraw$update, api, assets, user, vested, msg1, withdraw));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					} else {
						break _v8$3;
					}
				case 3:
					if (_v8.b.$ === 7) {
						var claim = _v8.a.a;
						var msg1 = _v8.b.a;
						return A3(
							dialog,
							$author$project$Home$Vesting$Model$Claim,
							$author$project$Home$Vesting$Msg$Claim,
							A4($author$project$Home$Vesting$Claim$Update$update, assets, user, msg1, claim));
					} else {
						break _v8$3;
					}
				default:
					break _v8$3;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Shared$Asset$Route$url = $elm$core$Basics$append('/markets/');
var $author$project$Markets$Update$update = F3(
	function (key, msg, model) {
		switch (msg.$) {
			case 1:
				var reserveAddress = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Shared$Asset$Route$url(reserveAddress)));
			case 2:
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{ka: true}));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Repay$Port$collapseDebt = _Platform_outgoingPort(
	'collapseDebt',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmountUsd',
					$elm$json$Json$Encode$float($.Z)),
					_Utils_Tuple2(
					'gaUsdRate',
					$elm$json$Json$Encode$float($._))
				]));
	});
var $author$project$Shared$Market$Logic$usdtDenominator = 1000000;
var $author$project$Shared$Market$Logic$usdRate = F2(
	function (rates, assetId) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Dict$get, assetId, rates)) / $author$project$Shared$Market$Logic$usdtDenominator;
	});
var $author$project$Shared$Market$Logic$inUsd = F3(
	function (rates, asset, notDenominated) {
		return (!notDenominated) ? 0 : (A2($author$project$Shared$Market$Logic$inOrigNoCheck, asset, notDenominated) * A2($author$project$Shared$Market$Logic$usdRate, rates, asset.bP));
	});
var $author$project$VToken$Shared$Logic$price = function (state) {
	return state.gb / state.k4;
};
var $author$project$Repay$Port$repay = _Platform_outgoingPort(
	'repay',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmountUsd',
					$elm$json$Json$Encode$float($.Z)),
					_Utils_Tuple2(
					'gaUsdRate',
					$elm$json$Json$Encode$float($._)),
					_Utils_Tuple2(
					'paymentAmount',
					$elm$json$Json$Encode$int($.fp))
				]));
	});
var $author$project$Repay$Port$repayWithAtoken = _Platform_outgoingPort(
	'repayWithAtoken',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'aTokensAmount',
					$elm$json$Json$Encode$int($.cU)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmountUsd',
					$elm$json$Json$Encode$float($.Z)),
					_Utils_Tuple2(
					'gaUsdRate',
					$elm$json$Json$Encode$float($._))
				]));
	});
var $author$project$Repay$Update$update = F6(
	function (rates, assets, user, m, msg, model) {
		switch (msg.$) {
			case 0:
				var str = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: str})));
			case 2:
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$reset(
						_Utils_update(
							model,
							{gZ: ''})));
			case 1:
				var satoshi = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{
								gZ: $elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, m.bh, satoshi))
							})));
			case 5:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			case 3:
				var amount = msg.a;
				var usdRate_ = A2($author$project$Shared$Market$Logic$usdRate, rates, m.bh.bP);
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						_Utils_eq(model.jR, $author$project$Repay$Logic$fromSupply) ? $author$project$Repay$Port$collapseDebt(
							{
								gZ: amount,
								g5: m.iT,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								Z: A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, amount),
								_: usdRate_
							}) : (_Utils_eq(model.jR, m.gO) ? $author$project$Repay$Port$repayWithAtoken(
							{
								cU: amount,
								g5: m.iT,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								Z: $author$project$VToken$Shared$Logic$price(m.f6) * A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, amount),
								_: usdRate_
							}) : $author$project$Repay$Port$repay(
							{
								g5: m.iT,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								Z: A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, amount),
								_: usdRate_,
								fp: amount
							})));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 4:
				var r = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{jR: r}));
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Vires$Msg$Claim = function (a) {
	return {$: 0, a: a};
};
var $author$project$Vires$Claim$Logic$all = F2(
	function (ebRewards, rewards) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.c8;
				},
				ebRewards)) + $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.c8;
				},
				$elm$core$Dict$values(rewards)));
	});
var $author$project$Vires$Claim$Port$claimAllRewardsAndAllEbAvailable2 = _Platform_outgoingPort(
	'claimAllRewardsAndAllEbAvailable2',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'displayAmount',
					$elm$json$Json$Encode$int($.dV)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'lock',
					$elm$json$Json$Encode$bool($.iI)),
					_Utils_Tuple2(
					'unstakeLegacy',
					$elm$json$Json$Encode$bool($.gx))
				]));
	});
var $author$project$Vires$Claim$Update$update = F6(
	function (assets, user, rewards, ebRewards, msg, model) {
		switch (msg.$) {
			case 1:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(a)
						}));
			case 3:
				var l = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{iI: l}));
			case 4:
				var m = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{iB: m}));
			case 0:
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$Vires$Claim$Port$claimAllRewardsAndAllEbAvailable2(
							{
								dV: A2($author$project$Vires$Claim$Logic$all, ebRewards, rewards),
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								iI: model.iI,
								gx: model.iB
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Vires$Update$update = F6(
	function (rewards, ebRewards, assets, user, msg, model) {
		if (!msg.$) {
			var msg1 = msg.a;
			var _v1 = A6($author$project$Vires$Claim$Update$update, assets, user, rewards, ebRewards, msg1, model.hh);
			var m = _v1.a;
			var c = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{hh: m}),
				A2($elm$core$Platform$Cmd$map, $author$project$Vires$Msg$Claim, c));
		} else {
			return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Shared$Suppy$Logic$isProtectedCollateral = F2(
	function (m, userData) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.gb;
			},
			A2($author$project$Shared$User$Logic$ofMarket, m, userData));
		if (((!_v0.$) && (!_v0.a.$)) && (_v0.a.c === 1)) {
			var _v1 = _v0.a;
			var _v2 = _v1.c;
			return true;
		} else {
			return false;
		}
	});
var $author$project$Withdraw$Port$supplyUnlockedLPTokens = _Platform_outgoingPort(
	'supplyUnlockedLPTokens',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Shared$User$Logic$userTotalSupply = F2(
	function (state, supply) {
		if (!supply.$) {
			var a = supply.a;
			return a;
		} else {
			var lp = supply.a;
			return $elm$core$Basics$round(
				lp * $author$project$VToken$Shared$Logic$price(state));
		}
	});
var $author$project$Withdraw$Port$withdraw2 = _Platform_outgoingPort(
	'withdraw2',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'displayAmount',
					$elm$json$Json$Encode$int($.dV)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmountUsd',
					$elm$json$Json$Encode$float($.Z)),
					_Utils_Tuple2(
					'gaUsdRate',
					$elm$json$Json$Encode$float($._)),
					_Utils_Tuple2(
					'reserve',
					$elm$json$Json$Encode$string($.jS))
				]));
	});
var $author$project$Withdraw$Port$withdrawProtectedCollateral = _Platform_outgoingPort(
	'withdrawProtectedCollateral',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'displayAmount',
					$elm$json$Json$Encode$int($.dV)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'gaAmountUsd',
					$elm$json$Json$Encode$float($.Z)),
					_Utils_Tuple2(
					'gaUsdRate',
					$elm$json$Json$Encode$float($._))
				]));
	});
var $author$project$Withdraw$Update$update = F7(
	function (rates, assets, user, userData, m, msg, model) {
		var supply = A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$User$Logic$ofMarket(m),
			$elm$core$Maybe$andThen(
				function ($) {
					return $.gb;
				}));
		var deposit = $author$project$Shared$User$Logic$userTotalSupply(m.f6);
		switch (msg.$) {
			case 0:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: a})));
			case 1:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{
								gZ: $elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, m.bh, a))
							})));
			case 3:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			case 2:
				var amount = msg.a;
				var _v1 = A2(
					$elm$core$Maybe$map,
					deposit,
					supply(userData));
				if (!_v1.$) {
					var supplied = _v1.a;
					var _v2 = (_Utils_cmp(amount, supplied) > -1) ? _Utils_Tuple2(-1, supplied) : _Utils_Tuple2(amount, amount);
					var amountArg = _v2.a;
					var displayArg = _v2.b;
					var _v3 = _Utils_Tuple2(
						A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
						A2($author$project$Shared$Suppy$Logic$isProtectedCollateral, m, userData));
					if (!_v3.a.$) {
						if (_v3.b) {
							var feeAsset = _v3.a.a;
							return _Utils_Tuple2(
								$author$project$Shared$Update$loading(model),
								$author$project$Withdraw$Port$withdrawProtectedCollateral(
									{
										gZ: amountArg,
										g5: m.iT,
										dV: displayArg,
										h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
										h1: feeAsset.bP,
										Z: A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, amount),
										_: A2($author$project$Shared$Market$Logic$usdRate, rates, m.bh.bP)
									}));
						} else {
							var feeAsset = _v3.a.a;
							return _Utils_Tuple2(
								$author$project$Shared$Update$loading(model),
								$author$project$Withdraw$Port$withdraw2(
									{
										gZ: amountArg,
										dV: displayArg,
										h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
										h1: feeAsset.bP,
										Z: A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, amount),
										_: A2($author$project$Shared$Market$Logic$usdRate, rates, m.bh.bP),
										jS: m.jT
									}));
						}
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 4:
				if (!msg.a.$) {
					var w = msg.a.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{lo: w}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 5:
				return $author$project$Common$Cmd$no(model);
			case 6:
				var _v4 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					supply(userData));
				if ((!_v4.a.$) && (!_v4.b.$)) {
					var feeAsset = _v4.a.a;
					var supply_ = _v4.b.a;
					var cmd = $author$project$Withdraw$Port$supplyUnlockedLPTokens(
						{
							gZ: deposit(supply_),
							g5: m.iT,
							h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
							h1: feeAsset.bP
						});
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						cmd);
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Home$Update$update = F9(
	function (key, api, lock, rates, assets, markets, user, msg, model) {
		var navigateToGovernance = function (_v30) {
			return _Utils_Tuple2(
				model,
				A2($elm$browser$Browser$Navigation$pushUrl, key, '/governance'));
		};
		var gotoMarkets = function (_v29) {
			return _Utils_Tuple2(
				model,
				$author$project$Port$scroll('all-markets'));
		};
		var forceRefresh = function (u) {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Common$Cmd$try,
						A2($author$project$Home$Cmd$refreshCommand, api, false),
						u.gV),
						$author$project$Port$broadcast('wallet.refresh')
					]));
		};
		var open = F3(
			function (mapDialog, mapCmd, _v28) {
				var dialog = _v28.a;
				var cmd = _v28.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jl: $elm$core$Maybe$Just(
								mapDialog(dialog))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, mapCmd, cmd),
								forceRefresh(user)
							])));
			});
		_v0$28:
		while (true) {
			switch (msg.$) {
				case 0:
					var address = msg.a;
					return A3($author$project$Home$Cmd$loadUserDataAndScheduleRefresh, api, address, model);
				case 1:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{j$: $elm$core$Dict$empty, k$: $elm$core$Dict$empty}));
				case 16:
					if (!msg.a) {
						var _v1 = msg.a;
						return _Utils_Tuple2(
							model,
							forceRefresh(user));
					} else {
						break _v0$28;
					}
				case 14:
					var now = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								jf: $elm$core$Maybe$Just(now)
							}));
				case 15:
					var u = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								iA: $elm$core$Maybe$Just(u),
								jf: $elm$core$Maybe$Just(u)
							}));
				case 13:
					var _v3 = msg.a;
					return A3(
						open,
						$author$project$Home$Model$Vires,
						$author$project$Home$Msg$Claim,
						_Utils_Tuple2(
							$author$project$Vires$Init$init(lock),
							$elm$core$Platform$Cmd$none));
				case 3:
					switch (msg.a.$) {
						case 3:
							var _v2 = msg.a;
							return navigateToGovernance(0);
						case 0:
							var m = msg.a.a;
							return A3(
								open,
								$author$project$Home$Model$Withdraw(m),
								$author$project$Home$Msg$Withdraw,
								A2($author$project$Withdraw$Init$init, api, user));
						case 1:
							var _v5 = msg.a;
							var m = _v5.a;
							var c = _v5.b;
							return A3(
								open,
								$author$project$Home$Model$ChangeCollateral(m),
								$author$project$Home$Msg$ChangeCollateral,
								$author$project$Common$Cmd$no(
									$author$project$Home$ChangeCollateral$init(c)));
						case 4:
							var _v6 = msg.a;
							return _Utils_Tuple2(model, $author$project$Home$Update$openConvertToUSDN);
						default:
							var _v7 = msg.a;
							return gotoMarkets(0);
					}
				case 4:
					if (!msg.a.$) {
						var m = msg.a.a;
						return A3(
							open,
							$author$project$Home$Model$Repay(m),
							$author$project$Home$Msg$Repay,
							$author$project$Common$Cmd$no(
								A3($author$project$Repay$Init$init, user.lh, model.k$, m)));
					} else {
						var _v8 = msg.a;
						return gotoMarkets(0);
					}
				case 2:
					if (!msg.a.$) {
						var _v4 = msg.a;
						return navigateToGovernance(0);
					} else {
						var msg1 = msg.a;
						var _v9 = A3($author$project$Markets$Update$update, key, msg1, model.eY);
						var m1 = _v9.a;
						var c1 = _v9.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{eY: m1}),
							A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Markets, c1));
					}
				case 6:
					var when = msg.a;
					var _v10 = user.gV;
					if (!_v10.$) {
						var address = _v10.a;
						if (!when.$) {
							return _Utils_Tuple2(
								model,
								A3($author$project$Home$Cmd$refreshCommand, api, false, address));
						} else {
							var nonce = when.a;
							if (_Utils_eq(nonce, model.fG)) {
								var nextNonce = nonce + 1;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{fG: nextNonce}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Home$Cmd$scheduleRefresh(nextNonce),
												A3($author$project$Home$Cmd$refreshCommand, api, true, address)
											])));
							} else {
								return $author$project$Common$Cmd$no(model);
							}
						}
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				case 5:
					if (!msg.a.$) {
						var _v12 = msg.a.a;
						var userState = _v12.a;
						var rewards = _v12.b;
						return _Utils_Tuple2(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										iA: $elm$core$Maybe$Nothing,
										j$: rewards,
										k$: A2($author$project$Shared$Suppy$Logic$filterLegacyDust, markets, userState)
									})),
							$author$project$Common$Time$now($author$project$Home$Msg$LastUpdateTime));
					} else {
						break _v0$28;
					}
				case 7:
					var msg1 = msg.a;
					return A2($author$project$Common$Slides$update, msg1, model);
				case 11:
					return _Utils_Tuple2(
						$author$project$Shared$Update$close0(model),
						$author$project$Home$Update$refreshOnTxSucceed);
				case 12:
					return $author$project$Shared$Update$close(model);
				case 8:
					if (msg.a.$ === 6) {
						var _v14 = msg.a;
						return $author$project$Shared$Update$close(model);
					} else {
						break _v0$28;
					}
				case 10:
					if (msg.a.$ === 1) {
						var _v16 = msg.a;
						return $author$project$Shared$Update$close(model);
					} else {
						break _v0$28;
					}
				case 9:
					switch (msg.a.$) {
						case 2:
							var _v15 = msg.a;
							return $author$project$Shared$Update$close(model);
						case 1:
							var p = msg.a.a;
							var changeCollateral = function (s) {
								if (!s.$) {
									var a = s.a;
									var cl = s.b;
									var pr = s.c;
									return A3($author$project$Shared$User$Model$Supply, a, !cl, pr);
								} else {
									return s;
								}
							};
							return _Utils_Tuple2(
								$author$project$Shared$Update$close0(
									_Utils_update(
										model,
										{
											k$: A3(
												$elm$core$Dict$update,
												p.g5,
												$elm$core$Maybe$map(
													function (u) {
														return _Utils_update(
															u,
															{
																gb: A2($elm$core$Maybe$map, changeCollateral, u.gb)
															});
													}),
												model.k$)
										})),
								$author$project$Home$Update$refreshOnTxSucceed);
						default:
							break _v0$28;
					}
				case 17:
					var msg1 = msg.a;
					var _v18 = A5($author$project$Home$Vesting$Update$update, api, assets, user, msg1, model.k6);
					var vesting = _v18.a;
					var vestingCmd = _v18.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k6: vesting}),
						A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Vesting, vestingCmd));
				case 18:
					switch (msg.a.$) {
						case 5:
							var _v13 = msg.a;
							return $author$project$Shared$Update$close(model);
						case 7:
							var _v19 = msg.a;
							return $author$project$Home$Update$closeAndOpenConvertToUSDN(model);
						default:
							break _v0$28;
					}
				default:
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load('https://v2.vires.finance'));
			}
		}
		var _v20 = _Utils_Tuple2(msg, model.jl);
		_v20$4:
		while (true) {
			if (!_v20.b.$) {
				switch (_v20.b.a.$) {
					case 0:
						if (_v20.a.$ === 8) {
							var msg1 = _v20.a.a;
							var _v21 = _v20.b.a;
							var m = _v21.a;
							var b = _v21.b;
							var _v22 = A6($author$project$Repay$Update$update, rates, assets, user, m, msg1, b);
							var m1 = _v22.a;
							var c1 = _v22.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										jl: $elm$core$Maybe$Just(
											A2($author$project$Home$Model$Repay, m, m1))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Repay, c1));
						} else {
							break _v20$4;
						}
					case 3:
						if (_v20.a.$ === 18) {
							var msg1 = _v20.a.a;
							var _v23 = _v20.b.a;
							var m = _v23.a;
							var w = _v23.b;
							var _v24 = A7($author$project$Withdraw$Update$update, rates, assets, user, model.k$, m, msg1, w);
							var wdModel = _v24.a;
							var c1 = _v24.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										jl: $elm$core$Maybe$Just(
											A2($author$project$Home$Model$Withdraw, m, wdModel))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Withdraw, c1));
						} else {
							break _v20$4;
						}
					case 1:
						if (_v20.a.$ === 9) {
							var msg1 = _v20.a.a;
							var _v25 = _v20.b.a;
							var m = _v25.a;
							var b = _v25.b;
							var _v26 = A5($author$project$Home$ChangeCollateral$update, assets, m, user, msg1, b);
							var m1 = _v26.a;
							var c1 = _v26.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										jl: $elm$core$Maybe$Just(
											A2($author$project$Home$Model$ChangeCollateral, m, m1))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$ChangeCollateral, c1));
						} else {
							break _v20$4;
						}
					default:
						if (_v20.a.$ === 10) {
							var msg1 = _v20.a.a;
							var cm = _v20.b.a.a;
							var _v27 = A6($author$project$Vires$Update$update, model.j$, user.hN, assets, user, msg1, cm);
							var m1 = _v27.a;
							var c1 = _v27.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										jl: $elm$core$Maybe$Just(
											$author$project$Home$Model$Vires(m1))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Home$Msg$Claim, c1));
						} else {
							break _v20$4;
						}
				}
			} else {
				break _v20$4;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$Shared$Asset$Data$imageUrl = function (id) {
	return 'https://r.wavesexplorer.com/assets/site/img/assets_logo/' + (id + '.svg');
};
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $nathanjohnson320$base58$Base58$alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $nathanjohnson320$base58$Base58$alphabetLength = $cmditch$elm_bigint$BigInt$fromInt(
	$elm$core$String$length($nathanjohnson320$base58$Base58$alphabet));
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $nathanjohnson320$base58$Base58$getIndex = function (_char) {
	return A2(
		$elm$core$Result$map,
		$cmditch$elm_bigint$BigInt$fromInt,
		A2(
			$elm$core$Result$fromMaybe,
			'\'' + ($elm$core$String$fromChar(_char) + '\' is not a valid base58 character.'),
			$elm$core$List$head(
				A2(
					$elm$core$String$indexes,
					$elm$core$String$fromChar(_char),
					$nathanjohnson320$base58$Base58$alphabet))));
};
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $nathanjohnson320$base58$Base58$decode = function (str) {
	var strList = $elm$core$String$toList(str);
	var _v0 = A3(
		$elm$core$List$foldr,
		F2(
			function (letter, _v1) {
				var multi = _v1.a;
				var dec = _v1.b;
				var result = A2(
					$elm$core$Result$andThen,
					function (n) {
						return A2(
							$elm$core$Result$map,
							$cmditch$elm_bigint$BigInt$add(n),
							dec);
					},
					A2(
						$elm$core$Result$map,
						$cmditch$elm_bigint$BigInt$mul(multi),
						$nathanjohnson320$base58$Base58$getIndex(letter)));
				var mul = A2($cmditch$elm_bigint$BigInt$mul, multi, $nathanjohnson320$base58$Base58$alphabetLength);
				return _Utils_Tuple2(mul, result);
			}),
		_Utils_Tuple2(
			$cmditch$elm_bigint$BigInt$fromInt(1),
			$elm$core$Result$Ok(
				$cmditch$elm_bigint$BigInt$fromInt(0))),
		strList);
	var decodedResult = _v0.b;
	return (str === '') ? $elm$core$Result$Err('An empty string is not valid base58') : decodedResult;
};
var $cmditch$elm_bigint$BigInt$bigIntToInt_ = function (bigInt) {
	_v0$3:
	while (true) {
		switch (bigInt.$) {
			case 2:
				return 0;
			case 0:
				if (bigInt.a.b) {
					if (!bigInt.a.b.b) {
						var _v1 = bigInt.a;
						var a = _v1.a;
						return a;
					} else {
						if (!bigInt.a.b.b.b) {
							var _v2 = bigInt.a;
							var a = _v2.a;
							var _v3 = _v2.b;
							var b = _v3.a;
							return (b * A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude)) + a;
						} else {
							break _v0$3;
						}
					}
				} else {
					break _v0$3;
				}
			default:
				break _v0$3;
		}
	}
	return 42;
};
var $cmditch$elm_bigint$BigInt$abs = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 1:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
		default:
			var i = bigInt;
			return i;
	}
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$gt = F2(
	function (x, y) {
		return A2($cmditch$elm_bigint$BigInt$compare, x, y) === 2;
	});
var $cmditch$elm_bigint$BigInt$lte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$gt, x, y);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $cmditch$elm_bigint$BigInt$sub = F2(
	function (a, b) {
		return A2(
			$cmditch$elm_bigint$BigInt$add,
			a,
			$cmditch$elm_bigint$BigInt$negate(b));
	});
var $cmditch$elm_bigint$BigInt$zero = $cmditch$elm_bigint$BigInt$fromInt(0);
var $cmditch$elm_bigint$BigInt$divmodDigit_ = F4(
	function (to_test, padding, num, den) {
		if (!to_test) {
			return _Utils_Tuple2($cmditch$elm_bigint$BigInt$zero, num);
		} else {
			var x = $cmditch$elm_bigint$BigInt$fromInt(to_test);
			var candidate = A2(
				$cmditch$elm_bigint$BigInt$mul,
				A2($cmditch$elm_bigint$BigInt$mul, x, den),
				padding);
			var _v0 = A2($cmditch$elm_bigint$BigInt$lte, candidate, num) ? _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$mul, x, padding),
				A2($cmditch$elm_bigint$BigInt$sub, num, candidate)) : _Utils_Tuple2($cmditch$elm_bigint$BigInt$zero, num);
			var newdiv = _v0.a;
			var newmod = _v0.b;
			var _v1 = A4($cmditch$elm_bigint$BigInt$divmodDigit_, (to_test / 2) | 0, padding, newmod, den);
			var restdiv = _v1.a;
			var restmod = _v1.b;
			return _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$add, newdiv, restdiv),
				restmod);
		}
	});
var $cmditch$elm_bigint$BigInt$maxDigitBits = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $cmditch$elm_bigint$Constants$maxDigitValue));
var $cmditch$elm_bigint$BigInt$divmodDigit = F3(
	function (padding, x, y) {
		return A4(
			$cmditch$elm_bigint$BigInt$divmodDigit_,
			A2($elm$core$Basics$pow, 2, $cmditch$elm_bigint$BigInt$maxDigitBits),
			padding,
			x,
			y);
	});
var $cmditch$elm_bigint$BigInt$one = $cmditch$elm_bigint$BigInt$fromInt(1);
var $cmditch$elm_bigint$BigInt$repeatedly = F3(
	function (f, x, n) {
		return A3(
			$elm$core$List$foldl,
			$elm$core$Basics$always(f),
			x,
			A2($elm$core$List$range, 1, n));
	});
var $cmditch$elm_bigint$BigInt$padDigits = function (n) {
	return A3(
		$cmditch$elm_bigint$BigInt$repeatedly,
		$cmditch$elm_bigint$BigInt$mul(
			$cmditch$elm_bigint$BigInt$fromInt($cmditch$elm_bigint$BigInt$baseDigit)),
		$cmditch$elm_bigint$BigInt$one,
		n);
};
var $cmditch$elm_bigint$BigInt$divMod_ = F3(
	function (n, num, den) {
		if (!n) {
			return A3(
				$cmditch$elm_bigint$BigInt$divmodDigit,
				$cmditch$elm_bigint$BigInt$padDigits(n),
				num,
				den);
		} else {
			var _v0 = A3(
				$cmditch$elm_bigint$BigInt$divmodDigit,
				$cmditch$elm_bigint$BigInt$padDigits(n),
				num,
				den);
			var cdiv = _v0.a;
			var cmod = _v0.b;
			var _v1 = A3($cmditch$elm_bigint$BigInt$divMod_, n - 1, cmod, den);
			var rdiv = _v1.a;
			var rmod = _v1.b;
			return _Utils_Tuple2(
				A2($cmditch$elm_bigint$BigInt$add, cdiv, rdiv),
				rmod);
		}
	});
var $cmditch$elm_bigint$BigInt$toDigits = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var ds = bigInt.a;
			return ds;
		default:
			var ds = bigInt.a;
			return ds;
	}
};
var $cmditch$elm_bigint$BigInt$divmod = F2(
	function (num, den) {
		if (_Utils_eq(den, $cmditch$elm_bigint$BigInt$zero)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var cand_l = ($elm$core$List$length(
				$cmditch$elm_bigint$BigInt$toDigits(num)) - $elm$core$List$length(
				$cmditch$elm_bigint$BigInt$toDigits(den))) + 1;
			var _v0 = A3(
				$cmditch$elm_bigint$BigInt$divMod_,
				A2($elm$core$Basics$max, 0, cand_l),
				$cmditch$elm_bigint$BigInt$abs(num),
				$cmditch$elm_bigint$BigInt$abs(den));
			var d = _v0.a;
			var m = _v0.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						A2(
							$cmditch$elm_bigint$BigInt$signProduct,
							$cmditch$elm_bigint$BigInt$sign(num),
							$cmditch$elm_bigint$BigInt$sign(den)),
						$cmditch$elm_bigint$BigInt$magnitude(d)),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						$cmditch$elm_bigint$BigInt$sign(num),
						$cmditch$elm_bigint$BigInt$magnitude(m))));
		}
	});
var $cmditch$elm_bigint$BigInt$eightHexDigits = A2(
	$cmditch$elm_bigint$BigInt$mul,
	$cmditch$elm_bigint$BigInt$fromInt(2),
	$cmditch$elm_bigint$BigInt$fromInt(2147483648));
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $cmditch$elm_bigint$BigInt$hexMagnitudeToString = function (bigInt) {
	var _v0 = A2($cmditch$elm_bigint$BigInt$divmod, bigInt, $cmditch$elm_bigint$BigInt$eightHexDigits);
	if (_v0.$ === 1) {
		return 'Failure converting BigInt to hex string. Should be impossible. Open up issue on the elm-bigint repo.';
	} else {
		var _v1 = _v0.a;
		var d = _v1.a;
		var r = _v1.b;
		var rString = $rtfeldman$elm_hex$Hex$toString(
			$cmditch$elm_bigint$BigInt$bigIntToInt_(r));
		return _Utils_eq(
			d,
			$cmditch$elm_bigint$BigInt$fromInt(0)) ? rString : _Utils_ap(
			$cmditch$elm_bigint$BigInt$hexMagnitudeToString(d),
			A3($elm$core$String$padLeft, 8, '0', rString));
	}
};
var $cmditch$elm_bigint$BigInt$toHexString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return _Utils_eq(mag, _List_Nil) ? '0' : $cmditch$elm_bigint$BigInt$hexMagnitudeToString(
				$cmditch$elm_bigint$BigInt$Pos(mag));
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$toHexString(
				A2(
					$cmditch$elm_bigint$BigInt$mul,
					$cmditch$elm_bigint$BigInt$fromInt(-1),
					bigInt));
	}
};
var $author$project$Shared$Waves$Asset$toEth = function (_v0) {
	var waves = _v0;
	var _v1 = $nathanjohnson320$base58$Base58$decode(waves);
	if (!_v1.$) {
		var bigInt = _v1.a;
		return '0x' + A3(
			$elm$core$String$slice,
			0,
			40,
			$cmditch$elm_bigint$BigInt$toHexString(bigInt));
	} else {
		return 'Invalid waves asset';
	}
};
var $author$project$Shared$Asset$Port$watchAsset = _Platform_outgoingPort(
	'watchAsset',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.gV)),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int($.hC)),
					_Utils_Tuple2(
					'image',
					$elm$json$Json$Encode$string($.il)),
					_Utils_Tuple2(
					'symbol',
					$elm$json$Json$Encode$string($.ks))
				]));
	});
var $author$project$MarketDetail$Update$update = F3(
	function (m, msg, model) {
		switch (msg.$) {
			case 0:
				var x = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							k3: $elm$core$Maybe$Just(x)
						}));
			case 1:
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{k3: $elm$core$Maybe$Nothing}));
			case 2:
				var a = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j9: a}),
					A2(
						$author$project$Port$setItem2,
						'Compound',
						$elm$core$Maybe$Just(
							A3($author$project$Common$Base$iff, 'true', 'false', a))));
			case 3:
				if ((msg.a === 'Compound') && (!msg.b.$)) {
					var compound = msg.b.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{j9: compound === 'true'}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 4:
				var a = msg.a;
				var id = a;
				var symbol = _Utils_eq(id, m.bh.bP) ? m.bh.ac : A2($elm$core$String$left, 5, 'v' + m.bh.ac);
				return _Utils_Tuple2(
					model,
					$author$project$Shared$Asset$Port$watchAsset(
						{
							gV: $author$project$Shared$Waves$Asset$toEth(a),
							hC: m.bh.hC,
							il: $author$project$Shared$Asset$Data$imageUrl(id),
							ks: symbol
						}));
			default:
				var s = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Port$copy(s));
		}
	});
var $author$project$RaF$Update$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var link = msg.a;
			return _Utils_Tuple2(
				model,
				$author$project$Port$copy(link));
		} else {
			return $author$project$Common$Cmd$no(model);
		}
	});
var $pablen$toasty$Toasty$Leaving = 1;
var $pablen$toasty$Toasty$Remove = function (a) {
	return {$: 1, a: a};
};
var $pablen$toasty$Toasty$update = F4(
	function (_v0, tagger, msg, model) {
		var cfg = _v0;
		var _v1 = model.kJ;
		var toasts = _v1.a;
		var seed = _v1.b;
		switch (msg.$) {
			case 0:
				var toast = msg.a;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$pablen$toasty$Toasty$config,
					tagger,
					toast,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 1:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$filter,
					function (_v3) {
						var id = _v3.a;
						var toast = _v3.b;
						var status = _v3.c;
						return !_Utils_eq(id, targetId);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kJ: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$map,
					function (_v5) {
						var id = _v5.a;
						var status = _v5.b;
						var toast = _v5.c;
						return _Utils_eq(id, targetId) ? _Utils_Tuple3(id, 1, toast) : _Utils_Tuple3(id, status, toast);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kJ: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					A2(
						$elm$core$Task$perform,
						function (_v4) {
							return tagger(
								$pablen$toasty$Toasty$Remove(targetId));
						},
						$elm$core$Process$sleep(cfg.cK)));
		}
	});
var $author$project$User$Connect$Port$askKeeperInstalled = _Platform_outgoingPort(
	'askKeeperInstalled',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Port$close = $author$project$Port$broadcast('close');
var $author$project$User$Connect$Port$login = _Platform_outgoingPort('login', $elm$json$Json$Encode$string);
var $author$project$User$Connect$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 6:
				return _Utils_Tuple2(
					model,
					$author$project$User$Connect$Port$askKeeperInstalled(0));
			case 7:
				return _Utils_Tuple2(
					model,
					$author$project$Shared$Etherium$Port$getEthereumWalletInstalled(0));
			case 1:
				var installed = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{iv: installed}));
			case 2:
				var installed = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{iW: installed}));
			case 0:
				var _with = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$User$Connect$Port$login(_with),
								$author$project$Port$close
							])));
			case 4:
				return $author$project$Common$Cmd$no(model);
			case 3:
				if (((msg.a === 'termsAccepted') && (!msg.b.$)) && (msg.b.a === 'true')) {
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{ku: true}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 5:
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ku: t}),
					A2(
						$author$project$Port$setItem2,
						'termsAccepted',
						$elm$core$Maybe$Just(
							A3($author$project$Common$Base$iff, 'true', 'false', t))));
			default:
				var url = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							li: A2($elm$core$List$cons, url, model.li)
						}));
		}
	});
var $author$project$User$Model$LoginWith = $elm$core$Basics$identity;
var $author$project$User$Port$logout = _Platform_outgoingPort(
	'logout',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Shared$Wallet$Update$update = F4(
	function (nodeApi, address, msg, model) {
		_v0$5:
		while (true) {
			switch (msg.$) {
				case 1:
					if (!msg.a.$) {
						var balances = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{g6: balances}));
					} else {
						break _v0$5;
					}
				case 0:
					if (!msg.a.$) {
						var balance = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									gF: $elm$core$Maybe$Just(balance)
								}));
					} else {
						break _v0$5;
					}
				case 3:
					var adr = msg.a;
					return A3($author$project$Shared$Wallet$Cmd$loadUserDataAndScheduleRefresh, nodeApi, adr, model);
				case 4:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{g6: $elm$core$Dict$empty, fG: model.fG + 1, gF: $elm$core$Maybe$Nothing}));
				case 2:
					var when = msg.a;
					if (!address.$) {
						var a = address.a;
						if (!when.$) {
							return _Utils_Tuple2(
								model,
								A2($author$project$Shared$Wallet$Cmd$balance, nodeApi, a));
						} else {
							var nonce = when.a;
							if (_Utils_eq(nonce, model.fG)) {
								var nextNonce = nonce + 1;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{fG: nextNonce}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Shared$Wallet$Cmd$scheduleRefresh(nextNonce),
												A2($author$project$Shared$Wallet$Cmd$balance, nodeApi, a)
											])));
							} else {
								return $author$project$Common$Cmd$no(model);
							}
						}
					} else {
						return $author$project$Common$Cmd$no(model);
					}
				default:
					break _v0$5;
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$User$Update$update = F4(
	function (key, _v0, msg, model) {
		var api = _v0.a;
		var nodeApi = _v0.b;
		var close = function (m) {
			return _Utils_update(
				m,
				{jk: false});
		};
		_v1$13:
		while (true) {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var address = msg.a.a;
						return _Utils_Tuple2(
							close(
								_Utils_update(
									model,
									{
										gV: $elm$core$Maybe$Just(address)
									})),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$User$Cmd$userRelatedInfo, api, true, address),
										$author$project$Port$getItem('loginWith')
									])));
					} else {
						return $author$project$Common$Cmd$no(
							close(model));
					}
				case 11:
					if (msg.a === 'loginWith') {
						var l = msg.b;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									iN: A2($elm$core$Maybe$map, $elm$core$Basics$identity, l)
								}));
					} else {
						break _v1$13;
					}
				case 1:
					return _Utils_Tuple2(
						close(model),
						$author$project$User$Port$logout(0));
				case 5:
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$User$Port$logout(0),
									A2($elm$browser$Browser$Navigation$replaceUrl, key, '#connect')
								])));
				case 2:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{gV: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing, ic: $elm$core$Maybe$Nothing, jZ: $elm$core$Dict$empty, lh: $author$project$Shared$Wallet$Model$empty}));
				case 3:
					var isOpened = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{jk: isOpened}));
				case 4:
					var text = msg.a;
					return _Utils_Tuple2(
						close(model),
						$author$project$Port$copy(text));
				case 6:
					var msg1 = msg.a;
					var _v2 = A4($author$project$Shared$Wallet$Update$update, nodeApi, model.gV, msg1, model.lh);
					var w = _v2.a;
					var wc = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{lh: w}),
						A2($elm$core$Platform$Cmd$map, $author$project$User$Msg$Wallet, wc));
				case 7:
					if (!msg.a.$) {
						var data = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									hN: $elm$core$Maybe$Just(data)
								}));
					} else {
						break _v1$13;
					}
				case 8:
					if (!msg.a.$) {
						var data = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									ic: $elm$core$Maybe$Just(data)
								}));
					} else {
						break _v1$13;
					}
				case 10:
					if (!msg.b.$) {
						var adr = msg.a;
						var revenue = msg.b.a;
						return $author$project$Common$Cmd$no(
							_Utils_eq(
								$elm$core$Maybe$Just(adr),
								model.gV) ? _Utils_update(
								model,
								{jZ: revenue}) : model);
					} else {
						break _v1$13;
					}
				default:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Common$Cmd$try,
							A2($author$project$User$Cmd$userRelatedInfo, api, false),
							model.gV));
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$VToken$Msg$PopupMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$VToken$Shared$Init$init = {gZ: '', hK: false, iG: 0};
var $author$project$VToken$Popup$init = {h1: $elm$core$Maybe$Nothing, S: $author$project$VToken$Shared$Init$init, aw: false, jL: $author$project$VToken$Shared$Init$init, W: $author$project$VToken$Shared$Init$init, kt: 0};
var $author$project$VToken$Popup$MintMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Popup$RedeemMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$VToken$Popup$ReplenishMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$VToken$Shared$Logic$onContract = F2(
	function (stakes, m) {
		return A2($elm$core$Dict$get, m.jT, stakes);
	});
var $author$project$VToken$Mint$Port$mintAtoken = _Platform_outgoingPort(
	'mintAtoken',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'aTokensAmount',
					$elm$json$Json$Encode$int($.cU)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$Shared$Update$amount = F2(
	function (s, model) {
		return _Utils_update(
			model,
			{gZ: s});
	});
var $author$project$VToken$Shared$Update$update = F8(
	function (action, feeAssetId, assets, wallets, m, all, msg, model) {
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						A2($author$project$Shared$Update$amount, s, model)));
			case 1:
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						A2(
							$author$project$Shared$Update$amount,
							$elm$core$String$fromFloat(
								A2($author$project$Shared$Market$Logic$inOrig, m.bh, all)),
							model)));
			case 2:
				var amount = msg.a;
				var _v1 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, wallets, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, feeAssetId);
				if (!_v1.$) {
					var feeAsset = _v1.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						action(
							{
								cU: amount,
								g5: m.iT,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			default:
				return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$VToken$Mint$Update$update = $author$project$VToken$Shared$Update$update($author$project$VToken$Mint$Port$mintAtoken);
var $author$project$VToken$Redeem$Port$redeemAtokens = _Platform_outgoingPort(
	'redeemAtokens',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'aTokensAmount',
					$elm$json$Json$Encode$int($.cU)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$VToken$Redeem$Update$update = $author$project$VToken$Shared$Update$update($author$project$VToken$Redeem$Port$redeemAtokens);
var $author$project$VToken$Replenish$Port$replenishWithAtoken = _Platform_outgoingPort(
	'replenishWithAtoken',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'aTokensAmount',
					$elm$json$Json$Encode$int($.cU)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$VToken$Replenish$Update$update = $author$project$VToken$Shared$Update$update($author$project$VToken$Replenish$Port$replenishWithAtoken);
var $author$project$VToken$Popup$update = F6(
	function (market, assets, user, stakes, msg, model) {
		var inWallet = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Shared$Wallet$Logic$wallet, market.gO, user.lh));
		switch (msg.$) {
			case 0:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{kt: t}));
			case 1:
				var msg1 = msg.a;
				var staked = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($author$project$VToken$Shared$Logic$onContract, stakes, market));
				var _v1 = A7($author$project$VToken$Mint$Update$update, model.h1, assets, user, market, staked, msg1, model.S);
				var m = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$VToken$Popup$MintMsg, cmd));
			case 2:
				var msg1 = msg.a;
				var _v2 = A7($author$project$VToken$Redeem$Update$update, model.h1, assets, user, market, inWallet, msg1, model.jL);
				var m = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jL: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$VToken$Popup$RedeemMsg, cmd));
			case 3:
				var msg1 = msg.a;
				var _v3 = A7($author$project$VToken$Replenish$Update$update, model.h1, assets, user, market, inWallet, msg1, model.W);
				var m = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{W: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$VToken$Popup$ReplenishMsg, cmd));
			case 5:
				return $author$project$Common$Cmd$no(model);
			case 4:
				var id = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(id)
						}));
			default:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{aw: a}));
		}
	});
var $author$project$VToken$Vesting$Msg$Manage = function (a) {
	return {$: 3, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Init$init = function (regularVested) {
	return {
		gX: false,
		gZ: '',
		hK: false,
		h1: $elm$core$Maybe$Nothing,
		h8: A3(
			$author$project$Common$Base$iff,
			$author$project$Home$Vesting$Shared$Data$whale,
			$author$project$Home$Vesting$Shared$Data$regular,
			_Utils_eq(regularVested, $elm$core$Maybe$Nothing)),
		iG: 0
	};
};
var $author$project$VToken$Vesting$Manage$Import$Init$init = {gX: false, gZ: '', hK: false, h1: $elm$core$Maybe$Nothing, iG: 0};
var $author$project$VToken$Vesting$Manage$Init$init = function (regularVested) {
	return {
		hY: $author$project$VToken$Vesting$Manage$Export$Init$init(regularVested),
		$9: $author$project$VToken$Vesting$Manage$Import$Init$init,
		kt: 0
	};
};
var $author$project$VToken$Vesting$Manage$Msg$Export = function (a) {
	return {$: 2, a: a};
};
var $author$project$VToken$Vesting$Manage$Msg$Import = function (a) {
	return {$: 3, a: a};
};
var $author$project$Home$Vesting$Shared$Data$vvxtnlp = {hC: 6, bP: '8KEtor9aSsSj38MknyAE7k1uRThHY9prAXgiE4D7WpyL', iP: 'XTN Vesting', ac: 'VVXTNLP'};
var $author$project$VToken$Vesting$Manage$Export$Port$withdrawAsLP = _Platform_outgoingPort(
	'withdrawAsLP',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1)),
					_Utils_Tuple2(
					'regular',
					$elm$json$Json$Encode$int($.fH)),
					_Utils_Tuple2(
					'whale',
					$elm$json$Json$Encode$int($.gI))
				]));
	});
var $author$project$VToken$Vesting$Manage$Export$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 0:
				var amount = msg.a;
				var _v1 = _Utils_Tuple3(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets),
					_Utils_eq(model.h8, $author$project$Home$Vesting$Shared$Data$whale));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var usdn = _v1.b.a;
					var isWhale = _v1.c;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$VToken$Vesting$Manage$Export$Port$withdrawAsLP(
							{
								gZ: amount,
								g5: usdn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP,
								fH: A3($author$project$Common$Base$iff, 0, amount, isWhale),
								gI: A3($author$project$Common$Base$iff, amount, 0, isWhale)
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 1:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			case 2:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: a})));
			case 4:
				var amount = msg.a;
				return _Utils_Tuple2(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{
								gZ: $elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, $author$project$Home$Vesting$Shared$Data$vvxtnlp, amount))
							})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var f = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{h8: f}));
			default:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{gX: a}));
		}
	});
var $author$project$VToken$Vesting$Manage$Import$Port$importLP = _Platform_outgoingPort(
	'importLP',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int($.gZ)),
					_Utils_Tuple2(
					'assetId',
					$elm$json$Json$Encode$string($.g5)),
					_Utils_Tuple2(
					'displayAssetId',
					$elm$json$Json$Encode$string($.dW)),
					_Utils_Tuple2(
					'fee',
					$elm$json$Json$Encode$int($.h0)),
					_Utils_Tuple2(
					'feeAssetId',
					$elm$json$Json$Encode$string($.h1))
				]));
	});
var $author$project$VToken$Vesting$Manage$Import$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 0:
				var amount = msg.a;
				var _v1 = _Utils_Tuple2(
					A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, model.h1),
					$author$project$Shared$Asset$Logic$getXTN(assets));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var feeAsset = _v1.a.a;
					var xtn = _v1.b.a;
					return _Utils_Tuple2(
						$author$project$Shared$Update$loading(model),
						$author$project$VToken$Vesting$Manage$Import$Port$importLP(
							{
								gZ: amount,
								g5: $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP,
								dW: xtn.bP,
								h0: A2($author$project$Shared$Transaction$Logic$feeInAsset, feeAsset, $author$project$Shared$Transaction$Logic$fee.fT),
								h1: feeAsset.bP
							}));
				} else {
					return $author$project$Common$Cmd$no(model);
				}
			case 1:
				var fee = msg.a;
				return A2($author$project$Shared$Fee$Update$update, fee, model);
			case 2:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{gZ: a})));
			case 3:
				var amount = msg.a;
				return _Utils_Tuple2(
					$author$project$Shared$Update$dirty(
						_Utils_update(
							model,
							{
								gZ: $elm$core$String$fromFloat(
									A2($author$project$Shared$Market$Logic$inOrig, $author$project$Home$Vesting$Shared$Data$vvxtnlp, amount))
							})),
					$elm$core$Platform$Cmd$none);
			default:
				var a = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{gX: a}));
		}
	});
var $author$project$VToken$Vesting$Manage$Update$update = F4(
	function (assets, user, msg, model) {
		switch (msg.$) {
			case 1:
				var t = msg.a;
				return $author$project$Common$Cmd$no(
					_Utils_update(
						model,
						{kt: t}));
			case 0:
				return $author$project$Common$Cmd$no(model);
			case 2:
				var msg1 = msg.a;
				var _v1 = A4($author$project$VToken$Vesting$Manage$Export$Update$update, assets, user, msg1, model.hY);
				var m = _v1.a;
				var c = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hY: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$VToken$Vesting$Manage$Msg$Export, c));
			default:
				var msg1 = msg.a;
				var _v2 = A4($author$project$VToken$Vesting$Manage$Import$Update$update, assets, user, msg1, model.$9);
				var m = _v2.a;
				var c = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{$9: m}),
					A2($elm$core$Platform$Cmd$map, $author$project$VToken$Vesting$Manage$Msg$Import, c));
		}
	});
var $author$project$VToken$Vesting$Update$update = F4(
	function (assets, user, msg, model) {
		var close = function (_v4) {
			return $author$project$Common$Cmd$no(
				_Utils_update(
					model,
					{iR: $elm$core$Maybe$Nothing}));
		};
		_v0$6:
		while (true) {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var vested = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{lk: vested}));
					} else {
						break _v0$6;
					}
				case 1:
					if (!msg.a.$) {
						var vested = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{jN: vested}));
					} else {
						break _v0$6;
					}
				case 2:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								iR: $elm$core$Maybe$Just(
									$author$project$VToken$Vesting$Manage$Init$init(model.jN))
							}));
				case 4:
					return close(0);
				default:
					if (!msg.a.$) {
						var _v1 = msg.a;
						return close(0);
					} else {
						var msg1 = msg.a;
						var _v2 = model.iR;
						if (!_v2.$) {
							var manage = _v2.a;
							var _v3 = A4($author$project$VToken$Vesting$Manage$Update$update, assets, user, msg1, manage);
							var m = _v3.a;
							var c = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										iR: $elm$core$Maybe$Just(m)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$VToken$Vesting$Msg$Manage, c));
						} else {
							return $author$project$Common$Cmd$no(model);
						}
					}
			}
		}
		return $author$project$Common$Cmd$no(model);
	});
var $author$project$VToken$Update$update = F5(
	function (api, assets, user, msg, model) {
		var updateActiveOnly = function (active) {
			return _Utils_update(
				model,
				{kc: active});
		};
		_v0$9:
		while (true) {
			switch (msg.$) {
				case 1:
					var address = msg.a;
					return _Utils_Tuple2(
						model,
						A3($author$project$VToken$Cmd$userStake, api, $author$project$VToken$Msg$GotUserStake, address));
				case 2:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{kh: $elm$core$Dict$empty}));
				case 6:
					var active = msg.a;
					return _Utils_Tuple2(
						updateActiveOnly(active),
						A2(
							$author$project$Port$setItem2,
							'vTokens:activeOnly',
							A3(
								$author$project$Common$Base$iff,
								$elm$core$Maybe$Just('true'),
								$elm$core$Maybe$Nothing,
								active)));
				case 7:
					var result = msg.a;
					return A2($author$project$Shared$FAQ$Update$update, result, model);
				case 8:
					var spoiler = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								kf: A2($author$project$Common$Markdown$updateSpoiler, spoiler, model.kf)
							}));
				case 0:
					if (!msg.a.$) {
						var stakes = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{kh: stakes}));
					} else {
						break _v0$9;
					}
				case 3:
					var m = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								gT: $elm$core$Maybe$Just(
									_Utils_Tuple2(m, $author$project$VToken$Popup$init))
							}));
				case 9:
					if (((msg.a === 'vTokens:activeOnly') && (!msg.b.$)) && (msg.b.a === 'true')) {
						return $author$project$Common$Cmd$no(
							updateActiveOnly(true));
					} else {
						break _v0$9;
					}
				case 10:
					var msg1 = msg.a;
					var _v1 = A4($author$project$VToken$Vesting$Update$update, assets, user, msg1, model.k6);
					var m = _v1.a;
					var c = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k6: m}),
						A2($elm$core$Platform$Cmd$map, $author$project$VToken$Msg$Vesting, c));
				default:
					break _v0$9;
			}
		}
		var _v2 = model.gT;
		if (!_v2.$) {
			var _v3 = _v2.a;
			var m = _v3.a;
			var popup = _v3.b;
			var close = function (_v7) {
				return _Utils_update(
					model,
					{gT: $elm$core$Maybe$Nothing});
			};
			switch (msg.$) {
				case 5:
					return _Utils_Tuple2(
						close(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$VToken$Cmd$userStake, api, $author$project$VToken$Msg$GotUserStake),
								user.gV)));
				case 4:
					if (msg.a.$ === 5) {
						var _v5 = msg.a;
						return $author$project$Common$Cmd$no(
							close(0));
					} else {
						var msg1 = msg.a;
						var _v6 = A6($author$project$VToken$Popup$update, m, assets, user, model.kh, msg1, popup);
						var pop = _v6.a;
						var c = _v6.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									gT: $elm$core$Maybe$Just(
										_Utils_Tuple2(m, pop))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$VToken$Msg$PopupMsg, c));
					}
				default:
					return $author$project$Common$Cmd$no(model);
			}
		} else {
			return $author$project$Common$Cmd$no(model);
		}
	});
var $author$project$Shared$Market$Model$ViresMarket = F3(
	function (staked, circulation, total) {
		return {hg: circulation, f3: staked, kL: total};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Cmd$viresMarketDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Shared$Market$Model$ViresMarket,
	A2($elm$json$Json$Decode$field, 'staked', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'circulation', $author$project$Shared$Json$bigInt),
	A2($elm$json$Json$Decode$field, 'total', $author$project$Shared$Json$bigInt));
var $author$project$Cmd$vires = F2(
	function (_v0, msg) {
		var api = _v0;
		return $elm$http$Http$get(
			{
				bF: A2($elm$http$Http$expectJson, msg, $author$project$Cmd$viresMarketDecoder),
				cN: api + '/markets/vires'
			});
	});
var $author$project$Update$update = F2(
	function (msg, model) {
		var refreshNow = function (_v18) {
			var api = model.h3.g_;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Cmd$markets, api, $author$project$Msg$GotMarketsStates),
						A2($author$project$Cmd$Rate$rate, api, $author$project$Msg$GotRates),
						$author$project$Cmd$Rate$newRate($author$project$Msg$GotNewRates),
						A2($author$project$Cmd$vires, api, $author$project$Msg$GotViresMarket),
						A2($author$project$Governance$Cmd$governance, api, $author$project$Msg$GotGovernance)
					]));
		};
		var closePopup = function (_v17) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{jv: $elm$core$Maybe$Nothing}),
				A2($elm$browser$Browser$Navigation$replaceUrl, model.iw, '#'));
		};
		var closeMenu = function (m) {
			return _Utils_update(
				m,
				{i7: false});
		};
		var apis = _Utils_Tuple2(model.h3.g_, model.h3.jb);
		var user = function (userMsg) {
			var _v16 = A4($author$project$User$Update$update, model.iw, apis, userMsg, model.kZ);
			var u = _v16.a;
			var c = _v16.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{kZ: u}),
				A2($elm$core$Platform$Cmd$map, $author$project$Msg$User, c));
		};
		_v0$42:
		while (true) {
			switch (msg.$) {
				case 32:
					var zone = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{kx: zone}));
				case 33:
					var name = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{ky: name}));
				case 34:
					if (!msg.a.$) {
						var h = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									$8: $elm$core$Maybe$Just(h)
								}),
							$author$project$Common$Time$now(
								$author$project$Msg$GotHistoricalHeightTime(h)));
					} else {
						break _v0$42;
					}
				case 35:
					var height = msg.a;
					var time = msg.b;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{
								ii: _Utils_Tuple2(time, height)
							}));
				case 36:
					if (!msg.a.$) {
						var h = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									$8: $elm$core$Maybe$Just(h)
								}));
					} else {
						break _v0$42;
					}
				case 37:
					return _Utils_Tuple2(
						model,
						A2($author$project$Shared$Blockchain$Cmd$height, model.h3.g_, $author$project$Msg$GotHeight));
				case 30:
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{iq: !model.iq}));
				case 0:
					var urlRequest = msg.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							closeMenu(model),
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.iw,
								$elm$url$Url$toString(url)));
					} else {
						if (urlRequest.a === '') {
							return $author$project$Common$Cmd$no(
								closeMenu(model));
						} else {
							var href = urlRequest.a;
							return _Utils_Tuple2(
								closeMenu(model),
								$elm$browser$Browser$Navigation$load(href));
						}
					}
				case 1:
					var route = msg.a;
					return A2(
						$author$project$Navigation$navigate,
						route,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				case 24:
					var s = msg.a;
					return $author$project$Common$Cmd$no(
						closeMenu(
							_Utils_update(
								model,
								{j3: s})));
				case 31:
					var v = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{la: v}));
				case 27:
					if (msg.a === 'en') {
						var lang = msg.a;
						return _Utils_Tuple2(
							closeMenu(
								_Utils_update(
									model,
									{
										iz: lang,
										kT: function () {
											var _v2 = model.kT;
											if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
												var _v3 = _v2.b;
												var fallback = _v3.a;
												return _List_fromArray(
													[fallback]);
											} else {
												return model.kT;
											}
										}()
									})),
							A2(
								$author$project$Port$setItem2,
								'lang',
								$elm$core$Maybe$Just('en')));
					} else {
						var lang = msg.a;
						var l = lang;
						return _Utils_Tuple2(
							closeMenu(
								_Utils_update(
									model,
									{iz: lang})),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Cmd$translation, $author$project$Msg$LanguageLoaded, lang, model.jW),
										A2(
										$author$project$Port$setItem2,
										'lang',
										$elm$core$Maybe$Just(l))
									])));
					}
				case 28:
					if (!msg.a.$) {
						var tr = msg.a.a;
						var translations = function () {
							var _v4 = model.kT;
							if (_v4.b) {
								if (!_v4.b.b) {
									return A2($elm$core$List$cons, tr, model.kT);
								} else {
									var fallback = _v4.b;
									return A2($elm$core$List$cons, tr, fallback);
								}
							} else {
								return _List_fromArray(
									[tr]);
							}
						}();
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{kT: translations}));
					} else {
						break _v0$42;
					}
				case 11:
					if (!msg.a.$) {
						var v = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									k9: $elm$core$Maybe$Just(v)
								}));
					} else {
						break _v0$42;
					}
				case 29:
					if (!msg.a.$) {
						var g = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									ic: $elm$core$Maybe$Just(g)
								}));
					} else {
						break _v0$42;
					}
				case 13:
					if (!msg.a.$) {
						var rates = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{i9: rates})));
					} else {
						break _v0$42;
					}
				case 17:
					var tx = msg.a;
					return A4(
						$pablen$toasty$Toasty$addToast,
						$author$project$Common$Toast$config,
						$author$project$Msg$ToastyMsg,
						$author$project$Toast$TransactionSucceed(tx),
						_Utils_Tuple2(
							model,
							refreshNow(0)));
				case 18:
					var tx = msg.a;
					return A4(
						$pablen$toasty$Toasty$addToast,
						$author$project$Common$Toast$config,
						$author$project$Msg$ToastyMsg,
						$author$project$Toast$UpdatedCollateralSucceed(tx),
						$author$project$Common$Cmd$no(model));
				case 26:
					var message = msg.a;
					return A4(
						$pablen$toasty$Toasty$addToast,
						$author$project$Common$Toast$config,
						$author$project$Msg$ToastyMsg,
						$author$project$Toast$Info(message),
						$author$project$Common$Cmd$no(model));
				case 15:
					return _Utils_Tuple2(
						model,
						A3(
							$author$project$Common$Base$iff,
							refreshNow(0),
							$elm$core$Platform$Cmd$none,
							!model.la));
				case 10:
					if (!msg.a.$) {
						var _v5 = msg.a.a;
						var config = _v5.a;
						var assets = _v5.b;
						var markets = _v5.c;
						return A2(
							$author$project$Update$update,
							$author$project$Msg$Refresh,
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										g6: assets,
										hn: config,
										eY: A2($elm$core$List$sortBy, $author$project$Shared$Market$Logic$order, markets)
									})));
					} else {
						var err = msg.a.a;
						return A2($author$project$Shared$Update$log, err, model);
					}
				case 12:
					if (!msg.a.$) {
						var rates = msg.a.a;
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{jI: rates})));
					} else {
						var err = msg.a.a;
						return A2($author$project$Shared$Update$log, err, model);
					}
				case 14:
					if (!msg.a.$) {
						var states = msg.a.a;
						var updateState = function (m) {
							var state = m.f6;
							return _Utils_update(
								m,
								{
									f6: A2(
										$elm$core$Maybe$withDefault,
										state,
										A2($elm$core$Dict$get, m.jT, states))
								});
						};
						return $author$project$Common$Cmd$no(
							$author$project$Shared$Update$loaded(
								_Utils_update(
									model,
									{
										eY: A2($elm$core$List$map, updateState, model.eY)
									})));
					} else {
						var err = msg.a.a;
						return A2($author$project$Shared$Update$log, err, model);
					}
				case 16:
					var err = msg.a;
					return A4(
						$pablen$toasty$Toasty$addToast,
						$author$project$Common$Toast$config,
						$author$project$Msg$ToastyMsg,
						$author$project$Toast$Error(err),
						$author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{
									hT: A2($elm$core$List$cons, err, model.hT)
								})));
				case 2:
					var userMsg = msg.a;
					return user(userMsg);
				case 19:
					var subMsg = msg.a;
					return A4($pablen$toasty$Toasty$update, $author$project$Common$Toast$config, $author$project$Msg$ToastyMsg, subMsg, model);
				case 20:
					var opened = msg.a;
					return $author$project$Common$Cmd$no(
						_Utils_update(
							model,
							{i7: opened}));
				case 9:
					if (msg.a.$ === 1) {
						var _v6 = msg.a;
						return closePopup(0);
					} else {
						break _v0$42;
					}
				case 22:
					if (!msg.a.$) {
						var _v7 = msg.a;
						return closePopup(0);
					} else {
						break _v0$42;
					}
				case 7:
					switch (msg.a.$) {
						case 1:
							if (msg.a.a.$ === 10) {
								var data = msg.a.a.a;
								return A4(
									$pablen$toasty$Toasty$addToast,
									$author$project$Common$Toast$config,
									$author$project$Msg$ToastyMsg,
									$author$project$Toast$Gateway(
										$author$project$Gateway$Toast$TopUpWaves(data)),
									closePopup(0));
							} else {
								break _v0$42;
							}
						case 2:
							if (msg.a.a.$ === 8) {
								var data = msg.a.a.a;
								return A4(
									$pablen$toasty$Toasty$addToast,
									$author$project$Common$Toast$config,
									$author$project$Msg$ToastyMsg,
									$author$project$Toast$Gateway(
										$author$project$Gateway$Toast$SentFromWaves(data)),
									closePopup(0));
							} else {
								break _v0$42;
							}
						case 4:
							var _v8 = msg.a;
							return closePopup(0);
						default:
							break _v0$42;
					}
				case 8:
					if (msg.a.$ === 4) {
						var _v9 = msg.a;
						return closePopup(0);
					} else {
						break _v0$42;
					}
				case 25:
					if (msg.a === 'close') {
						return closePopup(0);
					} else {
						break _v0$42;
					}
				case 21:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{je: false}),
						$author$project$Port$closeDucks(0));
				case 23:
					var str = msg.a;
					return A4(
						$pablen$toasty$Toasty$addToast,
						$author$project$Common$Toast$config,
						$author$project$Msg$ToastyMsg,
						$author$project$Toast$Copied(str),
						$author$project$Common$Cmd$no(model));
				case 38:
					if (!msg.a.$) {
						var a = msg.a.a;
						return $author$project$Common$Cmd$no(
							_Utils_update(
								model,
								{cZ: a}));
					} else {
						break _v0$42;
					}
				case 39:
					return _Utils_Tuple2(
						model,
						A2($author$project$Governance$Voting$Cmd$active, model.h3.g_, $author$project$Msg$GotActiveVoting));
				default:
					break _v0$42;
			}
		}
		var api = model.h3.g_;
		var p = function () {
			var _v10 = _Utils_Tuple2(model.jo, msg);
			_v10$4:
			while (true) {
				switch (_v10.a.$) {
					case 0:
						if (_v10.b.$ === 3) {
							var home = _v10.a.a;
							var homeMsg = _v10.b.a;
							return A4(
								$author$project$Shared$Update$page,
								model,
								$author$project$Page$Home,
								$author$project$Msg$Home,
								A9($author$project$Home$Update$update, model.iw, api, model.iI, model.jI, model.g6, model.eY, model.kZ, homeMsg, home));
						} else {
							break _v10$4;
						}
					case 1:
						if (_v10.b.$ === 4) {
							var _v11 = _v10.a;
							var id = _v11.a;
							var model1 = _v11.b;
							var marketMsg = _v10.b.a;
							var _v12 = A3(
								$author$project$Common$List$getBy,
								function ($) {
									return $.jT;
								},
								id,
								model.eY);
							if (!_v12.$) {
								var m = _v12.a;
								return A4(
									$author$project$Shared$Update$page,
									model,
									$author$project$Page$Market(id),
									$author$project$Msg$Market,
									A3($author$project$MarketDetail$Update$update, m, marketMsg, model1));
							} else {
								return $author$project$Common$Cmd$no(model);
							}
						} else {
							break _v10$4;
						}
					case 2:
						if (_v10.b.$ === 5) {
							var m1 = _v10.a.a;
							var msg1 = _v10.b.a;
							return A4(
								$author$project$Shared$Update$page,
								model,
								$author$project$Page$VToken,
								$author$project$Msg$VToken,
								A5($author$project$VToken$Update$update, api, model.g6, model.kZ, msg1, m1));
						} else {
							break _v10$4;
						}
					case 3:
						if (_v10.b.$ === 6) {
							var m1 = _v10.a.a;
							var msg1 = _v10.b.a;
							return A4(
								$author$project$Shared$Update$page,
								model,
								$author$project$Page$Governance,
								$author$project$Msg$Governance,
								A8($author$project$Governance$Update$update, model.iw, api, model.iI, model.g6, model.kZ, model.h3.k8, msg1, m1));
						} else {
							break _v10$4;
						}
					default:
						break _v10$4;
				}
			}
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}();
		var pc = p.b;
		var popup = F3(
			function (mapPopup, mapMsg, _v15) {
				var m = _v15.a;
				var c = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jv: $elm$core$Maybe$Just(
								mapPopup(m))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								pc,
								A2($elm$core$Platform$Cmd$map, mapMsg, c)
							])));
			});
		var _v13 = _Utils_Tuple2(model.jv, msg);
		_v13$4:
		while (true) {
			if (_v13.a.$ === 1) {
				var _v14 = _v13.a;
				return p;
			} else {
				switch (_v13.a.a.$) {
					case 0:
						if (_v13.b.$ === 8) {
							var model_ = _v13.a.a.a;
							var msg_ = _v13.b.a;
							return A3(
								popup,
								$author$project$Page$Connect,
								$author$project$Msg$Connect,
								A2($author$project$User$Connect$Update$update, msg_, model_));
						} else {
							break _v13$4;
						}
					case 1:
						if (_v13.b.$ === 22) {
							var model_ = _v13.a.a.a;
							var msg_ = _v13.b.a;
							return A3(
								popup,
								$author$project$Page$RaF,
								$author$project$Msg$RaF,
								A2($author$project$RaF$Update$update, msg_, model_));
						} else {
							break _v13$4;
						}
					default:
						if (_v13.b.$ === 7) {
							var model_ = _v13.a.a.a;
							var msg_ = _v13.b.a;
							return A3(
								popup,
								$author$project$Page$Gateway,
								$author$project$Msg$Gateway,
								A5($author$project$Gateway$Update$update, model.g6, model.h3.jb, model.kZ, msg_, model_));
						} else {
							break _v13$4;
						}
				}
			}
		}
		return p;
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Shared$NewRate$toNewRates = F4(
	function (vires, assets, newRates, rates) {
		var _v0 = _Utils_Tuple3(
			$author$project$Shared$Asset$Logic$getXTN(assets),
			A2($elm$core$Dict$get, 'XTN', newRates),
			A2($elm$core$Dict$get, 'USDT', newRates));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var xtn = _v0.a.a;
			var wavesXTN = _v0.b.a;
			var wavesUSDT = _v0.c.a;
			var fix = $elm$core$Maybe$map(
				function (oldRate) {
					return $elm$core$Basics$round((oldRate * wavesUSDT) / wavesXTN);
				});
			return A3(
				$elm$core$Dict$update,
				xtn.bP,
				fix,
				A3($elm$core$Dict$update, vires.bP, fix, rates));
		} else {
			return rates;
		}
	});
var $author$project$Gateway$Msg$Close = {$: 4};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Common$Attributes$bindToEscape = A2($elm$html$Html$Attributes$attribute, 'data-key', 'escape');
var $author$project$Common$Dialog$c_ = {
	c9: $elm$html$Html$Attributes$class('background'),
	dj: $elm$html$Html$Attributes$class('popup'),
	dA: _List_fromArray(
		[
			$author$project$Common$Attributes$bindToEscape,
			$elm$html$Html$Attributes$class('close'),
			A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close')
		]),
	dQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('dialog')
		]),
	eB: $elm$html$Html$Attributes$class('dialog-inline'),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title')
		])
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Common$Dialog$background = function (closeMsg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Common$Dialog$c_.c9,
				$elm$html$Html$Events$onClick(closeMsg)
			]),
		_List_Nil);
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Common$Attributes$blank = $elm$html$Html$Attributes$target('_blank');
var $author$project$Common$Dialog$body = function (attrs) {
	return $elm$html$Html$div(
		A2($elm$core$List$cons, $author$project$Common$Dialog$c_.dj, attrs));
};
var $author$project$Common$Button$c = {
	O: $elm$html$Html$Attributes$class('button'),
	dn: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('buttons')
		]),
	dp: $elm$html$Html$Attributes$class('cancel'),
	aL: $elm$html$Html$Attributes$class('cta'),
	aN: $elm$html$Html$Attributes$class('default'),
	ey: $elm$html$Html$Attributes$class('icon'),
	ci: $elm$html$Html$Attributes$class('secondary'),
	gv: $elm$html$Html$Attributes$class('under-button')
};
var $author$project$Gateway$View$c = {
	ej: $elm$html$Html$Attributes$class('gateway')
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Common$Attributes$cancel = A2($elm$html$Html$Attributes$attribute, 'data-role', 'cancel');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Common$Button$cancel = function (title) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[$author$project$Common$Button$c.O, $author$project$Common$Button$c.dp, $author$project$Common$Button$c.aN, $author$project$Common$Attributes$cancel]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Translations$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'cancel');
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Common$Dialog$footer = $elm$html$Html$footer(_List_Nil);
var $author$project$Shared$Dialog$footer = F2(
	function (t, ctaButton) {
		return $author$project$Common$Dialog$footer(
			_List_fromArray(
				[
					$author$project$Common$Button$cancel(
					$author$project$Translations$cancel(t)),
					ctaButton
				]));
	});
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Common$Dialog$header = F2(
	function (closeMsg, nodes) {
		return A2(
			$elm$html$Html$header,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$p, $author$project$Common$Dialog$c_.kB, nodes),
					A2(
					$elm$html$Html$a,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(closeMsg),
						A2($elm$core$List$cons, $author$project$Common$Attributes$bindToEscape, $author$project$Common$Dialog$c_.dA)),
					_List_Nil)
				]));
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Translations$Gateway$newBridgeMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'gateway.newBridgeMD');
};
var $author$project$Shared$Html$texts = function (textValue) {
	return _List_fromArray(
		[
			$elm$html$Html$text(textValue)
		]);
};
var $author$project$Translations$Gateway$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'gateway.title');
};
var $author$project$Common$Button$view = function (attributes) {
	return $elm$html$Html$button(
		A2($elm$core$List$cons, $author$project$Common$Button$c.O, attributes));
};
var $author$project$Common$Dialog$view = $elm$html$Html$div($author$project$Common$Dialog$c_.dQ);
var $author$project$Common$Markdown$c = {
	eX: $elm$html$Html$Attributes$class('markdown')
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			a: A2($elm$core$List$cons, linkRef, state.a),
			b: state.b
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\r',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.fP) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.jw)));
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\r':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{ac: key, gA: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.c, s.fP, s.dB, s.cs);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.cs) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, adjustedOffset) < 0,
			0,
			{dB: newCol, g: s.g, h: s.h, c: adjustedOffset, fP: newRow, cs: s.cs});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {dj: body, is: intended, iS: marker, jm: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.dB, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.is, item.iS, item.jm, _List_Nil, item.dj);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.cL;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.cD);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.cD);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.l));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.l));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.l));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.l));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {hP: childMatch.hP - parentMatch.n, l: childMatch.l, kk: childMatch.kk - parentMatch.n, cD: childMatch.cD, v: childMatch.v - parentMatch.n, n: childMatch.n - parentMatch.n, cL: childMatch.cL};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			hP: parentMatch.hP,
			l: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.l),
			kk: parentMatch.kk,
			cD: parentMatch.cD,
			v: parentMatch.v,
			n: parentMatch.n,
			cL: parentMatch.cL
		};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		hP: match.hP,
		l: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.l),
		kk: match.kk,
		cD: match.cD,
		v: match.v,
		n: match.n,
		cL: match.cL
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.kk;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.hP, match.kk) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.kk, match.kk) < 0) && (_Utils_cmp(prevMatch.hP, match.hP) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.cy;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.ar;
		}
	} else {
		return match.ar;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.cy;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.ar;
		}
	} else {
		return match.ar;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.cy;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.ar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.cy;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.ar;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		hP: 0,
		l: _List_Nil,
		kk: 0,
		cD: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		v: 0,
		n: 0,
		cL: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			hP: matchModel.hP,
			l: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.cD, _List_Nil, matchModel.l),
			kk: matchModel.kk,
			cD: matchModel.cD,
			v: matchModel.v,
			n: matchModel.n,
			cL: matchModel.cL
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.hP, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			var _v4 = matchHead.cL;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.hP, matchHead.kk) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.hP, matchHead.kk) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.hP, matchHead.kk, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.kk > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.kk, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{io: regMatch.io + backslashesLength, bZ: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				io: regMatch.io + backslashesLength,
				bZ: 1,
				f: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\r':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.cy;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.io)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.io - 1, regMatch.io, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.io + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						io: index,
						bZ: delimiterLength,
						f: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{aV: lFringeRank, a5: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				io: regMatch.io + backslashesLength,
				bZ: $elm$core$String$length(backtick),
				f: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 9};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.cy;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{io: (regMatch.io + backslashesLength) - 1, bZ: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							io: regMatch.io,
							bZ: $elm$core$String$length(regMatch.ar),
							f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.cy;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{io: regMatch.io + backslashesLength, bZ: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{io: (regMatch.io + backslashesLength) - 1, bZ: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							io: regMatch.io,
							bZ: $elm$core$String$length(regMatch.ar),
							f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{io: regMatch.io + backslashesLength, bZ: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.io + backslashesLength) + 1) : (regMatch.io + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						io: index,
						bZ: 1,
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{io: index, bZ: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						io: index,
						bZ: 1,
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 10, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.cy;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{io: regMatch.io + backslashesLength, bZ: length, f: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.io, rfirst.io) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
									$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
									$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText)))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.ar,
				$elm$url$Url$percentDecode(match.ar));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.cD) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				cL: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.cD,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.cD)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.cD : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.cD,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cy;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.cL;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.ar;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{hP: matchModel.hP + regexMatchLength, cL: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.cy;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						hP: matchModel.hP + $elm$core$String$length(regexMatch.ar),
						cL: function () {
							var _v5 = matchModel.cL;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.hP, testMatch.kk) > 0) && (_Utils_cmp(match.hP, testMatch.hP) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.cD) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				cL: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.cD,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.cD)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 1;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {ew: htmlTag, bZ: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.kk, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.ew;
			var length = parsed.a.bZ;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 1, htmlTag);
			return $elm$core$Maybe$Just(
				{io: match.kk, bZ: length, f: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		return false;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.f;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.bZ - 1, closeToken.bZ);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.bZ, closeToken.bZ);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.f;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.f;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.f;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.aV, open.a5) || _Utils_eq(close.aV, close.a5)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.bZ + openToken.bZ))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.bZ)) && (!A2($elm$core$Basics$modBy, 3, openToken.bZ)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.f;
			if (_v1.$ === 10) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.bZ - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.bZ);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.f;
			if (_v5.$ === 10) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.bZ - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.bZ);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {hP: token.io + token.bZ, l: _List_Nil, kk: token.io, cD: '', v: 0, n: 0, cL: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F5(
	function (remaining, tokens, matches, refs, rawText) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.f;
				if (_v1.$ === 9) {
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches),
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.io, match.hP) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v46) {
		var openToken = _v46.a;
		var remainTokens = _v46.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v49 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v49.$) {
					var newToken = _v49.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v38 = token.f;
				switch (_v38.$) {
					case 0:
						var isEscaped = _v38.a;
						var _v39 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v39.$) {
							var code = _v39.a;
							var _v40 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v40.a;
							var newMatches = _v40.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v38.a;
						var isAngleBracketOpen = function (_v45) {
							var meaning = _v45.f;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v41 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v41.$) {
							var found = _v41.a;
							var _v42 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v42.$) {
								var _v43 = _v42.a;
								var newTokens = _v43.a;
								var newMatches = _v43.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v34) {
		var openToken = _v34.a;
		var remainTokens = _v34.c;
		var updatedOpenToken = function () {
			var _v35 = openToken.f;
			if ((!_v35.$) && (!_v35.a)) {
				var _v36 = _v35.a;
				return _Utils_update(
					openToken,
					{io: openToken.io + 1, bZ: openToken.bZ - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v29 = token.f;
				if (_v29.$ === 7) {
					var _char = _v29.a;
					var leftFringeRank = _v29.b.aV;
					var rightFringeRank = _v29.b.a5;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v32 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v32.$) {
								var found = _v32.a;
								var _v33 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v33.a;
								var match = _v33.b;
								var newTokens = _v33.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v27) {
		var openToken = _v27.a;
		var innerTokens = _v27.b;
		var remainTokens = _v27.c;
		var remainLength = openToken.bZ - closeToken.bZ;
		var updt = (!remainLength) ? {aK: closeToken, as: openToken, a4: remainTokens, bb: tokensTail} : ((remainLength > 0) ? {
			aK: closeToken,
			as: _Utils_update(
				openToken,
				{io: openToken.io + remainLength, bZ: closeToken.bZ}),
			a4: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{bZ: remainLength}),
				remainTokens),
			bb: tokensTail
		} : {
			aK: _Utils_update(
				closeToken,
				{bZ: openToken.bZ}),
			as: openToken,
			a4: remainTokens,
			bb: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{io: closeToken.io + openToken.bZ, bZ: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.as.bZ),
			updt.as,
			updt.aK,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.bb, match, updt.a4);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.f;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					if (isOpen === 1) {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = A2(
							$elm$core$List$cons,
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
							matches),
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue htmlElementTTM;
					} else {
						var _v25 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
							tokensTail);
						if (_v25.$ === 1) {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = A2(
								$elm$core$List$cons,
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
								matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						} else {
							var _v26 = _v25.a;
							var closeToken = _v26.a;
							var innerTokens = _v26.b;
							var newTail = _v26.c;
							var newMatch = A7(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
								references,
								rawText,
								function (s) {
									return s;
								},
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
								token,
								closeToken,
								innerTokens);
							var $temp$remaining = newTail,
								$temp$tokens = tokens,
								$temp$matches = A2($elm$core$List$cons, newMatch, matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.f;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.io + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.f;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.f;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.f;
				if (_v5.$ === 10) {
					var isEscaped = _v5.a;
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.f;
			if ((_v2.$ === 10) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{io: openToken.io + 1, bZ: openToken.bZ - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.io + openToken.bZ;
		var textEnd = closeToken.io;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.io;
		var end = closeToken.io + closeToken.bZ;
		var match = {hP: end, l: _List_Nil, kk: start, cD: text, v: textEnd, n: textStart, cL: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {hP: end, l: matches, kk: start, cD: text, v: textEnd, n: textStart, cL: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {aD: alignment, iy: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {dj: body, iz: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.aT;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {aI: '`', aT: 0, ba: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.ba)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.aI))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {aI: '~', aT: 1, ba: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {aJ: character, bX: indent, bZ: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.cs, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.bZ, fence.aJ))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.bX)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.aJ),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	return A2($elm$core$String$endsWith, '#', headingString) ? $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(
		A2($elm$core$String$dropRight, 1, headingString)) : headingString;
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.fP, s.dB, s.cs);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.g)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{dB: newCol, g: s.g, h: s.h, c: newOffset, fP: newRow, cs: s.cs});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {dB: col, g: context, fP: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {dB: s.dB, g: newContext, h: s.h, c: s.c, fP: s.fP, cs: s.cs};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.fP, s0.dB, context),
						s0.g),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.g, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{hI: destination, kB: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.gr;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						fC: delimiterText,
						gr: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F3(
		function (listmarker, intended, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						dj: body,
						iS: listmarker,
						i: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {dj: body, iS: listmarker, i: $elm$core$Maybe$Nothing};
				default:
					return {dj: '', iS: listmarker, i: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A3(parseListItem, listmarker, intended, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v99 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v99.$) {
					var childrenAsBlocks = _v99.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v99.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v100 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v100.$) {
					var value = _v100.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v100.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v84 = state.b;
	_v84$5:
	while (true) {
		if (_v84.b) {
			switch (_v84.a.$) {
				case 11:
					var body2 = _v84.a.a;
					var rest = _v84.b;
					var _v85 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v85.$) {
						var value = _v85.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
									rest)
							});
					} else {
						var error = _v85.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v86 = _v84.a;
					var tight = _v86.a;
					var intended = _v86.b;
					var closeListItems = _v86.c;
					var openListItem = _v86.d;
					var rest = _v84.b;
					var _v87 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.dj);
					if (!_v87.$) {
						var value = _v87.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{dj: value.b, i: openListItem.i},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v87.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v92 = _v84.a;
					var tight = _v92.a;
					var intended = _v92.b;
					var marker = _v92.c;
					var order = _v92.d;
					var closeListItems = _v92.e;
					var openListItem = _v92.f;
					var rest = _v84.b;
					var _v93 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v93.$) {
						var value = _v93.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.b, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v93.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v84.b.b) {
						switch (_v84.b.a.$) {
							case 3:
								var _v88 = _v84.a;
								var _v89 = _v84.b;
								var _v90 = _v89.a;
								var tight = _v90.a;
								var intended = _v90.b;
								var closeListItems = _v90.c;
								var openListItem = _v90.d;
								var rest = _v89.b;
								var _v91 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.dj);
								if (!_v91.$) {
									var value = _v91.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{dj: value.b, i: openListItem.i},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v91.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v94 = _v84.a;
								var _v95 = _v84.b;
								var _v96 = _v95.a;
								var tight = _v96.a;
								var intended = _v96.b;
								var marker = _v96.c;
								var order = _v96.d;
								var closeListItems = _v96.e;
								var openListItem = _v96.f;
								var rest = _v95.b;
								var _v97 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v97.$) {
									var value = _v97.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.b, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v97.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v84$5;
						}
					} else {
						break _v84$5;
					}
				default:
					break _v84$5;
			}
		} else {
			break _v84$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.b);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												dj: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.dj, block1.dj),
												iz: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							default:
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
													rest))
										});
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v49 = _v41.b;
						var _v50 = _v49.a;
						var tight = _v50.a;
						var intended1 = _v50.b;
						var closeListItems2 = _v50.c;
						var openListItem2 = _v50.d;
						var rest = _v49.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var closeListItems1 = newRawBlock.c;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.iS, openListItem1.iS)) {
									var _v52 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.dj);
									if (!_v52.$) {
										var value = _v52.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{dj: value.b, i: openListItem2.i},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{dj: value.b, i: openListItem2.i},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v52.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v53 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.dj);
									if (!_v53.$) {
										var value = _v53.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{dj: value.b, i: openListItem2.i},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v53.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														dj: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.dj, body1)
													})),
											rest)
									});
							default:
								var _v54 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.dj);
								if (!_v54.$) {
									var value = _v54.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{dj: value.b, i: openListItem2.i},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v54.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v55 = _v41.b;
						var _v56 = _v55.a;
						var tight = _v56.a;
						var intended1 = _v56.b;
						var marker = _v56.c;
						var order = _v56.d;
						var closeListItems2 = _v56.e;
						var openListItem2 = _v56.f;
						var rest = _v55.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var closeListItems1 = newRawBlock.e;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v58 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v58.$) {
										var value = _v58.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v58.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v59.$) {
										var value = _v59.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v60 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v60.$) {
									var value = _v60.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v60.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v61 = _v41.b;
								var body2 = _v61.a.a;
								var rest = _v61.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v62 = _v41.a;
									var _v63 = _v62.a;
									var _v64 = _v41.b;
									var unparsedInlines = _v64.a.a;
									var rest = _v64.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v65 = _v41.a;
									var _v66 = _v65.a;
									var _v67 = _v41.b;
									var unparsedInlines = _v67.a.a;
									var rest = _v67.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v68 = _v41.a.a;
								var text = _v68.a;
								var alignments = _v68.b;
								var _v69 = _v41.b;
								var rawHeaders = _v69.a.a;
								var rest = _v69.b;
								var _v70 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v70.$) {
									var headers = _v70.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.fC)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v71 = _v41.b;
							var rest = _v71.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v72 = _v41.b;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									var _v75 = _v74.a;
									var tight = _v75.a;
									var intended1 = _v75.b;
									var marker = _v75.c;
									var order = _v75.d;
									var closeListItems2 = _v75.e;
									var openListItem2 = _v75.f;
									var rest = _v74.b;
									var _v76 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v76.$) {
										var value = _v76.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.b, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v76.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v78 = _v41.b;
									var _v79 = _v78.a;
									var _v80 = _v78.b;
									var _v81 = _v80.a;
									var tight = _v81.a;
									var intended1 = _v81.b;
									var closeListItems2 = _v81.c;
									var openListItem2 = _v81.d;
									var rest = _v80.b;
									var _v82 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.dj);
									if (!_v82.$) {
										var value = _v82.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{dj: value.b, i: openListItem2.i},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{dj: value.b, i: openListItem2.i},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v82.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				a: state.a,
				b: A2($elm$core$List$cons, newRawBlock, state.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.hI;
						var title = _v37.kB;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			var innerText = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.b, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.a, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.iy;
				var alignment = _v24.aD;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {aD: alignment, iy: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var intended = rawBlock.b;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{a: linkReferences, b: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								var e = _v18.a;
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.i, item.dj);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{a: linkReferences, b: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						var e = _v20.a;
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				var rawBlocks = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{a: linkReferences, b: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{dj: codeBlockBody, iz: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.fC)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.b;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	dj: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.dj, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																dj: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.dj, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				dj: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.dj, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			dj: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.dj, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.dj) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{a: _List_Nil, b: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var tight = block.a;
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var _int = block.b;
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var tight = block.a;
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var task = _v4.a;
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var tight = block.a;
			var _int = block.b;
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var headingLevel = block.a;
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.iy;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.dj;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.bO(
								{
									dx: children,
									eO: level,
									jJ: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cb,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.cM(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.ca,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.bn(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.cF));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.bj,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.iy;
							var alignment = _v11.aD;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.cB(
							$elm$core$List$singleton(
								renderer.a9(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.cC, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.cz(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.aD;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.a9,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.cA,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.ge(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.ik,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cx,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.bD,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cw,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.il(
							{
								bg: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								cs: src,
								kB: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.cD(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.bo(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.iD,
									{hI: destination, kB: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.bL));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.ac;
				var value = _v0.gA;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v1) {
			var rawDecoder = _v1;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (tagName, attributes, children) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$core$String$words = _String_words;
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	bj: $elm$html$Html$blockquote(_List_Nil),
	bn: function (_v0) {
		var body = _v0.dj;
		var language = _v0.iz;
		var classes = function () {
			var _v1 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((!_v1.$) && _v1.a.b) {
				var _v2 = _v1.a;
				var actualLanguage = _v2.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	bo: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	bD: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	bL: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	bO: function (_v3) {
		var level = _v3.eO;
		var children = _v3.dx;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	ik: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	il: function (imageInfo) {
		var _v5 = imageInfo.kB;
		if (!_v5.$) {
			var title = _v5.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.cs),
						$elm$html$Html$Attributes$alt(imageInfo.bg),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.cs),
						$elm$html$Html$Attributes$alt(imageInfo.bg)
					]),
				_List_Nil);
		}
	},
	iD: F2(
		function (link, content) {
			var _v6 = link.kB;
			if (!_v6.$) {
				var title = _v6.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.hI),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.hI)
						]),
					content);
			}
		}),
	ca: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	cb: $elm$html$Html$p(_List_Nil),
	cw: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	cx: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	ge: $elm$html$Html$table(_List_Nil),
	cz: $elm$html$Html$tbody(_List_Nil),
	cA: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	cB: $elm$html$Html$thead(_List_Nil),
	cC: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	a9: $elm$html$Html$tr(_List_Nil),
	cD: $elm$html$Html$text,
	cF: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	cM: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $author$project$Common$Markdown$linkInBlank = F2(
	function (_v0, content) {
		var title = _v0.kB;
		var destination = _v0.hI;
		var newTabIfCrossDomain = function (attrs) {
			return A2($elm$core$String$contains, '://', destination) ? A2($elm$core$List$cons, $author$project$Common$Attributes$blank, attrs) : attrs;
		};
		return A2(
			$elm$html$Html$a,
			newTabIfCrossDomain(
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(destination),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$html$Html$Attributes$title, $elm$core$List$singleton),
							title)))),
			content);
	});
var $author$project$Common$Markdown$renderer = _Utils_update(
	$dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer,
	{iD: $author$project$Common$Markdown$linkInBlank});
var $author$project$Common$Markdown$view = function (markdown) {
	var _v0 = $dillonkearns$elm_markdown$Markdown$Parser$parse(markdown);
	if (!_v0.$) {
		var ast = _v0.a;
		var _v1 = A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $author$project$Common$Markdown$renderer, ast);
		if (!_v1.$) {
			var html = _v1.a;
			return html;
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Common$Markdown$viewInDiv = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Markdown$view,
		$elm$html$Html$div(
			A2($elm$core$List$cons, $author$project$Common$Markdown$c.eX, attrs)));
};
var $author$project$Gateway$View$view = function (t) {
	var cta = A2(
		$author$project$Common$Button$view,
		_List_fromArray(
			[
				$author$project$Common$Button$c.aL,
				$elm$html$Html$Events$onClick($author$project$Gateway$Msg$Close)
			]),
		$elm$core$List$singleton(
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('https://waves.exchange/deposit'),
						$author$project$Common$Attributes$blank
					]),
				$elm$core$List$singleton(
					$elm$html$Html$text('Go to WX Network')))));
	return $author$project$Common$Dialog$view(
		_List_fromArray(
			[
				$author$project$Common$Dialog$background($author$project$Gateway$Msg$Close),
				A2(
				$author$project$Common$Dialog$body,
				_List_fromArray(
					[$author$project$Gateway$View$c.ej]),
				_List_fromArray(
					[
						A2(
						$author$project$Common$Dialog$header,
						$author$project$Gateway$Msg$Close,
						$author$project$Shared$Html$texts(
							$author$project$Translations$Gateway$title(t))),
						A2(
						$author$project$Common$Markdown$viewInDiv,
						_List_Nil,
						$author$project$Translations$Gateway$newBridgeMD(t)),
						A2($author$project$Shared$Dialog$footer, t, cta)
					]))
			]));
};
var $author$project$Governance$Voting$View$c = {
	cZ: $elm$html$Html$Attributes$class('active-voting')
};
var $author$project$Common$Badge$c = {
	da: $elm$html$Html$Attributes$class('badge')
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Common$Badge$view = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$span(_List_Nil),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$span(
				A2($elm$core$List$cons, $author$project$Common$Badge$c.da, attrs))));
};
var $author$project$Common$Badge$num = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Html$texts,
			$author$project$Common$Badge$view(attrs)));
};
var $author$project$Governance$Voting$View$active = function (attrs) {
	return $author$project$Common$Badge$num(
		A2($elm$core$List$cons, $author$project$Governance$Voting$View$c.cZ, attrs));
};
var $author$project$Common$Tabs$c = {
	gT: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-active')
		])
};
var $author$project$Governance$View$c = {
	ic: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('governance')
		])
};
var $author$project$Translations$Governance$governancePanel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.governancePanel');
};
var $author$project$Translations$info = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'info');
};
var $author$project$Translations$Governance$MyVires$myVires = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.My Vires');
};
var $author$project$Shared$Text$nbsp = '\u00A0';
var $author$project$Shared$Html$nothing = $elm$html$Html$text('');
var $author$project$Shared$Layout$c = {
	dC: $elm$html$Html$Attributes$class('column'),
	bp: $elm$html$Html$Attributes$class('columns'),
	dG: $elm$html$Html$Attributes$class('container'),
	ec: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('footer')
		]),
	eH: $elm$html$Html$Attributes$class('is-one-fifth'),
	eI: $elm$html$Html$Attributes$class('is-one-quarter'),
	eJ: $elm$html$Html$Attributes$class('is-one-third'),
	fX: $elm$html$Html$Attributes$class('section')
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Shared$Layout$sectionN = function (attrs) {
	return $elm$html$Html$section(
		A2($elm$core$List$cons, $author$project$Shared$Layout$c.fX, attrs));
};
var $author$project$Common$Tabs$tab = F2(
	function (tabAttrs, linkAttrs) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$a(linkAttrs),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$html$Html$li(tabAttrs)));
	});
var $author$project$Shared$Layout$header = $elm$html$Html$h1(_List_Nil);
var $author$project$Shared$Layout$textHeader = A2($elm$core$Basics$composeR, $author$project$Shared$Html$texts, $author$project$Shared$Layout$header);
var $author$project$Shared$Html$try = function (map) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(map),
		$elm$core$Maybe$withDefault($author$project$Shared$Html$nothing));
};
var $author$project$Shared$Html$tryMany = function (map) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(map),
		$elm$core$Maybe$withDefault(_List_Nil));
};
var $author$project$Common$Tabs$c_ = {
	dH: $elm$html$Html$Attributes$class('tab-content'),
	gf: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('tabs')
		])
};
var $author$project$Common$Tabs$view = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$ul(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div($author$project$Common$Tabs$c_.gf)));
var $author$project$Governance$Info$Msg$AmountChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$Waves$Asset$Asset = $elm$core$Basics$identity;
var $author$project$Governance$Info$Msg$OpenLock = {$: 3};
var $author$project$Governance$Info$Msg$PeriodChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$Info$Msg$SpoilerTriggered = function (a) {
	return {$: 6, a: a};
};
var $author$project$Shared$Markdown$c = {
	c0: $elm$html$Html$Attributes$class('after-border')
};
var $author$project$Shared$Markdown$afterBorder = function (attrs) {
	return $author$project$Common$Markdown$viewInDiv(
		A2($elm$core$List$cons, $author$project$Shared$Markdown$c.c0, attrs));
};
var $author$project$Translations$asset = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'asset');
};
var $cuducos$elm_format_number$FormatNumber$Locales$Max = function (a) {
	return {$: 1, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {hC: decimals, eF: integers, jn: original, a3: prefix, a8: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.eF,
				$elm$core$List$singleton(formatted.hC))));
	return onlyZeros ? 1 : ((formatted.jn < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.hC;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.hC;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{a3: locale.aY, a8: locale.b5});
			case 0:
				return _Utils_update(
					partial,
					{a3: locale.fu, a8: locale.fv});
			default:
				return _Utils_update(
					partial,
					{a3: locale.gM, a8: locale.gN});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.hB, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.kv, formatted.eF);
		var decimals = stringfyDecimals(formatted.hC);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.a3, integers, decimals, formatted.a8]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	hB: '.',
	hC: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aY: '−',
	b5: '',
	fu: '',
	fv: '',
	kv: '',
	gM: '',
	gN: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		hC: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		kv: ','
	});
var $author$project$Shared$Text$sep_ = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{hB: '.', kv: $author$project$Shared$Text$nbsp});
var $author$project$Shared$Text$num = function (n) {
	return $cuducos$elm_format_number$FormatNumber$format(
		_Utils_update(
			$author$project$Shared$Text$sep_,
			{
				hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(n)
			}));
};
var $author$project$Shared$Asset$Format$assetOnlyNumsN = F3(
	function (precision, a, satoshi) {
		return A2(
			$author$project$Shared$Text$num,
			precision,
			A2($author$project$Shared$Market$Logic$inOrig, a, satoshi));
	});
var $author$project$Shared$Asset$Format$assetN = F3(
	function (precision, a, satoshi) {
		return A3($author$project$Shared$Asset$Format$assetOnlyNumsN, precision, a, satoshi) + ('\u00A0' + a.ac);
	});
var $author$project$Shared$Asset$Format$asset2 = function (a) {
	return A2($author$project$Shared$Asset$Format$assetN, 2, a);
};
var $author$project$Shared$Text$locale = {
	bt: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(6)
		}),
	d7: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(10)
		}),
	eE: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(0)
		}),
	ap: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(1)
		}),
	fq: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(2)
		}),
	gu: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(2)
		}),
	bd: _Utils_update(
		$author$project$Shared$Text$sep_,
		{
			hC: $cuducos$elm_format_number$FormatNumber$Locales$Max(2)
		})
};
var $author$project$Shared$Text$formatKn = F2(
	function (n, x) {
		return (x >= 1000000000) ? (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.ap, x / 1000000000) + 'B') : ((x >= 1000000) ? (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.ap, x / 1000000) + 'M') : ((x >= 1000) ? (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.ap, x / 1000) + 'K') : ((x >= 10) ? A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.ap, x) : A2($author$project$Shared$Text$num, n, x))));
	});
var $author$project$Shared$Text$formatCurrencyKn = F2(
	function (n, currency) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Text$formatKn(n),
			A2(
				$Gizra$elm_compat_019$Basics018$flip,
				$elm$core$Basics$append,
				_Utils_ap($author$project$Shared$Text$nbsp, currency)));
	});
var $author$project$Shared$Asset$Format$assetK = function (a) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Market$Logic$inOrig(a),
		A2($author$project$Shared$Text$formatCurrencyKn, a.hC, a.ac));
};
var $author$project$Translations$Governance$basedOnMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.basedOnMD');
};
var $author$project$Common$Table$body = $elm$html$Html$tbody(_List_Nil);
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Governance$Info$View$c = {
	bh: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('asset')
		]),
	$7: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('calc')
		]),
	ip: _List_fromArray(
		[
			$elm$html$Html$Attributes$id('info')
		]),
	eY: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('markets')
		]),
	iU: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-danger')
		]),
	T: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('money')
		]),
	jd: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-warning')
		]),
	fr: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('period')
		]),
	fA: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('protocol-revenue')
		]),
	j4: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-active')
		])
};
var $author$project$Common$Table$c_ = {
	dr: $elm$html$Html$Attributes$class('cell'),
	eb: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('foot')
		]),
	eq: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('head')
		]),
	aS: $elm$html$Html$Attributes$class('header'),
	e9: $elm$html$Html$Attributes$class('na'),
	fP: $elm$html$Html$Attributes$class('row'),
	ge: $elm$html$Html$Attributes$class('table')
};
var $author$project$Common$Table$cellN = function (attributes) {
	return $elm$html$Html$td(
		A2($elm$core$List$cons, $author$project$Common$Table$c_.dr, attributes));
};
var $author$project$Common$Table$cell = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Common$Table$cellN(attributes));
};
var $author$project$Shared$Layout$column = function (attrs) {
	return $elm$html$Html$div(
		A2($elm$core$List$cons, $author$project$Shared$Layout$c.dC, attrs));
};
var $author$project$Shared$Layout$columnsMany = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$author$project$Shared$Layout$column(_List_Nil))),
		$elm$html$Html$div(
			A2($elm$core$List$cons, $author$project$Shared$Layout$c.bp, attrs)));
};
var $author$project$Translations$Governance$Info$Income$daily = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.income.daily');
};
var $author$project$Common$Time$daysInYear = 365;
var $author$project$Shared$Waves$View$displayAsset = F2(
	function (metamask, asset) {
		var a = asset;
		return metamask ? $author$project$Shared$Waves$Asset$toEth(asset) : a;
	});
var $author$project$Translations$Governance$Info$Calc$estAPR = F2(
	function (translations, apr) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'governance.info.calc.estAPR',
			_List_fromArray(
				[
					_Utils_Tuple2('apr', apr)
				]));
	});
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Common$Table$foot = $elm$html$Html$tfoot($author$project$Common$Table$c_.eb);
var $author$project$Shared$Text$formatK = $author$project$Shared$Text$formatKn(6);
var $author$project$Shared$Text$formatAPR = function (p) {
	return ($elm$core$Basics$abs(p) < 0.0001) ? ((p > 0) ? '<\u00A00.01%' : ((p < 0) ? '>\u00A0-0.01%' : '—')) : (($elm$core$Basics$abs(p) < 1) ? (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.fq, p * 100) + '%') : ((p >= 10) ? ($author$project$Shared$Text$formatK(p * 100) + '%') : (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.eE, p * 100) + '%')));
};
var $author$project$Shared$Text$formatUsd = function (amountInUsd) {
	return (amountInUsd < 0) ? ('-' + ($author$project$Shared$Text$nbsp + ('$' + ($author$project$Shared$Text$nbsp + A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$author$project$Shared$Text$locale.bd,
		$elm$core$Basics$abs(amountInUsd)))))) : ('$' + ($author$project$Shared$Text$nbsp + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.bd, amountInUsd)));
};
var $author$project$Shared$Text$formatUsdK = A2(
	$elm$core$Basics$composeR,
	$author$project$Shared$Text$formatK,
	$elm$core$Basics$append('$' + $author$project$Shared$Text$nbsp));
var $author$project$Shared$Text$formatUsdK2 = A2(
	$elm$core$Basics$composeR,
	$author$project$Shared$Text$formatKn(2),
	$elm$core$Basics$append('$' + $author$project$Shared$Text$nbsp));
var $author$project$Translations$Governance$getViresMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.getViresMD');
};
var $author$project$Governance$Shared$Logic$governanceAprFromYearlyIncome = F4(
	function (yearlyIncomeUsd, vires, rates, governance) {
		return (!governance.bH) ? yearlyIncomeUsd : (yearlyIncomeUsd / A3($author$project$Shared$Market$Logic$inUsd, rates, vires, governance.bH));
	});
var $author$project$Shared$Apy$borrowAPR = F2(
	function (model, utilization_) {
		borrowAPR:
		while (true) {
			switch (model.$) {
				case 1:
					var a = model.a;
					return a * utilization_;
				case 0:
					var b = model.a;
					return b;
				default:
					var left = model.a;
					var stop = model.b;
					var right = model.c;
					if (_Utils_cmp(utilization_, stop) < 1) {
						var $temp$model = left,
							$temp$utilization_ = utilization_;
						model = $temp$model;
						utilization_ = $temp$utilization_;
						continue borrowAPR;
					} else {
						return A2($author$project$Shared$Apy$borrowAPR, left, stop) + A2($author$project$Shared$Apy$borrowAPR, right, utilization_ - stop);
					}
			}
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Shared$Apy$utilization = F2(
	function (totalBorrow, totalSupply) {
		return A2($elm$core$Basics$min, 1, totalBorrow / totalSupply);
	});
var $author$project$Shared$Market$Logic$utilization = function (s) {
	return A2($author$project$Shared$Apy$utilization, s.dk, s.gb);
};
var $author$project$Shared$Market$Logic$borrowAPR = function (m) {
	return A2(
		$author$project$Shared$Apy$borrowAPR,
		m.ip.eG,
		$author$project$Shared$Market$Logic$utilization(m.f6));
};
var $author$project$Shared$Market$Logic$interestReserveRatio = 0.9;
var $author$project$Shared$Market$Logic$protocolSupplyAPRForUtilization = F2(
	function (u, info) {
		var extraApr = function (map) {
			return A2(
				$elm$core$Maybe$map,
				function (aprBase) {
					return (aprBase * (1 - u)) * (1 - $author$project$Shared$Market$Logic$interestReserveRatio);
				},
				map(info));
		};
		return $elm$core$List$sum(
			$author$project$Common$List$just(
				_List_fromArray(
					[
						extraApr(
						function ($) {
							return $.eM;
						}),
						extraApr(
						function ($) {
							return $.ct;
						})
					])));
	});
var $author$project$Shared$Market$Logic$protocolSupplyAPR = function (m) {
	return A2(
		$author$project$Shared$Market$Logic$protocolSupplyAPRForUtilization,
		$author$project$Shared$Market$Logic$utilization(m.f6),
		m.ip);
};
var $author$project$Governance$Shared$Logic$yearlyIncome_ = function (m) {
	var protocolSupplyAPR = $author$project$Shared$Market$Logic$protocolSupplyAPR(m);
	var supplyIncome = m.f6.gb * protocolSupplyAPR;
	var borrowApr = $author$project$Shared$Market$Logic$borrowAPR(m);
	var borrowIncome = (m.f6.dk * borrowApr) * m.ip.jU;
	var borrowAndSupply = borrowIncome + supplyIncome;
	if (m.ip.jC) {
		var protectedApr = A2($author$project$Shared$Market$Logic$protocolSupplyAPRForUtilization, 0, m.ip);
		var protectedIncome = m.f6.jD * protectedApr;
		return borrowAndSupply + protectedIncome;
	} else {
		return borrowAndSupply;
	}
};
var $author$project$Governance$Shared$Logic$yearlyIncome = A2($elm$core$Basics$composeR, $author$project$Governance$Shared$Logic$yearlyIncome_, $elm$core$Basics$round);
var $author$project$Governance$Shared$Logic$totalYearlyIncomeUsd = F2(
	function (rates, markets) {
		var perMarketUsd = F2(
			function (m, usd) {
				return usd + A3(
					$author$project$Shared$Market$Logic$inUsd,
					rates,
					m.bh,
					$author$project$Governance$Shared$Logic$yearlyIncome(m));
			});
		return A3($elm$core$List$foldl, perMarketUsd, 0, markets);
	});
var $author$project$Governance$Shared$Logic$governanceApr = F4(
	function (rates, markets, vires, governance) {
		return A4(
			$author$project$Governance$Shared$Logic$governanceAprFromYearlyIncome,
			A2($author$project$Governance$Shared$Logic$totalYearlyIncomeUsd, rates, markets),
			vires,
			rates,
			governance);
	});
var $author$project$Common$Table$head = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$tr(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$thead($author$project$Common$Table$c_.eq)));
var $author$project$Common$Table$headerN = function (attributes) {
	return $elm$html$Html$th(
		A2($elm$core$List$cons, $author$project$Common$Table$c_.aS, attributes));
};
var $author$project$Common$Table$header = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$author$project$Common$Table$headerN(attributes));
};
var $author$project$Shared$Asset$View$c = {
	bh: $elm$html$Html$Attributes$class('asset'),
	ez: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('icon-text')
		]),
	eW: $elm$html$Html$Attributes$class('logo'),
	iP: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('help is-hidden-mobile')
		]),
	ac: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('asset-name')
		])
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Shared$Asset$View$icon = function (name) {
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$elm$core$String$toLower(name)),
				$author$project$Shared$Asset$View$c.eW
			]),
		_List_Nil);
};
var $author$project$Shared$Asset$View$iconWithName = function (name) {
	return _List_fromArray(
		[
			$author$project$Shared$Asset$View$icon(name),
			$elm$html$Html$text($author$project$Shared$Text$nbsp),
			$elm$html$Html$text(name)
		]);
};
var $author$project$Translations$Governance$Info$Income$income = F2(
	function (translations, period) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'governance.info.income.income',
			_List_fromArray(
				[
					_Utils_Tuple2('period', period)
				]));
	});
var $author$project$Common$Select$c = {
	eB: $elm$html$Html$Attributes$class('css-less'),
	cj: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('select')
		])
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Common$Select$inline = function (attrs) {
	return $elm$html$Html$select(
		A2($elm$core$List$cons, $author$project$Common$Select$c.eB, attrs));
};
var $author$project$Common$Form$c = {
	dI: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('control')
		]),
	aR: $elm$html$Html$Attributes$class('field'),
	d8: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('field-body')
		]),
	d9: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('field-label is-normal')
		]),
	en: $elm$html$Html$Attributes$class('has-addons'),
	et: $elm$html$Html$Attributes$class('is-horizontal'),
	an: $elm$html$Html$Attributes$class('input'),
	iy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('label')
		]),
	cj: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('select')
		])
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Common$Form$input = F3(
	function (msg, attrs, value) {
		return A2(
			$elm$html$Html$input,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Form$c.an,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onInput(msg),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$value(value),
						attrs))),
			_List_Nil);
	});
var $author$project$Translations$Governance$MyVires$lock = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.lock');
};
var $author$project$Translations$Governance$lockViresToReceiveProtocolRevenueMD = F2(
	function (translations, assets) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'governance.lockViresToReceiveProtocolRevenueMD',
			_List_fromArray(
				[
					_Utils_Tuple2('assets', assets)
				]));
	});
var $author$project$Translations$Governance$Info$Calc$locking = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.calc.locking');
};
var $author$project$Common$List$mapArg = function (arg) {
	return $elm$core$List$map(
		function (f) {
			return f(arg);
		});
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $author$project$Governance$Shared$View$maxVires = $elm$html$Html$Attributes$max('10000000');
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Translations$Governance$Info$Income$monthly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.income.monthly');
};
var $author$project$Shared$Asset$View$names = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function ($) {
			return $.ac;
		}),
	$elm$core$String$join(', '));
var $elm$html$Html$option = _VirtualDom_node('option');
var $author$project$Governance$Info$View$periods = _List_fromArray(
	[$author$project$Common$Time$daysInYear, $author$project$Common$Time$monthsInYear, 1]);
var $author$project$Governance$Shared$Plans$maxX = 1;
var $author$project$Governance$Shared$Plans$plans = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Governance$Shared$Plans$maxX,
			{ef: 24, em: 6, gw: $elm$core$Maybe$Nothing})
		]));
var $author$project$Common$Button$enabled = F3(
	function (attributes, label, msg) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Button$c.O,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(msg),
					attributes)),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Common$Button$primary = $author$project$Common$Button$enabled(
	_List_fromArray(
		[$author$project$Common$Button$c.aL]));
var $author$project$Translations$Governance$Info$protocolRevenueSheetMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.protocolRevenueSheetMD');
};
var $author$project$Common$Math$round2 = function (x) {
	return $elm$core$Basics$round(x * 100) / 100;
};
var $author$project$Common$Table$row = function (attributes) {
	return $elm$html$Html$tr(
		A2($elm$core$List$cons, $author$project$Common$Table$c_.fP, attributes));
};
var $author$project$Shared$Layout$section = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Shared$Layout$sectionN(attrs));
};
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Common$Table$textCell = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$text,
		$author$project$Common$Table$cell(attrs));
};
var $author$project$Shared$Html$textSpan = F2(
	function (attrs, txt) {
		return A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	});
var $author$project$Translations$Governance$Info$totalRevenue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.totalRevenue');
};
var $author$project$Common$Attributes$type_ = {
	jg: $elm$html$Html$Attributes$type_('number')
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Governance$Shared$Logic$unlocked = function (u) {
	return u.f3 - u.iJ;
};
var $author$project$Common$Table$view = function (attributes) {
	return $elm$html$Html$table(
		A2($elm$core$List$cons, $author$project$Common$Table$c_.ge, attributes));
};
var $author$project$Shared$FAQ$View$c = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('faq markdown'),
		$elm$html$Html$Attributes$id('faq')
	]);
var $author$project$Common$Markdown$spoiler = F4(
	function (_v0, msg, renderedChildren, id_) {
		var spoilers = _v0;
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			function () {
				if (renderedChildren.b) {
					var title = renderedChildren.a;
					var body = renderedChildren.b;
					return A2($elm$core$Dict$member, id_, spoilers) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									msg(id_)),
									$elm$html$Html$Attributes$id(id_),
									$elm$html$Html$Attributes$class('spoiler opened')
								]),
							$elm$core$List$singleton(title)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spoiler-content')
								]),
							body)
						]) : $elm$core$List$singleton(
						A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									msg(id_)),
									$elm$html$Html$Attributes$class('spoiler closed')
								]),
							$elm$core$List$singleton(title)));
				} else {
					return renderedChildren;
				}
			}());
	});
var $dillonkearns$elm_markdown$Markdown$Html$tag = F2(
	function (expectedTag, a) {
		return F3(
			function (tagName, attributes, children) {
				return _Utils_eq(tagName, expectedTag) ? $elm$core$Result$Ok(a) : $elm$core$Result$Err('Expected ' + (expectedTag + (' but was ' + tagName)));
			});
	});
var $dillonkearns$elm_markdown$List$Helpers$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$withAttribute = F2(
	function (attributeName, _v0) {
		var renderer = _v0;
		return F3(
			function (tagName, attributes, innerBlocks) {
				return function () {
					var _v1 = A2(
						$dillonkearns$elm_markdown$List$Helpers$find,
						function (_v2) {
							var name = _v2.ac;
							var value = _v2.gA;
							return _Utils_eq(name, attributeName);
						},
						attributes);
					if (!_v1.$) {
						var value = _v1.a.gA;
						return $elm$core$Result$map(
							$elm$core$Basics$apR(value));
					} else {
						return function (_v3) {
							return $elm$core$Result$Err('Expecting attribute \"' + (attributeName + '\".'));
						};
					}
				}()(
					A3(renderer, tagName, attributes, innerBlocks));
			});
	});
var $author$project$Common$Markdown$spoilerRendered = F2(
	function (spoilers, msg) {
		return _Utils_update(
			$author$project$Common$Markdown$renderer,
			{
				ik: $dillonkearns$elm_markdown$Markdown$Html$oneOf(
					_List_fromArray(
						[
							A2(
							$dillonkearns$elm_markdown$Markdown$Html$withAttribute,
							'id',
							A2(
								$dillonkearns$elm_markdown$Markdown$Html$tag,
								'spoiler',
								F2(
									function (id, renderedChildren) {
										return A4($author$project$Common$Markdown$spoiler, spoilers, msg, renderedChildren, id);
									})))
						]))
			});
	});
var $author$project$Common$Markdown$viewWithSpoilers = F3(
	function (spoilers, msg, markdown) {
		var _v0 = $dillonkearns$elm_markdown$Markdown$Parser$parse(markdown);
		if (!_v0.$) {
			var ast = _v0.a;
			var _v1 = A2(
				$dillonkearns$elm_markdown$Markdown$Renderer$render,
				A2($author$project$Common$Markdown$spoilerRendered, spoilers, msg),
				ast);
			if (!_v1.$) {
				var html = _v1.a;
				return html;
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Shared$FAQ$View$view = F3(
	function (spoilers, msg, md) {
		return A2(
			$elm$html$Html$div,
			$author$project$Shared$FAQ$View$c,
			A3($author$project$Common$Markdown$viewWithSpoilers, spoilers, msg, md));
	});
var $author$project$Translations$Governance$Info$viresRevenue = F3(
	function (translations, viresAmount, viresSign) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'governance.info.viresRevenue',
			_List_fromArray(
				[
					_Utils_Tuple2('viresAmount', viresAmount),
					_Utils_Tuple2('viresSign', viresSign)
				]));
	});
var $author$project$Shared$Vires$View$viresSign = 'ⓥ';
var $author$project$Translations$Governance$Info$Calc$viresWillTurnIntoRevenue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.calc.viresWillTurnIntoRevenue');
};
var $author$project$Translations$Governance$Info$Income$yearly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.info.income.yearly');
};
var $author$project$Governance$Info$View$view = F8(
	function (t, vires, assets, allMarkets, rates, user, model, gov_) {
		var markets = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.iB;
				}),
			allMarkets);
		var totalUsdYearlyIncome = A2($author$project$Governance$Shared$Logic$totalYearlyIncomeUsd, rates, markets);
		var totalUdsPer = function (yearPart) {
			return totalUsdYearlyIncome / yearPart;
		};
		var totalUdsPerCell = A2(
			$elm$core$Basics$composeR,
			totalUdsPer,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Shared$Text$formatUsdK,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$text,
					$author$project$Common$Table$cell($author$project$Governance$Info$View$c.T))));
		var totalUsdRow = A2(
			$elm$core$List$cons,
			A2(
				$author$project$Common$Table$textCell,
				_List_Nil,
				$author$project$Translations$Governance$Info$totalRevenue(t)),
			A2($elm$core$List$map, totalUdsPerCell, $author$project$Governance$Info$View$periods));
		var totalYearlyIncomeUsd = A2($author$project$Governance$Shared$Logic$totalYearlyIncomeUsd, rates, markets);
		var market = function (m) {
			var income = $author$project$Governance$Shared$Logic$yearlyIncome_(m);
			var incomePer = function (yearPart) {
				return A2(
					$author$project$Common$Table$textCell,
					$author$project$Governance$Info$View$c.T,
					A2(
						$author$project$Shared$Asset$Format$assetK,
						m.bh,
						$elm$core$Basics$round(income / yearPart)));
			};
			return A2(
				$author$project$Common$Table$row,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Common$Table$cellN,
						$author$project$Governance$Info$View$c.bh,
						$author$project$Shared$Asset$View$iconWithName(m.bh.ac)),
					A2($elm$core$List$map, incomePer, $author$project$Governance$Info$View$periods)));
		};
		var header = _List_fromArray(
			[
				A2(
				$author$project$Common$Table$header,
				_List_Nil,
				$author$project$Translations$asset(t)),
				A2(
				$author$project$Common$Table$header,
				$author$project$Governance$Info$View$c.T,
				A2(
					$author$project$Translations$Governance$Info$Income$income,
					t,
					$author$project$Translations$Governance$Info$Income$daily(t))),
				A2(
				$author$project$Common$Table$header,
				$author$project$Governance$Info$View$c.T,
				A2(
					$author$project$Translations$Governance$Info$Income$income,
					t,
					$author$project$Translations$Governance$Info$Income$monthly(t))),
				A2(
				$author$project$Common$Table$header,
				$author$project$Governance$Info$View$c.T,
				A2(
					$author$project$Translations$Governance$Info$Income$income,
					t,
					$author$project$Translations$Governance$Info$Income$yearly(t)))
			]);
		var faq = function (txt) {
			var viresId = A2(
				$author$project$Shared$Waves$View$displayAsset,
				A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, user.iN)),
				vires.bP);
			var max = A2($author$project$Shared$Asset$Format$asset2, vires, 1000000000000000);
			var locked = A2($author$project$Shared$Asset$Format$asset2, vires, gov_.f3);
			return A2(
				$author$project$Shared$Layout$section,
				_List_Nil,
				A3(
					$author$project$Shared$FAQ$View$view,
					model.kf,
					$author$project$Governance$Info$Msg$SpoilerTriggered,
					A3(
						$elm$core$String$replace,
						'{{ locked in governance }}',
						locked,
						A3(
							$elm$core$String$replace,
							'{{ max supply }}',
							max,
							A3(
								$elm$core$String$replace,
								'{{ vires waves id }}',
								vires.bP,
								A3($elm$core$String$replace, '{{ vires id }}', viresId, txt))))));
		};
		var all = $elm$core$List$sum(
			$author$project$Common$List$just(
				_List_fromArray(
					[
						A2($author$project$Shared$Wallet$Logic$wallet, vires.bP, user.lh),
						A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.f3;
						},
						user.hN),
						A2($elm$core$Maybe$map, $author$project$Governance$Shared$Logic$unlocked, user.ic)
					])));
		var amount = function () {
			var _v1 = model.gZ;
			if (!_v1.$) {
				var a = _v1.a;
				return a;
			} else {
				var a = A2($author$project$Shared$Market$Logic$inOrig, vires, all);
				return (a < 1) ? '100' : $elm$core$String$fromFloat(
					$author$project$Common$Math$round2(
						A2($author$project$Shared$Market$Logic$inOrig, vires, all)));
			}
		}();
		var amountInput = A3(
			$author$project$Common$Form$input,
			$author$project$Governance$Info$Msg$AmountChanged,
			_List_fromArray(
				[$author$project$Common$Attributes$type_.jg, $author$project$Governance$Shared$View$maxVires]),
			amount);
		var givenWhen = function () {
			var periods_ = _List_fromArray(
				[
					_Utils_Tuple2(
					1,
					$author$project$Translations$Governance$Info$Income$yearly(t)),
					_Utils_Tuple2(
					$author$project$Common$Time$monthsInYear,
					$author$project$Translations$Governance$Info$Income$monthly(t)),
					_Utils_Tuple2(
					$author$project$Common$Time$daysInYear,
					$author$project$Translations$Governance$Info$Income$daily(t))
				]);
			var period = function (_v0) {
				var yearPart = _v0.a;
				var label = _v0.b;
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromFloat(yearPart)),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(model.lq, yearPart))
						]),
					$author$project$Shared$Html$texts(
						$elm$core$String$toLower(label)));
			};
			var periodSelector = A2(
				$author$project$Common$Select$inline,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onInput($author$project$Governance$Info$Msg$PeriodChanged),
					$author$project$Governance$Info$View$c.fr),
				A2($elm$core$List$map, period, periods_));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('given-when')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Governance$Info$Calc$locking(t)),
						amountInput,
						$elm$html$Html$text(
						$author$project$Translations$Governance$Info$Calc$viresWillTurnIntoRevenue(t)),
						periodSelector,
						$elm$html$Html$text('▼')
					]));
		}();
		var viresToLock = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toFloat(amount));
		var newGov = _Utils_update(
			gov_,
			{
				bH: gov_.bH + A2($author$project$Shared$Asset$Logic$toSatoshi, vires, viresToLock)
			});
		var apr = A4($author$project$Governance$Shared$Logic$governanceApr, rates, markets, vires, newGov);
		var gViresTotal = A2($author$project$Shared$Market$Logic$inOrig, vires, newGov.bH);
		var myRevenueShare = (!viresToLock) ? 0 : ((!gViresTotal) ? 1 : (viresToLock / gViresTotal));
		var market_ = function (m) {
			var income = $author$project$Governance$Shared$Logic$yearlyIncome_(m);
			var incomePer = $elm$core$Basics$round((income * myRevenueShare) / model.lq);
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Shared$Asset$View$icon(m.bh.ac),
						$elm$html$Html$text($author$project$Shared$Text$nbsp),
						$elm$html$Html$text(
						A2($author$project$Shared$Asset$Format$assetK, m.bh, incomePer))
					]));
		};
		var markets_ = A2(
			$elm$html$Html$ul,
			$author$project$Governance$Info$View$c.eY,
			A2($elm$core$List$map, market_, markets));
		var myRevenueShareInUsd = $author$project$Shared$Text$formatUsdK2((totalYearlyIncomeUsd * myRevenueShare) / model.lq);
		var ctaCol = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cta-column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-revenue-usd')
						]),
					$author$project$Shared$Html$texts('≈' + ($author$project$Shared$Text$nbsp + myRevenueShareInUsd))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('apr')
						]),
					$author$project$Shared$Html$texts(
						A2(
							$author$project$Translations$Governance$Info$Calc$estAPR,
							t,
							$author$project$Shared$Text$formatAPR(apr)))),
					A2(
					$author$project$Common$Button$primary,
					$author$project$Translations$Governance$MyVires$lock(t),
					$author$project$Governance$Info$Msg$OpenLock)
				]));
		var calc = A2(
			$elm$html$Html$div,
			$author$project$Governance$Info$View$c.$7,
			_List_fromArray(
				[
					givenWhen,
					A2(
					$author$project$Shared$Layout$columnsMany,
					_List_Nil,
					_List_fromArray(
						[markets_, ctaCol])),
					A2(
					$author$project$Shared$Markdown$afterBorder,
					_List_Nil,
					$author$project$Translations$Governance$getViresMD(t))
				]));
		var viresRow = function () {
			var viresAmount = 100;
			var gViresRevenue = function (yearPart) {
				var xx = $elm$core$Dict$keys($author$project$Governance$Shared$Plans$plans);
				var per1gVires = totalUdsPer(yearPart) / A3($author$project$Common$Base$iff, 1, gViresTotal, !gViresTotal);
				return A2(
					$author$project$Common$Table$cellN,
					$author$project$Governance$Info$View$c.T,
					A2(
						$elm$core$List$map,
						$author$project$Shared$Html$textSpan(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('change')
								])),
						A2(
							$elm$core$List$intersperse,
							' – ',
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$mul(per1gVires),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Basics$mul(viresAmount),
										$author$project$Shared$Text$formatUsd)),
								$elm_community$list_extra$List$Extra$unique(
									$author$project$Common$List$just(
										A2(
											$author$project$Common$List$mapArg,
											xx,
											_List_fromArray(
												[$elm$core$List$minimum, $elm$core$List$maximum]))))))));
			};
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Common$Table$textCell,
					_List_Nil,
					A3(
						$author$project$Translations$Governance$Info$viresRevenue,
						t,
						$elm$core$String$fromInt(viresAmount),
						$author$project$Shared$Vires$View$viresSign)),
				A2($elm$core$List$map, gViresRevenue, $author$project$Governance$Info$View$periods));
		}();
		var revenue = function () {
			var rows = A2($elm$core$List$map, market, markets);
			return A2(
				$author$project$Common$Table$view,
				$author$project$Governance$Info$View$c.fA,
				_List_fromArray(
					[
						$author$project$Common$Table$head(header),
						$author$project$Common$Table$body(rows),
						$author$project$Common$Table$foot(
						A2(
							$elm$core$List$map,
							$author$project$Common$Table$row(_List_Nil),
							_List_fromArray(
								[totalUsdRow, viresRow])))
					]));
		}();
		return A2(
			$elm$html$Html$div,
			$author$project$Governance$Info$View$c.ip,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					A2(
						$author$project$Translations$Governance$lockViresToReceiveProtocolRevenueMD,
						t,
						$author$project$Shared$Asset$View$names(assets))),
					A2($author$project$Shared$Layout$section, _List_Nil, calc),
					A2(
					$author$project$Shared$Layout$sectionN,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Markdown$viewInDiv,
							_List_Nil,
							$author$project$Translations$Governance$Info$protocolRevenueSheetMD(t)),
							revenue,
							A2(
							$author$project$Common$Markdown$viewInDiv,
							_List_Nil,
							$author$project$Translations$Governance$basedOnMD(t))
						])),
					A2($author$project$Shared$Html$try, faq, model.h$)
				]));
	});
var $author$project$Governance$Lock$Msg$AmountChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Lock$Msg$Close = {$: 5};
var $author$project$Governance$Lock$Msg$FeeAssetChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Lock$Msg$Lock = {$: 0};
var $author$project$Governance$Lock$Msg$SetAmount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Lock$Msg$SetMigrate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$Attributes$disabled = $elm$html$Html$Attributes$disabled(true);
var $author$project$Common$Attributes$invalid = $elm$html$Html$Attributes$class('invalid');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$Shared$Dialog$amount = F4(
	function (attrs, err, msg, model) {
		var attr2 = (model.hK && (!_Utils_eq(err, $elm$core$Maybe$Nothing))) ? A2($elm$core$List$cons, $author$project$Common$Attributes$invalid, attrs) : attrs;
		var attributes = $author$project$Shared$Model$isLoading(model) ? A2($elm$core$List$cons, $author$project$Common$Attributes$disabled, attr2) : attr2;
		return A3(
			$author$project$Common$Form$input,
			msg,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Attributes$type_.jg,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$min('0'),
					attributes)),
			model.gZ);
	});
var $author$project$Shared$Asset$Format$asset = function (a) {
	return A2($author$project$Shared$Asset$Format$assetN, a.hC, a);
};
var $author$project$Translations$Wallet$connectWallet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'wallet.connectWallet');
};
var $author$project$Common$Button$textLink = F3(
	function (attrs, url, label) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$href(url),
				A2($elm$core$List$cons, $author$project$Common$Button$c.O, attrs)),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Shared$Wallet$View$connect = function (t) {
	return A3(
		$author$project$Common$Button$textLink,
		_List_fromArray(
			[$author$project$Common$Button$c.aL]),
		'#connect',
		$author$project$Translations$Wallet$connectWallet(t));
};
var $author$project$Common$Button$text = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$author$project$Common$Button$view(attributes));
};
var $author$project$Common$Button$disabledCta = function (attrs) {
	return $author$project$Common$Button$text(
		A2(
			$elm$core$List$cons,
			$author$project$Common$Attributes$disabled,
			A2($elm$core$List$cons, $author$project$Common$Button$c.aL, attrs)));
};
var $author$project$Common$Validate$disabledCtaMessage = $elm$core$Maybe$Just('');
var $author$project$Common$Attributes$is_ = function (class_) {
	return A2(
		$elm$core$Basics$composeR,
		A2($author$project$Common$Base$iff, class_, ''),
		$elm$html$Html$Attributes$class);
};
var $author$project$Common$Attributes$is = {
	gT: $author$project$Common$Attributes$is_('is-active'),
	iG: $author$project$Common$Attributes$is_('is-loading')
};
var $author$project$Common$Attributes$submit = $elm$html$Html$Attributes$type_('submit');
var $author$project$Common$Button$submit = $author$project$Common$Button$enabled(
	_List_fromArray(
		[$author$project$Common$Button$c.aL, $author$project$Common$Attributes$submit]));
var $author$project$Common$Dialog$ctaButton = F4(
	function (msg, label, model, err) {
		var _v0 = _Utils_Tuple2(err, msg);
		if (!_v0.a.$) {
			var err1 = _v0.a.a;
			return A2(
				$author$project$Common$Button$disabledCta,
				_List_fromArray(
					[
						$author$project$Common$Attributes$is.iG(
						$author$project$Shared$Model$isLoading(model))
					]),
				model.hK ? A3(
					$author$project$Common$Base$iff,
					label,
					err1,
					_Utils_eq(err, $author$project$Common$Validate$disabledCtaMessage)) : label);
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.b;
				return A2($author$project$Common$Button$disabledCta, _List_Nil, label);
			} else {
				var _v2 = _v0.a;
				var msg1 = _v0.b.a;
				return A2($author$project$Common$Button$submit, label, msg1);
			}
		}
	});
var $author$project$Translations$Governance$MyVires$myTotalDeposited = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myTotalDeposited');
};
var $author$project$Translations$Governance$MyVires$myTotalDepositedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myTotalDepositedTooltip');
};
var $elm$html$Html$abbr = _VirtualDom_node('abbr');
var $author$project$Common$Tooltip$c = {
	fO: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('has-tooltip-right')
		]),
	gj: $elm$html$Html$Attributes$class('has-tooltip-arrow has-tooltip-multiline has-tooltip-text-centered')
};
var $author$project$Common$Tooltip$tooltip = F2(
	function (attrs, text) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-tooltip', text),
					$author$project$Common$Tooltip$c.gj
				]),
			attrs);
	});
var $author$project$Common$Tooltip$abbr = F2(
	function (tooltip_, title) {
		return A2(
			$elm$html$Html$abbr,
			A2($author$project$Common$Tooltip$tooltip, $author$project$Common$Tooltip$c.fO, tooltip_),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Shared$Info$c = {
	ip: $elm$html$Html$Attributes$class('info'),
	fP: $elm$html$Html$Attributes$class('row'),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title')
		]),
	gA: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('value')
		])
};
var $author$project$Shared$Info$row = F3(
	function (attrs, titleNodes, valueNodes) {
		return A2(
			$elm$html$Html$div,
			A2($elm$core$List$cons, $author$project$Shared$Info$c.fP, attrs),
			_List_fromArray(
				[
					A2($elm$html$Html$span, $author$project$Shared$Info$c.kB, titleNodes),
					A2($elm$html$Html$span, $author$project$Shared$Info$c.gA, valueNodes)
				]));
	});
var $author$project$Shared$Info$rowNWithTooltip = F3(
	function (attrs, title, tooltip_) {
		return A2(
			$author$project$Shared$Info$row,
			attrs,
			_List_fromArray(
				[
					A2($author$project$Common$Tooltip$abbr, tooltip_, title)
				]));
	});
var $author$project$Governance$Shared$Info$deposit = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$MyVires$myTotalDeposited(t),
		$author$project$Translations$Governance$MyVires$myTotalDepositedTooltip(t));
};
var $author$project$Translations$Governance$MyVires$enterLockAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.enterLockAmount');
};
var $author$project$Shared$Info$newSection = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('start-new-section')
	]);
var $author$project$Shared$Text$formatFee = F2(
	function (currency, amount) {
		return _Utils_ap(
			A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.d7, amount),
			_Utils_ap($author$project$Shared$Text$nbsp, currency));
	});
var $author$project$Shared$Transaction$View$selectFeeAsset = F6(
	function (assets, user, preferredAsset, feeInWaves, msg, userSelectedAssetId) {
		var selectedAsset = function () {
			var _v2 = A2(
				$elm$core$Maybe$andThen,
				A2($Gizra$elm_compat_019$Basics018$flip, $author$project$Common$List$getById, assets),
				userSelectedAssetId);
			if (_v2.$ === 1) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Shared$Asset$Model$waves,
					A4($author$project$Shared$Transaction$Logic$defaultAssetForFee, assets, user, preferredAsset, feeInWaves));
			} else {
				var a = _v2.a;
				return a;
			}
		}();
		var itemText = function (a) {
			return A2(
				$author$project$Shared$Text$formatFee,
				a.ac,
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					a,
					A2($author$project$Shared$Transaction$Logic$feeInAsset, a, feeInWaves)));
		};
		var canBeUsed = function (a) {
			return (!(!a.e0)) && A3($author$project$Shared$Transaction$Logic$isEnoughFee, user.lh, feeInWaves, a);
		};
		var opt = function (a) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(a.bP),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(a.bP, selectedAsset.bP)),
						$elm$html$Html$Attributes$disabled(
						!canBeUsed(a))
					]),
				$author$project$Shared$Html$texts(
					itemText(a)));
		};
		var showInDropDown = function (a) {
			return _Utils_eq(a.bP, $author$project$Shared$Asset$Model$waves.bP) || (_Utils_eq(a.bP, preferredAsset.bP) || canBeUsed(a));
		};
		var _v0 = A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, user.iN);
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = A2($elm$core$List$filter, showInDropDown, assets);
			if (_v1.b && (!_v1.b.b)) {
				var a = _v1.a;
				return $elm$html$Html$text(
					itemText(a));
			} else {
				var shownAssets = _v1;
				return A2(
					$author$project$Common$Select$inline,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(msg)
						]),
					A2($elm$core$List$map, opt, shownAssets));
			}
		} else {
			return $elm$html$Html$text(
				itemText($author$project$Shared$Asset$Model$waves));
		}
	});
var $author$project$Translations$transactionFee = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'transactionFee');
};
var $author$project$Translations$transactionFeeTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'transactionFeeTooltip');
};
var $author$project$Shared$Info$feeInfo = F7(
	function (t, assets, user, preferredAssetId, feeInWaves, msg, selectedAssetId) {
		var asset = A6($author$project$Shared$Transaction$View$selectFeeAsset, assets, user, preferredAssetId, feeInWaves, msg, selectedAssetId);
		return A4(
			$author$project$Shared$Info$rowNWithTooltip,
			$author$project$Shared$Info$newSection,
			$author$project$Translations$transactionFee(t),
			$author$project$Translations$transactionFeeTooltip(t),
			$elm$core$List$singleton(asset));
	});
var $author$project$Shared$Info$feeRow = F7(
	function (t, assets, user, preferredAsset, feeInWaves, msg, selectedAssetId) {
		return A7($author$project$Shared$Info$feeInfo, t, assets, user, preferredAsset, feeInWaves, msg, selectedAssetId);
	});
var $author$project$Shared$Info$feeRowSC = F5(
	function (t, assets, wallets, msg, selectedAssetId) {
		return A7($author$project$Shared$Info$feeRow, t, assets, wallets, $author$project$Shared$Asset$Model$waves, $author$project$Shared$Transaction$Logic$fee.fT, msg, selectedAssetId);
	});
var $author$project$Common$Form$control = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$singleton,
	$elm$html$Html$p($author$project$Common$Form$c.dI));
var $author$project$Common$Form$fieldWithAddon = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map($author$project$Common$Form$control),
		$elm$html$Html$div(
			A2(
				$elm$core$List$cons,
				$author$project$Common$Form$c.aR,
				A2($elm$core$List$cons, $author$project$Common$Form$c.en, attrs))));
};
var $author$project$Shared$Text$formatPercent = function (p) {
	return ($elm$core$Basics$abs(p) < 0.0001) ? ((p > 0) ? '<\u00A00.01%' : ((p < 0) ? '>\u00A0-0.01%' : '0%')) : (A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.fq, p * 100) + '%');
};
var $author$project$Shared$Delta$View$c = {
	ds: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('change')
		])
};
var $author$project$Shared$Delta$View$change = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$text,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$span($author$project$Shared$Delta$View$c.ds)));
var $author$project$Shared$Delta$View$changeArrowSeparator = $author$project$Shared$Delta$View$change($author$project$Shared$Text$nbsp + ('→' + $author$project$Shared$Text$nbsp));
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Shared$Delta$View$view = F3(
	function (mapShort, mapLong, list) {
		var map = F2(
			function (lst, acc) {
				if (lst.b) {
					if (!lst.b.b) {
						var last = lst.a;
						return A2(
							$elm$core$List$cons,
							mapLong(last),
							acc);
					} else {
						var e = lst.a;
						var rest = lst.b;
						return A2(
							map,
							rest,
							A2(
								$elm$core$List$cons,
								mapShort(e),
								acc));
					}
				} else {
					return acc;
				}
			});
		return A2(
			$elm$core$List$intersperse,
			$author$project$Shared$Delta$View$changeArrowSeparator,
			A2(
				$elm$core$List$map,
				$author$project$Shared$Delta$View$change,
				$elm$core$List$reverse(
					A2(
						map,
						A2($elm_community$list_extra$List$Extra$uniqueBy, mapShort, list),
						_List_Nil))));
	});
var $author$project$Shared$Delta$View$fundsDelta2 = function (asset) {
	return A2(
		$author$project$Shared$Delta$View$view,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$max(0),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Shared$Market$Logic$inOrig(asset),
				$author$project$Shared$Text$num(2))),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$max(0),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Shared$Market$Logic$inOrig(asset),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Shared$Text$num(2),
					A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$Basics$append, '\u00A0' + asset.ac)))));
};
var $author$project$Shared$Asset$View$iconWithTextName = F2(
	function (asset, displayName) {
		return A2(
			$elm$html$Html$span,
			$author$project$Shared$Asset$View$c.ez,
			_List_fromArray(
				[
					$author$project$Shared$Asset$View$icon(asset.ac),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Shared$Asset$View$c.ac,
							$elm$core$List$singleton(
								$elm$html$Html$text(displayName))),
							A2(
							$elm$html$Html$div,
							$author$project$Shared$Asset$View$c.iP,
							$elm$core$List$singleton(
								$elm$html$Html$text(asset.iP)))
						]))
				]));
	});
var $author$project$Shared$Asset$View$iconWithText = function (asset) {
	return A2($author$project$Shared$Asset$View$iconWithTextName, asset, asset.ac);
};
var $author$project$Shared$Html$space = $elm$html$Html$text(' ');
var $author$project$Governance$Shared$View$headerWithVires = F3(
	function (vires, closeMsg, header) {
		return A2(
			$author$project$Common$Dialog$header,
			closeMsg,
			_List_fromArray(
				[
					$author$project$Shared$Asset$View$iconWithText(vires),
					$author$project$Shared$Html$space,
					header
				]));
	});
var $author$project$Common$Maybe$nothingIfLessThan = F2(
	function (minReasonableNumber, i) {
		return (_Utils_cmp(i, minReasonableNumber) < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
	});
var $author$project$Shared$Asset$Logic$ignoreDust = $author$project$Common$Maybe$nothingIfLessThan(10);
var $author$project$Translations$Governance$Lock$lockKindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.lock.lockKindReminder');
};
var $author$project$Translations$processingTransaction = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'processingTransaction');
};
var $author$project$Shared$Validate$andNotLoading = F3(
	function (t, model, err) {
		var _v0 = _Utils_Tuple2(err, model.iG);
		if (_v0.a.$ === 1) {
			if (!_v0.b) {
				var _v1 = _v0.a;
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = _v0.a;
				return $elm$core$Maybe$Just(
					$author$project$Translations$processingTransaction(t));
			}
		} else {
			return err;
		}
	});
var $author$project$Translations$Validation$walletIsNotConnected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.walletIsNotConnected');
};
var $author$project$Shared$Validate$checkIfLoggedIn = F3(
	function (t, user, err) {
		var _v0 = user.gV;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Just(
				$author$project$Translations$Validation$walletIsNotConnected(t));
		} else {
			return err;
		}
	});
var $author$project$Shared$Validate$loggedInAndNotLoading = F3(
	function (t, user, model) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Shared$Validate$checkIfLoggedIn, t, user),
			A2($author$project$Shared$Validate$andNotLoading, t, model));
	});
var $author$project$Translations$Home$maxAvailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.maxAvailable');
};
var $author$project$Translations$Home$Vires$migrate = F2(
	function (translations, viresAmount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.vires.migrate',
			_List_fromArray(
				[
					_Utils_Tuple2('viresAmount', viresAmount)
				]));
	});
var $author$project$Translations$Home$Vires$migrateTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.migrateTooltip');
};
var $author$project$Translations$Governance$MyVires$now = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.now');
};
var $author$project$Common$Events$onClickOrDisabled = F2(
	function (msg, condition) {
		return condition ? $elm$html$Html$Events$onClick(msg) : $author$project$Common$Attributes$disabled;
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Shared$KindReminder$c = {
	ip: $elm$html$Html$Attributes$class('info'),
	eQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('line')
		]),
	fJ: $elm$html$Html$Attributes$class('kind-reminder'),
	cD: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text')
		]),
	gE: $elm$html$Html$Attributes$class('warning')
};
var $author$project$Shared$KindReminder$line = A2($elm$html$Html$span, $author$project$Shared$KindReminder$c.eQ, _List_Nil);
var $author$project$Shared$KindReminder$view = function (attrs) {
	return $elm$html$Html$p(
		A2($elm$core$List$cons, $author$project$Shared$KindReminder$c.fJ, attrs));
};
var $author$project$Shared$KindReminder$default = F2(
	function (attrs, message) {
		return A2(
			$author$project$Shared$KindReminder$view,
			attrs,
			_List_fromArray(
				[
					$author$project$Shared$KindReminder$line,
					A2($elm$html$Html$p, $author$project$Shared$KindReminder$c.cD, message)
				]));
	});
var $author$project$Shared$KindReminder$text = A2(
	$elm$core$Basics$composeR,
	$author$project$Shared$Html$texts,
	$author$project$Shared$KindReminder$default(_List_Nil));
var $author$project$Common$CheckBox$c = {
	dv: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('check-box')
		]),
	bl: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('check-box field is-horizontal')
		]),
	dw: $elm$html$Html$Attributes$class('checked'),
	dS: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('disabled')
		]),
	iy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('label')
		]),
	gt: $elm$html$Html$Attributes$class('tumbler')
};
var $author$project$Common$CheckBox$customTumbler = F2(
	function (attrs, isChecked) {
		var checked = A3(
			$author$project$Common$Base$iff,
			A2($elm$core$List$cons, $author$project$Common$CheckBox$c.dw, attrs),
			attrs,
			isChecked);
		return A2(
			$elm$html$Html$div,
			A2($elm$core$List$cons, $author$project$Common$CheckBox$c.gt, checked),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$Attributes$class,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						A2($Gizra$elm_compat_019$Basics018$flip, $elm$html$Html$span, _List_Nil))),
				_List_fromArray(
					['line', 'circle'])));
	});
var $author$project$Common$CheckBox$tumbler = F2(
	function (msg, isChecked) {
		var click = $elm$html$Html$Events$onClick(
			msg(!isChecked));
		return A2(
			$author$project$Common$CheckBox$customTumbler,
			_List_fromArray(
				[click]),
			isChecked);
	});
var $author$project$Translations$Governance$MyVires$unlockStarts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.unlockStarts');
};
var $author$project$Translations$Governance$MyVires$unlockStartsTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.unlockStartsTooltip');
};
var $author$project$Governance$Shared$Info$unlockStarts = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$MyVires$unlockStarts(t),
		$author$project$Translations$Governance$MyVires$unlockStartsTooltip(t));
};
var $author$project$Translations$Governance$unlocked = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.unlocked');
};
var $author$project$Translations$Governance$unlockedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.unlockedTooltip');
};
var $author$project$Governance$Shared$Info$unlocked = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$unlocked(t),
		$author$project$Translations$Governance$unlockedTooltip(t));
};
var $author$project$Common$Validate$and = F2(
	function (validator2, validator1) {
		var and_ = function (model) {
			var _v0 = validator1(model);
			if (_v0.$ === 1) {
				return validator2(model);
			} else {
				var err = _v0;
				return err;
			}
		};
		return and_;
	});
var $author$project$Shared$Validate$canBeEmpty = F2(
	function (map, model) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(
				map(model))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Not an empty');
	});
var $author$project$Shared$Validate$canBeEmptyAmount = $author$project$Shared$Validate$canBeEmpty(
	function ($) {
		return $.gZ;
	});
var $author$project$Shared$Validate$canBeZero = function (model) {
	return _Utils_eq(
		$elm$core$String$toFloat(model.gZ),
		$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Not a zero');
};
var $author$project$Common$Validate$or = F2(
	function (validator1, validator2) {
		var or_ = function (model) {
			var _v0 = validator1(model);
			if (_v0.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				return validator2(model);
			}
		};
		return or_;
	});
var $author$project$Shared$Validate$canBeEmptyOrZero = A2($author$project$Common$Validate$or, $author$project$Shared$Validate$canBeEmptyAmount, $author$project$Shared$Validate$canBeZero);
var $author$project$Translations$loading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'loading');
};
var $author$project$Governance$Lock$Validate$fullyLoader = F3(
	function (t, gov, model) {
		return _Utils_eq(gov, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
			$author$project$Translations$loading(t)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Shared$Validate$notProcessingTransaction = F2(
	function (t, model) {
		return $author$project$Shared$Model$isLoading(model) ? $elm$core$Maybe$Just(
			$author$project$Translations$processingTransaction(t)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Translations$Validation$invalidAmountNumber = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.invalidAmountNumber');
};
var $author$project$Shared$Validate$positiveAmount = F2(
	function (t, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Just(
				$author$project$Translations$Validation$invalidAmountNumber(t));
		} else {
			var a = _v0.a;
			return (a > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Translations$Validation$invalidAmountNumber(t));
		}
	});
var $author$project$Shared$Asset$Logic$min = function (_v0) {
	var decimals = _v0.hC;
	return 1 / A2($elm$core$Basics$pow, 10, decimals);
};
var $author$project$Translations$Validation$poorAmountPrecision = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.poorAmountPrecision');
};
var $author$project$Shared$Validate$precision = F3(
	function (t, asset, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (!_v0.$) {
			var a = _v0.a;
			return (_Utils_cmp(
				a,
				$author$project$Shared$Asset$Logic$min(asset)) < 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Validation$poorAmountPrecision(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Shared$Validate$input = F3(
	function (validator, asset, model) {
		return A2(
			$elm$core$Maybe$andThen,
			validator,
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, asset, model.gZ));
	});
var $author$project$Shared$Validate$balance = F4(
	function (err, t, asset, available) {
		var validator = function (amount) {
			return (_Utils_cmp(amount, available) > 0) ? $elm$core$Maybe$Just(
				err(t)) : $elm$core$Maybe$Nothing;
		};
		return A2($author$project$Shared$Validate$input, validator, asset);
	});
var $author$project$Translations$Validation$insufficientWalletBalance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.insufficientWalletBalance');
};
var $author$project$Shared$Validate$walletBalance = $author$project$Shared$Validate$balance($author$project$Translations$Validation$insufficientWalletBalance);
var $author$project$Governance$Lock$Validate$validate = F4(
	function (t, vires, wallet, gov) {
		return A2(
			$author$project$Common$Validate$or,
			$author$project$Shared$Validate$canBeEmptyOrZero,
			A2(
				$author$project$Common$Validate$and,
				A3($author$project$Shared$Validate$walletBalance, t, vires, wallet),
				A2(
					$author$project$Common$Validate$and,
					A2($author$project$Shared$Validate$precision, t, vires),
					A2(
						$author$project$Common$Validate$and,
						$author$project$Shared$Validate$positiveAmount(t),
						A2(
							$author$project$Common$Validate$and,
							A2($author$project$Governance$Lock$Validate$fullyLoader, t, gov),
							$author$project$Shared$Validate$notProcessingTransaction(t))))));
	});
var $author$project$Shared$Info$view = function (attrs) {
	return $elm$html$Html$div(
		A2($elm$core$List$cons, $author$project$Shared$Info$c.ip, attrs));
};
var $author$project$Translations$Governance$MyVires$myViresWeight = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myViresWeight');
};
var $author$project$Translations$Governance$MyVires$myViresWeightTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myViresWeightTooltip');
};
var $author$project$Governance$Shared$Info$viresWeight = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$MyVires$myViresWeight(t),
		$author$project$Translations$Governance$MyVires$myViresWeightTooltip(t));
};
var $author$project$Shared$Asset$Format$assetOnlyNums = function (a) {
	return A2($author$project$Shared$Asset$Format$assetOnlyNumsN, a.hC, a);
};
var $author$project$Shared$Delta$View$fundsDelta = function (asset) {
	return A2(
		$author$project$Shared$Delta$View$view,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$max(0),
			$author$project$Shared$Asset$Format$assetOnlyNums(asset)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$max(0),
			$author$project$Shared$Asset$Format$asset(asset)));
};
var $author$project$Shared$Info$rowN = F2(
	function (attrs, title) {
		return A2(
			$author$project$Shared$Info$row,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Shared$Delta$View$funds = F2(
	function (title, asset) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Delta$View$fundsDelta(asset),
			A2($author$project$Shared$Info$rowN, _List_Nil, title));
	});
var $author$project$Translations$walletBalance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'walletBalance');
};
var $author$project$Shared$Delta$View$wallet = function (t) {
	return $author$project$Shared$Delta$View$funds(
		$author$project$Translations$walletBalance(t));
};
var $author$project$Shared$Delta$View$zeroed2 = function (asset) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$Gizra$elm_compat_019$Basics018$flip,
			$elm$core$List$cons,
			_List_fromArray(
				[0])),
		$author$project$Shared$Delta$View$fundsDelta2(asset));
};
var $author$project$Governance$Lock$View$view = F5(
	function (t, vires, assets, user, model) {
		var inWalletNow = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Shared$Wallet$Logic$wallet, vires.bP, user.lh));
		var info = function () {
			var unlocked = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $author$project$Governance$Shared$Logic$unlocked, user.ic));
			var staked = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.f3;
					},
					user.ic));
			var migrate = function (v) {
				return A4(
					$author$project$Shared$Info$rowNWithTooltip,
					_List_Nil,
					A2(
						$author$project$Translations$Home$Vires$migrate,
						t,
						A2($author$project$Shared$Asset$Format$asset, vires, v)),
					$author$project$Translations$Home$Vires$migrateTooltip(t),
					$elm$core$List$singleton(
						A2($author$project$Common$CheckBox$tumbler, $author$project$Governance$Lock$Msg$SetMigrate, model.iY)));
			};
			var maybeAmount = A2($author$project$Shared$Asset$Logic$tryToSatoshi, vires, model.gZ);
			var legacyStaked = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f3;
				},
				user.hN);
			var inWalletAfter = A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$sub(inWalletNow),
				maybeAmount);
			var amount = A2($elm$core$Maybe$withDefault, 0, maybeAmount);
			var deposit = A2(
				$author$project$Shared$Delta$View$fundsDelta2,
				vires,
				_List_fromArray(
					[
						staked,
						(staked + amount) + A3(
						$author$project$Common$Base$iff,
						A2($elm$core$Maybe$withDefault, 0, legacyStaked),
						0,
						model.iY)
					]));
			var activeViresWeight = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.lj;
				},
				user.ic);
			var viresWeight = A3(
				$author$project$Shared$Delta$View$view,
				$author$project$Shared$Text$formatPercent,
				$author$project$Shared$Text$formatPercent,
				$author$project$Common$List$just(
					_List_fromArray(
						[
							activeViresWeight,
							$elm$core$Maybe$Just(1)
						])));
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Shared$Html$try,
						migrate,
						A2($elm$core$Maybe$andThen, $author$project$Shared$Asset$Logic$ignoreDust, legacyStaked)),
						A2($author$project$Governance$Shared$Info$deposit, t, deposit),
						A2(
						$author$project$Governance$Shared$Info$unlocked,
						t,
						A2($author$project$Shared$Delta$View$zeroed2, vires, unlocked)),
						A2($author$project$Governance$Shared$Info$viresWeight, t, viresWeight),
						A2(
						$author$project$Governance$Shared$Info$unlockStarts,
						t,
						$author$project$Shared$Html$texts(
							$author$project$Translations$Governance$MyVires$now(t))),
						A3(
						$author$project$Shared$Delta$View$wallet,
						t,
						vires,
						$author$project$Common$List$just(
							_List_fromArray(
								[
									$elm$core$Maybe$Just(inWalletNow),
									inWalletAfter
								]))),
						A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Governance$Lock$Msg$FeeAssetChanged, model.h1)
					]));
		}();
		var err = A5($author$project$Governance$Lock$Validate$validate, t, vires, inWalletNow, user.ic, model);
		var lock = $author$project$User$Logic$isLoggedIn(user) ? A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Governance$Lock$Msg$Lock),
			$author$project$Translations$Governance$MyVires$lock(t),
			model,
			A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, err)) : $author$project$Shared$Wallet$View$connect(t);
		var amountInput = function () {
			var number = A4(
				$author$project$Shared$Dialog$amount,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder(
						$author$project$Translations$Governance$MyVires$enterLockAmount(t)),
						$author$project$Governance$Shared$View$maxVires
					]),
				err,
				$author$project$Governance$Lock$Msg$AmountChanged,
				model);
			var maxBtn = A2(
				$author$project$Common$Button$text,
				_List_fromArray(
					[
						A2(
						$author$project$Common$Events$onClickOrDisabled,
						$author$project$Governance$Lock$Msg$SetAmount(inWalletNow),
						inWalletNow > 0)
					]),
				$author$project$Translations$Home$maxAvailable(t));
			return A2(
				$author$project$Common$Form$fieldWithAddon,
				_List_Nil,
				_List_fromArray(
					[number, maxBtn]));
		}();
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Governance$Lock$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Governance$Shared$View$headerWithVires,
							vires,
							$author$project$Governance$Lock$Msg$Close,
							$elm$html$Html$text(
								$author$project$Translations$Governance$MyVires$lock(t))),
							amountInput,
							info,
							$author$project$Shared$KindReminder$text(
							$author$project$Translations$Governance$Lock$lockKindReminder(t)),
							A2($author$project$Shared$Dialog$footer, t, lock)
						]))
				]));
	});
var $author$project$Governance$MyVires$Msg$Copy = function (a) {
	return {$: 8, a: a};
};
var $author$project$Governance$MyVires$Msg$OpenDelegate = {$: 2};
var $author$project$Governance$MyVires$Msg$OpenLock = {$: 0};
var $author$project$Governance$MyVires$Msg$OpenUnstake = {$: 1};
var $author$project$Governance$Shared$View$c = {
	cX: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('actions md')
		])
};
var $author$project$Common$Card$c = {
	aG: $elm$html$Html$Attributes$class('border'),
	aH: $elm$html$Html$Attributes$class('card'),
	bk: $elm$html$Html$Attributes$class('card-table'),
	dH: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-content')
		]),
	bs: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-table-content')
		]),
	eD: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('inside')
		]),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title')
		])
};
var $author$project$Common$Card$content = $elm$html$Html$div($author$project$Common$Card$c.dH);
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Common$Card$view = function (attrs) {
	return $elm$html$Html$fieldset(
		A2(
			$elm$core$List$cons,
			$author$project$Common$Card$c.aH,
			A2($elm$core$List$cons, $author$project$Common$Card$c.aG, attrs)));
};
var $author$project$Governance$Shared$View$actions = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Card$content,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Common$Card$view($author$project$Governance$Shared$View$c.cX)));
var $author$project$Governance$MyVires$View$c = {
	e8: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('my-vires')
		])
};
var $author$project$Common$Button$default = $author$project$Common$Button$enabled(
	_List_fromArray(
		[$author$project$Common$Button$c.O, $author$project$Common$Button$c.aN]));
var $author$project$Translations$Governance$MyVires$delegateClaim = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.delegateClaim');
};
var $author$project$Translations$Governance$MyVires$delegateClaimDescriptionMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.delegateClaimDescriptionMD');
};
var $author$project$Shared$Text$formatCurrency = F2(
	function (currency, amount) {
		return _Utils_ap(
			A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.bt, amount),
			_Utils_ap($author$project$Shared$Text$nbsp, currency));
	});
var $author$project$Shared$Vires$View$formatVires = function (vires) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Market$Logic$inOrig(vires),
		$author$project$Shared$Text$formatCurrency($author$project$Shared$Vires$View$viresSign));
};
var $author$project$Shared$Vires$View$gViresSign = 'gVires';
var $author$project$Translations$governanceAPRTooltip = F2(
	function (translations, assets1) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'governanceAPRTooltip',
			_List_fromArray(
				[
					_Utils_Tuple2('assets1', assets1)
				]));
	});
var $author$project$Translations$governanceAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governanceAPR');
};
var $author$project$Governance$Shared$Info$governanceApr = F2(
	function (t, assets) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Html$texts,
			A3(
				$author$project$Shared$Info$rowNWithTooltip,
				_List_Nil,
				$author$project$Translations$governanceAPR(t),
				A2(
					$author$project$Translations$governanceAPRTooltip,
					t,
					$author$project$Shared$Asset$View$names(assets))));
	});
var $author$project$Translations$Governance$MyVires$myGovernanceWeight = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myGovernanceWeight');
};
var $author$project$Translations$Governance$MyVires$myGovernanceWeightTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.myGovernanceWeightTooltip');
};
var $author$project$Governance$Shared$Info$governanceWeight = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$MyVires$myGovernanceWeight(t),
		$author$project$Translations$Governance$MyVires$myGovernanceWeightTooltip(t));
};
var $author$project$Shared$Waves$Address$toEth = function (_v0) {
	var waves = _v0;
	var _v1 = $nathanjohnson320$base58$Base58$decode(waves);
	if (!_v1.$) {
		var bigInt = _v1.a;
		return '0x' + A3(
			$elm$core$String$slice,
			0,
			40,
			A2(
				$elm$core$String$dropLeft,
				3,
				$cmditch$elm_bigint$BigInt$toHexString(bigInt)));
	} else {
		return 'Invalid waves address';
	}
};
var $author$project$Shared$Waves$View$displayAddress = F2(
	function (metamask, address) {
		var a = address;
		return metamask ? $author$project$Shared$Waves$Address$toEth(address) : a;
	});
var $author$project$Shared$Text$ellipsisSign = '…';
var $author$project$Shared$Text$ellipsis = F2(
	function (max, s) {
		return (_Utils_cmp(
			$elm$core$String$length(s),
			max) > 0) ? _Utils_ap(
			A2($elm$core$String$left, max - 3, s),
			_Utils_ap(
				$author$project$Shared$Text$ellipsisSign,
				A2($elm$core$String$right, 3, s))) : s;
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$Icon = F5(
	function (prefix, name, width, height, paths) {
		return {$8: height, ac: name, jr: paths, a3: prefix, ll: width};
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$copy = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'copy',
	448,
	512,
	_List_fromArray(
		['M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z']));
var $lattyware$elm_fontawesome$FontAwesome$Icon$Presentation = $elm$core$Basics$identity;
var $lattyware$elm_fontawesome$FontAwesome$Icon$present = function (icon) {
	return {aF: _List_Nil, ey: icon, bP: $elm$core$Maybe$Nothing, av: $elm$core$Maybe$Nothing, ch: 'img', kB: $elm$core$Maybe$Nothing, bc: _List_Nil};
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add = F2(
	function (transform, combined) {
		switch (transform.$) {
			case 0:
				var direction = transform.a;
				var amount = function () {
					if (!direction.$) {
						var by = direction.a;
						return by;
					} else {
						var by = direction.a;
						return -by;
					}
				}();
				return _Utils_update(
					combined,
					{ke: combined.ke + amount});
			case 1:
				var direction = transform.a;
				var _v2 = function () {
					switch (direction.$) {
						case 0:
							var by = direction.a;
							return _Utils_Tuple2(0, -by);
						case 1:
							var by = direction.a;
							return _Utils_Tuple2(0, by);
						case 2:
							var by = direction.a;
							return _Utils_Tuple2(-by, 0);
						default:
							var by = direction.a;
							return _Utils_Tuple2(by, 0);
					}
				}();
				var x = _v2.a;
				var y = _v2.b;
				return _Utils_update(
					combined,
					{cR: combined.cR + x, cS: combined.cS + y});
			case 2:
				var rotation = transform.a;
				return _Utils_update(
					combined,
					{j1: combined.j1 + rotation});
			default:
				if (!transform.a) {
					var _v4 = transform.a;
					return _Utils_update(
						combined,
						{h5: true});
				} else {
					var _v5 = transform.a;
					return _Utils_update(
						combined,
						{h6: true});
				}
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize = 16;
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform = {h5: false, h6: false, j1: 0, ke: $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize, cR: 0, cS: 0};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine = function (transforms) {
	return A3($elm$core$List$foldl, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform, transforms);
};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform = function (transforms) {
	var combined = $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine(transforms);
	return _Utils_eq(combined, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(combined);
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $lattyware$elm_fontawesome$FontAwesome$Icon$titledContents = F3(
	function (titleId, contents, title) {
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$svg$Svg$title,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id(titleId)
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(title)
					])),
			contents);
	});
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg = F3(
	function (containerWidth, iconWidth, transform) {
		var path = 'translate(' + ($elm$core$String$fromFloat((iconWidth / 2) * (-1)) + ' -256)');
		var outer = 'translate(' + ($elm$core$String$fromFloat(containerWidth / 2) + ' 256)');
		var innerTranslate = 'translate(' + ($elm$core$String$fromFloat(transform.cR * 32) + (',' + ($elm$core$String$fromFloat(transform.cS * 32) + ') ')));
		var innerRotate = 'rotate(' + ($elm$core$String$fromFloat(transform.j1) + ' 0 0)');
		var flipY = transform.h6 ? (-1) : 1;
		var scaleY = (transform.ke / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipY;
		var flipX = transform.h5 ? (-1) : 1;
		var scaleX = (transform.ke / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipX;
		var innerScale = 'scale(' + ($elm$core$String$fromFloat(scaleX) + (', ' + ($elm$core$String$fromFloat(scaleY) + ') ')));
		return {
			eC: $elm$svg$Svg$Attributes$transform(
				_Utils_ap(
					innerTranslate,
					_Utils_ap(innerScale, innerRotate))),
			av: $elm$svg$Svg$Attributes$transform(outer),
			fo: $elm$svg$Svg$Attributes$transform(path)
		};
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $lattyware$elm_fontawesome$FontAwesome$Icon$allSpace = _List_fromArray(
	[
		$elm$svg$Svg$Attributes$x('0'),
		$elm$svg$Svg$Attributes$y('0'),
		$elm$svg$Svg$Attributes$width('100%'),
		$elm$svg$Svg$Attributes$height('100%')
	]);
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath = F2(
	function (attrs, d) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$fill('currentColor'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$d(d),
					attrs)),
			_List_Nil);
	});
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths = F2(
	function (attrs, icon) {
		var _v0 = icon.jr;
		if (!_v0.b) {
			return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath, attrs, '');
		} else {
			if (!_v0.b.b) {
				var only = _v0.a;
				return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath, attrs, only);
			} else {
				var secondary = _v0.a;
				var _v1 = _v0.b;
				var primary = _v1.a;
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('fa-group')
						]),
					_List_fromArray(
						[
							A2(
							$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('fa-secondary'),
								attrs),
							secondary),
							A2(
							$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePath,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('fa-primary'),
								attrs),
							primary)
						]));
			}
		}
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
var $elm$svg$Svg$Attributes$maskContentUnits = _VirtualDom_attribute('maskContentUnits');
var $elm$svg$Svg$Attributes$maskUnits = _VirtualDom_attribute('maskUnits');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewMaskedWithTransform = F4(
	function (id, transforms, inner, outer) {
		var maskInnerGroup = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[transforms.eC]),
			_List_fromArray(
				[
					A2(
					$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('black'),
							transforms.fo
						]),
					inner)
				]));
		var maskId = 'mask-' + (inner.ac + ('-' + id));
		var maskTag = A2(
			$elm$svg$Svg$mask,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id(maskId),
						$elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'),
						$elm$svg$Svg$Attributes$maskContentUnits('userSpaceOnUse')
					]),
				$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$fill('white'),
						$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[transforms.av]),
					_List_fromArray(
						[maskInnerGroup]))
				]));
		var clipId = 'clip-' + (outer.ac + ('-' + id));
		var defs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(clipId)
						]),
					_List_fromArray(
						[
							A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths, _List_Nil, outer)
						])),
					maskTag
				]));
		return _List_fromArray(
			[
				defs,
				A2(
				$elm$svg$Svg$rect,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fill('currentColor'),
								$elm$svg$Svg$Attributes$clipPath('url(#' + (clipId + ')')),
								$elm$svg$Svg$Attributes$mask('url(#' + (maskId + ')'))
							]),
							$lattyware$elm_fontawesome$FontAwesome$Icon$allSpace
						])),
				_List_Nil)
			]);
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewWithTransform = F2(
	function (transforms, icon) {
		if (!transforms.$) {
			var ts = transforms.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[ts.av]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[ts.eC]),
						_List_fromArray(
							[
								A2(
								$lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths,
								_List_fromArray(
									[ts.fo]),
								icon)
							]))
					]));
		} else {
			return A2($lattyware$elm_fontawesome$FontAwesome$Svg$Internal$corePaths, _List_Nil, icon);
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Icon$internalView = function (_v0) {
	var icon = _v0.ey;
	var attributes = _v0.aF;
	var transforms = _v0.bc;
	var role = _v0.ch;
	var id = _v0.bP;
	var title = _v0.kB;
	var outer = _v0.av;
	var alwaysId = A2($elm$core$Maybe$withDefault, icon.ac, id);
	var titleId = alwaysId + '-title';
	var semantics = A2(
		$elm$core$Maybe$withDefault,
		A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', titleId)),
			title));
	var _v1 = A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(icon.ll, icon.$8),
		A2(
			$elm$core$Maybe$map,
			function (o) {
				return _Utils_Tuple2(o.ll, o.$8);
			},
			outer));
	var width = _v1.a;
	var height = _v1.b;
	var classes = _List_fromArray(
		[
			'svg-inline--fa',
			'fa-' + icon.ac,
			'fa-w-' + $elm$core$String$fromInt(
			$elm$core$Basics$ceiling((width / height) * 16))
		]);
	var svgTransform = A2(
		$elm$core$Maybe$map,
		A2($lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg, width, icon.ll),
		$lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform(transforms));
	var contents = function () {
		var resolvedSvgTransform = A2(
			$elm$core$Maybe$withDefault,
			A3($lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg, width, icon.ll, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform),
			svgTransform);
		return A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2($lattyware$elm_fontawesome$FontAwesome$Icon$viewWithTransform, svgTransform, icon)
				]),
			A2(
				$elm$core$Maybe$map,
				A3($lattyware$elm_fontawesome$FontAwesome$Icon$viewMaskedWithTransform, alwaysId, resolvedSvgTransform, icon),
				outer));
	}();
	var potentiallyTitledContents = A2(
		$elm$core$Maybe$withDefault,
		contents,
		A2(
			$elm$core$Maybe$map,
			A2($lattyware$elm_fontawesome$FontAwesome$Icon$titledContents, titleId, contents),
			title));
	return A2(
		$elm$svg$Svg$svg,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', role),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						$elm$svg$Svg$Attributes$viewBox(
						'0 0 ' + ($elm$core$String$fromInt(width) + (' ' + $elm$core$String$fromInt(height)))),
						semantics
					]),
					A2($elm$core$List$map, $elm$svg$Svg$Attributes$class, classes),
					attributes
				])),
		potentiallyTitledContents);
};
var $lattyware$elm_fontawesome$FontAwesome$Icon$view = function (presentation) {
	return $lattyware$elm_fontawesome$FontAwesome$Icon$internalView(presentation);
};
var $lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon = A2($elm$core$Basics$composeR, $lattyware$elm_fontawesome$FontAwesome$Icon$present, $lattyware$elm_fontawesome$FontAwesome$Icon$view);
var $author$project$Common$Copy$icon = function (msg) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(msg),
				$elm$html$Html$Attributes$class('copy')
			]),
		$elm$core$List$singleton(
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$copy)));
};
var $author$project$Shared$Waves$Address$View$info = F5(
	function (mm, attrs, title, copyMsg, address) {
		var addressStr = address;
		var linkToExplorer = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://wavesexplorer.com/address/' + addressStr),
					$author$project$Common$Attributes$blank
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Shared$Text$ellipsis,
						10,
						A2($author$project$Shared$Waves$View$displayAddress, mm, address)))
				]));
		return A3(
			$author$project$Shared$Info$rowN,
			attrs,
			title,
			_List_fromArray(
				[
					linkToExplorer,
					$author$project$Common$Copy$icon(
					copyMsg(addressStr))
				]));
	});
var $author$project$Translations$Governance$MyVires$legacyStaking = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.legacyStaking');
};
var $author$project$Translations$Governance$MyVires$legacyStakingTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.legacyStakingTooltip');
};
var $author$project$Governance$Shared$Info$legacy = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$MyVires$legacyStaking(t),
		$author$project$Translations$Governance$MyVires$legacyStakingTooltip(t));
};
var $author$project$Shared$Html$newLine = A2($elm$html$Html$br, _List_Nil, _List_Nil);
var $author$project$Translations$Governance$stillLocked = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.stillLocked');
};
var $author$project$Translations$Governance$stillLockedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.stillLockedTooltip');
};
var $author$project$Governance$Shared$Info$stillLocked = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Governance$stillLocked(t),
		$author$project$Translations$Governance$stillLockedTooltip(t));
};
var $author$project$Shared$Info$textRow = F2(
	function (attrs, title) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				A2($author$project$Shared$Info$rowN, attrs, title)));
	});
var $author$project$Governance$MyVires$Delegate$Msg$ClaimFromChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$MyVires$Delegate$Msg$Delegate = {$: 2};
var $author$project$Governance$MyVires$Delegate$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$MyVires$Delegate$Msg$RemoveDelegation = {$: 3};
var $author$project$Governance$MyVires$Delegate$View$c = {
	dP: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('delegate')
		])
};
var $author$project$Translations$Governance$Delegate$delegateKindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.delegate.delegateKindReminder');
};
var $author$project$Translations$Governance$Delegate$enterAddressToDelegateClaim = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.delegate.enterAddressToDelegateClaim');
};
var $author$project$Translations$Governance$Delegate$remove = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.delegate.remove');
};
var $author$project$Translations$Governance$Delegate$removeDelegation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.delegate.removeDelegation');
};
var $author$project$Governance$MyVires$Delegate$Validate$validAddress = F2(
	function (t, model) {
		var _v0 = A2($elm$core$Dict$get, model.hi, model.gW);
		if ((!_v0.$) && _v0.a) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				A2($author$project$Translations$Validation$addressIsInvalid, t, 'WAVES'));
		}
	});
var $author$project$Governance$MyVires$Delegate$Validate$validate = function (t) {
	return A2(
		$author$project$Common$Validate$and,
		$author$project$Governance$MyVires$Delegate$Validate$validAddress(t),
		$author$project$Shared$Validate$notProcessingTransaction(t));
};
var $author$project$Governance$MyVires$Delegate$View$view = F5(
	function (t, vires, assets, user, model) {
		var removeDelegation = model.hK && $elm$core$String$isEmpty(
			$elm$core$String$trim(model.hi));
		var info = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Governance$MyVires$Delegate$Msg$FeeAssetChanged, model.h1)
				]));
		var cta = removeDelegation ? A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Governance$MyVires$Delegate$Msg$RemoveDelegation),
			$author$project$Translations$Governance$Delegate$removeDelegation(t),
			model,
			A2($author$project$Shared$Validate$notProcessingTransaction, t, model)) : A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Governance$MyVires$Delegate$Msg$Delegate),
			$author$project$Translations$Governance$MyVires$delegateClaim(t),
			model,
			A2($author$project$Governance$MyVires$Delegate$Validate$validate, t, model));
		var claimFrom = A2(
			$author$project$Common$Form$fieldWithAddon,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Common$Form$input,
					$author$project$Governance$MyVires$Delegate$Msg$ClaimFromChanged,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$placeholder(
							$author$project$Translations$Governance$Delegate$enterAddressToDelegateClaim(t)),
							$elm$html$Html$Attributes$disabled(
							$author$project$Shared$Model$isLoading(model))
						]),
					model.hi),
					A2(
					$author$project$Common$Button$text,
					_List_fromArray(
						[
							A3(
							$author$project$Common$Base$iff,
							$author$project$Common$Attributes$disabled,
							$elm$html$Html$Events$onClick(
								$author$project$Governance$MyVires$Delegate$Msg$ClaimFromChanged('')),
							removeDelegation)
						]),
					$author$project$Translations$Governance$Delegate$remove(t))
				]));
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Governance$MyVires$Delegate$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$Governance$MyVires$Delegate$View$c.dP,
					_List_fromArray(
						[
							A3(
							$author$project$Governance$Shared$View$headerWithVires,
							vires,
							$author$project$Governance$MyVires$Delegate$Msg$Close,
							$elm$html$Html$text(
								$author$project$Translations$Governance$MyVires$delegateClaim(t))),
							claimFrom,
							info,
							$author$project$Shared$KindReminder$text(
							$author$project$Translations$Governance$Delegate$delegateKindReminder(t)),
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $author$project$Governance$Revenue$Msg$FromChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Governance$Revenue$Msg$OpenClaim = {$: 4};
var $author$project$Governance$Revenue$Logic$accrued = function (r) {
	return r.hj + r.aZ;
};
var $author$project$Translations$Governance$ClaimRevenue$accrued = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.accrued');
};
var $author$project$Translations$Governance$ClaimRevenue$accruedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.accruedTooltip');
};
var $author$project$Translations$Governance$ClaimRevenue$alreadyClaimed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.alreadyClaimed');
};
var $author$project$Translations$Governance$ClaimRevenue$alreadyClaimedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.alreadyClaimedTooltip');
};
var $author$project$Governance$Revenue$View$c = {
	bh: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('asset')
		]),
	h8: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('from')
		]),
	T: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('money')
		]),
	jZ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('revenue')
		]),
	f_: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('revenue-sheet')
		])
};
var $author$project$Translations$Governance$ClaimRevenue$claimFrom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.claimFrom');
};
var $author$project$Translations$Governance$ClaimRevenue$claimRevenue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.claimRevenue');
};
var $author$project$Common$Form$field = function (attrs) {
	return $elm$html$Html$div(
		A2($elm$core$List$cons, $author$project$Common$Form$c.aR, attrs));
};
var $author$project$Common$Form$controlField = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Form$control,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Common$Form$field(_List_Nil)));
var $author$project$Governance$Revenue$Logic$earnedToDate = function (r) {
	return (r.bm + r.hj) + r.aZ;
};
var $author$project$Translations$Governance$ClaimRevenue$earnedToDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.earnedToDate');
};
var $author$project$Translations$Governance$ClaimRevenue$earnedToDateTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.earnedToDateTooltip');
};
var $author$project$Governance$Revenue$View$emptyCells = A2(
	$elm$core$List$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$text,
		$author$project$Common$Table$cell($author$project$Governance$Revenue$View$c.T)),
	A2($elm$core$List$repeat, 3, '–'));
var $author$project$Common$Form$fieldBody = $elm$html$Html$div($author$project$Common$Form$c.d8);
var $author$project$Common$Form$fieldHorizontal = function (attr) {
	return $elm$html$Html$div(
		A2(
			$elm$core$List$cons,
			$author$project$Common$Form$c.aR,
			A2($elm$core$List$cons, $author$project$Common$Form$c.et, attr)));
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Common$Form$label = $elm$html$Html$label($author$project$Common$Form$c.iy);
var $author$project$Common$Form$textLabel = A2($elm$core$Basics$composeR, $author$project$Shared$Html$texts, $author$project$Common$Form$label);
var $author$project$Common$Form$fieldLabel = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Form$textLabel,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div($author$project$Common$Form$c.d9)));
var $author$project$Common$Table$headerWithTooltip = F2(
	function (tooltip_, attributes) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$span(_List_Nil),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$abbr(
								A2($author$project$Common$Tooltip$tooltip, _List_Nil, tooltip_)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$html$Html$th(
									A2($elm$core$List$cons, $author$project$Common$Table$c_.aS, attributes))))))));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Shared$User$Logic$mapBy = F3(
	function (by, dict, map) {
		return $elm$core$List$filterMap(
			function (m) {
				return A2(
					$elm$core$Maybe$map,
					map(m),
					A2(
						$elm$core$Dict$get,
						by(m),
						dict));
			});
	});
var $author$project$Shared$User$Logic$mapReserves = $author$project$Shared$User$Logic$mapBy(
	function ($) {
		return $.jT;
	});
var $elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			list);
	});
var $author$project$Governance$Revenue$Logic$group = function (map) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$dict_extra$Dict$Extra$groupBy(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$split('_'),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							$elm$core$Maybe$withDefault(''))))),
			$elm$core$Dict$map(
				$elm$core$Basics$always(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($elm$core$Tuple$second),
						map)))));
};
var $author$project$Governance$Revenue$Logic$revenueGroped = function (revenue) {
	var sumRevenue = function (r) {
		var sum = function (map) {
			return $elm$core$List$sum(
				A2($elm$core$List$map, map, r));
		};
		return {
			hj: sum(
				function ($) {
					return $.hj;
				}),
			bm: sum(
				function ($) {
					return $.bm;
				}),
			aZ: sum(
				function ($) {
					return $.aZ;
				})
		};
	};
	return A2($author$project$Governance$Revenue$Logic$group, sumRevenue, revenue);
};
var $author$project$Translations$Governance$ClaimRevenue$revenueSheet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.revenueSheet');
};
var $author$project$Translations$Governance$ClaimRevenue$totalInUsd = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.totalInUsd');
};
var $author$project$Governance$Revenue$Claim$Msg$Claim = {$: 0};
var $author$project$Governance$Revenue$Claim$Msg$Close = {$: 3};
var $author$project$Governance$Revenue$Claim$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Revenue$Claim$Msg$RelockChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Revenue$Claim$View$c = {
	dz: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('claim-revenue')
		]),
	jZ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('revenue-list')
		])
};
var $author$project$Translations$Governance$ClaimRevenue$iWillReceiveToMyWalletFollowingTokens = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.iWillReceiveToMyWalletFollowingTokens');
};
var $author$project$Translations$Governance$ClaimRevenue$reLockKindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.reLockKindReminder');
};
var $author$project$Translations$Governance$ClaimRevenue$relockMyViresUnderPlan = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.relockMyViresUnderPlan');
};
var $author$project$Governance$Revenue$Logic$revenueGropedBy = F2(
	function (map, revenue) {
		return A2(
			$author$project$Governance$Revenue$Logic$group,
			$elm$core$List$sum,
			A2(
				$elm$core$Dict$map,
				$elm$core$Basics$always(map),
				revenue));
	});
var $author$project$Translations$Governance$ClaimRevenue$totalInUsdTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.claimRevenue.totalInUsdTooltip');
};
var $author$project$Shared$Html$try2 = F2(
	function (map, ab) {
		if ((!ab.a.$) && (!ab.b.$)) {
			var a = ab.a.a;
			var b = ab.b.a;
			return A2(map, a, b);
		} else {
			return $author$project$Shared$Html$nothing;
		}
	});
var $author$project$Governance$Revenue$Claim$View$view = function (t) {
	return function (vires) {
		return function (assets) {
			return function (markets) {
				return function (rates) {
					return function (user) {
						return function (from) {
							return function (revenue) {
								return function (governance) {
									return function (model) {
										var revenueGroped = A2(
											$author$project$Governance$Revenue$Logic$revenueGropedBy,
											function ($) {
												return $.hj;
											},
											revenue);
										var totalUsd = '≈\u00A0' + $author$project$Shared$Text$formatUsd(
											$elm$core$List$sum(
												A3(
													$author$project$Shared$User$Logic$mapReserves,
													revenueGroped,
													F2(
														function (m, r) {
															return A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, r);
														}),
													markets)));
										var revenueSheet = function () {
											var marketRevenue = F2(
												function (m, r) {
													return _List_fromArray(
														[
															$author$project$Shared$Asset$View$icon(m.bh.ac),
															$elm$html$Html$text(
															A2($author$project$Shared$Asset$Format$asset, m.bh, r))
														]);
												});
											return A2(
												$elm$html$Html$ul,
												$author$project$Governance$Revenue$Claim$View$c.jZ,
												A2(
													$elm$core$List$map,
													$elm$html$Html$li(_List_Nil),
													_Utils_ap(
														A3($author$project$Shared$User$Logic$mapReserves, revenueGroped, marketRevenue, markets),
														_List_fromArray(
															[
																$elm$core$List$singleton(
																A2(
																	$elm$html$Html$strong,
																	A2(
																		$author$project$Common$Tooltip$tooltip,
																		_List_Nil,
																		$author$project$Translations$Governance$ClaimRevenue$totalInUsdTooltip(t)),
																	$author$project$Shared$Html$texts(totalUsd)))
															]))));
										}();
										var info = function (u) {
											var relock = A2($author$project$Common$CheckBox$tumbler, $author$project$Governance$Revenue$Claim$Msg$RelockChanged, model.jO);
											var newViresWeight = 1;
											var viresWeight = model.jO ? A3(
												$author$project$Shared$Delta$View$view,
												$author$project$Shared$Text$formatPercent,
												$author$project$Shared$Text$formatPercent,
												_List_fromArray(
													[u.lj, newViresWeight])) : $author$project$Shared$Html$texts(
												$author$project$Shared$Text$formatPercent(u.lj));
											var fromAddress = F2(
												function (_v0, _v1) {
													var userAddress = _v0;
													var from_ = _v1;
													return _Utils_eq(userAddress, from_) ? $author$project$Shared$Html$nothing : A3(
														$author$project$Shared$Info$textRow,
														_List_Nil,
														$author$project$Translations$Governance$ClaimRevenue$claimFrom(t),
														A2($author$project$Shared$Text$ellipsis, 10, from_));
												});
											var deposit = $author$project$Shared$Html$texts(
												A2($author$project$Shared$Asset$Format$asset, vires, u.f3));
											var apr = $author$project$Shared$Text$formatPercent(
												A4($author$project$Governance$Shared$Logic$governanceApr, rates, markets, vires, governance));
											return A2(
												$author$project$Shared$Info$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Html$try2,
														fromAddress,
														_Utils_Tuple2(user.gV, from)),
														A3($author$project$Governance$Shared$Info$governanceApr, t, assets, apr),
														A3(
														$author$project$Shared$Info$rowN,
														_List_Nil,
														$author$project$Translations$Governance$ClaimRevenue$relockMyViresUnderPlan(t),
														$elm$core$List$singleton(relock)),
														A2($author$project$Governance$Shared$Info$deposit, t, deposit),
														A2($author$project$Governance$Shared$Info$viresWeight, t, viresWeight),
														A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Governance$Revenue$Claim$Msg$FeeAssetChanged, model.h1)
													]));
										};
										var claim = A4(
											$author$project$Common$Dialog$ctaButton,
											$elm$core$Maybe$Just($author$project$Governance$Revenue$Claim$Msg$Claim),
											$author$project$Translations$Governance$ClaimRevenue$claimRevenue(t),
											model,
											A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, $elm$core$Maybe$Nothing));
										return $author$project$Common$Dialog$view(
											_List_fromArray(
												[
													$author$project$Common$Dialog$background($author$project$Governance$Revenue$Claim$Msg$Close),
													A2(
													$author$project$Common$Dialog$body,
													$author$project$Governance$Revenue$Claim$View$c.dz,
													_List_fromArray(
														[
															A3(
															$author$project$Governance$Shared$View$headerWithVires,
															vires,
															$author$project$Governance$Revenue$Claim$Msg$Close,
															$elm$html$Html$text(
																$author$project$Translations$Governance$ClaimRevenue$claimRevenue(t))),
															$elm$html$Html$text(
															$author$project$Translations$Governance$ClaimRevenue$iWillReceiveToMyWalletFollowingTokens(t)),
															$author$project$Shared$Html$newLine,
															$author$project$Shared$Html$newLine,
															revenueSheet,
															A2($author$project$Shared$Html$try, info, user.ic),
															$author$project$Shared$KindReminder$text(
															$author$project$Translations$Governance$ClaimRevenue$reLockKindReminder(t)),
															A2($author$project$Shared$Dialog$footer, t, claim)
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Governance$Revenue$View$view = F8(
	function (t, vires, assets, markets, rates, user, governance, model) {
		var revenue = $author$project$Governance$Revenue$Logic$revenueGroped(
			A3(
				$author$project$Common$Base$iff,
				user.jZ,
				model.j_,
				_Utils_eq(model.h8, user.gV)));
		var sheet = function () {
			var header = _List_fromArray(
				[
					A2(
					$author$project$Common$Table$header,
					_List_Nil,
					$author$project$Translations$asset(t)),
					A3(
					$author$project$Common$Table$headerWithTooltip,
					$author$project$Translations$Governance$ClaimRevenue$earnedToDateTooltip(t),
					$author$project$Governance$Revenue$View$c.T,
					$author$project$Translations$Governance$ClaimRevenue$earnedToDate(t)),
					A3(
					$author$project$Common$Table$headerWithTooltip,
					$author$project$Translations$Governance$ClaimRevenue$alreadyClaimedTooltip(t),
					$author$project$Governance$Revenue$View$c.T,
					$author$project$Translations$Governance$ClaimRevenue$alreadyClaimed(t)),
					A3(
					$author$project$Common$Table$headerWithTooltip,
					$author$project$Translations$Governance$ClaimRevenue$accruedTooltip(t),
					$author$project$Governance$Revenue$View$c.T,
					$author$project$Translations$Governance$ClaimRevenue$accrued(t))
				]);
			var cells = function (r) {
				return _List_fromArray(
					[
						$author$project$Governance$Revenue$Logic$earnedToDate(r),
						r.bm,
						$author$project$Governance$Revenue$Logic$accrued(r)
					]);
			};
			var assetCell = function (a) {
				var asset = $author$project$Shared$Asset$View$iconWithName(a.ac);
				return A2($author$project$Common$Table$cellN, $author$project$Governance$Revenue$View$c.bh, asset);
			};
			var emptyMarket = function (a) {
				return A2(
					$elm$core$List$cons,
					assetCell(a),
					$author$project$Governance$Revenue$View$emptyCells);
			};
			var market = F2(
				function (m, r) {
					var revenueCell = A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Asset$Format$asset(m.bh),
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							$author$project$Common$Table$cell($author$project$Governance$Revenue$View$c.T)));
					return A2(
						$author$project$Common$Table$row,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							assetCell(m.bh),
							A2(
								$elm$core$List$map,
								revenueCell,
								cells(r))));
				});
			var _v3 = function () {
				if ($elm$core$Dict$isEmpty(revenue)) {
					return _Utils_Tuple2(
						A2(
							$elm$core$List$map,
							$author$project$Common$Table$row(_List_Nil),
							A2($elm$core$List$map, emptyMarket, assets)),
						$elm$core$Maybe$Nothing);
				} else {
					var usdCell = A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Text$formatUsd,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							$author$project$Common$Table$cell($author$project$Governance$Revenue$View$c.T)));
					var sum = F2(
						function (claims, acc) {
							return A3($elm$core$List$map2, $elm$core$Basics$add, acc, claims);
						});
					var marketUSD = F2(
						function (m, r) {
							return A2(
								$elm$core$List$map,
								A2($author$project$Shared$Market$Logic$inUsd, rates, m.bh),
								cells(r));
						});
					var mapRevenue = function (map) {
						return A3($author$project$Shared$User$Logic$mapReserves, revenue, map, markets);
					};
					return _Utils_Tuple2(
						mapRevenue(market),
						$elm$core$Maybe$Just(
							A2(
								$author$project$Common$Table$row,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Common$Table$textCell,
										_List_Nil,
										$author$project$Translations$Governance$ClaimRevenue$totalInUsd(t)),
									A2(
										$elm$core$List$map,
										usdCell,
										A3(
											$elm$core$List$foldl,
											sum,
											_List_fromArray(
												[0, 0, 0]),
											mapRevenue(marketUSD)))))));
				}
			}();
			var body = _v3.a;
			var footer = _v3.b;
			return A2(
				$author$project$Common$Table$view,
				$author$project$Governance$Revenue$View$c.f_,
				_List_fromArray(
					[
						$author$project$Common$Table$head(header),
						$author$project$Common$Table$body(body),
						A2(
						$author$project$Shared$Html$try,
						A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Common$Table$foot),
						footer)
					]));
		}();
		var fromField = function () {
			var from = function () {
				var other = function (_v2) {
					var adr = _v2;
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(adr)
							]),
						$author$project$Shared$Html$texts(adr));
				};
				var my = function () {
					var _v1 = user.gV;
					if (!_v1.$) {
						var adr = _v1.a;
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(adr),
									$elm$html$Html$Attributes$selected(true)
								]),
							$author$project$Shared$Html$texts(adr));
					} else {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$selected(true)
								]),
							$author$project$Shared$Html$texts(
								$author$project$Translations$Wallet$connectWallet(t)));
					}
				}();
				var lsDelegators = function () {
					var _v0 = A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$List$member, model.hF),
							$elm$core$Basics$not),
						model.iQ);
					if (!_v0.b) {
						return _List_Nil;
					} else {
						var addresses = _v0;
						return A2($elm$core$List$map, other, addresses);
					}
				}();
				return A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Governance$Revenue$Msg$FromChanged)),
							$elm$html$Html$Attributes$class('css-less')
						]),
					A2(
						$elm$core$List$cons,
						my,
						_Utils_ap(
							A2($elm$core$List$map, other, model.hF),
							lsDelegators)));
			}();
			return A2(
				$author$project$Common$Form$fieldHorizontal,
				$author$project$Governance$Revenue$View$c.h8,
				_List_fromArray(
					[
						$author$project$Common$Form$fieldLabel(
						$author$project$Translations$Governance$ClaimRevenue$claimFrom(t)),
						$author$project$Common$Form$fieldBody(
						_List_fromArray(
							[
								$author$project$Common$Form$controlField(from)
							]))
					]));
		}();
		var claim = A2(
			$author$project$Common$Button$primary,
			$author$project$Translations$Governance$ClaimRevenue$claimRevenue(t),
			$author$project$Governance$Revenue$Msg$OpenClaim);
		return A2(
			$elm$html$Html$div,
			$author$project$Governance$Revenue$View$c.jZ,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('markdown')
						]),
					$elm$core$List$singleton(
						A2(
							$elm$html$Html$h2,
							_List_Nil,
							$author$project$Shared$Html$texts(
								$author$project$Translations$Governance$ClaimRevenue$revenueSheet(t))))),
					A2(
					$author$project$Shared$Layout$sectionN,
					_List_Nil,
					_List_fromArray(
						[fromField, sheet, claim])),
					A2(
					$elm$html$Html$map,
					$author$project$Governance$Revenue$Msg$Claim,
					A2(
						$author$project$Shared$Html$try,
						A9($author$project$Governance$Revenue$Claim$View$view, t, vires, assets, markets, rates, user, model.h8, revenue, governance),
						model.hh))
				]));
	});
var $author$project$Translations$Governance$MyVires$withdrawUnlocked = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.withdrawUnlocked');
};
var $author$project$Translations$Governance$MyVires$withdrawUnlockedDescriptionMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.myVires.withdrawUnlockedDescriptionMD');
};
var $author$project$Governance$MyVires$View$view = F8(
	function (t, assets, markets, rates, vires, user, model, governance) {
		var info = function () {
			var viresWeight = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.lj;
				},
				user.ic);
			var viresWeightPercent = A2($elm$core$Maybe$map, $author$project$Shared$Text$formatPercent, viresWeight);
			var unlocked = A2(
				$author$project$Shared$Vires$View$formatVires,
				vires,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$map, $author$project$Governance$Shared$Logic$unlocked, user.ic)));
			var staked = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.f3;
					},
					user.ic));
			var mm = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, user.iN));
			var locked = A2(
				$author$project$Shared$Vires$View$formatVires,
				vires,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.iJ;
						},
						user.ic)));
			var legacyStaked = A2(
				$elm$core$Maybe$map,
				$author$project$Shared$Vires$View$formatVires(vires),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Shared$Asset$Logic$ignoreDust,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.f3;
						},
						user.hN)));
			var inWalletNow = A2(
				$author$project$Shared$Vires$View$formatVires,
				vires,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($author$project$Shared$Wallet$Logic$wallet, vires.bP, user.lh)));
			var governanceWeight = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.iJ;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Market$Logic$inOrig(vires),
						$author$project$Shared$Text$formatCurrency($author$project$Shared$Vires$View$gViresSign))),
				user.ic);
			var deposit = A2($author$project$Shared$Vires$View$formatVires, vires, staked);
			var apr = $author$project$Shared$Text$formatPercent(
				A4($author$project$Governance$Shared$Logic$governanceApr, rates, markets, vires, governance));
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Shared$Info$textRow,
						_List_Nil,
						$author$project$Translations$walletBalance(t),
						inWalletNow),
						$author$project$Shared$Html$newLine,
						A3($author$project$Governance$Shared$Info$governanceApr, t, assets, apr),
						A2(
						$author$project$Governance$Shared$Info$deposit,
						t,
						$author$project$Shared$Html$texts(deposit)),
						A2(
						$author$project$Shared$Html$try,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Shared$Html$texts,
							$author$project$Governance$Shared$Info$legacy(t)),
						legacyStaked),
						A2(
						$author$project$Governance$Shared$Info$unlocked,
						t,
						$author$project$Shared$Html$texts(unlocked)),
						A2(
						$author$project$Governance$Shared$Info$stillLocked,
						t,
						$author$project$Shared$Html$texts(locked)),
						A2(
						$author$project$Governance$Shared$Info$unlockStarts,
						t,
						$author$project$Shared$Html$texts(
							$author$project$Translations$Governance$MyVires$now(t))),
						$author$project$Shared$Html$newLine,
						A2(
						$author$project$Shared$Html$try,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Shared$Html$texts,
							$author$project$Governance$Shared$Info$viresWeight(t)),
						viresWeightPercent),
						A2(
						$author$project$Shared$Html$try,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Shared$Html$texts,
							$author$project$Governance$Shared$Info$governanceWeight(t)),
						governanceWeight),
						A2(
						$author$project$Shared$Html$try,
						A4(
							$author$project$Shared$Waves$Address$View$info,
							mm,
							$author$project$Shared$Info$newSection,
							$author$project$Translations$Governance$MyVires$delegateClaim(t),
							$author$project$Governance$MyVires$Msg$Copy),
						model.hE)
					]));
		}();
		var delegate = A2(
			$elm$core$Basics$composeR,
			A4($author$project$Governance$MyVires$Delegate$View$view, t, vires, assets, user),
			$elm$html$Html$map($author$project$Governance$MyVires$Msg$Delegate));
		var actions = $author$project$Governance$Shared$View$actions(
			_List_fromArray(
				[
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					A2(
						$author$project$Translations$governanceAPRTooltip,
						t,
						$author$project$Shared$Asset$View$names(assets))),
					A2(
					$author$project$Common$Button$primary,
					$author$project$Translations$Governance$MyVires$lock(t),
					$author$project$Governance$MyVires$Msg$OpenLock),
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					$author$project$Translations$Governance$MyVires$delegateClaimDescriptionMD(t)),
					A2(
					$author$project$Common$Button$default,
					$author$project$Translations$Governance$MyVires$delegateClaim(t),
					$author$project$Governance$MyVires$Msg$OpenDelegate),
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					$author$project$Translations$Governance$MyVires$withdrawUnlockedDescriptionMD(t)),
					A2(
					$author$project$Common$Button$default,
					$author$project$Translations$Governance$MyVires$withdrawUnlocked(t),
					$author$project$Governance$MyVires$Msg$OpenUnstake),
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					$author$project$Translations$Governance$getViresMD(t))
				]));
		return _List_fromArray(
			[
				A2(
				$author$project$Shared$Layout$section,
				$author$project$Governance$MyVires$View$c.e8,
				A2(
					$author$project$Shared$Layout$columnsMany,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Card$view,
							_List_Nil,
							$elm$core$List$singleton(
								$author$project$Common$Card$content(
									$elm$core$List$singleton(info)))),
							actions
						]))),
				A2(
				$author$project$Shared$Layout$section,
				_List_Nil,
				A2(
					$elm$html$Html$map,
					$author$project$Governance$MyVires$Msg$Revenue,
					A8($author$project$Governance$Revenue$View$view, t, vires, assets, markets, rates, user, governance, model.jZ))),
				A2($author$project$Shared$Html$try, delegate, model.dP)
			]);
	});
var $author$project$Governance$Unstake$Msg$Close = {$: 2};
var $author$project$Governance$Unstake$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Unstake$Msg$Unstake = {$: 0};
var $author$project$Translations$Home$Vires$stakeKindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.stakeKindReminder');
};
var $author$project$Shared$Delta$View$zeroed = function (asset) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$Gizra$elm_compat_019$Basics018$flip,
			$elm$core$List$cons,
			_List_fromArray(
				[0])),
		$author$project$Shared$Delta$View$fundsDelta(asset));
};
var $author$project$Governance$Unstake$View$view = F5(
	function (t, vires, assets, user, model) {
		var unlocked = A2($elm$core$Maybe$map, $author$project$Governance$Shared$Logic$unlocked, user.ic);
		var inWallet_ = A2($author$project$Shared$Wallet$Logic$wallet, vires.bP, user.lh);
		var inWalletNow = A2($elm$core$Maybe$withDefault, 0, inWallet_);
		var inWalletAfter = $elm$core$List$sum(
			$author$project$Common$List$just(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.f3;
						},
						user.hN),
						unlocked,
						inWallet_
					])));
		var info = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Shared$Html$try,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Delta$View$zeroed(vires),
						$author$project$Governance$Shared$Info$legacy(t)),
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Shared$Asset$Logic$ignoreDust,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.f3;
							},
							user.hN))),
					A2(
					$author$project$Shared$Html$try,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Delta$View$zeroed(vires),
						$author$project$Governance$Shared$Info$unlocked(t)),
					unlocked),
					A3(
					$author$project$Shared$Delta$View$wallet,
					t,
					vires,
					_List_fromArray(
						[inWalletNow, inWalletAfter])),
					A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Governance$Unstake$Msg$FeeAssetChanged, model.h1)
				]));
		var cta = A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Governance$Unstake$Msg$Unstake),
			$author$project$Translations$Governance$MyVires$withdrawUnlocked(t),
			model,
			A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, $elm$core$Maybe$Nothing));
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Governance$Unstake$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Governance$Shared$View$headerWithVires,
							vires,
							$author$project$Governance$Unstake$Msg$Close,
							$elm$html$Html$text(
								$author$project$Translations$Governance$MyVires$withdrawUnlocked(t))),
							info,
							$author$project$Shared$KindReminder$text(
							$author$project$Translations$Home$Vires$stakeKindReminder(t)),
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $author$project$Governance$Voting$New$Msg$Next = {$: 0};
var $author$project$Governance$Voting$New$Msg$PayloadChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$Voting$New$Msg$SummaryChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$New$Msg$TitleChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$New$View$c = {
	cY: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('activation-time')
		]),
	dK: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('create-proposal')
		]),
	hR: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('error')
		]),
	jt: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('payload')
		]),
	ga: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('summary')
		])
};
var $author$project$Translations$Governance$Voting$createVoting = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.voting.createVoting');
};
var $ryannhg$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryannhg$date_format$DateFormat$dayOfMonthFixed = $ryannhg$date_format$DateFormat$DayOfMonthFixed;
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {kD: toAmPm, kF: toMonthAbbreviation, kG: toMonthName, aj: toOrdinalSuffix, kH: toWeekdayAbbreviation, kI: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.kk, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.kD(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dN: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		e3: month,
		gK: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dN;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).e3;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gK;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.kF(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.kG(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.kH(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.kI(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aj(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryannhg$date_format$DateFormat$hourMilitaryFixed = $ryannhg$date_format$DateFormat$HourMilitaryFixed;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $ryannhg$date_format$DateFormat$MonthFixed = {$: 2};
var $ryannhg$date_format$DateFormat$monthFixed = $ryannhg$date_format$DateFormat$MonthFixed;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $ryannhg$date_format$DateFormat$YearNumber = {$: 16};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $author$project$Common$Format$dateTimeWithoutSeconds = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthFixed,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nonBreakingHyphen),
			$ryannhg$date_format$DateFormat$monthFixed,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nonBreakingHyphen),
			$ryannhg$date_format$DateFormat$yearNumber,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nbsp),
			$ryannhg$date_format$DateFormat$hourMilitaryFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed
		]));
var $author$project$Common$Button$group = $elm$html$Html$div($author$project$Common$Button$c.dn);
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Common$Form$multiline = F3(
	function (msg, attrs, value) {
		return A2(
			$elm$html$Html$textarea,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Form$c.an,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onInput(msg),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$value(value),
						attrs))),
			_List_Nil);
	});
var $author$project$Common$Button$secondaryLink = $author$project$Common$Button$textLink(
	_List_fromArray(
		[$author$project$Common$Button$c.ci]));
var $author$project$Shared$Blockchain$Logic$add = F2(
	function (_v0, _v1) {
		var b1 = _v0;
		var b2 = _v1;
		return b1 + b2;
	});
var $author$project$Shared$Blockchain$Data$avgTime = 60 * 1000;
var $author$project$Shared$Blockchain$Logic$date = F2(
	function (_v0, _v1) {
		var historicalTime = _v0.a;
		var historicalHeight = _v0.b;
		var height = _v1;
		return $elm$time$Time$posixToMillis(historicalTime) + ((height - historicalHeight) * $author$project$Shared$Blockchain$Data$avgTime);
	});
var $author$project$Governance$Voting$New$Validate$validPayload = F4(
	function (c, hh, height, model) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Governance$Voting$New$Data$payloadDecoder, model.jt);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$core$Maybe$Just(
				$elm$json$Json$Decode$errorToString(err));
		} else {
			var p = _v0.a;
			var tsTo = A2(
				$author$project$Shared$Blockchain$Logic$date,
				hh,
				A2($author$project$Shared$Blockchain$Logic$add, c.g1, height));
			var tsFrom = A2(
				$author$project$Shared$Blockchain$Logic$date,
				hh,
				A2($author$project$Shared$Blockchain$Logic$add, c.g2, height));
			return ((_Utils_cmp(p.kA, tsFrom) < 0) || (_Utils_cmp(p.kA, tsTo) > 0)) ? $elm$core$Maybe$Just(
				'Timestamp should be within a range: ' + A2(
					$elm$core$String$join,
					'\u00A0–\u00A0',
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[tsFrom, tsTo])))) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Governance$Voting$New$Validate$len = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$length);
var $author$project$Governance$Voting$New$Validate$description = function (model) {
	return ($author$project$Governance$Voting$New$Validate$len(model.hH) < 20) ? $elm$core$Maybe$Just('Description is too short (minimum is 20 characters)') : $elm$core$Maybe$Nothing;
};
var $author$project$Translations$Governance$Voting$Create$invalidPayload = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.voting.create.invalidPayload');
};
var $author$project$Governance$Voting$New$Validate$payload = function (model) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(model.jt)) ? $elm$core$Maybe$Just('Payload required') : $elm$core$Maybe$Nothing;
};
var $author$project$Governance$Voting$New$Validate$title = function (model) {
	return ($author$project$Governance$Voting$New$Validate$len(model.kB) < 10) ? $elm$core$Maybe$Just('Title is too short (minimum is 10 characters)') : $elm$core$Maybe$Nothing;
};
var $author$project$Governance$Voting$New$Validate$validate = F4(
	function (t, c, hh, height) {
		return A2(
			$author$project$Common$Validate$and,
			A2(
				$elm$core$Basics$composeR,
				A3($author$project$Governance$Voting$New$Validate$validPayload, c, hh, height),
				$elm$core$Maybe$map(
					$elm$core$Basics$always(
						$author$project$Translations$Governance$Voting$Create$invalidPayload(t)))),
			A2(
				$author$project$Common$Validate$and,
				$author$project$Governance$Voting$New$Validate$payload,
				A2($author$project$Common$Validate$and, $author$project$Governance$Voting$New$Validate$description, $author$project$Governance$Voting$New$Validate$title)));
	});
var $author$project$Governance$Voting$New$Propose$Msg$Close = {$: 1};
var $author$project$Governance$Voting$New$Propose$Msg$Copy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Governance$Voting$New$Propose$Msg$Create = {$: 0};
var $author$project$Governance$Voting$New$Propose$Msg$FeeAssetChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$Voting$New$Propose$View$c = {
	dK: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('create-proposal')
		]),
	hR: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('error')
		]),
	ga: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('summary')
		])
};
var $author$project$Translations$Validation$cantPayFee = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.cantPayFee');
};
var $author$project$Shared$Validate$enoughFee = F6(
	function (t, feeInWaves, assets, user, preferredAsset, model) {
		var _v0 = A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, preferredAsset, feeInWaves, model.h1);
		if (!_v0.$) {
			var asset = _v0.a;
			return A3($author$project$Shared$Transaction$Logic$isEnoughFee, user.lh, feeInWaves, asset) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Translations$Validation$cantPayFee(t));
		} else {
			return $elm$core$Maybe$Just(
				$author$project$Translations$Validation$cantPayFee(t));
		}
	});
var $author$project$Shared$Vires$View$format_gVires = function (vires) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Market$Logic$inOrig(vires),
		$author$project$Shared$Text$formatCurrency($author$project$Shared$Vires$View$gViresSign));
};
var $author$project$Governance$Shared$Logic$gVires = function (u) {
	return u.iJ;
};
var $author$project$Governance$Voting$Shared$Info$governance = F3(
	function (t, vires, user) {
		return A2(
			$author$project$Shared$Html$try,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Governance$Shared$Logic$gVires,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Shared$Vires$View$format_gVires(vires),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Html$texts,
						$author$project$Governance$Shared$Info$governanceWeight(t)))),
			user.ic);
	});
var $author$project$Governance$Voting$Shared$View$c = {
	bf: $elm$html$Html$Attributes$class('against'),
	hA: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('date')
		]),
	bG: $elm$html$Html$Attributes$class('for'),
	jt: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('payload')
		]),
	lb: $elm$html$Html$Attributes$class('votes')
};
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Common$Form$multilineReadonly = F2(
	function (attrs, value) {
		return A2(
			$elm$html$Html$textarea,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Form$c.an,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$value(value),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$readonly(true),
						A2($elm$core$List$cons, $author$project$Common$Attributes$disabled, attrs)))),
			_List_Nil);
	});
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Governance$Voting$Shared$View$payload = function (p) {
	return A2(
		$author$project$Common$Form$field,
		$author$project$Governance$Voting$Shared$View$c.jt,
		_List_fromArray(
			[
				$author$project$Common$Form$textLabel('Transaction Payload'),
				$author$project$Common$Form$control(
				A2(
					$author$project$Common$Form$multilineReadonly,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$rows(10)
						]),
					p))
			]));
};
var $author$project$Common$Form$readOnly = F2(
	function (attrs, value) {
		return A2(
			$elm$html$Html$input,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Form$c.an,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$value(value),
					A2($elm$core$List$cons, $author$project$Common$Attributes$disabled, attrs))),
			_List_Nil);
	});
var $author$project$Common$Copy$view = F3(
	function (label, msg, txt) {
		return A2(
			$author$project$Common$Form$fieldWithAddon,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Common$Form$readOnly, _List_Nil, txt),
					A2(
					$author$project$Common$Button$text,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							msg(txt))
						]),
					label)
				]));
	});
var $author$project$Common$Copy$viewWithCopy = $author$project$Common$Copy$view('Copy');
var $author$project$Governance$Voting$Shared$View$proposalId = F2(
	function (msgCopy, id) {
		return A2(
			$author$project$Common$Form$field,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Form$textLabel('Proposal ID'),
					$author$project$Common$Form$control(
					A2($author$project$Common$Copy$viewWithCopy, msgCopy, id))
				]));
	});
var $author$project$Common$Dialog$textHeader = function (closeMsg) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$author$project$Common$Dialog$header(closeMsg));
};
var $author$project$Governance$Voting$New$Propose$View$view = F9(
	function (t, config, vires, assets, user, title_, summary_, payload_, model) {
		var summary = A2($author$project$Common$Markdown$viewInDiv, $author$project$Governance$Voting$New$Propose$View$c.ga, summary_);
		var payloadId = A2($author$project$Governance$Voting$Shared$View$proposalId, $author$project$Governance$Voting$New$Propose$Msg$Copy, model.jz);
		var insufficient_gVires = _Utils_cmp(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $author$project$Governance$Shared$Logic$gVires, user.ic)),
			config.i0) < 0;
		var info = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Common$Base$iff,
					A3($author$project$Governance$Voting$Shared$Info$governance, t, vires, user),
					$author$project$Shared$Html$nothing,
					insufficient_gVires),
					A7($author$project$Shared$Info$feeRow, t, assets, user, $author$project$Shared$Asset$Model$waves, $author$project$Governance$Voting$New$Propose$Data$fee, $author$project$Governance$Voting$New$Propose$Msg$FeeAssetChanged, model.h1)
				]));
		var cta = function () {
			if ($author$project$Shared$Model$isLoading(model)) {
				return A2($author$project$Common$Button$disabledCta, _List_Nil, 'Working…');
			} else {
				if (insufficient_gVires) {
					return A2(
						$author$project$Common$Button$disabledCta,
						_List_Nil,
						A2($author$project$Shared$Vires$View$format_gVires, vires, config.i0) + ' required to propose');
				} else {
					var _v0 = A6($author$project$Shared$Validate$enoughFee, t, $author$project$Governance$Voting$New$Propose$Data$fee, assets, user, $author$project$Shared$Asset$Model$waves, model);
					if (!_v0.$) {
						var err = _v0.a;
						return A2($author$project$Common$Button$disabledCta, _List_Nil, err);
					} else {
						return A2(
							$author$project$Common$Button$primary,
							$author$project$Translations$Governance$Voting$createVoting(t),
							$author$project$Governance$Voting$New$Propose$Msg$Create);
					}
				}
			}
		}();
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Governance$Voting$New$Propose$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$Governance$Voting$New$Propose$View$c.dK,
					_List_fromArray(
						[
							A2($author$project$Common$Dialog$textHeader, $author$project$Governance$Voting$New$Propose$Msg$Close, title_),
							summary,
							$author$project$Governance$Voting$Shared$View$payload(payload_),
							payloadId,
							info,
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $author$project$Common$Time$zoneName = function (z) {
	if (!z.$) {
		var n = z.a;
		return n;
	} else {
		var offset = z.a;
		var offsetSet = $elm$core$String$fromInt(offset);
		return 'GMT' + ((!offset) ? '' : ((offset > 0) ? ('+' + offsetSet) : ('-' + offsetSet)));
	}
};
var $author$project$Governance$Voting$New$View$view = F9(
	function (t, config, vires, _v0, hh, height, assets, user, model) {
		var timeZone = _v0.a;
		var timeZoneName = _v0.b;
		var title = A2(
			$author$project$Common$Form$field,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Form$textLabel('Title'),
					$author$project$Common$Form$control(
					A3(
						$author$project$Common$Form$input,
						$author$project$Governance$Voting$New$Msg$TitleChanged,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('Enter proposal title')
							]),
						model.kB))
				]));
		var summary = A2(
			$author$project$Common$Form$field,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Form$textLabel('Summary (Markdown)'),
					$author$project$Common$Form$control(
					A3(
						$author$project$Common$Form$multiline,
						$author$project$Governance$Voting$New$Msg$SummaryChanged,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$placeholder('Enter proposal summary'),
							$author$project$Governance$Voting$New$View$c.ga),
						model.hH))
				]));
		var payloadErr = A3(
			$author$project$Common$Base$iff,
			_List_Nil,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split('\n'),
					A4($author$project$Governance$Voting$New$Validate$validPayload, config, hh, height, model))),
			$elm$core$String$isEmpty(
				$elm$core$String$trim(model.jt)));
		var payload = A2(
			$author$project$Common$Form$field,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Form$textLabel('Transaction Payload (JSON)'),
					$author$project$Common$Form$control(
					A3(
						$author$project$Common$Form$multiline,
						$author$project$Governance$Voting$New$Msg$PayloadChanged,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$placeholder('Paste transaction payload here'),
							$author$project$Governance$Voting$New$View$c.jt),
						model.jt))
				]));
		var err = A5($author$project$Governance$Voting$New$Validate$validate, t, config, hh, height, model);
		var cta = A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Governance$Voting$New$Msg$Next),
			'Create Voting',
			model,
			err);
		var buttons = $author$project$Common$Button$group(
			_List_fromArray(
				[
					A2(
					$author$project$Common$Button$secondaryLink,
					'/governance/vote',
					$author$project$Translations$cancel(t)),
					cta
				]));
		var activationTime = function () {
			var _v1 = _Utils_Tuple2(
				payloadErr,
				A2($elm$json$Json$Decode$decodeString, $author$project$Governance$Voting$New$Data$payloadDecoder, model.jt));
			if ((!_v1.a.b) && (!_v1.b.$)) {
				var p = _v1.b.a;
				var t_ = $elm$time$Time$millisToPosix(p.kA);
				return A2(
					$elm$html$Html$div,
					$author$project$Governance$Voting$New$View$c.cY,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							$author$project$Shared$Html$texts('Approximate activation time')),
							$author$project$Shared$Html$newLine,
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							$author$project$Shared$Html$texts('UTC')),
							$elm$html$Html$text($author$project$Shared$Text$nbsp),
							$elm$html$Html$text(
							A2($author$project$Common$Format$dateTimeWithoutSeconds, $elm$time$Time$utc, t_)),
							$author$project$Shared$Html$newLine,
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							$author$project$Shared$Html$texts(
								$author$project$Common$Time$zoneName(timeZoneName))),
							$elm$html$Html$text($author$project$Shared$Text$nbsp),
							$elm$html$Html$text(
							A2($author$project$Common$Format$dateTimeWithoutSeconds, timeZone, t_))
						]));
			} else {
				return $author$project$Shared$Html$nothing;
			}
		}();
		return A2(
			$author$project$Shared$Layout$sectionN,
			$author$project$Governance$Voting$New$View$c.dK,
			_List_fromArray(
				[
					$author$project$Shared$Layout$textHeader(
					$author$project$Translations$Governance$Voting$createVoting(t)),
					title,
					summary,
					payload,
					A2(
					$elm$html$Html$div,
					$author$project$Governance$Voting$New$View$c.hR,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Shared$Html$texts,
							$elm$html$Html$div(_List_Nil)),
						payloadErr)),
					activationTime,
					$author$project$Shared$Html$newLine,
					buttons,
					A2(
					$elm$html$Html$map,
					$author$project$Governance$Voting$New$Msg$Propose,
					A2(
						$author$project$Shared$Html$try,
						A8($author$project$Governance$Voting$New$Propose$View$view, t, config, vires, assets, user, model.kB, model.hH, model.jt),
						model.jB))
				]));
	});
var $author$project$Governance$Voting$Proposal$Msg$Broadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Governance$Voting$Proposal$Msg$Copy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$Model$RetractProposal = 3;
var $author$project$Governance$Voting$Proposal$Vote$Model$RetractVote = 2;
var $author$project$Governance$Voting$Proposal$Msg$Update = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$Model$VoteNo = 1;
var $author$project$Governance$Voting$Proposal$Vote$Model$VoteYes = 0;
var $author$project$Governance$Voting$Proposal$View$backToList = A2($author$project$Common$Button$secondaryLink, '/governance/vote', '←\u00A0Back to list');
var $author$project$Translations$Governance$Voting$broadcast = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.voting.broadcast');
};
var $author$project$Governance$Voting$Proposal$View$c = {
	bf: $author$project$Governance$Voting$Shared$View$c.bf,
	dT: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('discuss')
		]),
	dX: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('done')
		]),
	bG: $author$project$Governance$Voting$Shared$View$c.bG,
	ee: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('forum')
		]),
	fb: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('next')
		]),
	km: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('status')
		]),
	lb: _List_fromArray(
		[$author$project$Governance$Voting$Shared$View$c.lb])
};
var $author$project$Governance$Voting$Shared$View$dateTime = F3(
	function (timeZone, height, block) {
		return A2(
			$author$project$Shared$Html$textSpan,
			$author$project$Governance$Voting$Shared$View$c.hA,
			A2(
				$author$project$Common$Format$dateTimeWithoutSeconds,
				timeZone,
				$elm$time$Time$millisToPosix(
					A2($author$project$Shared$Blockchain$Logic$date, height, block))));
	});
var $author$project$Common$Button$disabled = $author$project$Common$Button$text(
	_List_fromArray(
		[$author$project$Common$Attributes$disabled, $author$project$Common$Button$c.aN]));
var $author$project$Governance$Voting$Shared$Logic$quorum_gVires = F2(
	function (config, p) {
		return p.ia * config.jG;
	});
var $author$project$Governance$Voting$Shared$Logic$totalVotes = function (votes) {
	return votes.lr + votes.ja;
};
var $author$project$Governance$Voting$Shared$Logic$hasQuorum = F2(
	function (c, p) {
		return (p.ia > 0) && (_Utils_cmp(
			$author$project$Governance$Voting$Shared$Logic$totalVotes(p.lb),
			A2($author$project$Governance$Voting$Shared$Logic$quorum_gVires, c, p)) > -1);
	});
var $author$project$Governance$Voting$Shared$Logic$forecast = F2(
	function (c, p) {
		return (!A2($author$project$Governance$Voting$Shared$Logic$hasQuorum, c, p)) ? 2 : ((_Utils_cmp(
			p.lb.lr / $author$project$Governance$Voting$Shared$Logic$totalVotes(p.lb),
			c.jp) > -1) ? 4 : 3);
	});
var $author$project$Governance$Voting$Shared$View$quorum = F3(
	function (vires, config, p) {
		return A3(
			$Gizra$elm_compat_019$Basics018$flip,
			$elm$core$Basics$append,
			'\u00A0gVires required',
			$author$project$Shared$Text$formatK(
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					vires,
					$elm$core$Basics$round(
						A2($author$project$Governance$Voting$Shared$Logic$quorum_gVires, config, p)))));
	});
var $author$project$Governance$Voting$Shared$View$status = function (s) {
	switch (s) {
		case 0:
			return 'Discussion';
		case 1:
			return 'Voting';
		case 3:
			return 'Defeated';
		case 5:
			return 'Broadcasting';
		case 6:
			return 'Succeed';
		case 4:
			return 'Passed';
		case 7:
			return 'Was not broadcast';
		case 2:
			return 'No quorum';
		default:
			return 'Retracted';
	}
};
var $author$project$Governance$Voting$Shared$View$title = function (p) {
	var _v0 = p.kB;
	if (!_v0.$) {
		var t = _v0.a;
		return t;
	} else {
		return p.jz;
	}
};
var $author$project$Governance$Voting$Proposal$Vote$Msg$Close = {$: 2};
var $author$project$Governance$Voting$Proposal$Vote$Msg$Copy = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$Msg$FeeAssetChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$Msg$Vote = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Voting$Proposal$Vote$View$c = {
	gC: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('vote')
		])
};
var $author$project$Shared$Button$processingTransaction = function (t) {
	return A2(
		$author$project$Common$Button$disabledCta,
		_List_Nil,
		$author$project$Translations$processingTransaction(t));
};
var $author$project$Governance$Voting$Proposal$Vote$View$view = F7(
	function (t, vires, assets, user, a, proposalId, model) {
		var info = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Governance$Voting$Shared$Info$governance, t, vires, user),
					A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Governance$Voting$Proposal$Vote$Msg$FeeAssetChanged, model.h1)
				]));
		var action = function () {
			switch (a) {
				case 0:
					return 'Vote Yes';
				case 1:
					return 'Vote No';
				case 2:
					return 'Retract Vote';
				default:
					return 'Retract Proposal';
			}
		}();
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A2(
			$author$project$Common$Button$primary,
			action,
			$author$project$Governance$Voting$Proposal$Vote$Msg$Vote(a));
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Governance$Voting$Proposal$Vote$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$Governance$Voting$Proposal$Vote$View$c.gC,
					_List_fromArray(
						[
							A2($author$project$Common$Dialog$textHeader, $author$project$Governance$Voting$Proposal$Vote$Msg$Close, action),
							A2($author$project$Governance$Voting$Shared$View$proposalId, $author$project$Governance$Voting$Proposal$Vote$Msg$Copy, proposalId),
							info,
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$check = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'check',
	512,
	512,
	_List_fromArray(
		['M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$times = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'times',
	352,
	512,
	_List_fromArray(
		['M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z']));
var $author$project$Governance$Voting$Shared$View$votes = F3(
	function (vires, userVotes, p) {
		var x = F2(
			function (map, icon) {
				var u = A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeR, map, $author$project$Common$Maybe$nothingIfZero),
					userVotes);
				var my = function (v) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my')
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$text,
							_List_fromArray(
								[
									' (my ',
									$author$project$Shared$Text$formatK(
									A2($author$project$Shared$Market$Logic$inOrig, vires, v)),
									')'
								])));
				};
				return _List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(icon),
						$elm$html$Html$text($author$project$Shared$Text$nbsp),
						$elm$html$Html$text(
						$author$project$Shared$Text$formatK(
							A2(
								$author$project$Shared$Market$Logic$inOrig,
								vires,
								map(p.lb)))),
						A2($author$project$Shared$Html$try, my, u)
					]);
			});
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$author$project$Governance$Voting$Shared$View$c.lb]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Governance$Voting$Shared$View$c.bG]),
					A2(
						x,
						function ($) {
							return $.lr;
						},
						$lattyware$elm_fontawesome$FontAwesome$Solid$check)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Governance$Voting$Shared$View$c.bf]),
					A2(
						x,
						function ($) {
							return $.ja;
						},
						$lattyware$elm_fontawesome$FontAwesome$Solid$times))
				]));
	});
var $author$project$Governance$Voting$Proposal$View$view = F8(
	function (t, timeZone, config, vires, hh, assets, user, model) {
		var vote = function (_v11) {
			var yesNo = _v11.a;
			var vote_ = _v11.b;
			return A7($author$project$Governance$Voting$Proposal$Vote$View$view, t, vires, assets, user, yesNo, model.jz, vote_);
		};
		var proposalId = A2($author$project$Governance$Voting$Shared$View$proposalId, $author$project$Governance$Voting$Proposal$Msg$Copy, model.jz);
		var proposal = function (p) {
			var title = $author$project$Shared$Layout$textHeader(
				$author$project$Governance$Voting$Shared$View$title(p));
			var payload = function (json) {
				var formattedJsonString = A2(
					$elm$json$Json$Encode$encode,
					4,
					$author$project$Governance$Voting$Shared$Cmd$payloadEncoder(json));
				return A2(
					$author$project$Common$Form$field,
					$author$project$Governance$Voting$Shared$View$c.jt,
					_List_fromArray(
						[
							$author$project$Common$Form$textLabel('Transaction Payload'),
							$author$project$Common$Form$control(
							A2(
								$elm$html$Html$pre,
								_List_Nil,
								$elm$core$List$singleton(
									A2(
										$elm$html$Html$code,
										_List_Nil,
										$author$project$Shared$Html$texts(formattedJsonString)))))
						]));
			};
			var forum = F2(
				function (txt, link) {
					return A2(
						$elm$html$Html$a,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$href(link),
							A2($elm$core$List$cons, $author$project$Common$Attributes$blank, $author$project$Governance$Voting$Proposal$View$c.dT)),
						_List_fromArray(
							[
								$elm$html$Html$text(txt),
								A2($author$project$Shared$Html$textSpan, $author$project$Governance$Voting$Proposal$View$c.ee, 'forum.vires.finance')
							]));
				});
			var votingArea = function () {
				var status = p.km;
				var workflow = function () {
					var time = function (b) {
						return A3($author$project$Governance$Voting$Shared$View$dateTime, timeZone, hh, b);
					};
					var next = $elm$html$Html$li($author$project$Governance$Voting$Proposal$View$c.fb);
					var label = A2(
						$elm$core$Basics$composeR,
						$author$project$Governance$Voting$Shared$View$status,
						$author$project$Shared$Html$textSpan($author$project$Governance$Voting$Proposal$View$c.km));
					var voting = _List_fromArray(
						[
							label(1),
							time(p.lc.kk),
							time(p.lc.hP),
							A3($author$project$Governance$Voting$Shared$View$votes, vires, model.k2, p)
						]);
					var discussion = _List_fromArray(
						[
							label(0),
							time(p.hr),
							A2(
							$author$project$Shared$Html$try,
							forum(''),
							p.cN)
						]);
					var completed = $elm$html$Html$li($author$project$Governance$Voting$Proposal$View$c.dX);
					var apply = function () {
						var d = function () {
							var _v10 = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.kA;
								},
								p.jt);
							if (!_v10.$) {
								var ts = _v10.a;
								return A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$time$Time$millisToPosix,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Common$Format$dateTimeWithoutSeconds(timeZone),
											$author$project$Shared$Html$textSpan($author$project$Governance$Voting$Shared$View$c.hA))),
									_List_fromArray(
										[
											ts - $elm$core$Basics$round(1.5 * $Gizra$elm_compat_019$Time018$hour),
											ts + $elm$core$Basics$round(2 * $Gizra$elm_compat_019$Time018$hour)
										]));
							} else {
								return _List_Nil;
							}
						}();
						return A2(
							$elm$core$List$cons,
							label(5),
							d);
					}();
					var active = $elm$html$Html$li(
						_List_fromArray(
							[
								$author$project$Common$Attributes$is.gT(true)
							]));
					var _final = function (s) {
						return _List_fromArray(
							[
								completed(discussion),
								completed(voting),
								active(
								_List_fromArray(
									[
										label(s)
									]))
							]);
					};
					var succeed = function () {
						var inBlockchain = _List_fromArray(
							[
								label(6),
								A2($author$project$Shared$Html$try, time, p.g$)
							]);
						return _List_fromArray(
							[
								completed(discussion),
								completed(voting),
								active(inBlockchain)
							]);
					}();
					switch (status) {
						case 0:
							return _List_fromArray(
								[
									active(discussion),
									next(voting),
									next(apply)
								]);
						case 1:
							var forecast = A2($author$project$Governance$Voting$Shared$Logic$forecast, config, p);
							return _List_fromArray(
								[
									completed(discussion),
									active(voting),
									next(
									_List_fromArray(
										[
											$elm$html$Html$text('Forecast:\u00A0'),
											label(forecast),
											(forecast === 2) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											$author$project$Shared$Html$texts(
												A3($author$project$Governance$Voting$Shared$View$quorum, vires, config, p))) : $author$project$Shared$Html$nothing
										])),
									next(apply)
								]);
						case 4:
							return _List_fromArray(
								[
									completed(discussion),
									completed(voting),
									active(
									_List_fromArray(
										[
											label(4)
										])),
									next(apply)
								]);
						case 5:
							return _List_fromArray(
								[
									completed(discussion),
									completed(voting),
									active(apply)
								]);
						case 8:
							return _List_fromArray(
								[
									completed(discussion),
									active(
									_List_fromArray(
										[
											label(8)
										]))
								]);
						case 6:
							return succeed;
						default:
							return _final(status);
					}
				}();
				var buttons = function () {
					var disabledVoting = function (label) {
						return _List_fromArray(
							[
								$elm$html$Html$text(label),
								$author$project$Shared$Html$newLine,
								$author$project$Shared$Html$newLine,
								$author$project$Common$Button$disabled('Yes'),
								$author$project$Common$Button$disabled('No')
							]);
					};
					var _v0 = _Utils_Tuple3(user.gV, status, model.k2);
					_v0$2:
					while (true) {
						_v0$6:
						while (true) {
							switch (_v0.b) {
								case 5:
									var _v1 = _v0.b;
									return $elm$core$List$singleton(
										function () {
											var _v2 = A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.jt;
												},
												model.jy);
											if (!_v2.$) {
												var tx = _v2.a;
												return $author$project$Shared$Model$isLoading(model) ? $author$project$Common$Button$disabled(
													$author$project$Translations$processingTransaction(t)) : A3(
													$author$project$Common$Button$enabled,
													_List_fromArray(
														[$author$project$Common$Button$c.aN, $author$project$Common$Button$c.ci]),
													$author$project$Translations$Governance$Voting$broadcast(t),
													$author$project$Governance$Voting$Proposal$Msg$Broadcast(tx));
											} else {
												return A2(
													$author$project$Common$Button$disabledCta,
													_List_Nil,
													$author$project$Translations$Governance$Voting$broadcast(t));
											}
										}());
								case 1:
									if (_v0.a.$ === 1) {
										var _v3 = _v0.a;
										var _v4 = _v0.b;
										return disabledVoting('Connect wallet to vote');
									} else {
										if (!_v0.c.$) {
											var _v6 = _v0.b;
											var v = _v0.c.a;
											return ((v.lr > 0) || (v.ja > 0)) ? _List_fromArray(
												[
													A3(
													$author$project$Common$Button$enabled,
													_List_fromArray(
														[$author$project$Common$Button$c.aN, $author$project$Common$Button$c.ci]),
													'Retract',
													$author$project$Governance$Voting$Proposal$Msg$Update(2))
												]) : _List_fromArray(
												[
													_Utils_eq(p.cN, $elm$core$Maybe$Nothing) ? $author$project$Common$Button$disabled('Yes') : A3(
													$author$project$Common$Button$enabled,
													_List_fromArray(
														[$author$project$Common$Button$c.aN, $author$project$Common$Button$c.ci, $author$project$Governance$Voting$Proposal$View$c.bG]),
													'Yes',
													$author$project$Governance$Voting$Proposal$Msg$Update(0)),
													A3(
													$author$project$Common$Button$enabled,
													_List_fromArray(
														[$author$project$Common$Button$c.aN, $author$project$Common$Button$c.ci, $author$project$Governance$Voting$Proposal$View$c.bf]),
													'No',
													$author$project$Governance$Voting$Proposal$Msg$Update(1))
												]);
										} else {
											break _v0$6;
										}
									}
								case 0:
									if (_v0.a.$ === 1) {
										break _v0$2;
									} else {
										var adr = _v0.a;
										var _v7 = _v0.b;
										return _Utils_eq(
											adr,
											$elm$core$Maybe$Just(p.g7)) ? _List_fromArray(
											[
												A3(
												$author$project$Common$Button$enabled,
												_List_fromArray(
													[$author$project$Common$Button$c.aN, $author$project$Common$Button$c.ci]),
												'Retract Proposal',
												$author$project$Governance$Voting$Proposal$Msg$Update(3))
											]) : disabledVoting('Voting is not started yet');
									}
								case 8:
									if (_v0.a.$ === 1) {
										break _v0$2;
									} else {
										var _v8 = _v0.b;
										return _List_Nil;
									}
								default:
									if (_v0.a.$ === 1) {
										break _v0$2;
									} else {
										break _v0$6;
									}
							}
						}
						return disabledVoting('Voting is finished');
					}
					var _v5 = _v0.a;
					return _List_Nil;
				}();
				return _List_fromArray(
					[
						A2($elm$html$Html$ul, _List_Nil, workflow),
						$author$project$Shared$Html$newLine,
						$author$project$Shared$Html$newLine,
						$author$project$Common$Button$group(buttons)
					]);
			}();
			return _List_fromArray(
				[
					title,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('proposal-text')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Shared$Html$try,
							$author$project$Common$Markdown$viewInDiv(_List_Nil),
							p.hH),
							$author$project$Shared$Html$newLine,
							A2($author$project$Shared$Html$try, payload, p.jt),
							proposalId,
							A2(
							$author$project$Shared$Html$try,
							forum('Discuss this proposal at '),
							p.cN)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('workflow')
						]),
					votingArea)
				]);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('proposal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('proposal-content')
						]),
					A2($author$project$Shared$Html$tryMany, proposal, model.jy)),
					A2(
					$elm$html$Html$map,
					$author$project$Governance$Voting$Proposal$Msg$Vote,
					A2($author$project$Shared$Html$try, vote, model.ld)),
					$author$project$Shared$Html$newLine,
					$author$project$Governance$Voting$Proposal$View$backToList
				]));
	});
var $author$project$Governance$Voting$Proposals$Msg$ShowFailed = {$: 4};
var $author$project$Shared$Blockchain$Logic$blockToInt = function (_v0) {
	var b = _v0;
	return b;
};
var $author$project$Governance$Voting$Proposals$View$c = {
	bf: $author$project$Governance$Voting$Shared$View$c.bf,
	bq: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('completed')
		]),
	dU: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('discussions')
		]),
	bG: $author$project$Governance$Voting$Shared$View$c.bG,
	ed: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('forecast')
		]),
	bQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('in-blockchain')
		]),
	jA: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('proposals')
		]),
	f5: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('start-end')
		]),
	lb: $author$project$Governance$Voting$Shared$View$c.lb,
	lc: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('voting')
		])
};
var $author$project$Governance$Voting$Proposals$Msg$NavigateToProposal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$Voting$Proposals$View$row = function (p) {
	return $author$project$Common$Table$row(
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Governance$Voting$Proposals$Msg$NavigateToProposal(p.jz))
			]));
};
var $author$project$Shared$Layout$header2 = $elm$html$Html$h2(_List_Nil);
var $author$project$Shared$Layout$textHeader2 = A2($elm$core$Basics$composeR, $author$project$Shared$Html$texts, $author$project$Shared$Layout$header2);
var $author$project$Governance$Voting$Proposals$View$sectionHeader = A2($elm$core$Basics$composeR, $author$project$Governance$Voting$Shared$View$status, $author$project$Shared$Layout$textHeader2);
var $author$project$Translations$Governance$Voting$showFailed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.voting.showFailed');
};
var $author$project$Governance$Voting$Proposals$View$view = F7(
	function (t, timeZone, vires, config, hh, gov, model) {
		var header = {
			cf: A2(
				$author$project$Common$Table$header,
				_List_fromArray(
					[$author$project$Governance$Voting$Proposals$View$c.lb]),
				'Results'),
			kB: A2($author$project$Common$Table$header, _List_Nil, 'Title')
		};
		var filter = function (s) {
			return A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.$8;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Blockchain$Logic$blockToInt,
						$elm$core$Basics$sub(0))),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.km;
						},
						A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$List$member, s)),
					model.jA));
		};
		var render = F2(
			function (s, viewFunc) {
				var _v0 = filter(s);
				if (!_v0.b) {
					return $author$project$Shared$Html$nothing;
				} else {
					var proposals = _v0;
					return viewFunc(proposals);
				}
			});
		var create = A3(
			$author$project$Common$Button$textLink,
			_List_fromArray(
				[$author$project$Common$Button$c.aL]),
			'/governance/vote/new',
			'Create new proposal');
		var faq = function (g) {
			var hours = A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$toFloat,
				A2(
					$elm$core$Basics$composeR,
					A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$Basics$fdiv, 60),
					$elm$core$String$fromFloat));
			var bind = A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$String$replace,
					'{{locked}}',
					A2($author$project$Shared$Vires$View$formatVires, vires, config.i0)),
				A2(
					$elm$core$Basics$composeR,
					A2(
						$elm$core$String$replace,
						'{{discussion}}',
						hours(
							$author$project$Shared$Blockchain$Logic$blockToInt(config.lf))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$String$replace,
							'{{voting}}',
							hours(
								$author$project$Shared$Blockchain$Logic$blockToInt(config.le) - $author$project$Shared$Blockchain$Logic$blockToInt(config.lf))),
						A2(
							$elm$core$Basics$composeR,
							A2(
								$elm$core$String$replace,
								'{{quorum}}',
								$author$project$Shared$Text$formatPercent(config.jG)),
							A2(
								$elm$core$Basics$composeR,
								A2(
									$elm$core$String$replace,
									'{{total}}',
									A2(
										$author$project$Shared$Vires$View$format_gVires,
										vires,
										$elm$core$Basics$round(g.bH * config.jG))),
								A2(
									$elm$core$String$replace,
									'{{passed}}',
									$author$project$Shared$Text$formatPercent(config.jp)))))));
			return A2(
				$author$project$Shared$Html$try,
				A2(
					$elm$core$Basics$composeR,
					bind,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$Markdown$view,
						A2(
							$elm$core$Basics$composeR,
							A2(
								$Gizra$elm_compat_019$Basics018$flip,
								$elm$core$Basics$append,
								_List_fromArray(
									[create])),
							$author$project$Shared$Layout$sectionN(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('faq markdown voting')
									]))))),
				model.h$);
		};
		var cell = {
			cf: function (p) {
				return A2(
					$author$project$Common$Table$cell,
					_List_Nil,
					A3(
						$author$project$Governance$Voting$Shared$View$votes,
						vires,
						A2($elm$core$Dict$get, p.jz, model.k2),
						p));
			},
			kB: A2(
				$elm$core$Basics$composeR,
				$author$project$Governance$Voting$Shared$View$title,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$text,
					$author$project$Common$Table$cell(_List_Nil))),
			cP: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.lc;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hP;
					},
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Governance$Voting$Shared$View$dateTime, timeZone, hh),
						$author$project$Common$Table$cell(_List_Nil))))
		};
		var discussions = function () {
			var proposals = filter(
				_List_fromArray(
					[0]));
			var proposal = function (p) {
				return A2(
					$author$project$Governance$Voting$Proposals$View$row,
					p,
					_List_fromArray(
						[
							cell.kB(p),
							A2(
							$author$project$Common$Table$cellN,
							$author$project$Governance$Voting$Proposals$View$c.f5,
							A2(
								$elm$core$List$map,
								A2($author$project$Governance$Voting$Shared$View$dateTime, timeZone, hh),
								_List_fromArray(
									[p.lc.kk, p.lc.hP])))
						]));
			};
			return A2(
				$author$project$Shared$Layout$sectionN,
				$author$project$Governance$Voting$Proposals$View$c.dU,
				_List_fromArray(
					[
						$author$project$Governance$Voting$Proposals$View$sectionHeader(0),
						function () {
						if ($author$project$Shared$Model$isLoading(model)) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								$author$project$Shared$Html$texts(
									$author$project$Translations$loading(t)));
						} else {
							if ($elm$core$List$isEmpty(proposals)) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									$author$project$Shared$Html$texts('No active proposal discussions'));
							} else {
								var head = _List_fromArray(
									[
										header.kB,
										A2($author$project$Common$Table$header, _List_Nil, 'Voting Starts / Ends')
									]);
								return A2(
									$author$project$Common$Table$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Common$Table$head(head),
											$author$project$Common$Table$body(
											A2($elm$core$List$map, proposal, proposals))
										]));
							}
						}
					}()
					]));
		}();
		var _final = F2(
			function (title, proposals) {
				var proposal = function (p) {
					return A2(
						$author$project$Governance$Voting$Proposals$View$row,
						p,
						_List_fromArray(
							[
								cell.kB(p),
								(p.km === 8) ? A2(
								$author$project$Common$Table$textCell,
								_List_Nil,
								$author$project$Governance$Voting$Shared$View$status(8)) : cell.cP(p)
							]));
				};
				var head = _List_fromArray(
					[
						header.kB,
						A2($author$project$Common$Table$header, _List_Nil, 'Voting Ended')
					]);
				return A2(
					$author$project$Shared$Layout$sectionN,
					$author$project$Governance$Voting$Proposals$View$c.bq,
					_List_fromArray(
						[
							$author$project$Shared$Layout$textHeader2(title),
							A2(
							$author$project$Common$Table$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Common$Table$head(head),
									$author$project$Common$Table$body(
									A2($elm$core$List$map, proposal, proposals))
								]))
						]));
			});
		var failed = model.kb ? A2(
			render,
			_List_fromArray(
				[3, 2, 7, 8]),
			_final('Not passed')) : ($author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Html$nothing : A2(
			$author$project$Shared$Html$textSpan,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('show-failed'),
					$elm$html$Html$Events$onClick($author$project$Governance$Voting$Proposals$Msg$ShowFailed)
				]),
			$author$project$Translations$Governance$Voting$showFailed(t)));
		var inBlockchain = function (proposals) {
			var proposal = function (p) {
				return A2(
					$author$project$Governance$Voting$Proposals$View$row,
					p,
					_List_fromArray(
						[
							cell.kB(p),
							A2(
							$author$project$Common$Table$cell,
							$author$project$Governance$Voting$Proposals$View$c.bQ,
							A2(
								$author$project$Shared$Html$try,
								A2($author$project$Governance$Voting$Shared$View$dateTime, timeZone, hh),
								p.g$))
						]));
			};
			var head = _List_fromArray(
				[
					header.kB,
					A2($author$project$Common$Table$header, $author$project$Governance$Voting$Proposals$View$c.bQ, 'In Blockchain')
				]);
			return A2(
				$author$project$Shared$Layout$sectionN,
				$author$project$Governance$Voting$Proposals$View$c.bq,
				_List_fromArray(
					[
						$author$project$Governance$Voting$Proposals$View$sectionHeader(6),
						A2(
						$author$project$Common$Table$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Common$Table$head(head),
								$author$project$Common$Table$body(
								A2($elm$core$List$map, proposal, proposals))
							]))
					]));
		};
		var voting = function (proposals) {
			var proposal = function (p) {
				var results = function () {
					var f = A2($author$project$Governance$Voting$Shared$Logic$forecast, config, p);
					var attr = A3($author$project$Common$Base$iff, $author$project$Governance$Voting$Proposals$View$c.bG, $author$project$Governance$Voting$Proposals$View$c.bf, f === 4);
					return A2(
						$author$project$Common$Table$cellN,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Governance$Voting$Shared$View$votes,
								vires,
								A2($elm$core$Dict$get, p.jz, model.k2),
								p),
								A2(
								$elm$html$Html$div,
								A2($elm$core$List$cons, attr, $author$project$Governance$Voting$Proposals$View$c.ed),
								_List_fromArray(
									[
										$elm$html$Html$text('forecast: '),
										$elm$html$Html$text(
										$author$project$Governance$Voting$Shared$View$status(f)),
										(f === 2) ? A2(
										$elm$html$Html$div,
										_List_Nil,
										$author$project$Shared$Html$texts(
											A3($author$project$Governance$Voting$Shared$View$quorum, vires, config, p))) : $author$project$Shared$Html$nothing
									]))
							]));
				}();
				return A2(
					$author$project$Governance$Voting$Proposals$View$row,
					p,
					_List_fromArray(
						[
							cell.kB(p),
							results,
							cell.cP(p)
						]));
			};
			var head = $author$project$Common$Table$head(
				_List_fromArray(
					[
						header.kB,
						header.cf,
						A2($author$project$Common$Table$header, _List_Nil, 'Voting Ends')
					]));
			return A2(
				$author$project$Shared$Layout$sectionN,
				$author$project$Governance$Voting$Proposals$View$c.lc,
				_List_fromArray(
					[
						$author$project$Governance$Voting$Proposals$View$sectionHeader(1),
						A2(
						$author$project$Common$Table$view,
						_List_Nil,
						_List_fromArray(
							[
								head,
								$author$project$Common$Table$body(
								A2($elm$core$List$map, proposal, proposals))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			$author$project$Governance$Voting$Proposals$View$c.jA,
			_List_fromArray(
				[
					A2($author$project$Shared$Html$try, faq, gov),
					discussions,
					A2(
					render,
					_List_fromArray(
						[1]),
					voting),
					A2(
					render,
					_List_fromArray(
						[4]),
					_final('Passed')),
					A2(
					render,
					_List_fromArray(
						[5]),
					_final('Broadcasting')),
					A2(
					render,
					_List_fromArray(
						[6]),
					inBlockchain),
					failed
				]));
	});
var $author$project$Governance$Voting$View$view = F9(
	function (t, _v0, vires, assets, hh, height, gov, user, model) {
		var timeZone = _v0.a;
		var zoneName = _v0.b;
		var _v1 = model.hn;
		if (!_v1.$) {
			var config = _v1.a;
			var _v2 = model.jo;
			switch (_v2.$) {
				case 0:
					var m = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Governance$Voting$Msg$Proposals,
						A7($author$project$Governance$Voting$Proposals$View$view, t, timeZone, vires, config, hh, gov, m));
				case 1:
					var m = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Governance$Voting$Msg$Proposal,
						A8($author$project$Governance$Voting$Proposal$View$view, t, timeZone, config, vires, hh, assets, user, m));
				default:
					var m = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Governance$Voting$Msg$New,
						A9(
							$author$project$Governance$Voting$New$View$view,
							t,
							config,
							vires,
							_Utils_Tuple2(timeZone, zoneName),
							hh,
							height,
							assets,
							user,
							m));
			}
		} else {
			return $author$project$Shared$Html$nothing;
		}
	});
var $author$project$Translations$Governance$Voting$vote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.voting.vote');
};
var $author$project$Governance$View$view = function (t) {
	return function (_v0) {
		return function (vires) {
			return function (assets) {
				return function (hh) {
					return function (height) {
						return function (markets) {
							return function (governance) {
								return function (rates) {
									return function (user) {
										return function (activeVoting) {
											return function (model) {
												var timeZone = _v0.a;
												var zoneName = _v0.b;
												var tabs = function () {
													var activeTabIndex = function () {
														var _v4 = model.kt;
														switch (_v4.$) {
															case 1:
																return 1;
															case 2:
																return 2;
															default:
																return 0;
														}
													}();
													var tab = F3(
														function (idx, link, label) {
															return A3(
																$author$project$Common$Tabs$tab,
																A3(
																	$author$project$Common$Base$iff,
																	$author$project$Common$Tabs$c.gT,
																	_List_Nil,
																	_Utils_eq(idx, activeTabIndex)),
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$href('/governance/' + link)
																	]),
																label);
														});
													var textTab = F3(
														function (idx, link, label) {
															return A3(
																tab,
																idx,
																link,
																$author$project$Shared$Html$texts(
																	label(t)));
														});
													return $author$project$Common$Tabs$view(
														_List_fromArray(
															[
																A3(textTab, 0, '', $author$project$Translations$info),
																A3(textTab, 1, 'my', $author$project$Translations$Governance$MyVires$myVires),
																A3(
																tab,
																2,
																'vote',
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Governance$Voting$vote(t)),
																		$elm$html$Html$text($author$project$Shared$Text$nbsp),
																		A2(
																		$author$project$Shared$Html$try,
																		$author$project$Governance$Voting$View$active(_List_Nil),
																		activeVoting)
																	]))
															]));
												}();
												var tabContent = function () {
													var _v2 = model.kt;
													switch (_v2.$) {
														case 1:
															var my = _v2.a;
															return A2(
																$elm$core$List$map,
																$elm$html$Html$map($author$project$Governance$Msg$MyVires),
																A2(
																	$author$project$Shared$Html$tryMany,
																	A7($author$project$Governance$MyVires$View$view, t, assets, markets, rates, vires, user, my),
																	governance));
														case 0:
															var info = _v2.a;
															return $elm$core$List$singleton(
																A2(
																	$elm$html$Html$map,
																	$author$project$Governance$Msg$Info,
																	A2(
																		$author$project$Shared$Html$try,
																		A7($author$project$Governance$Info$View$view, t, vires, assets, markets, rates, user, info),
																		governance)));
														default:
															var vote = _v2.a;
															if (!height.$) {
																var h = height.a;
																return $elm$core$List$singleton(
																	A2(
																		$elm$html$Html$map,
																		$author$project$Governance$Msg$Voting,
																		A9(
																			$author$project$Governance$Voting$View$view,
																			t,
																			_Utils_Tuple2(timeZone, zoneName),
																			vires,
																			assets,
																			hh,
																			h,
																			governance,
																			user,
																			vote)));
															} else {
																return $author$project$Shared$Html$texts('Loading blockchain height...');
															}
													}
												}();
												var dialog = function () {
													var _v1 = model.dQ;
													switch (_v1.$) {
														case 1:
															var lock = _v1.a;
															return A2(
																$elm$html$Html$map,
																$author$project$Governance$Msg$Lock,
																A5($author$project$Governance$Lock$View$view, t, vires, assets, user, lock));
														case 2:
															var unstake = _v1.a;
															return A2(
																$elm$html$Html$map,
																$author$project$Governance$Msg$Unstake,
																A5($author$project$Governance$Unstake$View$view, t, vires, assets, user, unstake));
														default:
															return $author$project$Shared$Html$nothing;
													}
												}();
												var body = A2(
													$author$project$Shared$Layout$sectionN,
													$author$project$Governance$View$c.ic,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Shared$Layout$textHeader(
																$author$project$Translations$Governance$governancePanel(t)),
																tabs
															]),
														_Utils_ap(
															tabContent,
															_List_fromArray(
																[dialog]))));
												return {
													dj: _List_fromArray(
														[body]),
													kB: $author$project$Translations$Governance$governancePanel(t)
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Home$Msg$GotoV2 = {$: 19};
var $author$project$Home$Msg$MyBorrow = function (a) {
	return {$: 4, a: a};
};
var $author$project$Home$Msg$MySupply = function (a) {
	return {$: 3, a: a};
};
var $author$project$Home$Msg$MyVires = function (a) {
	return {$: 13, a: a};
};
var $author$project$Translations$Home$AllMarkets$allMarkets = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.allMarkets.allMarkets');
};
var $author$project$Home$View$c = {
	c1: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('all-markets'),
			$elm$html$Html$Attributes$id('all-markets')
		]),
	dd: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('banner-container')
		]),
	dk: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('borrow')
		]),
	dF: $elm$html$Html$Attributes$class('connect-wallet'),
	aS: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('header')
		]),
	eY: $elm$html$Html$Attributes$class('markets'),
	e6: $elm$html$Html$Attributes$class('my'),
	gb: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('supply')
		]),
	kO: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('total-liquidity')
		])
};
var $author$project$Translations$Home$connectWalletToStart = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.connectWalletToStart');
};
var $author$project$Translations$Home$Banners$earnVires = F2(
	function (translations, apr4) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.banners.earnVires',
			_List_fromArray(
				[
					_Utils_Tuple2('apr4', apr4)
				]));
	});
var $author$project$Home$View$ellipse = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('ellipse')
		]),
	_List_Nil);
var $author$project$Shared$Borrow$Logic$hasBorrow = function (ui) {
	return !_Utils_eq(ui.dk, $elm$core$Maybe$Nothing);
};
var $author$project$Shared$Borrow$Logic$hasAnyBorrow = function (userData) {
	return A2(
		$elm$core$List$any,
		$author$project$Shared$Borrow$Logic$hasBorrow,
		$elm$core$Dict$values(userData));
};
var $author$project$Translations$Home$MyBorrow$myBorrow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.myBorrow.myBorrow');
};
var $author$project$Translations$Home$MySupply$mySupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.mySupply');
};
var $author$project$Common$Select$option = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$elm$html$Html$option(attrs));
};
var $author$project$Translations$Home$Banners$protocol = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.banners.protocol');
};
var $author$project$Common$Percent$round = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$mul(100),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$round,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$toFloat,
			A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$Basics$fdiv, 100))));
var $author$project$Translations$Home$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.title');
};
var $author$project$Common$Slides$Manual = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Slides$c = {
	gT: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('active')
		]),
	dc: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title banner run-animation')
		]),
	fm: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pages')
		]),
	f0: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('slides')
		])
};
var $author$project$Common$Slides$view = F2(
	function (model, slide) {
		var slideData = A2(
			$elm$html$Html$Attributes$attribute,
			'data-slide',
			$elm$core$String$fromInt(model.ah));
		var pages = function (i) {
			return _Utils_eq(i, model.ah) ? A2($elm$html$Html$li, $author$project$Common$Slides$c.gT, _List_Nil) : A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Common$Slides$Manual(i))
					]),
				_List_Nil);
		};
		return A2(
			$elm$html$Html$div,
			$author$project$Common$Slides$c.f0,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					A2($elm$core$List$cons, slideData, $author$project$Common$Slides$c.dc),
					slide),
					A2(
					$elm$html$Html$ul,
					$author$project$Common$Slides$c.fm,
					A2(
						$elm$core$List$map,
						pages,
						A2($elm$core$List$range, 0, model.gl - 1)))
				]));
	});
var $author$project$Home$ChangeCollateral$Close = {$: 2};
var $author$project$Home$ChangeCollateral$Confirm = {$: 0};
var $author$project$Home$ChangeCollateral$FeeAssetChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Market$deprecated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.deprecated');
};
var $author$project$Shared$Market$View$iconWithText = F2(
	function (t, m) {
		var a = m.bh;
		return $author$project$Shared$Asset$View$iconWithText(
			A3(
				$author$project$Common$Base$iff,
				_Utils_update(
					a,
					{
						iP: $author$project$Translations$Market$deprecated(t)
					}),
				a,
				m.iB));
	});
var $author$project$Shared$Dialog$assetHeader = F3(
	function (t, closeMsg, m) {
		return A2(
			$author$project$Common$Dialog$header,
			closeMsg,
			$elm$core$List$singleton(
				A2($author$project$Shared$Market$View$iconWithText, t, m)));
	});
var $author$project$Home$ChangeCollateral$c = {
	cW: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('action')
		]),
	r: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('collateral')
		])
};
var $author$project$Translations$Home$Validation$accountHealthTooLow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.validation.accountHealthTooLow');
};
var $author$project$Shared$Borrow$Logic$borrowPowerUsdt = F3(
	function (rates, markets, userData) {
		var perMarket = F2(
			function (m, u) {
				var _v0 = u.gb;
				if (((!_v0.$) && (!_v0.a.$)) && _v0.a.b) {
					var _v1 = _v0.a;
					var supply = _v1.a;
					var borrowed = A2($elm$core$Maybe$withDefault, 0, u.dk);
					return A3(
						$author$project$Shared$Market$Logic$inUsd,
						rates,
						m.bh,
						A2($elm$core$Basics$max, 0, supply - borrowed)) * m.ip.hm;
				} else {
					return 0;
				}
			});
		return $elm$core$List$sum(
			A3($author$project$Shared$User$Logic$mapReserves, userData, perMarket, markets));
	});
var $author$project$Shared$Borrow$Logic$borrowPowerUsedUsdt = F4(
	function (overlapFactor, rates, markets, userData) {
		var perMarket = F2(
			function (m, u) {
				var _v0 = u.dk;
				if (!_v0.$) {
					var borrow = _v0.a;
					var _v1 = function () {
						var _v2 = u.gb;
						if (((!_v2.$) && (!_v2.a.$)) && _v2.a.b) {
							var _v3 = _v2.a;
							var supply = _v3.a;
							return _Utils_Tuple2(
								supply,
								A3(
									$author$project$Shared$Market$Logic$inUsd,
									rates,
									m.bh,
									A2($elm$core$Basics$min, supply, borrow)) * overlapFactor);
						} else {
							return _Utils_Tuple2(0, 0);
						}
					}();
					var collateral = _v1.a;
					var overlapCharge = _v1.b;
					return (_Utils_cmp(borrow, collateral) > 0) ? ((A3(
						$author$project$Shared$Market$Logic$inUsd,
						rates,
						m.bh,
						A2($elm$core$Basics$max, 0, borrow - collateral)) / m.ip.iF) + overlapCharge) : overlapCharge;
				} else {
					return 0;
				}
			});
		return $elm$core$List$sum(
			A3($author$project$Shared$User$Logic$mapReserves, userData, perMarket, markets));
	});
var $author$project$Shared$Borrow$Logic$risk = F4(
	function (overlapFactor, rates, markets, userData) {
		var bpu = A4($author$project$Shared$Borrow$Logic$borrowPowerUsedUsdt, overlapFactor, rates, markets, userData);
		if (!bpu) {
			return 0;
		} else {
			var bp = A3($author$project$Shared$Borrow$Logic$borrowPowerUsdt, rates, markets, userData);
			return (!bp) ? 1 : (bpu / bp);
		}
	});
var $author$project$Shared$Transaction$Validation$collateral = F9(
	function (t, overlapFactor, accountHealthThreshold, rates, markets, userData, m, cl, _v0) {
		var _v1 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gb;
				},
				A2($author$project$Shared$User$Logic$ofMarket, m, userData)),
			cl);
		if ((((!_v1.a.$) && (!_v1.a.a.$)) && _v1.a.a.b) && (!_v1.b)) {
			var _v2 = _v1.a.a;
			var supply = _v2.a;
			var p = _v2.c;
			var risk = A4(
				$author$project$Shared$Borrow$Logic$risk,
				overlapFactor,
				rates,
				markets,
				A3(
					$elm$core$Dict$update,
					m.jT,
					$elm$core$Maybe$map(
						function (ud) {
							return _Utils_update(
								ud,
								{
									gb: $elm$core$Maybe$Just(
										A3($author$project$Shared$User$Model$Supply, supply, false, p))
								});
						}),
					userData));
			return (_Utils_cmp(risk, 1 - accountHealthThreshold) < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Translations$Home$Validation$accountHealthTooLow(t));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$confirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'confirm');
};
var $author$project$Shared$Html$classDirty = function (dirty) {
	return dirty ? $elm$html$Html$Attributes$class('dirty') : $elm$html$Html$Attributes$class('');
};
var $author$project$Shared$Dialog$dirtySection = function (_v0) {
	var dirty = _v0.hK;
	return $elm$html$Html$section(
		_List_fromArray(
			[
				$author$project$Shared$Html$classDirty(dirty)
			]));
};
var $author$project$Translations$Home$accountHealth = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.accountHealth');
};
var $author$project$Translations$Home$accountHealthTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.accountHealthTooltip');
};
var $author$project$Shared$Borrow$Info$health = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Home$accountHealth(t),
		$author$project$Translations$Home$accountHealthTooltip(t));
};
var $author$project$Shared$Borrow$Logic$health = function (risk_) {
	return 1 - risk_;
};
var $author$project$Shared$Delta$View$health = function (t) {
	var format = function (p) {
		return (_Utils_cmp(p, -10000) < 0) ? '-∞%' : $author$project$Shared$Text$formatPercent(p);
	};
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$author$project$Shared$Delta$View$view,
			A2($elm$core$Basics$composeR, $author$project$Shared$Borrow$Logic$health, format),
			A2($elm$core$Basics$composeR, $author$project$Shared$Borrow$Logic$health, format)),
		$author$project$Shared$Borrow$Info$health(t));
};
var $author$project$Translations$Home$ChangeCollateral$kindReminderOff = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.changeCollateral.kindReminderOff');
};
var $author$project$Translations$Home$ChangeCollateral$kindReminderOn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.changeCollateral.kindReminderOn');
};
var $author$project$Home$ChangeCollateral$kindReminder = function (t) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$author$project$Common$Base$iff,
			$author$project$Translations$Home$ChangeCollateral$kindReminderOn(t),
			$author$project$Translations$Home$ChangeCollateral$kindReminderOff(t)),
		$author$project$Shared$KindReminder$text);
};
var $author$project$Home$ChangeCollateral$riskDelta = F7(
	function (overlapFactor, userData, rates, markets, market, collateral, _v0) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Shared$Borrow$Logic$risk, overlapFactor, rates, markets),
			function () {
				var _v1 = A2($author$project$Shared$User$Logic$ofMarket, market, userData);
				if (!_v1.$) {
					var ud = _v1.a;
					var _v2 = ud.gb;
					if ((!_v2.$) && (!_v2.a.$)) {
						var _v3 = _v2.a;
						var a = _v3.a;
						var cl = _v3.b;
						var p = _v3.c;
						return _Utils_eq(cl, collateral) ? _List_fromArray(
							[userData]) : _List_fromArray(
							[
								userData,
								A3(
								$elm$core$Dict$insert,
								market.jT,
								_Utils_update(
									ud,
									{
										gb: $elm$core$Maybe$Just(
											A3($author$project$Shared$User$Model$Supply, a, !cl, p))
									}),
								userData)
							]);
					} else {
						return _List_fromArray(
							[userData]);
					}
				} else {
					return _List_fromArray(
						[userData]);
				}
			}());
	});
var $author$project$Translations$Home$ChangeCollateral$turningAsCollateralOff = F2(
	function (translations, asset) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.changeCollateral.turningAsCollateralOff',
			_List_fromArray(
				[
					_Utils_Tuple2('asset', asset)
				]));
	});
var $author$project$Translations$Home$ChangeCollateral$turningAsCollateralOn = F2(
	function (translations, asset) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.changeCollateral.turningAsCollateralOn',
			_List_fromArray(
				[
					_Utils_Tuple2('asset', asset)
				]));
	});
var $author$project$Shared$Info$viewWithFee = F8(
	function (t, attrs, assets, wallets, preferredAsset, feeInWaves, msg, selectedAssetId) {
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$Gizra$elm_compat_019$Basics018$flip,
				$elm$core$Basics$append,
				_List_fromArray(
					[
						A7($author$project$Shared$Info$feeRow, t, assets, wallets, preferredAsset, feeInWaves, msg, selectedAssetId)
					])),
			$author$project$Shared$Info$view(attrs));
	});
var $author$project$Home$ChangeCollateral$view = function (t) {
	return function (assets) {
		return function (user) {
			return function (overlapFactor) {
				return function (accountHealthThreshold) {
					return function (rates) {
						return function (markets) {
							return function (userData) {
								return function (m) {
									return function (model) {
										var validate = A2(
											$author$project$Common$Validate$and,
											A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
											A8($author$project$Shared$Transaction$Validation$collateral, t, overlapFactor, accountHealthThreshold, rates, markets, userData, m, model.r));
										var translation = A3($author$project$Common$Base$iff, $author$project$Translations$Home$ChangeCollateral$turningAsCollateralOn, $author$project$Translations$Home$ChangeCollateral$turningAsCollateralOff, model.r);
										var information = function () {
											var asset = m.bh.ac;
											return A9(
												$author$project$Shared$Info$viewWithFee,
												t,
												_List_Nil,
												assets,
												user,
												m.bh,
												$author$project$Shared$Transaction$Logic$fee.fT,
												$author$project$Home$ChangeCollateral$FeeAssetChanged,
												model.h1,
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Delta$View$health,
														t,
														A7($author$project$Home$ChangeCollateral$riskDelta, overlapFactor, userData, rates, markets, m, model.r, model)),
														A3(
														$author$project$Shared$Info$textRow,
														_List_Nil,
														asset + ' Supplied',
														A2(
															$author$project$Shared$Text$formatCurrency,
															asset,
															A2(
																$elm$core$Maybe$withDefault,
																0,
																A2(
																	$elm$core$Maybe$map,
																	A2(
																		$elm$core$Basics$composeR,
																		$author$project$Shared$User$Logic$userTotalSupply(m.f6),
																		$author$project$Shared$Market$Logic$inOrig(m.bh)),
																	A2(
																		$elm$core$Maybe$andThen,
																		function ($) {
																			return $.gb;
																		},
																		A2($author$project$Shared$User$Logic$ofMarket, m, userData))))))
													]));
										}();
										var header = A3($author$project$Shared$Dialog$assetHeader, t, $author$project$Home$ChangeCollateral$Close, m);
										var err = validate(model);
										var save = A4(
											$author$project$Common$Dialog$ctaButton,
											$elm$core$Maybe$Just($author$project$Home$ChangeCollateral$Confirm),
											$author$project$Translations$confirm(t),
											model,
											A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, err));
										var actionText = A2(
											$elm$html$Html$p,
											$author$project$Home$ChangeCollateral$c.cW,
											$author$project$Shared$Html$texts(
												A2(translation, t, m.bh.ac)));
										return $author$project$Common$Dialog$view(
											_List_fromArray(
												[
													$author$project$Common$Dialog$background($author$project$Home$ChangeCollateral$Close),
													A2(
													$author$project$Common$Dialog$body,
													$author$project$Home$ChangeCollateral$c.r,
													_List_fromArray(
														[
															header,
															A2(
															$author$project$Shared$Dialog$dirtySection,
															model,
															_List_fromArray(
																[
																	actionText,
																	information,
																	A2($author$project$Home$ChangeCollateral$kindReminder, t, model.r)
																])),
															A2($author$project$Shared$Dialog$footer, t, save)
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Home$Vesting$Msg$OpenClaim = {$: 2};
var $author$project$Home$Vesting$Msg$OpenWithdraw = {$: 1};
var $author$project$Translations$apr = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'apr');
};
var $author$project$Home$Vesting$Shared$Logic$availableRewards = function (r) {
	return A2($elm$core$Basics$max, 0, r.kL - r.bm);
};
var $author$project$Home$Vesting$View$c = {
	g3: $elm$html$Html$Attributes$class('apr'),
	ae: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('operations')
		]),
	j$: $elm$html$Html$Attributes$class('rewards'),
	M: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('supplied')
		]),
	kW: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('unlocked')
		]),
	k6: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('vesting')
		])
};
var $author$project$Shared$Asset$View$cell = function (attributes) {
	return $author$project$Common$Table$cell(
		A2($elm$core$List$cons, $author$project$Shared$Asset$View$c.bh, attributes));
};
var $author$project$Translations$Home$Legacy$convertToUSDN = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.legacy.convertToUSDN');
};
var $author$project$Translations$Home$Vesting$dailyStakingIncome = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vesting.dailyStakingIncome');
};
var $author$project$Shared$Text$longDash = '—';
var $author$project$Shared$Text$formatPercentOrDash = function (p) {
	return (!p) ? $author$project$Shared$Text$longDash : $author$project$Shared$Text$formatPercent(p);
};
var $author$project$Translations$Home$supplied = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.supplied');
};
var $author$project$Home$Vesting$View$header = {
	M: A2(
		$elm$core$Basics$composeR,
		$author$project$Translations$Home$supplied,
		$author$project$Common$Table$header($author$project$Home$Vesting$View$c.M))
};
var $author$project$Translations$borrowAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'borrowAPR');
};
var $author$project$Translations$borrowAPRTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'borrowAPRTooltip');
};
var $author$project$Shared$Market$View$c = {
	g3: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('apr')
		]),
	c6: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('apy')
		]),
	dk: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('borrow')
		]),
	eY: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('markets')
		]),
	ae: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('operations')
		]),
	j$: $elm$html$Html$Attributes$class('rewards'),
	gb: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('supply')
		]),
	cH: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('total apy')
		])
};
var $author$project$Translations$operations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'operations');
};
var $author$project$Translations$supplyAPY = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'supplyAPY');
};
var $author$project$Translations$totalAPYTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalAPYTooltip');
};
var $author$project$Translations$totalDebt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalDebt');
};
var $author$project$Translations$totalDebtTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalDebtTooltip');
};
var $author$project$Translations$totalSupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalSupply');
};
var $author$project$Translations$totalSupplyTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalSupplyTooltip');
};
var $author$project$Shared$Market$View$header = {
	bh: A2(
		$elm$core$Basics$composeR,
		$author$project$Translations$asset,
		$author$project$Common$Table$header(
			_List_fromArray(
				[$author$project$Shared$Asset$View$c.bh]))),
	g9: function (t) {
		return A3(
			$author$project$Common$Table$headerWithTooltip,
			$author$project$Translations$borrowAPRTooltip(t),
			$author$project$Shared$Market$View$c.c6,
			$author$project$Translations$borrowAPR(t));
	},
	ae: A2(
		$elm$core$Basics$composeR,
		$author$project$Translations$operations,
		$author$project$Common$Table$header($author$project$Shared$Market$View$c.ae)),
	kr: function (t) {
		return A3(
			$author$project$Common$Table$headerWithTooltip,
			$author$project$Translations$totalAPYTooltip(t),
			$author$project$Shared$Market$View$c.cH,
			$author$project$Translations$supplyAPY(t));
	},
	kM: function (t) {
		return A3(
			$author$project$Common$Table$headerWithTooltip,
			$author$project$Translations$totalDebtTooltip(t),
			$author$project$Shared$Market$View$c.dk,
			$author$project$Translations$totalDebt(t));
	},
	kP: function (t) {
		return A3(
			$author$project$Common$Table$headerWithTooltip,
			$author$project$Translations$totalSupplyTooltip(t),
			$author$project$Shared$Market$View$c.gb,
			$author$project$Translations$totalSupply(t));
	}
};
var $author$project$Shared$User$Logic$mapAssetsById = $author$project$Shared$User$Logic$mapBy(
	function ($) {
		return $.bP;
	});
var $author$project$Translations$Home$Legacy$myLegacyDeposits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.legacy.myLegacyDeposits');
};
var $author$project$Home$Vesting$Shared$View$plusPercent = '+' + $author$project$Shared$Text$formatPercent($author$project$Home$Vesting$Shared$Logic$liquidationBonus);
var $author$project$Common$Button$underButton = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$elm$html$Html$div(
			A2($elm$core$List$cons, $author$project$Common$Button$c.gv, attrs)));
};
var $author$project$Home$Vesting$Claim$Msg$Claim = {$: 0};
var $author$project$Home$Vesting$Claim$Msg$Close = {$: 2};
var $author$project$Home$Vesting$Claim$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$Home$available = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.available');
};
var $author$project$Translations$Home$Vires$claim = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.claim');
};
var $author$project$Home$Vesting$Claim$Validate$validate = F3(
	function (t, assets, wallets) {
		return A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, wallets, $author$project$Shared$Asset$Model$waves);
	});
var $author$project$Home$Vesting$Claim$View$view = F6(
	function (t, user, assets, usdn, rewards, model) {
		var info = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Shared$Info$textRow,
					_List_Nil,
					'Total',
					A2(
						$author$project$Shared$Asset$Format$asset,
						usdn,
						A2($elm$core$Basics$max, 0, rewards.kL))),
					A3(
					$author$project$Shared$Info$textRow,
					_List_Nil,
					'Already claimed',
					A2(
						$author$project$Shared$Asset$Format$asset,
						usdn,
						A2($elm$core$Basics$max, 0, rewards.bm))),
					A3(
					$author$project$Shared$Info$textRow,
					_List_Nil,
					$author$project$Translations$Home$available(t),
					A2(
						$author$project$Shared$Asset$Format$asset,
						usdn,
						$author$project$Home$Vesting$Shared$Logic$availableRewards(rewards))),
					A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Home$Vesting$Claim$Msg$FeeAssetChanged, model.h1)
				]));
		var claim = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Home$Vesting$Claim$Msg$Claim),
			$author$project$Translations$Home$Vires$claim(t),
			model,
			A4($author$project$Home$Vesting$Claim$Validate$validate, t, assets, user, model));
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Home$Vesting$Claim$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Common$Dialog$textHeader, $author$project$Home$Vesting$Claim$Msg$Close, 'Claim Vesting Rewards'),
							info,
							A2(
							$author$project$Shared$Dialog$footer,
							t,
							A3(
								$author$project$Common$Base$iff,
								claim,
								$author$project$Shared$Wallet$View$connect(t),
								$author$project$User$Logic$isLoggedIn(user)))
						]))
				]));
	});
var $author$project$Home$Vesting$Convert$Msg$Close = {$: 1};
var $author$project$Home$Vesting$Convert$Msg$Convert = {$: 0};
var $author$project$Home$Vesting$Convert$Msg$FeeAssetChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Vesting$Shared$Logic$convertableSupplies = F2(
	function (markets, ud) {
		var isLegacy = F2(
			function (reserveAddress, _v0) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.iB;
						},
						A3(
							$author$project$Common$List$getBy,
							function ($) {
								return $.jT;
							},
							reserveAddress,
							markets)));
			});
		return A2($elm$core$Dict$filter, isLegacy, ud);
	});
var $author$project$Translations$Home$Vesting$Convert$kindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vesting.convert.kindReminder');
};
var $author$project$Home$Vesting$Shared$Info$liquidationBonus = A2($author$project$Shared$Info$textRow, _List_Nil, 'Liquidation Bonus\u00A0' + $author$project$Home$Vesting$Shared$View$plusPercent);
var $author$project$Home$Vesting$Shared$Logic$liquidationBonusAmount = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$toFloat,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$mul($author$project$Home$Vesting$Shared$Logic$liquidationBonus),
		$elm$core$Basics$round));
var $author$project$Home$Vesting$Shared$Logic$totalFromSupplyUSDN = function (convertableSupplies_) {
	var regularSupply = function (supply) {
		if (!supply.$) {
			var a = supply.a;
			return a;
		} else {
			return 0;
		}
	};
	return $elm$core$List$sum(
		A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gb;
				},
				$elm$core$Maybe$map(regularSupply)),
			$elm$core$Dict$values(convertableSupplies_)));
};
var $author$project$Home$Vesting$Convert$View$view = F9(
	function (t, assets, markets, usdn, user, migrated, userData, totalVested, model) {
		var info = function () {
			var totalWhale = $author$project$Home$Vesting$Shared$Logic$totalFromMigratedUSDN(migrated);
			var infoSupply = F3(
				function (prefix, a, amount) {
					return A3(
						$author$project$Shared$Info$rowN,
						_List_Nil,
						prefix + (' ' + (a.ac + ' Supply')),
						A2($author$project$Shared$Delta$View$zeroed, a, amount));
				});
			var fromWhales = A3(
				$author$project$Shared$User$Logic$mapAssetsById,
				migrated,
				infoSupply('Legacy'),
				assets);
			var convertableSupplies = A2($author$project$Home$Vesting$Shared$Logic$convertableSupplies, markets, userData);
			var fromNonLocked = function () {
				var row = F2(
					function (m, ui) {
						var _v0 = ui.gb;
						if ((!_v0.$) && (!_v0.a.$)) {
							var _v1 = _v0.a;
							var a = _v1.a;
							return A3(infoSupply, 'Non\u00A0locked', m.bh, a);
						} else {
							return $author$project$Shared$Html$nothing;
						}
					});
				return A3($author$project$Shared$User$Logic$mapReserves, convertableSupplies, row, markets);
			}();
			var totalRegular = $author$project$Home$Vesting$Shared$Logic$totalFromSupplyUSDN(convertableSupplies);
			var totalConvertableUSDN = totalWhale + totalRegular;
			var newVestedUSDN = $author$project$Home$Vesting$Shared$Logic$withLiquidationBonus(totalConvertableUSDN);
			var usdnInVestingInfo = function () {
				var now = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$map, $author$project$Home$Vesting$Shared$Logic$stillInVesting, totalVested));
				return A3(
					$author$project$Shared$Info$rowN,
					_List_Nil,
					'XTN in Vesting',
					A2(
						$author$project$Shared$Delta$View$fundsDelta,
						usdn,
						_List_fromArray(
							[now, now + newVestedUSDN])));
			}();
			var bonusAmount = $author$project$Home$Vesting$Shared$Logic$liquidationBonusAmount(totalConvertableUSDN);
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_Utils_ap(
					fromWhales,
					_Utils_ap(
						fromNonLocked,
						_List_fromArray(
							[
								$author$project$Home$Vesting$Shared$Info$liquidationBonus(
								A2($author$project$Shared$Asset$Format$asset, usdn, bonusAmount)),
								usdnInVestingInfo,
								A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Home$Vesting$Convert$Msg$FeeAssetChanged, model.h1)
							]))));
		}();
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A2(
			$author$project$Common$Button$primary,
			$author$project$Translations$Home$Legacy$convertToUSDN(t),
			$author$project$Home$Vesting$Convert$Msg$Convert);
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Home$Vesting$Convert$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Dialog$textHeader,
							$author$project$Home$Vesting$Convert$Msg$Close,
							$author$project$Translations$Home$Legacy$convertToUSDN(t)),
							info,
							$author$project$Shared$KindReminder$text(
							$author$project$Translations$Home$Vesting$Convert$kindReminder(t)),
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $author$project$Home$Vesting$Withdraw$ChangeTab = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Vesting$Withdraw$Close = {$: 3};
var $author$project$Home$Vesting$Withdraw$c_ = {
	dQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('withdraw-vested-dialog')
		]),
	gJ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('withdraw-vested')
		])
};
var $author$project$Common$Tabs$content = function (attrs) {
	return $elm$html$Html$section(
		A2($elm$core$List$cons, $author$project$Common$Tabs$c_.dH, attrs));
};
var $author$project$Home$Vesting$Shared$L2$l2 = {hC: 8, ac: 'L2MP'};
var $author$project$Common$Tuple$map = F2(
	function (m, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			m(a),
			m(b));
	});
var $author$project$Common$Tabs$tabBtn = F3(
	function (idx, active, msg) {
		return A2(
			$author$project$Common$Tabs$tab,
			_List_fromArray(
				[
					A3(
					$author$project$Common$Base$iff,
					$author$project$Common$Attributes$is.gT(true),
					$elm$html$Html$Events$onClick(
						msg(idx)),
					_Utils_eq(idx, active))
				]),
			_List_Nil);
	});
var $author$project$Common$Badge$text = function (attrs) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Html$texts,
		$author$project$Common$Badge$view(attrs));
};
var $author$project$Common$Tabs$textTab = F3(
	function (idx, active, msg) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Html$texts,
			A3($author$project$Common$Tabs$tabBtn, idx, active, msg));
	});
var $author$project$Home$Vesting$L2$Msg$AmountChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Home$Vesting$L2$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Home$Vesting$L2$Msg$FromChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Home$Vesting$L2$Msg$Max = function (a) {
	return {$: 5, a: a};
};
var $author$project$Home$Vesting$L2$Msg$SetStake = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Vesting$L2$Msg$Withdraw = function (a) {
	return {$: 0, a: a};
};
var $author$project$Home$Vesting$L2$View$c = {
	gZ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('amount')
		])
};
var $author$project$Shared$Dialog$ctaMsg = F3(
	function (model, asset, msg) {
		return A2(
			$elm$core$Maybe$map,
			msg,
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, asset, model.gZ));
	});
var $author$project$Shared$KindReminder$info = function (attrs) {
	return $author$project$Shared$KindReminder$view(
		A2($elm$core$List$cons, $author$project$Shared$KindReminder$c.ip, attrs));
};
var $author$project$Translations$Home$max = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.max');
};
var $author$project$Home$Vesting$Shared$Logic$maxWhaleExport = 750000 * A2($elm$core$Basics$pow, 10, $author$project$Home$Vesting$Shared$Data$vvxtnlp.hC);
var $author$project$Home$Vesting$Shared$Logic$maxVested = F3(
	function (regularVested, whaleVested, from) {
		var _v0 = _Utils_Tuple3(
			_Utils_eq(from, $author$project$Home$Vesting$Shared$Data$regular),
			regularVested,
			whaleVested);
		_v0$2:
		while (true) {
			if (_v0.a) {
				if (!_v0.b.$) {
					var r = _v0.b.a;
					return $author$project$Home$Vesting$Shared$Logic$stillInVesting(r);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.c.$) {
					var w = _v0.c.a;
					return A2(
						$elm$core$Basics$min,
						$author$project$Home$Vesting$Shared$Logic$maxWhaleExport,
						$author$project$Home$Vesting$Shared$Logic$stillInVesting(w));
				} else {
					break _v0$2;
				}
			}
		}
		return 0;
	});
var $author$project$Shared$Info$rowWithTooltip = F3(
	function (attrs, title, tooltip_) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				A2(
					$author$project$Shared$Info$row,
					attrs,
					_List_fromArray(
						[
							A2($author$project$Common$Tooltip$abbr, tooltip_, title)
						]))));
	});
var $author$project$Common$Form$selectAddOn = function (attr) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$select(attr),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$span($author$project$Common$Form$c.cj)));
};
var $author$project$Home$Vesting$Shared$Info$stillInVesting = A2($author$project$Shared$Info$rowN, _List_Nil, 'Still in vesting');
var $author$project$Home$Vesting$Shared$Validate$exceed = F4(
	function (t, regularVested, whaleVested, model) {
		var amount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, $author$project$Home$Vesting$Shared$Data$vvxtnlp, model.gZ));
		if (!amount) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_eq(model.h8, $author$project$Home$Vesting$Shared$Data$whale) && (_Utils_cmp(amount, $author$project$Home$Vesting$Shared$Logic$maxWhaleExport) > 0)) {
				return $elm$core$Maybe$Just('Exceed 705K limit');
			} else {
				var max = A3($author$project$Home$Vesting$Shared$Logic$maxVested, regularVested, whaleVested, model.h8);
				return (_Utils_cmp(amount, max) > 0) ? $elm$core$Maybe$Just('Exceed vested amount') : $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Home$Vesting$L2$Validate$validate = F6(
	function (t, assets, usdn, user, regularVested, whaleVested) {
		var onlyRegular = function (m) {
			return _Utils_eq(m.h8, $author$project$Home$Vesting$Shared$Data$regular) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Only regular vesting supported');
		};
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, $author$project$Shared$Asset$Model$waves),
			A2(
				$author$project$Common$Validate$and,
				onlyRegular,
				A2(
					$author$project$Common$Validate$and,
					A3($author$project$Home$Vesting$Shared$Validate$exceed, t, regularVested, whaleVested),
					A2(
						$author$project$Common$Validate$and,
						A2($author$project$Shared$Validate$precision, t, usdn),
						$author$project$Shared$Validate$positiveAmount(t)))));
	});
var $author$project$Translations$Home$Withdraw$withdraw = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.withdraw.withdraw');
};
var $author$project$Home$Vesting$L2$View$view = F8(
	function (t, assets, usdn, user, totalVested, regularVested, whaleVested, model) {
		var withdrawalAsL2 = A2(
			$elm$core$Basics$max,
			0,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($author$project$Shared$Asset$Logic$tryToSatoshi, usdn, model.gZ)));
		var warning = A2(
			$author$project$Shared$KindReminder$info,
			_List_Nil,
			$elm$core$List$singleton(
				A2($author$project$Common$Markdown$viewInDiv, _List_Nil, '**Instantly** withdraw your vested XTN as L2MP tokens.\\\n [Learn more about L2MP](https://rideonwaves.io/)')));
		var stakeTooltip = 'Stake L2MP tokens to get additional passive income. Unstake anytime';
		var stakeL2 = A4(
			$author$project$Shared$Info$rowNWithTooltip,
			_List_Nil,
			'Stake L2MP tokens',
			stakeTooltip,
			$elm$core$List$singleton(
				A2($author$project$Common$CheckBox$tumbler, $author$project$Home$Vesting$L2$Msg$SetStake, model.kg)));
		var msg = A3($author$project$Shared$Dialog$ctaMsg, model, usdn, $author$project$Home$Vesting$L2$Msg$Withdraw);
		var l2Amount = function (rate) {
			return A2(
				$author$project$Shared$Asset$Format$asset,
				$author$project$Home$Vesting$Shared$L2$l2,
				$elm$core$Basics$round(withdrawalAsL2 * rate));
		};
		var l2APR = function (apr) {
			return A4(
				$author$project$Shared$Info$rowWithTooltip,
				_List_Nil,
				'L2MP staking APR',
				stakeTooltip,
				'from ' + $author$project$Shared$Text$formatPercent(apr));
		};
		var info = function () {
			var stillInVestingInfo = function () {
				var _v0 = _Utils_Tuple2(regularVested, whaleVested);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var r = _v0.a.a;
					var w = _v0.b.a;
					var vested = F2(
						function (from, data) {
							var rest = $author$project$Home$Vesting$Shared$Logic$stillInVesting(data);
							return A3(
								$author$project$Shared$Delta$View$funds,
								'Still in ' + (from + ' vesting'),
								usdn,
								_Utils_eq(from, model.h8) ? _List_fromArray(
									[rest, rest - withdrawalAsL2]) : _List_fromArray(
									[rest]));
						});
					return _List_fromArray(
						[
							A2(vested, $author$project$Home$Vesting$Shared$Data$whale, w),
							A2(vested, $author$project$Home$Vesting$Shared$Data$regular, r)
						]);
				} else {
					var total = $author$project$Home$Vesting$Shared$Logic$stillInVesting(totalVested);
					return $elm$core$List$singleton(
						$author$project$Home$Vesting$Shared$Info$stillInVesting(
							A2(
								$author$project$Shared$Delta$View$fundsDelta,
								usdn,
								_List_fromArray(
									[total, total - withdrawalAsL2]))));
				}
			}();
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_Utils_ap(
					stillInVestingInfo,
					_List_fromArray(
						[
							A4(
							$author$project$Shared$Info$rowWithTooltip,
							_List_Nil,
							'L2 to be received',
							'You will get L2MP tokens on your wallet',
							l2Amount(95)),
							stakeL2,
							A2($author$project$Shared$Html$try, l2APR, model.g3),
							A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Home$Vesting$L2$Msg$FeeAssetChanged, model.h1)
						])));
		}();
		var err = A7($author$project$Home$Vesting$L2$Validate$validate, t, assets, usdn, user, regularVested, whaleVested, model);
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A4(
			$author$project$Common$Dialog$ctaButton,
			msg,
			$author$project$Translations$Home$Withdraw$withdraw(t),
			model,
			err);
		var amount = function () {
			var supplyWith = function () {
				var sources = $author$project$Common$List$just(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always($author$project$Home$Vesting$Shared$Data$regular),
							regularVested),
							A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always($author$project$Home$Vesting$Shared$Data$whale),
							whaleVested)
						]));
				return ($elm$core$List$length(sources) > 1) ? A2(
					$author$project$Common$Form$selectAddOn,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Home$Vesting$L2$Msg$FromChanged)
						]),
					A2(
						$elm$core$List$map,
						function (o) {
							return A2(
								$author$project$Common$Select$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(o)
									]),
								o);
						},
						sources)) : $author$project$Shared$Html$nothing;
			}();
			var number = A4(
				$author$project$Shared$Dialog$amount,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('Enter withdraw amount')
					]),
				err,
				$author$project$Home$Vesting$L2$Msg$AmountChanged,
				model);
			var maxBtn = A3(
				$author$project$Common$Button$enabled,
				_List_Nil,
				$author$project$Translations$Home$max(t),
				$author$project$Home$Vesting$L2$Msg$Max(
					A3($author$project$Home$Vesting$Shared$Logic$maxVested, regularVested, whaleVested, model.h8)));
			return A2(
				$author$project$Common$Form$fieldWithAddon,
				$author$project$Home$Vesting$L2$View$c.gZ,
				_List_fromArray(
					[number, supplyWith, maxBtn]));
		}();
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						warning,
						$author$project$Shared$Html$newLine,
						$author$project$Shared$Html$newLine,
						amount,
						info,
						A2(
						$author$project$Shared$KindReminder$default,
						_List_fromArray(
							[$author$project$Common$Markdown$c.eX]),
						$author$project$Common$Markdown$view('1 XTN in vesting will be converted to 0.95 L2MP.\\\n' + ('L2MP staking doesn\'t lock your tokens. You can **unstake anytime**.\\\n' + 'L2MP withdrawal restarts 500 day vesting period')))
					])),
			cta);
	});
var $author$project$Home$Vesting$USDN$Msg$FeeAssetChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Home$Vesting$USDN$Msg$Withdraw = {$: 0};
var $author$project$Home$Vesting$Shared$View$vestingIsPaused = A2($author$project$Common$Button$disabledCta, _List_Nil, 'Vesting is paused');
var $author$project$Home$Vesting$USDN$View$view = F8(
	function (t, assets, xtn, user, regular, whale, paused, model) {
		var availableNow = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bi;
				},
				regular));
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : (paused ? $author$project$Home$Vesting$Shared$View$vestingIsPaused : ((!availableNow) ? A2(
			$author$project$Common$Button$disabledCta,
			_List_Nil,
			$author$project$Translations$Home$Withdraw$withdraw(t)) : A2(
			$author$project$Common$Button$primary,
			$author$project$Translations$Home$Withdraw$withdraw(t),
			$author$project$Home$Vesting$USDN$Msg$Withdraw)));
		var info = function () {
			var format = $author$project$Shared$Asset$Format$asset2(xtn);
			var part = function (title) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Home$Vesting$Shared$Logic$stillInVesting,
					A2(
						$elm$core$Basics$composeR,
						format,
						A2($author$project$Shared$Info$textRow, _List_Nil, title)));
			};
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Shared$Html$try,
						part('Non-vested'),
						whale),
						A2(
						$author$project$Shared$Html$try,
						part('Vested'),
						regular),
						A3(
						$author$project$Shared$Info$textRow,
						_List_Nil,
						'Available now',
						format(availableNow)),
						A2(
						$author$project$Shared$Html$try,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hz;
							},
							A2(
								$elm$core$Basics$composeR,
								format,
								A2($author$project$Shared$Info$textRow, _List_Nil, 'Available daily'))),
						regular),
						A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$Home$Vesting$USDN$Msg$FeeAssetChanged, model.h1)
					]));
		}();
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						info,
						$author$project$Shared$KindReminder$text('Vesting schedule for regular part is linear for 500 days. If you have whale vesting part, consider importing-exporting to migrate it to regular part to start its vesting.')
					])),
			cta);
	});
var $author$project$Home$Vesting$Withdraw$view = F9(
	function (t, assets, usdn, user, total, regularVested, whaleVested, paused, model) {
		var tabs = $author$project$Common$Tabs$view(
			_List_fromArray(
				[
					A4($author$project$Common$Tabs$textTab, 0, model.Y, $author$project$Home$Vesting$Withdraw$ChangeTab, usdn.ac),
					A4(
					$author$project$Common$Tabs$tabBtn,
					1,
					model.Y,
					$author$project$Home$Vesting$Withdraw$ChangeTab,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Home$Vesting$Shared$L2$l2.ac),
							$elm$html$Html$text($author$project$Shared$Text$nbsp),
							A2(
							$author$project$Shared$Html$try,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Common$Percent$round,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Shared$Text$formatPercent,
									$author$project$Common$Badge$text(_List_Nil))),
							model.ab.g3)
						]))
				]));
		var _v0 = function () {
			var _v1 = model.Y;
			if (!_v1) {
				return A2(
					$author$project$Common$Tuple$map,
					$elm$html$Html$map($author$project$Home$Vesting$Withdraw$USDN_Msg),
					A8($author$project$Home$Vesting$USDN$View$view, t, assets, usdn, user, regularVested, whaleVested, paused, model.aC));
			} else {
				return A2(
					$author$project$Common$Tuple$map,
					$elm$html$Html$map($author$project$Home$Vesting$Withdraw$SURF_Msg),
					A8($author$project$Home$Vesting$L2$View$view, t, assets, usdn, user, total, regularVested, whaleVested, model.ab));
			}
		}();
		var content = _v0.a;
		var btn = _v0.b;
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Home$Vesting$Withdraw$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$Home$Vesting$Withdraw$c_.dQ,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Dialog$textHeader,
							$author$project$Home$Vesting$Withdraw$Close,
							$author$project$Translations$Home$Withdraw$withdraw(t)),
							tabs,
							A2(
							$author$project$Common$Tabs$content,
							$author$project$Home$Vesting$Withdraw$c_.gJ,
							$elm$core$List$singleton(content)),
							A2(
							$author$project$Shared$Dialog$footer,
							t,
							A3(
								$author$project$Common$Base$iff,
								btn,
								$author$project$Shared$Wallet$View$connect(t),
								$author$project$User$Logic$isLoggedIn(user)))
						]))
				]));
	});
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Common$Card$title = $elm$html$Html$legend(_List_Nil);
var $author$project$Common$Card$textTitle = A2($elm$core$Basics$composeR, $author$project$Shared$Html$texts, $author$project$Common$Card$title);
var $author$project$Common$Card$withTable = F3(
	function (title_, attrs, content_) {
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Card$c.aH,
				A2(
					$elm$core$List$cons,
					$author$project$Common$Card$c.aG,
					A2($elm$core$List$cons, $author$project$Common$Card$c.bk, attrs))),
			_List_fromArray(
				[
					$author$project$Common$Card$textTitle(title_),
					A2(
					$elm$html$Html$div,
					$author$project$Common$Card$c.bs,
					$elm$core$List$singleton(content_))
				]));
	});
var $author$project$Translations$Home$xDaily = F2(
	function (translations, amount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.xDaily',
			_List_fromArray(
				[
					_Utils_Tuple2('amount', amount)
				]));
	});
var $author$project$Home$Vesting$View$view = F6(
	function (t, assets, markets, user, userData, model) {
		var usdn_ = $author$project$Shared$Asset$Logic$getXTN(assets);
		var totalVested = $author$project$Home$Vesting$Shared$Logic$totalVested(model);
		var vestedTable = function () {
			var _v4 = _Utils_Tuple2(totalVested, usdn_);
			if ((!_v4.a.$) && (!_v4.b.$)) {
				var vested = _v4.a.a;
				var usdn = _v4.b.a;
				var operations = A2(
					$author$project$Common$Table$cell,
					$author$project$Home$Vesting$View$c.ae,
					A2(
						$author$project$Common$Button$text,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Home$Vesting$Msg$OpenWithdraw),
								$author$project$Common$Button$c.aL
							]),
						$author$project$Translations$Home$Withdraw$withdraw(t)));
				var defaultAction = $elm$html$Html$Events$onClick($author$project$Home$Vesting$Msg$OpenWithdraw);
				var claim = _List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Home$Vesting$Msg$OpenClaim)
					]);
				var amount = $author$project$Home$Vesting$Shared$Logic$stillInVesting(vested);
				var _v5 = _Utils_Tuple2(
					$author$project$Shared$Text$formatPercentOrDash(0),
					A2($author$project$Shared$Asset$Format$asset2, usdn, 0));
				var apr = _v5.a;
				var daily = _v5.b;
				var rewards = function (_v6) {
					var stakingRewards = _v6.f4;
					return A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							$elm$html$Html$div(_List_Nil)),
						_List_fromArray(
							[
								A2(
								$author$project$Shared$Html$textSpan,
								_List_Nil,
								A2(
									$author$project$Shared$Asset$Format$asset2,
									usdn,
									$author$project$Home$Vesting$Shared$Logic$availableRewards(stakingRewards))),
								$elm$html$Html$text(
								A2($author$project$Translations$Home$xDaily, t, daily))
							]));
				};
				var row = A2(
					$author$project$Common$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$Asset$View$cell,
							_List_fromArray(
								[defaultAction]),
							$author$project$Shared$Asset$View$iconWithText(usdn)),
							A2(
							$author$project$Common$Table$cellN,
							A2($elm$core$List$cons, defaultAction, $author$project$Home$Vesting$View$c.M),
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$div(_List_Nil)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Shared$Asset$Format$asset2, usdn, amount)),
										A2(
										$author$project$Shared$Html$try,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Shared$Asset$Format$asset2(usdn),
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Basics$append('+\u00A0'),
												$elm$html$Html$text)),
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.f4;
												},
												function ($) {
													return $.kL;
												}),
											model.jN))
									]))),
							A2(
							$author$project$Common$Table$cell,
							A2($elm$core$List$cons, $author$project$Home$Vesting$View$c.g3, claim),
							A2($author$project$Shared$Html$textSpan, _List_Nil, apr)),
							A2(
							$author$project$Common$Table$cellN,
							A2($elm$core$List$cons, $author$project$Home$Vesting$View$c.j$, claim),
							A2(
								$elm$core$Maybe$withDefault,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Shared$Text$longDash)
									]),
								A2($elm$core$Maybe$map, rewards, model.jN))),
							operations
						]));
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Common$Card$withTable,
						$author$project$Translations$Home$Legacy$myLegacyDeposits(t),
						$author$project$Home$Vesting$View$c.k6,
						A2(
							$author$project$Common$Table$view,
							$author$project$Home$Vesting$View$c.k6,
							_List_fromArray(
								[
									$author$project$Common$Table$head(
									_List_fromArray(
										[
											$author$project$Shared$Market$View$header.bh(t),
											A2($author$project$Common$Table$header, $author$project$Home$Vesting$View$c.M, 'Still in vesting'),
											A3(
											$author$project$Common$Table$headerWithTooltip,
											$author$project$Translations$Home$Vesting$dailyStakingIncome(t),
											_List_fromArray(
												[$author$project$Home$Vesting$View$c.g3]),
											$author$project$Translations$apr(t)),
											A3(
											$author$project$Common$Table$headerWithTooltip,
											$author$project$Translations$Home$Vesting$dailyStakingIncome(t),
											_List_fromArray(
												[$author$project$Home$Vesting$View$c.j$]),
											'Claimable rewards'),
											A2(
											$author$project$Common$Table$header,
											$author$project$Home$Vesting$View$c.ae,
											$author$project$Translations$operations(t))
										])),
									$author$project$Common$Table$body(
									$elm$core$List$singleton(row))
								]))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var migratedTable = function () {
			var _v3 = _Utils_Tuple2(
				$elm$core$Dict$isEmpty(model.iZ),
				usdn_);
			if ((!_v3.a) && (!_v3.b.$)) {
				var usdn = _v3.b.a;
				var row = F2(
					function (asset, amount) {
						return A2(
							$author$project$Common$Table$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Shared$Asset$View$cell,
									_List_Nil,
									$author$project$Shared$Asset$View$iconWithText(asset)),
									A2(
									$author$project$Common$Table$textCell,
									$author$project$Home$Vesting$View$c.M,
									A2($author$project$Shared$Asset$Format$asset2, asset, amount)),
									A2(
									$author$project$Common$Table$cell,
									$author$project$Home$Vesting$View$c.ae,
									A2(
										$author$project$Common$Button$disabledCta,
										_List_Nil,
										$author$project$Translations$Home$Withdraw$withdraw(t)))
								]));
					});
				var convertRow = A2(
					$author$project$Common$Table$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('operations'),
							$elm$html$Html$Events$onClick($author$project$Home$Vesting$Msg$OpenConvert)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Common$Table$cell,
							_List_Nil,
							$elm$html$Html$text(
								A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											$author$project$Translations$Home$Legacy$convertToUSDN(t),
											$author$project$Home$Vesting$Shared$View$plusPercent
										])))),
							A2(
							$author$project$Common$Table$cell,
							$author$project$Home$Vesting$View$c.M,
							$elm$html$Html$text(
								'→\u00A0' + A2(
									$author$project$Shared$Asset$Format$asset2,
									usdn,
									$author$project$Home$Vesting$Shared$Logic$withLiquidationBonus(
										$author$project$Home$Vesting$Shared$Logic$totalFromMigratedUSDN(model.iZ))))),
							A2(
							$author$project$Common$Table$cell,
							$author$project$Home$Vesting$View$c.ae,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Common$Button$primary,
										$author$project$Translations$Home$Legacy$convertToUSDN(t),
										$author$project$Home$Vesting$Msg$OpenConvert),
										A2($author$project$Common$Button$underButton, _List_Nil, $author$project$Home$Vesting$Shared$View$plusPercent)
									])))
						]));
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Common$Card$withTable,
						$author$project$Translations$Home$Legacy$myLegacyDeposits(t),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('migrated')
							]),
						A2(
							$author$project$Common$Table$view,
							$author$project$Home$Vesting$View$c.k6,
							_List_fromArray(
								[
									$author$project$Common$Table$head(
									_List_fromArray(
										[
											$author$project$Shared$Market$View$header.bh(t),
											$author$project$Home$Vesting$View$header.M(t),
											$author$project$Shared$Market$View$header.ae(t)
										])),
									$author$project$Common$Table$body(
									_Utils_ap(
										A3($author$project$Shared$User$Logic$mapAssetsById, model.iZ, row, assets),
										_List_fromArray(
											[convertRow])))
								]))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var dialog = function () {
			var _v0 = _Utils_Tuple3(
				model.dQ,
				usdn_,
				_Utils_Tuple2(totalVested, model.jN));
			_v0$3:
			while (true) {
				if (!_v0.b.$) {
					switch (_v0.a.$) {
						case 1:
							var convert = _v0.a.a;
							var usdn = _v0.b.a;
							return $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$map,
									$author$project$Home$Vesting$Msg$Convert,
									A9($author$project$Home$Vesting$Convert$View$view, t, assets, markets, usdn, user, model.iZ, userData, totalVested, convert)));
						case 2:
							if (!_v0.c.a.$) {
								var withdrawal = _v0.a.a;
								var usdn = _v0.b.a;
								var _v1 = _v0.c;
								var total = _v1.a.a;
								return $elm$core$Maybe$Just(
									A2(
										$elm$html$Html$map,
										$author$project$Home$Vesting$Msg$Withdraw,
										A9($author$project$Home$Vesting$Withdraw$view, t, assets, usdn, user, total, model.jN, model.lk, model.js, withdrawal)));
							} else {
								break _v0$3;
							}
						case 3:
							if (!_v0.c.b.$) {
								var claim = _v0.a.a;
								var usdn = _v0.b.a;
								var _v2 = _v0.c;
								var stakingRewards = _v2.b.a.f4;
								return $elm$core$Maybe$Just(
									A2(
										$elm$html$Html$map,
										$author$project$Home$Vesting$Msg$Claim,
										A6($author$project$Home$Vesting$Claim$View$view, t, user, assets, usdn, stakingRewards, claim)));
							} else {
								break _v0$3;
							}
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		return $author$project$Common$List$just(
			_List_fromArray(
				[migratedTable, vestedTable, dialog]));
	});
var $author$project$Markets$Msg$NavigateToGovernance = {$: 0};
var $author$project$Shared$Asset$Format$assetOnlyNumsK = function (a) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Shared$Market$Logic$inOrig(a),
		$author$project$Shared$Text$formatK);
};
var $author$project$Shared$Suppy$Logic$assumed = F2(
	function (rates, a) {
		var usdRate_ = A2($author$project$Shared$Market$Logic$usdRate, rates, a.bP);
		return $elm$core$Basics$round(
			(1000 * A2($elm$core$Basics$pow, 10, a.hC)) / usdRate_);
	});
var $author$project$Shared$Market$View$borrowAprTextAndIcon = function (apr) {
	return $elm$core$List$singleton(
		A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				$elm$html$Html$text(
					$author$project$Shared$Text$formatPercentOrDash(apr)))));
};
var $author$project$Markets$View$c = {
	aO: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('details')
		]),
	aP: $elm$html$Html$Attributes$class('deprecated'),
	R: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('main')
		]),
	ae: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('operations')
		]),
	be: $elm$html$Html$Attributes$class('vires'),
	lh: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('wallet')
		])
};
var $author$project$Shared$Table$c = {
	jn: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('original')
		]),
	kY: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('usdt')
		])
};
var $author$project$Common$Table$dash = function (attrs) {
	return A2(
		$author$project$Common$Table$cell,
		A2($elm$core$List$cons, $author$project$Common$Table$c_.e9, attrs),
		$elm$html$Html$text('—'));
};
var $author$project$Shared$Text$formatAsset = $cuducos$elm_format_number$FormatNumber$format($author$project$Shared$Text$locale.bt);
var $author$project$Markets$View$goToVires = $elm$html$Html$Events$onClick($author$project$Markets$Msg$NavigateToGovernance);
var $author$project$Translations$Governance$governance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'governance.governance');
};
var $author$project$Translations$inUSDcUSDnEtc = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'inUSDcUSDnEtc');
};
var $author$project$VToken$Shared$Logic$inVTokens = F2(
	function (state, amount) {
		return $elm$core$Basics$round(
			amount / $author$project$VToken$Shared$Logic$price(state));
	});
var $author$project$Common$Screen$isMobile = function (_v0) {
	var width = _v0;
	return width <= 768;
};
var $author$project$Shared$Market$Logic$lendersDept = function (s) {
	return s.dk - s.jS;
};
var $author$project$Shared$Vires$Logic$inYear = $elm$core$Basics$mul((24 * 60) * $author$project$Common$Time$daysInYear);
var $author$project$Shared$Vires$Logic$lockedSupplyAPR = F5(
	function (vires, rates, m, lp, _v0) {
		var factor = _v0;
		var totalInUsd = A3(
			$author$project$Shared$Market$Logic$inUsd,
			rates,
			m.bh,
			$elm$core$Basics$round(
				lp * $author$project$VToken$Shared$Logic$price(m.f6)));
		var share = function () {
			if (!m.f6.iM) {
				return 1;
			} else {
				var weightedLP = lp * (factor / 1000);
				return weightedLP / m.f6.iM;
			}
		}();
		var myIncomeInYearUSD = share * A3(
			$author$project$Shared$Market$Logic$inUsd,
			rates,
			vires,
			$author$project$Shared$Vires$Logic$inYear(m.f6.iK));
		return myIncomeInYearUSD / totalInUsd;
	});
var $author$project$Shared$Market$Logic$marketTotalSupply = function (s) {
	return s.gb + s.jD;
};
var $elm_community$basics_extra$Basics$Extra$maxSafeInteger = A2($elm$core$Basics$pow, 2, 53) - 1;
var $author$project$Shared$Blockchain$Model$maxHeight = $elm_community$basics_extra$Basics$Extra$maxSafeInteger;
var $author$project$Shared$Suppy$Logic$maxUserFactor = 1500;
var $author$project$Shared$Suppy$Logic$toMultiplier = function (_v0) {
	var factor = _v0;
	return factor / 1000;
};
var $author$project$Shared$Suppy$Logic$marketAndSupply = F3(
	function (op, supply, m) {
		var state = m.f6;
		if (!supply.$) {
			if (supply.c === 1) {
				var a = supply.a;
				var _v1 = supply.c;
				return _Utils_update(
					m,
					{
						f6: _Utils_update(
							state,
							{
								jD: A2(op, state.jD, a)
							})
					});
			} else {
				var a = supply.a;
				return _Utils_update(
					m,
					{
						f6: _Utils_update(
							state,
							{
								gb: A2(op, state.gb, a)
							})
					});
			}
		} else {
			var lp = supply.a;
			var w = supply.c;
			return _Utils_update(
				m,
				{
					f6: _Utils_update(
						state,
						{
							iL: A2(op, state.iL, lp),
							iM: A2(
								op,
								state.iM,
								$elm$core$Basics$round(
									lp * $author$project$Shared$Suppy$Logic$toMultiplier(w)))
						})
				});
		}
	});
var $author$project$Shared$Vires$Logic$nonLockedSupplyApr = F3(
	function (vires, rates, m) {
		var total = m.f6.gb;
		if (!total) {
			return 0;
		} else {
			var viresInOneYearInUsd = A3(
				$author$project$Shared$Market$Logic$inUsd,
				rates,
				vires,
				$author$project$Shared$Vires$Logic$inYear(m.f6.hG));
			var lockedSupplyInUsd = A2(
				$elm$core$Basics$max,
				1,
				A3($author$project$Shared$Market$Logic$inUsd, rates, m.bh, total));
			return viresInOneYearInUsd / lockedSupplyInUsd;
		}
	});
var $author$project$Shared$Vires$Logic$supplyApr = F5(
	function (vires, _v0, rates, m, supply) {
		var currentHeight = _v0;
		if (!supply.$) {
			if (supply.c === 1) {
				var _v2 = supply.c;
				return 0;
			} else {
				return A3($author$project$Shared$Vires$Logic$nonLockedSupplyApr, vires, rates, m);
			}
		} else {
			var lp = supply.a;
			var unlockHeight = supply.b;
			var factor = supply.c;
			return (_Utils_cmp(currentHeight, unlockHeight) < 0) ? A5($author$project$Shared$Vires$Logic$lockedSupplyAPR, vires, rates, m, lp, factor) : 0;
		}
	});
var $author$project$Shared$Vires$Logic$supplyAprForecast = F5(
	function (vires, rates, m, oldSupply, supply) {
		var supplyAfter = function () {
			var _v1 = _Utils_Tuple2(oldSupply, supply);
			_v1$3:
			while (true) {
				if (!_v1.a.$) {
					if (_v1.a.a.$ === 1) {
						if (_v1.b.$ === 1) {
							var _v2 = _v1.a.a;
							var old = _v2.a;
							var _v3 = _v1.b;
							var _new = _v3.a;
							var h = _v3.b;
							var w = _v3.c;
							return A3($author$project$Shared$User$Model$Locked, old + _new, h, w);
						} else {
							break _v1$3;
						}
					} else {
						if (_v1.b.$ === 1) {
							var _v4 = _v1.a.a;
							var old = _v4.a;
							var _v5 = _v1.b;
							var _new = _v5.a;
							var h = _v5.b;
							var w = _v5.c;
							return A3(
								$author$project$Shared$User$Model$Locked,
								A2($author$project$VToken$Shared$Logic$inVTokens, m.f6, old) + _new,
								h,
								w);
						} else {
							var _v6 = _v1.a.a;
							var old = _v6.a;
							var _v7 = _v1.b;
							var _new = _v7.a;
							var cl = _v7.b;
							var p = _v7.c;
							return A3($author$project$Shared$User$Model$Supply, old + _new, cl, p);
						}
					}
				} else {
					break _v1$3;
				}
			}
			return supply;
		}();
		var marketAfterSupply = A3(
			$author$project$Shared$Suppy$Logic$marketAndSupply,
			$elm$core$Basics$add,
			supplyAfter,
			function () {
				if (oldSupply.$ === 1) {
					return m;
				} else {
					var was = oldSupply.a;
					return A3($author$project$Shared$Suppy$Logic$marketAndSupply, $elm$core$Basics$sub, was, m);
				}
			}());
		return A5($author$project$Shared$Vires$Logic$supplyApr, vires, 0, rates, marketAfterSupply, supplyAfter);
	});
var $author$project$Shared$Vires$Logic$maxSupplyAprForecast = F3(
	function (vires, rates, m) {
		var lp = A2(
			$author$project$VToken$Shared$Logic$inVTokens,
			m.f6,
			A2($author$project$Shared$Suppy$Logic$assumed, rates, m.bh));
		return A5(
			$author$project$Shared$Vires$Logic$supplyAprForecast,
			vires,
			rates,
			m,
			$elm$core$Maybe$Nothing,
			A3($author$project$Shared$User$Model$Locked, lp, $author$project$Shared$Blockchain$Model$maxHeight, $author$project$Shared$Suppy$Logic$maxUserFactor));
	});
var $author$project$Markets$Msg$NavigateToMarket = function (a) {
	return {$: 1, a: a};
};
var $author$project$Markets$View$navigate = A2($elm$core$Basics$composeR, $author$project$Markets$Msg$NavigateToMarket, $elm$html$Html$Events$onClick);
var $author$project$Markets$Msg$ShowDeprecated = {$: 2};
var $author$project$Markets$View$showDetails = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('show-deprecated'),
			$elm$html$Html$Events$onClick($author$project$Markets$Msg$ShowDeprecated)
		]),
	A2(
		$elm$core$List$repeat,
		3,
		A2($elm$html$Html$span, _List_Nil, _List_Nil)));
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Common$Table$singleCellRow = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Table$cell(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(100)
				])),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$author$project$Common$Table$row(attributes)));
};
var $author$project$Shared$Html$textClass = F2(
	function (class1, textValue) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(class1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(textValue)
				]));
	});
var $elm$core$Basics$e = _Basics_e;
var $author$project$Common$Math$exp = function (x) {
	return A2($elm$core$Basics$pow, $elm$core$Basics$e, x);
};
var $author$project$Shared$Market$Logic$aprToApy = function (apr_) {
	return $author$project$Common$Math$exp(apr_) - 1;
};
var $author$project$Common$Maybe$addValue = F2(
	function (maybe, value) {
		if (!maybe.$) {
			var m = maybe.a;
			return value + m;
		} else {
			return value;
		}
	});
var $author$project$Shared$Apy$toBasicSupplyAPR = F3(
	function (reserveFactor, utilization_, borrowAPR_) {
		return (borrowAPR_ * utilization_) * (1 - reserveFactor);
	});
var $author$project$Shared$Market$Logic$basicSupplyAPR_ForUtilization = F2(
	function (u, marketInfo) {
		return A3(
			$author$project$Shared$Apy$toBasicSupplyAPR,
			marketInfo.jU,
			u,
			A2($author$project$Shared$Apy$borrowAPR, marketInfo.eG, u));
	});
var $author$project$Shared$Market$Logic$basicSupplyAPR = function (m) {
	return A2(
		$author$project$Shared$Market$Logic$basicSupplyAPR_ForUtilization,
		$author$project$Shared$Market$Logic$utilization(m.f6),
		m.ip);
};
var $author$project$Shared$Market$Logic$supplyAPR_PlusExternal = F3(
	function (map, util, info) {
		return A2(
			$elm$core$Maybe$map,
			function (aprBase) {
				return (aprBase * (1 - util)) * $author$project$Shared$Market$Logic$interestReserveRatio;
			},
			map(info));
	});
var $author$project$Shared$Market$Logic$leasingAPR_ForUtilization = function (util) {
	return A2(
		$author$project$Shared$Market$Logic$supplyAPR_PlusExternal,
		function ($) {
			return $.eM;
		},
		util);
};
var $author$project$Shared$Market$Logic$leasingAPR = function (m) {
	return A2(
		$author$project$Shared$Market$Logic$leasingAPR_ForUtilization,
		$author$project$Shared$Market$Logic$utilization(m.f6),
		m.ip);
};
var $author$project$Shared$Market$Logic$stakingAPR_ForUtilization = function (util) {
	return A2(
		$author$project$Shared$Market$Logic$supplyAPR_PlusExternal,
		function ($) {
			return $.ct;
		},
		util);
};
var $author$project$Shared$Market$Logic$stakingAPR = function (m) {
	return A2(
		$author$project$Shared$Market$Logic$stakingAPR_ForUtilization,
		$author$project$Shared$Market$Logic$utilization(m.f6),
		m.ip);
};
var $author$project$Shared$Market$Logic$totalSupplyAPR = function (m) {
	return A2(
		$author$project$Common$Maybe$addValue,
		$author$project$Shared$Market$Logic$leasingAPR(m),
		A2(
			$author$project$Common$Maybe$addValue,
			$author$project$Shared$Market$Logic$stakingAPR(m),
			$author$project$Shared$Market$Logic$basicSupplyAPR(m)));
};
var $author$project$Shared$Market$Logic$totalSupplyAPY = A2($elm$core$Basics$composeR, $author$project$Shared$Market$Logic$totalSupplyAPR, $author$project$Shared$Market$Logic$aprToApy);
var $author$project$Shared$Suppy$Logic$maxLockPeriod = 12;
var $author$project$Shared$Suppy$Logic$lockInMonth = function (_v0) {
	var w = _v0;
	switch (w) {
		case 1000:
			return 3;
		case 1250:
			return 6;
		case 1500:
			return $author$project$Shared$Suppy$Logic$maxLockPeriod;
		default:
			return 1;
	}
};
var $author$project$Translations$Home$Supply$Lock$oneYear = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.supply.lock.oneYear');
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$coins = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'coins',
	512,
	512,
	_List_fromArray(
		['M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z']));
var $author$project$Translations$Market$leasingAPRTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.leasingAPRTooltip');
};
var $author$project$Shared$Market$View$leasingIcon = function (t) {
	return A2(
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('staking'),
			A2(
				$author$project$Common$Tooltip$tooltip,
				_List_Nil,
				$author$project$Translations$Market$leasingAPRTooltip(t))),
		$elm$core$List$singleton(
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$coins)));
};
var $author$project$Translations$Market$stakingAPRTooltip = F2(
	function (translations, asset) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'market.stakingAPRTooltip',
			_List_fromArray(
				[
					_Utils_Tuple2('asset', asset)
				]));
	});
var $author$project$Shared$Market$View$stakingIcon = F2(
	function (t, asset) {
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('staking'),
				A2(
					$author$project$Common$Tooltip$tooltip,
					_List_Nil,
					A2($author$project$Translations$Market$stakingAPRTooltip, t, asset.ac))),
			$elm$core$List$singleton(
				$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$coins)));
	});
var $author$project$Shared$Market$View$supplyApyTextAndIcon = F3(
	function (t, _v0, apy) {
		var info = _v0.ip;
		var asset = _v0.bh;
		var apyPercent = $elm$html$Html$text(
			$author$project$Shared$Text$formatPercentOrDash(apy));
		var normalApy = (!_Utils_eq(info.ct, $elm$core$Maybe$Nothing)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('staking-apy')
				]),
			_List_fromArray(
				[
					A2($author$project$Shared$Market$View$stakingIcon, t, asset),
					$elm$html$Html$text($author$project$Shared$Text$nbsp),
					apyPercent
				])) : ((!_Utils_eq(info.eM, $elm$core$Maybe$Nothing)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('leasing-apy')
				]),
			_List_fromArray(
				[
					$author$project$Shared$Market$View$leasingIcon(t),
					$elm$html$Html$text($author$project$Shared$Text$nbsp),
					apyPercent
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(apyPercent)));
		return normalApy;
	});
var $author$project$Translations$viresAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'viresAPR');
};
var $author$project$Translations$viresAPRForLockedSupplyTooltip = F2(
	function (translations, period) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'viresAPR_ForLockedSupplyTooltip',
			_List_fromArray(
				[
					_Utils_Tuple2('period', period)
				]));
	});
var $author$project$Translations$viresApr = F2(
	function (translations, apr4) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'viresApr',
			_List_fromArray(
				[
					_Utils_Tuple2('apr4', apr4)
				]));
	});
var $author$project$Translations$Home$Supply$Lock$xMonths = F2(
	function (translations, n) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.supply.lock.xMonths',
			_List_fromArray(
				[
					_Utils_Tuple2('n', n)
				]));
	});
var $author$project$Shared$Market$View$totalSupplyApyIncVires = F5(
	function (t, m, supply_, apy, vApr) {
		var viresApy = F2(
			function (tooltip, apr) {
				return (!apr) ? $author$project$Shared$Html$nothing : A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('vires'),
						A2($author$project$Common$Tooltip$tooltip, _List_Nil, tooltip)),
					$author$project$Shared$Html$texts(
						'inc.\u00A0' + A2(
							$author$project$Translations$viresApr,
							t,
							$author$project$Shared$Text$formatAPR(apr))));
			});
		var supplyApy = A2($author$project$Shared$Market$View$supplyApyTextAndIcon, t, m);
		if (!supply_.$) {
			if (supply_.c === 1) {
				var _v1 = supply_.c;
				return _List_fromArray(
					[
						A3($author$project$Shared$Market$View$supplyApyTextAndIcon, t, m, apy)
					]);
			} else {
				return _List_fromArray(
					[
						supplyApy(apy + vApr),
						A2(
						viresApy,
						$author$project$Translations$viresAPR(t),
						vApr)
					]);
			}
		} else {
			var factor = supply_.c;
			var period = function () {
				var _v2 = $author$project$Shared$Suppy$Logic$lockInMonth(factor);
				if (_v2 === 12) {
					return $author$project$Translations$Home$Supply$Lock$oneYear(t);
				} else {
					var mn = _v2;
					return A2(
						$author$project$Translations$Home$Supply$Lock$xMonths,
						t,
						$elm$core$String$fromInt(mn));
				}
			}();
			return _List_fromArray(
				[
					supplyApy(apy + vApr),
					A2(
					viresApy,
					A2($author$project$Translations$viresAPRForLockedSupplyTooltip, t, period),
					vApr)
				]);
		}
	});
var $author$project$Translations$upTo = F2(
	function (translations, apr2) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'upTo',
			_List_fromArray(
				[
					_Utils_Tuple2('apr2', apr2)
				]));
	});
var $author$project$Translations$walletBalanceTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'walletBalanceTooltip');
};
var $author$project$Translations$xApr = F2(
	function (translations, apr1) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'xApr',
			_List_fromArray(
				[
					_Utils_Tuple2('apr1', apr1)
				]));
	});
var $author$project$Markets$View$view = function (t) {
	return function (screen) {
		return function (vires) {
			return function (assets) {
				return function (markets) {
					return function (rates) {
						return function (newRates) {
							return function (gov) {
								return function (walletData) {
									return function (model) {
										var viresOperations = A2(
											$author$project$Common$Table$cell,
											$author$project$Markets$View$c.ae,
											$author$project$Common$Button$group(
												_List_fromArray(
													[
														A2(
														$author$project$Common$Button$primary,
														$author$project$Translations$Governance$governance(t),
														$author$project$Markets$Msg$NavigateToGovernance)
													])));
										var totalViresStaked = A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.f3;
												},
												gov));
										var totalMobileRow = F4(
											function (title, asset, attrs, amount) {
												return A3(
													$author$project$Shared$Info$rowN,
													attrs,
													title,
													_List_fromArray(
														[
															A2(
															$author$project$Shared$Html$textClass,
															'in-orig',
															A2($author$project$Shared$Asset$Format$assetOnlyNumsK, asset, amount)),
															$elm$html$Html$text(' '),
															A2(
															$author$project$Shared$Html$textSpan,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('usdt')
																]),
															$author$project$Shared$Text$formatUsdK(
																A3($author$project$Shared$Market$Logic$inUsd, rates, asset, amount)))
														]));
											});
										var totalCell = F3(
											function (asset, attrs, amount) {
												return A2(
													$author$project$Common$Table$cellN,
													attrs,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															$author$project$Shared$Table$c.kY,
															$elm$core$List$singleton(
																$elm$html$Html$text(
																	$author$project$Shared$Text$formatUsdK(
																		A3($author$project$Shared$Market$Logic$inUsd, rates, asset, amount))))),
															A2(
															$elm$html$Html$div,
															$author$project$Shared$Table$c.jn,
															$elm$core$List$singleton(
																$elm$html$Html$text(
																	A2($author$project$Shared$Asset$Format$assetOnlyNumsK, asset, amount))))
														]));
											});
										var goToAsset = function (m) {
											return m.iB ? $elm$html$Html$Attributes$class('') : $author$project$Markets$View$navigate(m.jT);
										};
										var formatLP = function (a) {
											return A2(
												$elm$core$Basics$composeR,
												$author$project$Shared$Market$Logic$inOrig(a),
												A2(
													$elm$core$Basics$composeR,
													$author$project$Shared$Text$formatAsset,
													A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$Basics$append, '\u00A0LP')));
										};
										var fixedRates = A3($author$project$Shared$NewRate$toNewRates, vires, assets, newRates);
										var filteredMarkets = model.ka ? markets : A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.iB;
												},
												$elm$core$Basics$not),
											markets);
										var governanceApr = function () {
											if (!gov.$) {
												var g = gov.a;
												return $elm$core$Maybe$Just(
													$author$project$Shared$Text$formatAPR(
														$author$project$Governance$Shared$Plans$maxX * A4(
															$author$project$Governance$Shared$Logic$governanceApr,
															fixedRates(rates),
															filteredMarkets,
															vires,
															g)));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										var deprecated = (model.ka || (!A2(
											$elm$core$List$any,
											function ($) {
												return $.iB;
											},
											markets))) ? $author$project$Shared$Html$nothing : $author$project$Markets$View$showDetails;
										var balance = function (asset) {
											return $author$project$Shared$Text$formatAsset(
												A2(
													$author$project$Shared$Market$Logic$inOrig,
													asset,
													A2(
														$elm$core$Maybe$withDefault,
														0,
														A2($author$project$Shared$Wallet$Logic$wallet, asset.bP, walletData))));
										};
										var viresRowDesktop = function (_v3) {
											var aprCell = function () {
												if (!governanceApr.$) {
													var apr = governanceApr.a;
													return A2(
														$author$project$Common$Table$cellN,
														$author$project$Shared$Market$View$c.cH,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																$author$project$Shared$Html$texts(
																	A2($author$project$Translations$xApr, t, apr))),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('original')
																	]),
																$author$project$Shared$Html$texts(
																	$author$project$Translations$inUSDcUSDnEtc(t)))
															]));
												} else {
													return $author$project$Common$Table$dash($author$project$Shared$Market$View$c.cH);
												}
											}();
											return A2(
												$author$project$Common$Table$row,
												A2(
													$elm$core$List$cons,
													$author$project$Markets$View$goToVires,
													A2($elm$core$List$cons, $author$project$Markets$View$c.be, $author$project$Markets$View$c.R)),
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Asset$View$cell,
														_List_Nil,
														$author$project$Shared$Asset$View$iconWithText(vires)),
														A3(totalCell, vires, $author$project$Shared$Market$View$c.gb, totalViresStaked),
														aprCell,
														$author$project$Common$Table$dash(_List_Nil),
														$author$project$Common$Table$dash($author$project$Shared$Market$View$c.dk),
														A2(
														$author$project$Common$Table$textCell,
														$author$project$Markets$View$c.lh,
														balance(vires))
													]));
										};
										var viresRowMobile = function (_v1) {
											var mainRow = A2(
												$author$project$Common$Table$row,
												A2(
													$elm$core$List$cons,
													$author$project$Markets$View$goToVires,
													A2($elm$core$List$cons, $author$project$Markets$View$c.be, $author$project$Markets$View$c.R)),
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Asset$View$cell,
														_List_fromArray(
															[$author$project$Markets$View$goToVires]),
														$author$project$Shared$Asset$View$iconWithText(vires)),
														viresOperations
													]));
											var detailRow = A2(
												$author$project$Common$Table$singleCellRow,
												A2(
													$elm$core$List$cons,
													$author$project$Markets$View$goToVires,
													A2($elm$core$List$cons, $author$project$Markets$View$c.be, $author$project$Markets$View$c.aO)),
												A2(
													$author$project$Shared$Info$view,
													_List_Nil,
													_List_fromArray(
														[
															A4(
															totalMobileRow,
															'In Governance',
															vires,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('supply')
																]),
															totalViresStaked),
															A2(
															$author$project$Shared$Html$try,
															A2($author$project$Governance$Shared$Info$governanceApr, t, assets),
															governanceApr),
															A3(
															$author$project$Shared$Info$textRow,
															$author$project$Markets$View$c.lh,
															$author$project$Translations$walletBalance(t),
															balance(vires))
														])));
											return _List_fromArray(
												[mainRow, detailRow]);
										};
										var walletStr = function (m) {
											return balance(m.bh);
										};
										var desktopMarket = function (m) {
											var total = F2(
												function (map, attrs) {
													return A3(
														totalCell,
														m.bh,
														attrs,
														map(m.f6));
												});
											var supplyApyCell = function () {
												var assumedSupplyLP = A2(
													$author$project$VToken$Shared$Logic$inVTokens,
													m.f6,
													A2($author$project$Shared$Suppy$Logic$assumed, rates, m.bh));
												return A2(
													$author$project$Common$Table$cellN,
													A2(
														$elm$core$List$cons,
														goToAsset(m),
														$author$project$Shared$Market$View$c.cH),
													A5(
														$author$project$Shared$Market$View$totalSupplyApyIncVires,
														t,
														m,
														A3($author$project$Shared$User$Model$Locked, assumedSupplyLP, $author$project$Shared$Blockchain$Model$maxHeight, $author$project$Shared$Suppy$Logic$maxUserFactor),
														$author$project$Shared$Market$Logic$totalSupplyAPY(m),
														A5(
															$author$project$Shared$Vires$Logic$lockedSupplyAPR,
															vires,
															fixedRates(rates),
															m,
															assumedSupplyLP,
															$author$project$Shared$Suppy$Logic$maxUserFactor)));
											}();
											var lpTxt = A2(
												$elm$core$Basics$composeR,
												formatLP(m.bh),
												A2(
													$elm$core$Basics$composeR,
													$author$project$Shared$Html$texts,
													$elm$html$Html$div(
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('original')
															]))));
											var walletCell = function () {
												if (m.iB) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('usdt')
																]),
															$author$project$Shared$Html$texts('—')),
															A2(
															$author$project$Shared$Html$try,
															lpTxt,
															A2($author$project$Shared$Wallet$Logic$wallet, m.gO, walletData))
														]);
												} else {
													var walletCell1 = function () {
														var _v0 = A2($author$project$Shared$Wallet$Logic$wallet, m.gO, walletData);
														if (_v0.$ === 1) {
															return $author$project$Shared$Html$texts(
																walletStr(m));
														} else {
															var lp = _v0.a;
															return _List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('usdt')
																		]),
																	$author$project$Shared$Html$texts(
																		walletStr(m))),
																	lpTxt(lp)
																]);
														}
													}();
													return walletCell1;
												}
											}();
											var borrowAprCell = A2(
												$author$project$Common$Table$cellN,
												A2(
													$elm$core$List$cons,
													goToAsset(m),
													$author$project$Shared$Market$View$c.c6),
												$author$project$Shared$Market$View$borrowAprTextAndIcon(
													$author$project$Shared$Market$Logic$borrowAPR(m)));
											return A2(
												$author$project$Common$Table$row,
												A3(
													$author$project$Common$Base$iff,
													A2($elm$core$List$cons, $author$project$Markets$View$c.aP, $author$project$Markets$View$c.R),
													$author$project$Markets$View$c.R,
													m.iB),
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Asset$View$cell,
														_List_fromArray(
															[
																goToAsset(m)
															]),
														A2($author$project$Shared$Market$View$iconWithText, t, m)),
														A2(
														total,
														$author$project$Shared$Market$Logic$marketTotalSupply,
														A2(
															$elm$core$List$cons,
															goToAsset(m),
															$author$project$Shared$Market$View$c.gb)),
														supplyApyCell,
														A2(
														total,
														$author$project$Shared$Market$Logic$lendersDept,
														A2(
															$elm$core$List$cons,
															goToAsset(m),
															$author$project$Shared$Market$View$c.dk)),
														borrowAprCell,
														A2(
														$author$project$Common$Table$cellN,
														A2(
															$elm$core$List$cons,
															goToAsset(m),
															$author$project$Markets$View$c.lh),
														walletCell)
													]));
										};
										var mobileMarket = function (m) {
											var mainRow = m.iB ? A2(
												$author$project$Common$Table$row,
												A2($elm$core$List$cons, $author$project$Markets$View$c.aP, $author$project$Markets$View$c.R),
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Asset$View$cell,
														_List_fromArray(
															[
																goToAsset(m)
															]),
														A2($author$project$Shared$Market$View$iconWithText, t, m))
													])) : A2(
												$author$project$Common$Table$row,
												$author$project$Markets$View$c.R,
												_List_fromArray(
													[
														A2(
														$author$project$Shared$Asset$View$cell,
														_List_fromArray(
															[
																goToAsset(m)
															]),
														$author$project$Shared$Asset$View$iconWithText(m.bh))
													]));
											var detailsRow = function () {
												var total_ = F3(
													function (map, title, attrs) {
														return A4(
															totalMobileRow,
															title,
															m.bh,
															A2(
																$elm$core$List$cons,
																goToAsset(m),
																attrs),
															map(m.f6));
													});
												var marketSupply = A3(
													total_,
													$author$project$Shared$Market$Logic$marketTotalSupply,
													$author$project$Translations$totalSupply(t),
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('supply')
														]));
												var marketDept = A3(
													total_,
													$author$project$Shared$Market$Logic$lendersDept,
													$author$project$Translations$totalDebt(t),
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('borrow')
														]));
												var lpBalance = A2(
													$author$project$Shared$Html$try,
													A2(
														$elm$core$Basics$composeR,
														formatLP(m.bh),
														A2(
															$author$project$Shared$Info$textRow,
															A2(
																$elm$core$List$cons,
																goToAsset(m),
																$author$project$Markets$View$c.lh),
															'vToken balance')),
													A2($author$project$Shared$Wallet$Logic$wallet, m.gO, walletData));
												if (m.iB) {
													return A2(
														$author$project$Common$Table$singleCellRow,
														A2($elm$core$List$cons, $author$project$Markets$View$c.aP, $author$project$Markets$View$c.aO),
														A2(
															$author$project$Shared$Info$view,
															_List_Nil,
															_List_fromArray(
																[marketSupply, marketDept, lpBalance])));
												} else {
													var supplyApy = A3(
														$author$project$Shared$Info$textRow,
														A2(
															$elm$core$List$cons,
															goToAsset(m),
															$author$project$Shared$Market$View$c.c6),
														$author$project$Translations$supplyAPY(t),
														A2(
															$author$project$Translations$upTo,
															t,
															$author$project$Shared$Text$formatAPR(
																A3(
																	$author$project$Shared$Vires$Logic$maxSupplyAprForecast,
																	vires,
																	fixedRates(rates),
																	m) + $author$project$Shared$Market$Logic$totalSupplyAPY(m))));
													var borrowApr = A3(
														$author$project$Shared$Info$textRow,
														A2(
															$elm$core$List$cons,
															goToAsset(m),
															$author$project$Shared$Market$View$c.c6),
														$author$project$Translations$borrowAPR(t),
														$author$project$Shared$Text$formatPercentOrDash(
															$author$project$Shared$Market$Logic$borrowAPR(m)));
													return A2(
														$author$project$Common$Table$singleCellRow,
														$author$project$Markets$View$c.aO,
														A2(
															$author$project$Shared$Info$view,
															_List_Nil,
															_List_fromArray(
																[
																	marketSupply,
																	marketDept,
																	supplyApy,
																	borrowApr,
																	A3(
																	$author$project$Shared$Info$textRow,
																	A2(
																		$elm$core$List$cons,
																		goToAsset(m),
																		$author$project$Markets$View$c.lh),
																	$author$project$Translations$walletBalance(t),
																	walletStr(m)),
																	lpBalance
																])));
												}
											}();
											return _List_fromArray(
												[mainRow, detailsRow]);
										};
										var tableContent = function () {
											if ($author$project$Common$Screen$isMobile(screen)) {
												var mobileHead = $author$project$Common$Table$head(
													_List_fromArray(
														[
															$author$project$Shared$Market$View$header.bh(t),
															$author$project$Shared$Market$View$header.ae(t)
														]));
												return _List_fromArray(
													[
														mobileHead,
														$author$project$Common$Table$body(
														_Utils_ap(
															viresRowMobile(0),
															A2($elm$core$List$concatMap, mobileMarket, filteredMarkets)))
													]);
											} else {
												var desktopHead = $author$project$Common$Table$head(
													_List_fromArray(
														[
															$author$project$Shared$Market$View$header.bh(t),
															$author$project$Shared$Market$View$header.kP(t),
															$author$project$Shared$Market$View$header.kr(t),
															$author$project$Shared$Market$View$header.kM(t),
															$author$project$Shared$Market$View$header.g9(t),
															A3(
															$author$project$Common$Table$headerWithTooltip,
															$author$project$Translations$walletBalanceTooltip(t),
															$author$project$Markets$View$c.lh,
															$author$project$Translations$walletBalance(t))
														]));
												return _List_fromArray(
													[
														desktopHead,
														$author$project$Common$Table$body(
														A2(
															$elm$core$List$cons,
															viresRowDesktop(0),
															A2($elm$core$List$map, desktopMarket, filteredMarkets)))
													]);
											}
										}();
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Common$Table$view, $author$project$Shared$Market$View$c.eY, tableContent),
													deprecated
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$My$Vires$OpenClaim = 0;
var $author$project$My$Vires$c = {
	cV: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('account-status')
		]),
	de: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('main')
		]),
	dM: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('daily')
		]),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title')
		]),
	gA: $elm$html$Html$Attributes$class('value')
};
var $author$project$My$Vires$bigNumber = $elm$html$Html$span($author$project$My$Vires$c.de);
var $author$project$Shared$Layout$columns = F2(
	function (attrs, cols) {
		return $elm$core$List$isEmpty(cols) ? $author$project$Shared$Html$nothing : A2(
			$elm$html$Html$div,
			A2($elm$core$List$cons, $author$project$Shared$Layout$c.bp, attrs),
			cols);
	});
var $author$project$Shared$Text$formatCurrency2 = F2(
	function (currency, amount) {
		return _Utils_ap(
			A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Shared$Text$locale.bd, amount),
			_Utils_ap($author$project$Shared$Text$nbsp, currency));
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$infoCircle = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'info-circle',
	512,
	512,
	_List_fromArray(
		['M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z']));
var $author$project$Common$Tooltip$info = function (tooltip_) {
	return A2(
		$elm$html$Html$span,
		A2($author$project$Common$Tooltip$tooltip, _List_Nil, tooltip_),
		$elm$core$List$singleton(
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$infoCircle)));
};
var $author$project$Shared$Text$maybeEllipsis = $elm$core$Maybe$withDefault($author$project$Shared$Text$ellipsisSign);
var $author$project$My$Vires$title = $elm$html$Html$h5($author$project$My$Vires$c.kB);
var $author$project$AccountStatus$Logic$totalRewards = F3(
	function (vires, rewards, ebRewards) {
		var _v0 = _Utils_Tuple2(
			$elm$core$Dict$isEmpty(rewards),
			ebRewards);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return 0;
		} else {
			var regular = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						function ($) {
							return $.c8;
						}),
					$elm$core$Dict$toList(rewards)));
			var eb = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.c8;
					},
					ebRewards));
			return A2($author$project$Shared$Market$Logic$inOrig, vires, regular + eb);
		}
	});
var $author$project$My$Vires$view = F7(
	function (t, fixedRates, vires, governance, rewards, markets, user) {
		var totalRewards = A3($author$project$AccountStatus$Logic$totalRewards, vires, rewards, user.hN);
		var information = function () {
			var rewardsRow = function () {
				var col = F4(
					function (attrs, label, tooltip, value) {
						return A2(
							$author$project$Shared$Layout$column,
							_List_Nil,
							$elm$core$List$singleton(
								A2(
									$elm$html$Html$a,
									A2($elm$core$List$cons, $author$project$My$Vires$c.gA, attrs),
									A2(
										$elm$core$List$cons,
										$author$project$My$Vires$title(
											_List_fromArray(
												[
													$elm$html$Html$text(label),
													$elm$html$Html$text($author$project$Shared$Text$nbsp),
													$author$project$Common$Tooltip$info(tooltip)
												])),
										value))));
					});
				var governanceRewards = A4(
					col,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/governance/my')
						]),
					'Governance Rewards',
					'Staking VIRES in governance grants a share of the rewards stream from every market',
					$elm$core$List$singleton(
						$author$project$My$Vires$bigNumber(
							$author$project$Shared$Html$texts('Details →'))));
				var supplyRewards = A4(
					col,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(0)
						]),
					'Supply Rewards',
					'Providing liquidity grants VIRES rewards',
					$elm$core$List$singleton(
						$author$project$My$Vires$bigNumber(
							$author$project$Shared$Html$texts(
								A3($author$project$Shared$Text$formatCurrencyKn, 4, $author$project$Shared$Vires$View$viresSign, totalRewards)))));
				return _List_fromArray(
					[supplyRewards, governanceRewards]);
			}();
			var netApy = function () {
				var viresApr = A2(
					$elm$core$Maybe$map,
					A3($author$project$Governance$Shared$Logic$governanceApr, fixedRates, markets, vires),
					governance);
				return A2(
					$author$project$Shared$Layout$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$My$Vires$title(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$governanceAPR(t))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$My$Vires$c.gA]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$Shared$Html$texts(
										$author$project$Shared$Text$maybeEllipsis(
											A2($elm$core$Maybe$map, $author$project$Shared$Text$formatAPR, viresApr))))
								]))
						]));
			}();
			var linkCol = F3(
				function (attrs, label, value) {
					return A2(
						$author$project$Shared$Layout$column,
						_List_Nil,
						$elm$core$List$singleton(
							A2(
								$elm$html$Html$a,
								A2($elm$core$List$cons, $author$project$My$Vires$c.gA, attrs),
								A2(
									$elm$core$List$cons,
									$author$project$My$Vires$title(
										$author$project$Shared$Html$texts(label)),
									value))));
				});
			var inGovernance = A3(
				linkCol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/governance/my')
					]),
				'In Governance',
				$elm$core$List$singleton(
					$author$project$My$Vires$bigNumber(
						$author$project$Shared$Html$texts(
							$author$project$Shared$Text$maybeEllipsis(
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.f3;
										},
										A2(
											$elm$core$Basics$composeR,
											$author$project$Shared$Market$Logic$inOrig(vires),
											$author$project$Shared$Text$formatCurrency2($author$project$Shared$Vires$View$viresSign))),
									user.ic))))));
			var col_ = F2(
				function (label, value) {
					return A2(
						$author$project$Shared$Layout$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$My$Vires$title(label),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[$author$project$My$Vires$c.gA]),
								_List_fromArray(
									[
										$elm$html$Html$text(value)
									]))
							]));
				});
			var column = A2(
				$elm$core$Basics$composeR,
				$elm$html$Html$text,
				A2($elm$core$Basics$composeR, $elm$core$List$singleton, col_));
			return A2(
				$elm$core$List$map,
				$author$project$Shared$Layout$columns(_List_Nil),
				_List_fromArray(
					[
						_List_fromArray(
						[inGovernance, netApy]),
						rewardsRow
					]));
		}();
		return A2(
			$author$project$Common$Card$view,
			$author$project$My$Vires$c.cV,
			_List_fromArray(
				[
					$author$project$Common$Card$textTitle('My Vires'),
					$author$project$Common$Card$content(information)
				]));
	});
var $author$project$MyBorrow$Msg$OpenRepay = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Table$c = {
	hk: $elm$html$Html$Attributes$class('clickable')
};
var $author$project$MyBorrow$View$c = {
	c6: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('apy')
		]),
	db: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('balance')
		]),
	dk: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('my borrow')
		]),
	dq: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-content')
		]),
	dy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('circle')
		]),
	er: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('health-indicator')
		]),
	fq: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('percent')
		]),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title')
		])
};
var $author$project$Shared$My$View$cell = F3(
	function (rates, asset, amount) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				$author$project$Shared$Table$c.jn,
				$elm$core$List$singleton(
					$elm$html$Html$text(
						A2($author$project$Shared$Asset$Format$asset, asset, amount)))),
				A2(
				$elm$html$Html$div,
				$author$project$Shared$Table$c.kY,
				$elm$core$List$singleton(
					$elm$html$Html$text(
						$author$project$Shared$Text$formatUsd(
							A3($author$project$Shared$Market$Logic$inUsd, rates, asset, amount)))))
			]);
	});
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Translations$toBeRepaid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'toBeRepaid');
};
var $author$project$Translations$toBeRepaidTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'toBeRepaidTooltip');
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$MyBorrow$Health$backgroundCircle = A2(
	$elm$svg$Svg$circle,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('circle-container__background'),
			$elm$svg$Svg$Attributes$cx('16'),
			$elm$svg$Svg$Attributes$cy('16'),
			$elm$svg$Svg$Attributes$r('16')
		]),
	_List_Nil);
var $author$project$MyBorrow$Health$outerCircleAttrs = _List_fromArray(
	[
		$elm$svg$Svg$Attributes$class('circle-container__progress'),
		$elm$svg$Svg$Attributes$cx('16'),
		$elm$svg$Svg$Attributes$cy('16'),
		$elm$svg$Svg$Attributes$r('16')
	]);
var $author$project$MyBorrow$Health$view = function (health) {
	var offset = 'stroke-dashoffset: ' + $elm$core$String$fromFloat(100 - (health * 100));
	var color = $elm$svg$Svg$Attributes$class(
		(health > 0.3) ? 'green' : ((health > 0.1) ? 'yellow' : 'red'));
	var attrs = A3(
		$author$project$Common$Base$iff,
		$author$project$MyBorrow$Health$outerCircleAttrs,
		A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$attribute, 'style', offset),
			$author$project$MyBorrow$Health$outerCircleAttrs),
		health <= 0);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('circle-container'),
				$elm$svg$Svg$Attributes$viewBox('2 -2 28 36')
			]),
		_List_fromArray(
			[
				$author$project$MyBorrow$Health$backgroundCircle,
				A2(
				$elm$svg$Svg$circle,
				A2($elm$core$List$cons, color, attrs),
				_List_Nil)
			]));
};
var $author$project$MyBorrow$View$view = F7(
	function (t, overlapFactor, rates, markets, now, lastUpdated, userData) {
		var row = function (m) {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.dk;
				},
				A2($author$project$Shared$User$Logic$ofMarket, m, userData));
			if (!_v0.$) {
				var amount = _v0.a;
				var apr = $author$project$Shared$Market$Logic$borrowAPR(m);
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Common$Table$row,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MyBorrow$Msg$OpenRepay(m)),
								$author$project$Common$Table$c.hk,
								$elm$html$Html$Attributes$class(
								A3($author$project$Common$Base$iff, 'deprecated', '', m.iB))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Shared$Asset$View$cell,
								_List_Nil,
								A2($author$project$Shared$Market$View$iconWithText, t, m)),
								A2(
								$author$project$Common$Table$cellN,
								$author$project$MyBorrow$View$c.c6,
								$author$project$Shared$Market$View$borrowAprTextAndIcon(apr)),
								A2(
								$author$project$Common$Table$cellN,
								$author$project$MyBorrow$View$c.db,
								A3($author$project$Shared$My$View$cell, rates, m.bh, amount))
							])));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var rows = A2($elm$core$List$filterMap, row, markets);
		var health = $author$project$Shared$Borrow$Logic$health(
			A4($author$project$Shared$Borrow$Logic$risk, overlapFactor, rates, markets, userData));
		var healthText = (health < 0) ? '<0%' : $author$project$Shared$Text$formatPercentOrDash(health);
		var healthWarning = (health < 0) ? A2(
			$author$project$Shared$Html$textSpan,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('liquidation-warning')
				]),
			'Account falls under liquidation') : $author$project$Shared$Html$nothing;
		var healthTitle = A2(
			$elm$html$Html$p,
			$author$project$MyBorrow$View$c.kB,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Home$accountHealth(t)),
					$elm$html$Html$text($author$project$Shared$Text$nbsp),
					$author$project$Common$Tooltip$info(
					$author$project$Translations$Home$accountHealthTooltip(t)),
					healthWarning
				]));
		return A2(
			$elm$html$Html$div,
			$author$project$MyBorrow$View$c.dq,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Table$view,
					$author$project$MyBorrow$View$c.dk,
					_List_fromArray(
						[
							$author$project$Common$Table$head(
							_List_fromArray(
								[
									$author$project$Shared$Market$View$header.bh(t),
									$author$project$Shared$Market$View$header.g9(t),
									A3(
									$author$project$Common$Table$headerWithTooltip,
									$author$project$Translations$toBeRepaidTooltip(t),
									$author$project$MyBorrow$View$c.db,
									$author$project$Translations$toBeRepaid(t))
								])),
							$author$project$Common$Table$body(rows)
						])),
					A2(
					$elm$html$Html$div,
					$author$project$MyBorrow$View$c.er,
					_List_fromArray(
						[
							healthTitle,
							A2(
							$elm$html$Html$div,
							$author$project$MyBorrow$View$c.dy,
							_List_fromArray(
								[
									A2($elm$html$Html$Lazy$lazy, $author$project$MyBorrow$Health$view, health),
									A2(
									$elm$html$Html$div,
									$author$project$MyBorrow$View$c.fq,
									$author$project$Shared$Html$texts(healthText))
								]))
						]))
				]));
	});
var $author$project$MySupply$Msg$GotoMarkets = {$: 2};
var $author$project$MySupply$Msg$OpenChangeCollateral = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$MySupply$Msg$OpenConvert = {$: 4};
var $author$project$MySupply$Msg$OpenWithdraw = function (a) {
	return {$: 0, a: a};
};
var $author$project$MySupply$View$deprecated = 'deprecated';
var $author$project$MySupply$View$c = {
	c6: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('apy')
		]),
	bh: _List_fromArray(
		[$author$project$Shared$Asset$View$c.bh]),
	r: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('collateral')
		]),
	hy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('daily-income')
		]),
	aP: _List_fromArray(
		[
			$elm$html$Html$Attributes$class($author$project$MySupply$View$deprecated)
		]),
	e7: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('my supply')
		]),
	ae: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('operations')
		]),
	M: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('supplied')
		]),
	cT: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('yes-no')
		])
};
var $author$project$Translations$Home$MySupply$collateral = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.collateral');
};
var $author$project$Translations$Home$MySupply$collateralTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.collateralTooltip');
};
var $author$project$Home$Shared$isProhibitedSupply = function (m) {
	return m.jx;
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$arrowDown = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'arrow-down',
	448,
	512,
	_List_fromArray(
		['M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z']));
var $author$project$Translations$Home$goToAllMarkets = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.goToAllMarkets');
};
var $author$project$Shared$My$View$placeholder = F4(
	function (t, scroll, message, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('place-holder')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title')
						]),
					$elm$core$List$singleton(
						$elm$html$Html$text(title))),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message')
						]),
					$elm$core$List$singleton(
						$elm$html$Html$text(message))),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('go-to')
						]),
					$elm$core$List$singleton(
						A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(scroll)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$arrowDown),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									$elm$core$List$singleton(
										$elm$html$Html$text(
											$author$project$Translations$Home$goToAllMarkets(t))))
								]))))
				]));
	});
var $author$project$Translations$Home$MySupply$placeholderMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.placeholderMessage');
};
var $author$project$Translations$Home$MySupply$placeholderTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.placeholderTitle');
};
var $author$project$Translations$Home$MySupply$suppliedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.mySupply.suppliedTooltip');
};
var $author$project$Translations$Home$Supply$supply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.supply.supply');
};
var $author$project$Translations$Home$Unlock$unlock = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.unlock.unlock');
};
var $author$project$MySupply$View$view = function (t) {
	return function (screen) {
		return function (vires) {
			return function (assets) {
				return function (rates) {
					return function (newRates) {
						return function (markets) {
							return function (gov) {
								return function (user) {
									return function (now) {
										return function (lastUpdated) {
											return function (userData) {
												return function (height) {
													var market = F2(
														function (m, ud) {
															var _v0 = ud.gb;
															if (!_v0.$) {
																var supply = _v0.a;
																var withdrawOnClick = $elm$html$Html$Events$onClick(
																	$author$project$MySupply$Msg$OpenWithdraw(m));
																var supplyAmount = A2($author$project$Shared$User$Logic$userTotalSupply, m.f6, supply);
																var lockBlocks = $elm$core$Maybe$Nothing;
																var clickableCell = function (attrs) {
																	var click = $elm$html$Html$Events$onClick(
																		$author$project$MySupply$Msg$OpenWithdraw(m));
																	return $author$project$Common$Table$cellN(
																		A2(
																			$elm$core$List$cons,
																			click,
																			A2($elm$core$List$cons, $author$project$Common$Table$c.hk, attrs)));
																};
																var collateralCell = function () {
																	var yesDisabled = function (_v17) {
																		return A2(
																			$author$project$Common$Table$cell,
																			$author$project$MySupply$View$c.r,
																			A2(
																				$author$project$Shared$Html$textSpan,
																				A2(
																					$elm$core$List$cons,
																					$elm$html$Html$Attributes$class('disabled'),
																					$author$project$MySupply$View$c.cT),
																				'Yes'));
																	};
																	var dash = function (_v16) {
																		return A2(
																			clickableCell,
																			$author$project$MySupply$View$c.r,
																			$author$project$Shared$Html$texts('—'));
																	};
																	var _v8 = _Utils_Tuple3(
																		supply,
																		ud.dk,
																		$author$project$Home$Shared$isProhibitedSupply(m));
																	_v8$0:
																	while (true) {
																		if (!_v8.a.$) {
																			if (!_v8.a.c) {
																				if (_v8.b.$ === 1) {
																					if ((!_v8.a.b) && _v8.c) {
																						break _v8$0;
																					} else {
																						var _v10 = _v8.a;
																						var cl = _v10.b;
																						var _v11 = _v10.c;
																						var _v12 = _v8.b;
																						return A2(
																							$author$project$Common$Table$cell,
																							$author$project$MySupply$View$c.r,
																							A2(
																								$author$project$Shared$Html$textSpan,
																								A2(
																									$elm$core$List$cons,
																									$elm$html$Html$Events$onClick(
																										A2($author$project$MySupply$Msg$OpenChangeCollateral, m, !cl)),
																									$author$project$MySupply$View$c.cT),
																								A3($author$project$Common$Base$iff, 'Yes', 'No', cl)));
																					}
																				} else {
																					if ((!_v8.a.b) && _v8.c) {
																						break _v8$0;
																					} else {
																						var _v15 = _v8.a;
																						return yesDisabled(0);
																					}
																				}
																			} else {
																				if ((!_v8.a.b) && _v8.c) {
																					break _v8$0;
																				} else {
																					var _v13 = _v8.a;
																					var _v14 = _v13.c;
																					return yesDisabled(0);
																				}
																			}
																		} else {
																			return dash(0);
																		}
																	}
																	var _v9 = _v8.a;
																	return dash(0);
																}();
																var action = function () {
																	var lockBtn = F2(
																		function (msg, title) {
																			return A2(
																				$author$project$Common$Button$primary,
																				title,
																				msg(m));
																		});
																	var _v1 = _Utils_Tuple2(supply, m.iB);
																	if (!_v1.a.$) {
																		if (!_v1.a.c) {
																			if (!_v1.b) {
																				var _v2 = _v1.a;
																				var _v3 = _v2.c;
																				return A2(
																					lockBtn,
																					$author$project$MySupply$Msg$OpenWithdraw,
																					$author$project$Translations$Home$Withdraw$withdraw(t));
																			} else {
																				var _v4 = _v1.a;
																				var _v5 = _v4.c;
																				return A2(
																					$elm$html$Html$div,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2($author$project$Common$Button$primary, 'Convert', $author$project$MySupply$Msg$OpenConvert),
																							A2($author$project$Common$Button$underButton, _List_Nil, 'to XTN')
																						]));
																			}
																		} else {
																			return A2(
																				$author$project$Common$Button$primary,
																				$author$project$Translations$Home$Supply$supply(t),
																				$author$project$MySupply$Msg$OpenWithdraw(m));
																		}
																	} else {
																		if (!_v1.b) {
																			var _v6 = _v1.a;
																			return A2(lockBtn, $author$project$MySupply$Msg$OpenWithdraw, 'Unlock');
																		} else {
																			var _v7 = _v1.a;
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Common$Button$primary,
																						$author$project$Translations$Home$Unlock$unlock(t),
																						$author$project$MySupply$Msg$OpenWithdraw(m)),
																						A2($author$project$Common$Button$underButton, _List_Nil, 'allows XTN conversion')
																					]));
																		}
																	}
																}();
																return A2(
																	$author$project$Common$Table$row,
																	_List_fromArray(
																		[
																			$author$project$Common$Table$c.hk,
																			$elm$html$Html$Attributes$class(
																			A3(
																				$author$project$Common$Base$iff,
																				'',
																				'locked',
																				_Utils_eq(lockBlocks, $elm$core$Maybe$Nothing))),
																			$elm$html$Html$Attributes$class(
																			A3($author$project$Common$Base$iff, $author$project$MySupply$View$deprecated, '', m.iB))
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Shared$Asset$View$cell,
																			_List_fromArray(
																				[withdrawOnClick]),
																			A2($author$project$Shared$Market$View$iconWithText, t, m)),
																			A2(
																			clickableCell,
																			$author$project$MySupply$View$c.M,
																			A3($author$project$Shared$My$View$cell, rates, m.bh, supplyAmount)),
																			collateralCell,
																			A2($author$project$Common$Table$cell, $author$project$MySupply$View$c.ae, action)
																		]));
															} else {
																return $author$project$Shared$Html$nothing;
															}
														});
													var marketRows = A3($author$project$Shared$User$Logic$mapReserves, userData, market, markets);
													var rows = marketRows;
													var fixedRates = A3($author$project$Shared$NewRate$toNewRates, vires, assets, newRates);
													return $elm$core$List$isEmpty(rows) ? A4(
														$author$project$Shared$My$View$placeholder,
														t,
														$author$project$MySupply$Msg$GotoMarkets,
														$author$project$Translations$Home$MySupply$placeholderMessage(t),
														$author$project$Translations$Home$MySupply$placeholderTitle(t)) : A2(
														$elm$html$Html$div,
														_List_Nil,
														$elm$core$List$singleton(
															A2(
																$author$project$Common$Table$view,
																$author$project$MySupply$View$c.e7,
																_List_fromArray(
																	[
																		$author$project$Common$Table$head(
																		_List_fromArray(
																			[
																				$author$project$Shared$Market$View$header.bh(t),
																				A3(
																				$author$project$Common$Table$headerWithTooltip,
																				$author$project$Translations$Home$MySupply$suppliedTooltip(t),
																				$author$project$MySupply$View$c.M,
																				$author$project$Translations$Home$supplied(t)),
																				A3(
																				$author$project$Common$Table$headerWithTooltip,
																				$author$project$Translations$Home$MySupply$collateralTooltip(t),
																				$author$project$MySupply$View$c.r,
																				$author$project$Translations$Home$MySupply$collateral(t)),
																				A2(
																				$author$project$Common$Table$header,
																				$author$project$MySupply$View$c.ae,
																				$author$project$Translations$operations(t))
																			])),
																		$author$project$Common$Table$body(rows)
																	]))));
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Repay$Msg$Close = {$: 6};
var $author$project$Translations$Home$Repay$repay = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.repay');
};
var $author$project$Repay$Msg$AmountChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Repay$Msg$FeeAssetChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Repay$Msg$Max = function (a) {
	return {$: 1, a: a};
};
var $author$project$Repay$Msg$Repay = function (a) {
	return {$: 3, a: a};
};
var $author$project$Repay$Msg$RepayFromChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Shared$Suppy$Logic$borrowDelta = F4(
	function (op, userData, market, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, market.bh, model.gZ),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.dk;
				},
				A2($author$project$Shared$User$Logic$ofMarket, market, userData)));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var amount = _v0.a.a;
				var borrow = _v0.b.a;
				return _List_fromArray(
					[
						borrow,
						A2(
						$elm$core$Basics$max,
						0,
						A2(op, borrow, amount))
					]);
			} else {
				var amount = _v0.a.a;
				var _v1 = _v0.b;
				return _List_fromArray(
					[
						0,
						A2(
						$elm$core$Basics$max,
						0,
						A2(op, 0, amount))
					]);
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var borrow = _v0.b.a;
				return _List_fromArray(
					[borrow]);
			} else {
				return _List_fromArray(
					[0]);
			}
		}
	});
var $author$project$Translations$Home$borrowed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.borrowed');
};
var $author$project$Shared$Delta$View$borrowed = function (t) {
	return $author$project$Shared$Delta$View$funds(
		$author$project$Translations$Home$borrowed(t));
};
var $author$project$Shared$Suppy$Logic$walletDelta = F4(
	function (op, walletData, asset, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, asset, model.gZ),
			A2($author$project$Shared$Wallet$Logic$wallet, asset.bP, walletData));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var amount = _v0.a.a;
				var balance = _v0.b.a;
				return _List_fromArray(
					[
						balance,
						A2(op, balance, amount)
					]);
			} else {
				var amount = _v0.a.a;
				return _List_fromArray(
					[
						0,
						A2(op, 0, amount)
					]);
			}
		} else {
			if (!_v0.b.$) {
				var balance = _v0.b.a;
				return _List_fromArray(
					[balance]);
			} else {
				return _List_fromArray(
					[0]);
			}
		}
	});
var $author$project$Shared$Market$View$borrowRepayInfos = function (t) {
	return function (op) {
		return function (walletOp) {
			return function (riskDelta) {
				return function (overlapFactor) {
					return function (rates) {
						return function (markets) {
							return function (m) {
								return function (userData) {
									return function (wallets) {
										return function (model) {
											return _List_fromArray(
												[
													A2(
													$author$project$Shared$Delta$View$health,
													t,
													A6(riskDelta, overlapFactor, userData, rates, markets, m, model)),
													A4(
													$author$project$Shared$Info$rowWithTooltip,
													_List_Nil,
													$author$project$Translations$borrowAPR(t),
													$author$project$Translations$borrowAPRTooltip(t),
													$author$project$Shared$Text$formatPercentOrDash(
														$author$project$Shared$Market$Logic$borrowAPR(m))),
													A3(
													$author$project$Shared$Delta$View$borrowed,
													t,
													m.bh,
													A4($author$project$Shared$Suppy$Logic$borrowDelta, op, userData, m, model)),
													A3(
													$author$project$Shared$Delta$View$wallet,
													t,
													m.bh,
													A4($author$project$Shared$Suppy$Logic$walletDelta, walletOp, wallets, m.bh, model))
												]);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Translations$Home$Repay$enterRepayAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.enterRepayAmount');
};
var $author$project$Repay$View$enterRepayAmountPlaceholder = function (t) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$placeholder(
			$author$project$Translations$Home$Repay$enterRepayAmount(t))
		]);
};
var $author$project$Translations$Home$Repay$kindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.kindReminder');
};
var $author$project$Shared$Transaction$Logic$plusDeltaForLatencyCompensation = function (amount) {
	return $elm$core$Basics$round(amount * 1.00009);
};
var $author$project$Repay$Logic$all = $author$project$Shared$Transaction$Logic$plusDeltaForLatencyCompensation;
var $author$project$Repay$Logic$maxOrAllFromCollateral = F3(
	function (state, borrowed, collateral) {
		var collateral_ = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$author$project$Shared$User$Logic$userTotalSupply(state),
				collateral));
		var all_ = $author$project$Repay$Logic$all(borrowed);
		return (_Utils_cmp(all_, collateral_) < 1) ? _Utils_Tuple2(all_, 'All') : _Utils_Tuple2(collateral_, 'Max');
	});
var $author$project$Repay$Logic$maxOrAllFromLP = F2(
	function (borrowed, wallet) {
		return (_Utils_cmp(borrowed, wallet) < 1) ? _Utils_Tuple2(borrowed, 'All') : _Utils_Tuple2(
			A2($elm$core$Basics$max, 0, wallet),
			'Max');
	});
var $author$project$Shared$Transaction$Logic$balanceMinusFee = F4(
	function (feeInWaves, balanceAsset, feeAssetId, balance) {
		return _Utils_eq(feeAssetId, balanceAsset.bP) ? (balance - A2($author$project$Shared$Transaction$Logic$feeInAsset, balanceAsset, feeInWaves)) : balance;
	});
var $author$project$Repay$Logic$maxFromWallet = F4(
	function (n, wallet, balanceAsset, feeAssetId) {
		return A4($author$project$Shared$Transaction$Logic$balanceMinusFee, $author$project$Shared$Transaction$Logic$fee.fT * n, balanceAsset, feeAssetId, wallet);
	});
var $author$project$Repay$Logic$maxOrAllFromWallet = F5(
	function (n, borrowed, wallet, balanceAsset, feeAsset) {
		var fromWallet = A4($author$project$Repay$Logic$maxFromWallet, n, wallet, balanceAsset, feeAsset);
		var all_ = $author$project$Repay$Logic$all(borrowed);
		return (_Utils_cmp(all_, wallet) < 1) ? _Utils_Tuple2(all_, 'All') : _Utils_Tuple2(
			A2($elm$core$Basics$max, 0, fromWallet),
			'Max');
	});
var $author$project$Shared$Market$Logic$isShadow = function (m) {
	return A2($elm$core$String$contains, '_', m.iT);
};
var $author$project$VToken$Shared$Logic$name = function (m) {
	var classic = A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			['VIRES', m.bh.ac, 'LP']));
	return $author$project$Shared$Market$Logic$isShadow(m) ? (classic + '_V2') : classic;
};
var $author$project$Repay$Logic$riskDelta = F8(
	function (price, supplyOp, overlapFactor, userData, rates, markets, market, model) {
		var currentHealth = A4($author$project$Shared$Borrow$Logic$risk, overlapFactor, rates, markets, userData);
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, market.bh, model.gZ),
			A2($author$project$Shared$User$Logic$ofMarket, market, userData));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var repay = _v0.a.a;
			var ud = _v0.b.a;
			var _v1 = ud.dk;
			if (!_v1.$) {
				var borrow = _v1.a;
				return _List_fromArray(
					[
						currentHealth,
						A4(
						$author$project$Shared$Borrow$Logic$risk,
						overlapFactor,
						rates,
						markets,
						A3(
							$elm$core$Dict$insert,
							market.jT,
							_Utils_update(
								ud,
								{
									dk: $elm$core$Maybe$Just(
										A2(
											$elm$core$Basics$max,
											0,
											$elm$core$Basics$round(borrow - (repay * price)))),
									gb: A2(
										$elm$core$Maybe$map,
										supplyOp(repay),
										ud.gb)
								}),
							userData))
					]);
			} else {
				return _List_fromArray(
					[currentHealth]);
			}
		} else {
			return _List_fromArray(
				[currentHealth]);
		}
	});
var $author$project$VToken$Shared$Logic$toVToken = function (m) {
	var a = m.bh;
	return _Utils_update(
		a,
		{
			bP: m.gO,
			ac: $author$project$VToken$Shared$Logic$name(m)
		});
};
var $author$project$Translations$Home$Repay$insufficientCollateral = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.insufficientCollateral');
};
var $author$project$Repay$Validate$checkCollateral = F4(
	function (t, m, collateral, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (!_v0.$) {
			var repay = _v0.a;
			return (_Utils_cmp(
				repay,
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					m.bh,
					A2($author$project$Shared$User$Logic$userTotalSupply, m.f6, collateral))) > 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Home$Repay$insufficientCollateral(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$Home$Repay$noOutstandingDebt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.noOutstandingDebt');
};
var $author$project$Repay$Validate$outstandingDebt = F3(
	function (t, borrowed, _v0) {
		return (!borrowed) ? $elm$core$Maybe$Just(
			$author$project$Translations$Home$Repay$noOutstandingDebt(t)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Repay$Validate$validateWithCollateral = F6(
	function (t, assets, user, m, collateral, borrowed) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
			A2(
				$author$project$Common$Validate$and,
				A3($author$project$Repay$Validate$checkCollateral, t, m, collateral),
				A2(
					$author$project$Common$Validate$and,
					A2($author$project$Shared$Validate$precision, t, m.bh),
					A2(
						$author$project$Common$Validate$and,
						$author$project$Shared$Validate$positiveAmount(t),
						A2($author$project$Repay$Validate$outstandingDebt, t, borrowed)))));
	});
var $author$project$Translations$Home$Repay$exceedBorrowAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.exceedBorrowAmount');
};
var $author$project$Repay$Validate$doesNotExceedBorrowAmountInLP = F4(
	function (t, m, borrowed, model) {
		var _v0 = A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ);
		if (!_v0.$) {
			var repay = _v0.a;
			return (_Utils_cmp(
				repay,
				borrowed / $author$project$VToken$Shared$Logic$price(m.f6)) > 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Home$Repay$exceedBorrowAmount(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Repay$Validate$validateWithLP = F6(
	function (t, assets, user, m, wallet, borrowed) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
			A2(
				$author$project$Common$Validate$and,
				A3($author$project$Shared$Validate$walletBalance, t, m.bh, wallet),
				A2(
					$author$project$Common$Validate$and,
					A3($author$project$Repay$Validate$doesNotExceedBorrowAmountInLP, t, m, borrowed),
					A2(
						$author$project$Common$Validate$and,
						A2($author$project$Shared$Validate$precision, t, m.bh),
						A2(
							$author$project$Common$Validate$and,
							$author$project$Shared$Validate$positiveAmount(t),
							A2($author$project$Repay$Validate$outstandingDebt, t, borrowed))))));
	});
var $author$project$Repay$Validate$checkBalanceAndSponsorFee = F6(
	function (t, assets, wallets, m, balance, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (!_v0.$) {
			var repay = _v0.a;
			return (_Utils_cmp(
				repay,
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					m.bh,
					A4(
						$author$project$Repay$Logic$maxFromWallet,
						1,
						balance,
						m.bh,
						A2(
							$elm$core$Maybe$withDefault,
							m.bh,
							A5($author$project$Shared$Transaction$Logic$feeAsset, assets, wallets, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, model.h1)).bP))) > 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Validation$insufficientWalletBalance(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Repay$Validate$validateWithWallet = F6(
	function (t, assets, user, m, wallet, borrowed) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
			A2(
				$author$project$Common$Validate$and,
				A5($author$project$Repay$Validate$checkBalanceAndSponsorFee, t, assets, user, m, wallet),
				A2(
					$author$project$Common$Validate$and,
					A2($author$project$Shared$Validate$precision, t, m.bh),
					A2(
						$author$project$Common$Validate$and,
						$author$project$Shared$Validate$positiveAmount(t),
						A2($author$project$Repay$Validate$outstandingDebt, t, borrowed)))));
	});
var $author$project$Repay$View$tab = F9(
	function (t, assets, user, overlapFactor, rates, markets, userData, m, model) {
		var userSupply = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.gb;
			},
			A2($author$project$Shared$User$Logic$ofMarket, m, userData));
		var supply = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.gb;
			},
			A2($author$project$Shared$User$Logic$ofMarket, m, userData));
		var source = function () {
			var option = function (v) {
				return $author$project$Common$Select$option(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(v),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(v, model.jR))
						]));
			};
			var fromWallet = $elm$core$Maybe$Just(
				A2(
					option,
					m.bh.bP,
					'wallet • ' + A2(
						$author$project$Shared$Asset$Format$asset,
						m.bh,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($author$project$Shared$Wallet$Logic$wallet, m.bh.bP, user.lh)))));
			var fromSupply = function () {
				if (((!supply.$) && (!supply.a.$)) && (!supply.a.c)) {
					var _v12 = supply.a;
					var s = _v12.a;
					var _v13 = _v12.c;
					return $elm$core$Maybe$Just(
						A2(
							option,
							$author$project$Repay$Logic$fromSupply,
							'supply • ' + A2($author$project$Shared$Asset$Format$asset, m.bh, s)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var fromLP = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Shared$Market$Logic$inOrig(m.bh),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shared$Text$formatCurrency(
							$author$project$VToken$Shared$Logic$name(m)),
						option(m.gO))),
				A2($author$project$Shared$Wallet$Logic$wallet, m.gO, user.lh));
			var _v6 = _List_fromArray(
				[fromWallet, fromSupply, fromLP]);
			if ((((((_v6.b && (!_v6.a.$)) && _v6.b.b) && (_v6.b.a.$ === 1)) && _v6.b.b.b) && (_v6.b.b.a.$ === 1)) && (!_v6.b.b.b.b)) {
				var _v7 = _v6.b;
				var _v8 = _v7.a;
				var _v9 = _v7.b;
				var _v10 = _v9.a;
				return $author$project$Shared$Html$nothing;
			} else {
				var sources = _v6;
				return A3(
					$author$project$Shared$Info$rowN,
					_List_Nil,
					'Repay from',
					$elm$core$List$singleton(
						A2(
							$author$project$Common$Select$inline,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(
									$author$project$Shared$Model$isLoading(model)),
									$elm$html$Html$Events$onInput($author$project$Repay$Msg$RepayFromChanged)
								]),
							$author$project$Common$List$just(sources))));
			}
		}();
		var number = function (err_) {
			return A4(
				$author$project$Shared$Dialog$amount,
				$author$project$Repay$View$enterRepayAmountPlaceholder(t),
				err_,
				$author$project$Repay$Msg$AmountChanged,
				model);
		};
		var msg = A3($author$project$Shared$Dialog$ctaMsg, model, m.bh, $author$project$Repay$Msg$Repay);
		var repay = A2(
			$elm$core$Basics$composeR,
			A3($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model),
			A3(
				$author$project$Common$Dialog$ctaButton,
				msg,
				$author$project$Translations$Home$Repay$repay(t),
				model));
		var infos = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$cons(source),
			A8($author$project$Shared$Info$viewWithFee, t, _List_Nil, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, $author$project$Repay$Msg$FeeAssetChanged, model.h1));
		var information = F3(
			function (borrowOp, walletOp, supplyOp) {
				return $author$project$Shared$Market$View$borrowRepayInfos(t)(borrowOp)(walletOp)(
					A2($author$project$Repay$Logic$riskDelta, 1, supplyOp))(overlapFactor)(rates)(markets)(m)(userData)(user.lh)(model);
			});
		var dialog = F2(
			function (amountInput, info) {
				return A2(
					$author$project$Shared$Dialog$dirtySection,
					model,
					_List_fromArray(
						[
							amountInput,
							infos(info),
							$author$project$Shared$KindReminder$text(
							$author$project$Translations$Home$Repay$kindReminder(t))
						]));
			});
		var borrowed = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.dk;
				},
				A2($author$project$Shared$User$Logic$ofMarket, m, userData)));
		if (_Utils_eq(model.jR, $author$project$Repay$Logic$fromSupply)) {
			if (!supply.$) {
				var s = supply.a;
				var supplyOp = F2(
					function (repayAmount, sup) {
						if (!sup.$) {
							var a = sup.a;
							var cl = sup.b;
							var pr = sup.c;
							return A3($author$project$Shared$User$Model$Supply, a - repayAmount, cl, pr);
						} else {
							return sup;
						}
					});
				var err = A7($author$project$Repay$Validate$validateWithCollateral, t, assets, user, m, s, borrowed, model);
				var amountInput = function () {
					var _v1 = A3($author$project$Repay$Logic$maxOrAllFromCollateral, m.f6, borrowed, userSupply);
					var maximum = _v1.a;
					var maxLabel = _v1.b;
					return A2(
						$author$project$Common$Form$fieldWithAddon,
						_List_Nil,
						_List_fromArray(
							[
								number(err),
								A3(
								$author$project$Common$Button$enabled,
								_List_Nil,
								maxLabel,
								$author$project$Repay$Msg$Max(maximum))
							]));
				}();
				return _Utils_Tuple2(
					A2(
						dialog,
						amountInput,
						A3(information, $elm$core$Basics$sub, $elm$core$Basics$always, supplyOp)),
					repay(err));
			} else {
				return _Utils_Tuple2($author$project$Shared$Html$nothing, $author$project$Shared$Html$nothing);
			}
		} else {
			if (_Utils_eq(model.jR, m.bh.bP)) {
				var tokenBalance = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($author$project$Shared$Wallet$Logic$wallet, m.bh.bP, user.lh));
				var err = A7($author$project$Repay$Validate$validateWithWallet, t, assets, user, m, tokenBalance, borrowed, model);
				var amountInput = function () {
					var _v3 = A5(
						$author$project$Repay$Logic$maxOrAllFromWallet,
						$author$project$Shared$Transaction$Logic$fee.dJ,
						borrowed,
						tokenBalance,
						m.bh,
						A2(
							$elm$core$Maybe$withDefault,
							m.bh,
							A5($author$project$Shared$Transaction$Logic$feeAsset, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.dJ * $author$project$Shared$Transaction$Logic$fee.fT, model.h1)).bP);
					var maximum = _v3.a;
					var maxLabel = _v3.b;
					return A2(
						$author$project$Common$Form$fieldWithAddon,
						_List_Nil,
						_List_fromArray(
							[
								number(err),
								A3(
								$author$project$Common$Button$enabled,
								_List_Nil,
								maxLabel,
								$author$project$Repay$Msg$Max(maximum))
							]));
				}();
				return _Utils_Tuple2(
					A2(
						dialog,
						amountInput,
						A3(
							information,
							$elm$core$Basics$sub,
							$elm$core$Basics$sub,
							$elm$core$Basics$always($elm$core$Basics$identity))),
					repay(err));
			} else {
				var _v4 = A2($author$project$Shared$Wallet$Logic$wallet, m.gO, user.lh);
				if (!_v4.$) {
					var lpBalance = _v4.a;
					var info = function () {
						var vToken = $author$project$VToken$Shared$Logic$toVToken(m);
						var price = $author$project$VToken$Shared$Logic$price(m.f6);
						var borrowOp = F2(
							function (b, vTokens) {
								return $elm$core$Basics$round(b - (vTokens * price));
							});
						return _List_fromArray(
							[
								A2(
								$author$project$Shared$Delta$View$health,
								t,
								A8(
									$author$project$Repay$Logic$riskDelta,
									price,
									$elm$core$Basics$always($elm$core$Basics$identity),
									overlapFactor,
									userData,
									rates,
									markets,
									m,
									model)),
								A4(
								$author$project$Shared$Info$rowWithTooltip,
								_List_Nil,
								$author$project$Translations$borrowAPR(t),
								$author$project$Translations$borrowAPRTooltip(t),
								$author$project$Shared$Text$formatPercentOrDash(
									$author$project$Shared$Market$Logic$borrowAPR(m))),
								A3(
								$author$project$Shared$Delta$View$borrowed,
								t,
								m.bh,
								A4($author$project$Shared$Suppy$Logic$borrowDelta, borrowOp, userData, m, model)),
								A3(
								$author$project$Shared$Delta$View$wallet,
								t,
								vToken,
								A4($author$project$Shared$Suppy$Logic$walletDelta, $elm$core$Basics$sub, user.lh, vToken, model))
							]);
					}();
					var err = A7($author$project$Repay$Validate$validateWithLP, t, assets, user, m, lpBalance, borrowed, model);
					var amountInput = function () {
						var _v5 = A2($author$project$Repay$Logic$maxOrAllFromLP, borrowed, lpBalance);
						var maximum = _v5.a;
						var maxLabel = _v5.b;
						return A2(
							$author$project$Common$Form$fieldWithAddon,
							_List_Nil,
							_List_fromArray(
								[
									number(err),
									A3(
									$author$project$Common$Button$enabled,
									_List_Nil,
									maxLabel,
									$author$project$Repay$Msg$Max(maximum))
								]));
					}();
					return _Utils_Tuple2(
						A2(dialog, amountInput, info),
						repay(err));
				} else {
					return _Utils_Tuple2($author$project$Shared$Html$nothing, $author$project$Shared$Html$nothing);
				}
			}
		}
	});
var $author$project$Repay$View$view = F9(
	function (t, assets, user, overlapFactor, rates, markets, userData, m, model) {
		var header = A2(
			$author$project$Common$Dialog$header,
			$author$project$Repay$Msg$Close,
			_List_fromArray(
				[
					A2($author$project$Shared$Market$View$iconWithText, t, m),
					$elm$html$Html$text($author$project$Shared$Text$nbsp),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					$author$project$Shared$Html$texts(
						$author$project$Translations$Home$Repay$repay(t)))
				]));
		var _v0 = A9($author$project$Repay$View$tab, t, assets, user, overlapFactor, rates, markets, userData, m, model);
		var body = _v0.a;
		var cta = _v0.b;
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Repay$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					_List_fromArray(
						[
							header,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							$elm$core$List$singleton(body)),
							A2(
							$author$project$Shared$Dialog$footer,
							t,
							A3(
								$author$project$Common$Base$iff,
								cta,
								$author$project$Shared$Wallet$View$connect(t),
								$author$project$User$Logic$isLoggedIn(user)))
						]))
				]));
	});
var $author$project$Vires$Msg$Close = {$: 1};
var $author$project$Vires$View$c = {
	be: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('vires')
		])
};
var $author$project$Translations$Home$Vires$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.title');
};
var $author$project$Vires$Claim$Msg$Claim = {$: 0};
var $author$project$Vires$Claim$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Vires$Claim$Msg$SetLock = function (a) {
	return {$: 3, a: a};
};
var $author$project$Vires$Claim$Msg$SetMigrate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Translations$Home$Vires$alreadyClaimed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.alreadyClaimed');
};
var $author$project$Translations$Home$Vires$alreadyClaimedTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.alreadyClaimedTooltip');
};
var $author$project$Translations$Home$Vires$availableTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.availableTooltip');
};
var $author$project$Translations$Home$Vires$claimAndStake = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.claimAndStake');
};
var $author$project$Translations$Home$Vires$claimKindReminder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.claimKindReminder');
};
var $author$project$Translations$earlyBird = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'earlyBird');
};
var $author$project$Translations$Home$Vires$immediatelyStake = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.immediatelyStake');
};
var $author$project$Translations$Home$Vires$immediatelyStakeTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.immediatelyStakeTooltip');
};
var $author$project$Translations$Home$Vires$marketSource = F2(
	function (translations, asset) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.vires.marketSource',
			_List_fromArray(
				[
					_Utils_Tuple2('asset', asset)
				]));
	});
var $author$project$Translations$Home$Vires$nothingToClaim = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.nothingToClaim');
};
var $author$project$Translations$Home$Vires$totalRewards = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.totalRewards');
};
var $author$project$Translations$Home$Vires$totalRewardsTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.totalRewardsTooltip');
};
var $author$project$Translations$Home$Vires$unstakeLegacy = F2(
	function (translations, viresAmount1) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.vires.unstakeLegacy',
			_List_fromArray(
				[
					_Utils_Tuple2('viresAmount1', viresAmount1)
				]));
	});
var $author$project$Translations$Home$Vires$unstakeLegacyTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vires.unstakeLegacyTooltip');
};
var $author$project$Vires$Claim$Validate$source = F4(
	function (t, rewards, ebRewards, _v0) {
		return (A2($author$project$Vires$Claim$Logic$all, ebRewards, rewards) > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Translations$Home$Vires$nothingToClaim(t));
	});
var $author$project$Vires$Claim$Validate$validate = F5(
	function (t, assets, wallets, rewards, ebRewards) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, wallets, $author$project$Shared$Asset$Model$waves),
			A3($author$project$Vires$Claim$Validate$source, t, rewards, ebRewards));
	});
var $author$project$Vires$Claim$View$view = F9(
	function (t, markets, rates, gov, user, rewards, vires, assets, model) {
		var rowWithTooltip = F2(
			function (tooltip, title) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Shared$Vires$View$formatVires(vires),
					A3($author$project$Shared$Info$rowWithTooltip, _List_Nil, tooltip, title));
			});
		var migrate = function (v) {
			var _v2 = model.iI ? _Utils_Tuple2($author$project$Translations$Home$Vires$migrate, $author$project$Translations$Home$Vires$migrateTooltip) : _Utils_Tuple2($author$project$Translations$Home$Vires$unstakeLegacy, $author$project$Translations$Home$Vires$unstakeLegacyTooltip);
			var label = _v2.a;
			var tooltip = _v2.b;
			return A4(
				$author$project$Shared$Info$rowNWithTooltip,
				_List_Nil,
				A2(
					label,
					t,
					A2($author$project$Shared$Asset$Format$asset, vires, v)),
				tooltip(t),
				$elm$core$List$singleton(
					A2($author$project$Common$CheckBox$tumbler, $author$project$Vires$Claim$Msg$SetMigrate, model.iB)));
		};
		var lockInGovernance = A4(
			$author$project$Shared$Info$rowNWithTooltip,
			_List_Nil,
			$author$project$Translations$Home$Vires$immediatelyStake(t),
			$author$project$Translations$Home$Vires$immediatelyStakeTooltip(t),
			$elm$core$List$singleton(
				A2($author$project$Common$CheckBox$tumbler, $author$project$Vires$Claim$Msg$SetLock, model.iI)));
		var legacyStaked = A2(
			$elm$core$Maybe$andThen,
			$author$project$Shared$Asset$Logic$ignoreDust,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f3;
				},
				user.hN));
		var fromMarket = function (map) {
			return $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					map,
					$elm$core$Dict$values(rewards)));
		};
		var ebRewards = user.hN;
		var err = A4(
			$author$project$Shared$Validate$loggedInAndNotLoading,
			t,
			user,
			model,
			A6($author$project$Vires$Claim$Validate$validate, t, assets, user, rewards, ebRewards, model));
		var sources = function () {
			var source = F2(
				function (title, amount) {
					var a = A2($author$project$Shared$Vires$View$formatVires, vires, amount);
					if (title === '') {
						return A2(
							$elm$html$Html$option,
							_List_Nil,
							$author$project$Shared$Html$texts(a));
					} else {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[$author$project$Common$Attributes$disabled]),
							$author$project$Shared$Html$texts(title + (': ' + a)));
					}
				});
			var ebOption = function () {
				if (!ebRewards.$) {
					var e = ebRewards.a;
					return (!e.c8) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							source,
							$author$project$Translations$earlyBird(t),
							e.c8));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var assetsAvailable = function () {
				var available = A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function (m) {
							return A2($elm$core$Dict$get, m.jT, rewards);
						}),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$List$just,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.c8;
								}),
							$elm$core$List$sum)));
				return A2(
					$elm$core$Dict$map,
					$elm$core$Basics$always(available),
					A2(
						$elm_community$dict_extra$Dict$Extra$groupBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bh;
							},
							function ($) {
								return $.bP;
							}),
						markets));
			}();
			var asset = function (a) {
				return A2(
					$elm$core$Maybe$map,
					source(
						A2($author$project$Translations$Home$Vires$marketSource, t, a.ac)),
					A2($elm$core$Dict$get, a.bP, assetsAvailable));
			};
			var allOption = $elm$core$Maybe$Just(
				(A2($author$project$Vires$Claim$Logic$all, ebRewards, rewards) > 0) ? A2(
					source,
					'',
					A2($author$project$Vires$Claim$Logic$all, ebRewards, rewards)) : A2(
					$elm$html$Html$option,
					_List_Nil,
					$author$project$Shared$Html$texts(
						$author$project$Translations$Home$Vires$nothingToClaim(t))));
			return A2(
				$author$project$Common$Select$inline,
				_List_Nil,
				$author$project$Common$List$just(
					_Utils_ap(
						_List_fromArray(
							[allOption, ebOption]),
						A2($elm$core$List$map, asset, assets))));
		}();
		var eb = function (map) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, map, ebRewards));
		};
		var claim = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A4(
			$author$project$Common$Dialog$ctaButton,
			$elm$core$Maybe$Just($author$project$Vires$Claim$Msg$Claim),
			A3($author$project$Common$Base$iff, $author$project$Translations$Home$Vires$claimAndStake, $author$project$Translations$Home$Vires$claim, model.iI)(t),
			model,
			err);
		var apr = $author$project$Shared$Text$formatPercent(
			A4($author$project$Governance$Shared$Logic$governanceApr, rates, markets, vires, gov));
		var info = A9(
			$author$project$Shared$Info$viewWithFee,
			t,
			_List_Nil,
			assets,
			user,
			$author$project$Shared$Asset$Model$waves,
			$author$project$Shared$Transaction$Logic$fee.fT,
			$author$project$Vires$Claim$Msg$FeeAssetChanged,
			model.h1,
			_List_fromArray(
				[
					A3(
					rowWithTooltip,
					$author$project$Translations$Home$Vires$totalRewards(t),
					$author$project$Translations$Home$Vires$totalRewardsTooltip(t),
					fromMarket(
						function ($) {
							return $.gS;
						}) + eb(
						function ($) {
							return $.k6;
						})),
					A3(
					rowWithTooltip,
					$author$project$Translations$Home$Vires$alreadyClaimed(t),
					$author$project$Translations$Home$Vires$alreadyClaimedTooltip(t),
					fromMarket(
						function ($) {
							return $.bm;
						}) + eb(
						function ($) {
							return $.bm;
						})),
					A4(
					$author$project$Shared$Info$rowNWithTooltip,
					_List_Nil,
					$author$project$Translations$Home$available(t),
					$author$project$Translations$Home$Vires$availableTooltip(t),
					$elm$core$List$singleton(sources)),
					A3($author$project$Governance$Shared$Info$governanceApr, t, assets, apr),
					lockInGovernance,
					A2($author$project$Shared$Html$try, migrate, legacyStaked)
				]));
		return _Utils_Tuple2(
			_List_fromArray(
				[
					info,
					$author$project$Shared$KindReminder$text(
					$author$project$Translations$Home$Vires$claimKindReminder(t))
				]),
			claim);
	});
var $author$project$Vires$View$view = F9(
	function (t, markets, rates, user, rewards, vires, assets, model, gov) {
		var _v0 = function () {
			var _v1 = A9($author$project$Vires$Claim$View$view, t, markets, rates, gov, user, rewards, vires, assets, model.hh);
			var t_ = _v1.a;
			var b = _v1.b;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Vires$Msg$Claim),
					t_),
				A2($elm$html$Html$map, $author$project$Vires$Msg$Claim, b));
		}();
		var tabContent = _v0.a;
		var cta = _v0.b;
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$Vires$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$Vires$View$c.be,
					_List_fromArray(
						[
							A3(
							$author$project$Governance$Shared$View$headerWithVires,
							vires,
							$author$project$Vires$Msg$Close,
							$elm$html$Html$text(
								$author$project$Translations$Home$Vires$title(t))),
							A2($elm$html$Html$div, _List_Nil, tabContent),
							A2($author$project$Shared$Dialog$footer, t, cta)
						]))
				]));
	});
var $author$project$Withdraw$Msg$Close = {$: 5};
var $author$project$Withdraw$Msg$FeeAssetChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Withdraw$Msg$Unlock = {$: 6};
var $author$project$Withdraw$Unlock$actionTitle = 'Unlock';
var $author$project$Translations$valueInUnit = F3(
	function (translations, value, unit) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'valueInUnit',
			_List_fromArray(
				[
					_Utils_Tuple2('value', value),
					_Utils_Tuple2('unit', unit)
				]));
	});
var $author$project$Shared$Asset$View$inUnit = F2(
	function (t, unit) {
		return A2(
			$Gizra$elm_compat_019$Basics018$flip,
			$author$project$Translations$valueInUnit(t),
			unit);
	});
var $author$project$Shared$Delta$View$apy = F2(
	function (t, unit) {
		return A2(
			$author$project$Shared$Delta$View$view,
			$author$project$Shared$Text$formatPercent,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Shared$Text$formatPercent,
				A2($author$project$Shared$Asset$View$inUnit, t, unit)));
	});
var $author$project$Shared$Delta$View$supplied = function (t) {
	return $author$project$Shared$Delta$View$funds(
		$author$project$Translations$Home$supplied(t));
};
var $author$project$Shared$Suppy$Info$supplyAPY = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$supplyAPY(t),
		$author$project$Translations$totalAPYTooltip(t));
};
var $ryannhg$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$Common$Format$date = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthNumber,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nonBreakingHyphen),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nonBreakingHyphen),
			$ryannhg$date_format$DateFormat$yearNumber
		]));
var $author$project$Shared$Blockchain$Format$blockDate = F2(
	function (hh, timeZone) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Shared$Blockchain$Logic$date(hh),
			A2(
				$elm$core$Basics$composeR,
				$elm$time$Time$millisToPosix,
				$author$project$Common$Format$date(timeZone)));
	});
var $author$project$Shared$Unlock$Info$unlock = A3($author$project$Shared$Info$rowNWithTooltip, _List_Nil, 'Unlock', 'You can withdraw after this date');
var $author$project$Shared$Unlock$Delta$unlock = F3(
	function (hh, timeZone, blocks) {
		var format = A2($author$project$Shared$Blockchain$Format$blockDate, hh, timeZone);
		return $elm$core$List$isEmpty(blocks) ? $author$project$Shared$Html$nothing : $author$project$Shared$Unlock$Info$unlock(
			A3($author$project$Shared$Delta$View$view, format, format, blocks));
	});
var $author$project$Translations$Market$viresRewardsForSupplyAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.viresRewardsForSupplyAPR');
};
var $author$project$Shared$Vires$Info$viresAPR = function (t) {
	return A3(
		$author$project$Shared$Info$rowNWithTooltip,
		_List_Nil,
		$author$project$Translations$Market$viresRewardsForSupplyAPR(t),
		$author$project$Translations$viresAPR(t));
};
var $author$project$Withdraw$Unlock$tab = function (t) {
	return function (assets) {
		return function (vires) {
			return function (fixedRates) {
				return function (timeZone) {
					return function (hh) {
						return function (h) {
							return function (m) {
								return function (user) {
									return function (supply) {
										return function (model) {
											var validateAction = A2(
												$author$project$Common$Validate$and,
												A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
												$author$project$Shared$Validate$notProcessingTransaction(t));
											var _v0 = function () {
												if (supply.$ === 1) {
													var _v2 = _Utils_Tuple2(
														A3($author$project$Shared$Vires$Logic$nonLockedSupplyApr, vires, fixedRates, m),
														$elm$core$Maybe$Nothing);
													var targetSupplyAPR = _v2.a;
													var newUnlock = _v2.b;
													return _Utils_Tuple3(
														_List_fromArray(
															[newUnlock]),
														_List_fromArray(
															[0, targetSupplyAPR]),
														validateAction);
												} else {
													return _Utils_Tuple3(
														_List_Nil,
														_List_Nil,
														$elm$core$Basics$always($elm$core$Maybe$Nothing));
												}
											}();
											var unlockDates = _v0.a;
											var currentViresApr = _v0.b;
											var validate = _v0.c;
											var info = function () {
												var unlockInfo = m.iB ? $author$project$Shared$Html$nothing : A3(
													$author$project$Shared$Unlock$Delta$unlock,
													hh,
													timeZone,
													$author$project$Common$List$just(unlockDates));
												var supplied = _List_fromArray(
													[
														A2($author$project$Shared$User$Logic$userTotalSupply, m.f6, supply)
													]);
												return A2(
													$author$project$Shared$Info$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Shared$Suppy$Info$supplyAPY,
															t,
															A3(
																$author$project$Shared$Delta$View$apy,
																t,
																m.bh.ac,
																$elm$core$List$singleton(
																	$author$project$Shared$Market$Logic$totalSupplyAPY(m)))),
															A2(
															$author$project$Shared$Vires$Info$viresAPR,
															t,
															A3($author$project$Shared$Delta$View$apy, t, $author$project$Shared$Vires$View$viresSign, currentViresApr)),
															A3($author$project$Shared$Delta$View$supplied, t, m.bh, supplied),
															unlockInfo,
															A7($author$project$Shared$Info$feeRow, t, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, $author$project$Withdraw$Msg$FeeAssetChanged, model.h1)
														]));
											}();
											var cta = function () {
												var _v3 = validate(model);
												if (!_v3.$) {
													var err = _v3.a;
													return A2($author$project$Common$Button$disabledCta, _List_Nil, err);
												} else {
													return A2($author$project$Common$Button$primary, $author$project$Withdraw$Unlock$actionTitle, $author$project$Withdraw$Msg$Unlock);
												}
											}();
											return _Utils_Tuple2(info, cta);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Withdraw$Unlock$view = function (t) {
	return function (assets) {
		return function (vires) {
			return function (fixedRates) {
				return function (timeZone) {
					return function (hh) {
						return function (h) {
							return function (m) {
								return function (user) {
									return function (supply) {
										return function (model) {
											var header = A2(
												$author$project$Common$Dialog$header,
												$author$project$Withdraw$Msg$Close,
												_List_fromArray(
													[
														A2($author$project$Shared$Market$View$iconWithText, t, m),
														$elm$html$Html$text($author$project$Shared$Text$nbsp),
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														$author$project$Shared$Html$texts(
															$author$project$Translations$Home$Unlock$unlock(t)))
													]));
											var _v0 = $author$project$Withdraw$Unlock$tab(t)(assets)(vires)(fixedRates)(timeZone)(hh)(h)(m)(user)(supply)(model);
											var body = _v0.a;
											var cta = _v0.b;
											return $author$project$Common$Dialog$view(
												_List_fromArray(
													[
														$author$project$Common$Dialog$background($author$project$Withdraw$Msg$Close),
														A2(
														$author$project$Common$Dialog$body,
														_List_Nil,
														_List_fromArray(
															[
																header,
																A2(
																$elm$html$Html$div,
																_List_Nil,
																$elm$core$List$singleton(body)),
																A2(
																$author$project$Shared$Dialog$footer,
																t,
																A3(
																	$author$project$Common$Base$iff,
																	cta,
																	$author$project$Shared$Wallet$View$connect(t),
																	$author$project$User$Logic$isLoggedIn(user)))
															]))
													]));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Withdraw$Msg$AmountChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Withdraw$Msg$ConvertToUSDN = {$: 7};
var $author$project$Withdraw$Msg$SetAmount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Withdraw$Msg$Withdraw = function (a) {
	return {$: 2, a: a};
};
var $author$project$Withdraw$Logic$all = F2(
	function (state, supply) {
		return $author$project$Shared$Transaction$Logic$plusDeltaForLatencyCompensation(
			A2($author$project$Shared$User$Logic$userTotalSupply, state, supply));
	});
var $author$project$Translations$all = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'all');
};
var $author$project$Withdraw$View$allBtn = F2(
	function (t, amount) {
		return A2(
			$author$project$Common$Button$text,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Withdraw$Msg$SetAmount(amount))
				]),
			$author$project$Translations$all(t));
	});
var $author$project$Translations$Home$Withdraw$enterWithdrawalAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.withdraw.enterWithdrawalAmount');
};
var $author$project$Withdraw$View$enterWithdrawalAmount = function (t) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$placeholder(
			$author$project$Translations$Home$Withdraw$enterWithdrawalAmount(t))
		]);
};
var $author$project$Translations$Home$Withdraw$insufficientLiquidityMD = F2(
	function (translations, percent) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'home.withdraw.insufficientLiquidityMD',
			_List_fromArray(
				[
					_Utils_Tuple2('percent', percent)
				]));
	});
var $author$project$Common$Format$shortDateTimeWithoutYear = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthNumber,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nbsp),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text($author$project$Shared$Text$nbsp),
			$ryannhg$date_format$DateFormat$hourMilitaryFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed
		]));
var $author$project$Shared$Market$Info$limit = F6(
	function (limitTimeframe, timeZone, hh, height, asset, userAvailable) {
		var limitResetDate = function () {
			var _v0 = _Utils_Tuple2(limitTimeframe, height);
			if (!_v0.a.$) {
				var timeFrame = _v0.a.a;
				var h = _v0.b;
				return A2(
					$author$project$Common$Format$shortDateTimeWithoutYear,
					timeZone,
					$elm$time$Time$millisToPosix(
						A2($author$project$Shared$Blockchain$Logic$date, hh, (h + timeFrame) - (h % timeFrame))));
			} else {
				return $author$project$Shared$Text$ellipsisSign;
			}
		}();
		return A3(
			$author$project$Shared$Info$textRow,
			_List_Nil,
			'Limit until ' + limitResetDate,
			A2($author$project$Shared$Asset$Format$asset, asset, userAvailable));
	});
var $author$project$Translations$Home$marketAvailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.marketAvailable');
};
var $author$project$Withdraw$View$maxAvailableBtn = F2(
	function (t, amount) {
		return A2(
			$author$project$Common$Button$text,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Withdraw$Msg$SetAmount(amount))
				]),
			$author$project$Translations$Home$maxAvailable(t));
	});
var $author$project$Shared$Market$Logic$maxAvailableForWithdraw = function (s) {
	return A2($elm$core$Basics$max, 0, s.gb - s.dk);
};
var $author$project$Translations$Home$maxSafe = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.maxSafe');
};
var $author$project$Shared$Borrow$Logic$maxSafeBPUtilizationPercent = 0.8;
var $author$project$Shared$User$Logic$isCollateral = function (s) {
	if ((!s.$) && s.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Withdraw$Logic$afterWithdraw = F3(
	function (wd, m, userData) {
		var _v0 = A2($author$project$Shared$User$Logic$ofMarket, m, userData);
		if (!_v0.$) {
			var ud = _v0.a;
			var _v1 = ud.gb;
			if ((!_v1.$) && (!_v1.a.$)) {
				var _v2 = _v1.a;
				var supply = _v2.a;
				var cl = _v2.b;
				var p = _v2.c;
				return A3(
					$elm$core$Dict$insert,
					m.jT,
					_Utils_update(
						ud,
						{
							gb: $elm$core$Maybe$Just(
								A3($author$project$Shared$User$Model$Supply, supply - wd, cl, p))
						}),
					userData);
			} else {
				return userData;
			}
		} else {
			return userData;
		}
	});
var $author$project$Withdraw$Logic$riskAfterWithdraw = F6(
	function (overlapFactor, rates, markets, m, userData, withdrawal) {
		return A4(
			$author$project$Shared$Borrow$Logic$risk,
			overlapFactor,
			rates,
			markets,
			A3($author$project$Withdraw$Logic$afterWithdraw, withdrawal, m, userData));
	});
var $author$project$Withdraw$Logic$targetRisk = F6(
	function (risk, overlapFactor, rates, markets, m, userData) {
		var targetRiskPrecision = 0.999;
		var supply = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.gb;
			},
			A2($author$project$Shared$User$Logic$ofMarket, m, userData));
		var maxHoops = 1500;
		var find = F2(
			function (withdrawal, cnt) {
				find:
				while (true) {
					var calculated = A6($author$project$Withdraw$Logic$riskAfterWithdraw, overlapFactor, rates, markets, m, userData, withdrawal);
					if (_Utils_cmp(cnt, maxHoops) > 0) {
						return withdrawal;
					} else {
						if (_Utils_cmp(calculated, risk) > 0) {
							var $temp$withdrawal = $elm$core$Basics$round(withdrawal / 1.5),
								$temp$cnt = cnt + 1;
							withdrawal = $temp$withdrawal;
							cnt = $temp$cnt;
							continue find;
						} else {
							if (_Utils_cmp(calculated / risk, targetRiskPrecision) > 0) {
								return withdrawal;
							} else {
								var $temp$withdrawal = $elm$core$Basics$round(withdrawal * 2),
									$temp$cnt = cnt + 1;
								withdrawal = $temp$withdrawal;
								cnt = $temp$cnt;
								continue find;
							}
						}
					}
				}
			});
		return ($author$project$Shared$Borrow$Logic$hasAnyBorrow(userData) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Shared$User$Logic$isCollateral, supply))) ? A2(
			find,
			A2($elm$core$Basics$pow, 10, 18),
			1) : A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$author$project$Shared$User$Logic$userTotalSupply(m.f6),
				supply));
	});
var $author$project$Withdraw$Logic$maxSafe = $author$project$Withdraw$Logic$targetRisk($author$project$Shared$Borrow$Logic$maxSafeBPUtilizationPercent);
var $author$project$Withdraw$Logic$riskDelta = F6(
	function (overlapFactor, userData, rates, markets, m, model) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Shared$Borrow$Logic$risk, overlapFactor, rates, markets),
			function () {
				var _v0 = _Utils_Tuple2(
					A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.gb;
						},
						A2($author$project$Shared$User$Logic$ofMarket, m, userData)));
				if ((((!_v0.a.$) && (!_v0.b.$)) && (!_v0.b.a.$)) && _v0.b.a.b) {
					var wd = _v0.a.a;
					var _v1 = _v0.b.a;
					return _List_fromArray(
						[
							userData,
							A3($author$project$Withdraw$Logic$afterWithdraw, wd, m, userData)
						]);
				} else {
					return _List_fromArray(
						[userData]);
				}
			}());
	});
var $author$project$Shared$Suppy$Logic$supplyDelta = F4(
	function (op, userData, m, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gb;
				},
				A2($author$project$Shared$User$Logic$ofMarket, m, userData)));
		if (!_v0.a.$) {
			var amount = _v0.a.a;
			var supply = _v0.b;
			var s = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$author$project$Shared$User$Logic$userTotalSupply(m.f6),
					supply));
			return _List_fromArray(
				[
					s,
					A2(
					$elm$core$Basics$max,
					0,
					A2(op, s, amount))
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var supply = _v0.b.a;
				return _List_fromArray(
					[
						A2($author$project$Shared$User$Logic$userTotalSupply, m.f6, supply)
					]);
			} else {
				return _List_fromArray(
					[0]);
			}
		}
	});
var $author$project$Shared$Info$total = F3(
	function (m, map, title) {
		return A3(
			$author$project$Shared$Info$textRow,
			_List_Nil,
			title,
			A2(
				$author$project$Shared$Text$formatCurrency,
				m.bh.ac,
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					m.bh,
					map(m.f6))));
	});
var $author$project$Shared$User$Logic$userAvailable = F3(
	function (m, withdrawn, utilization_) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (_v1) {
					var u = _v1.a;
					return _Utils_cmp(utilization_, u) > -1;
				},
				m.iC),
			A2($author$project$Shared$User$Logic$ofMarket, m, withdrawn));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v2 = _v0.a.a;
			var total = _v2.b;
			var already = _v0.b.a;
			return $elm$core$Maybe$Just(total - already);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$Home$Withdraw$cantWithdrawMoreThanSupplied = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.withdraw.cantWithdrawMoreThanSupplied');
};
var $author$project$Translations$Home$Withdraw$cantWithdrawWithoutSupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.withdraw.cantWithdrawWithoutSupply');
};
var $author$project$Shared$Validate$doesntExceedLimit = F3(
	function (m, limit, model) {
		var _v0 = _Utils_Tuple2(
			limit,
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var max = _v0.a.a;
			var amount = _v0.b.a;
			return (_Utils_cmp(amount, max) > 0) ? $elm$core$Maybe$Just('Exceed withdrawal/borrow limit') : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Shared$Validate$enoughHealth = F9(
	function (t, riskWithNewParams, overlapFactor, accountHealthThreshold, rates, markets, userData, m, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (!_v0.$) {
			var amount = _v0.a;
			var h = $author$project$Shared$Borrow$Logic$health(
				A6(
					riskWithNewParams,
					overlapFactor,
					rates,
					markets,
					m,
					userData,
					A2($author$project$Shared$Asset$Logic$toSatoshi, m.bh, amount)));
			return (_Utils_cmp(h, accountHealthThreshold) < 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Home$Validation$accountHealthTooLow(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$Home$Validation$amountUnavailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.validation.amountUnavailable');
};
var $author$project$Shared$Validate$marketAvailable = F4(
	function (t, getMax, m, model) {
		var _v0 = $elm$core$String$toFloat(model.gZ);
		if (!_v0.$) {
			var a = _v0.a;
			return (_Utils_cmp(
				a,
				A2(
					$author$project$Shared$Market$Logic$inOrig,
					m.bh,
					getMax(m.f6))) > 0) ? $elm$core$Maybe$Just(
				$author$project$Translations$Home$Validation$amountUnavailable(t)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Withdraw$Validate$validate = function (t) {
	return function (assets) {
		return function (overlapFactor) {
			return function (accountHealthThreshold) {
				return function (rates) {
					return function (markets) {
						return function (user) {
							return function (userData) {
								return function (m) {
									return function (supply) {
										return function (hasBorrow) {
											return function (userAvailable) {
												var protectedOrMarketAvailable = function () {
													if (((!supply.$) && (!supply.a.$)) && (supply.a.c === 1)) {
														var _v8 = supply.a;
														var _v9 = _v8.c;
														return $elm$core$Basics$always($elm$core$Maybe$Nothing);
													} else {
														return A3($author$project$Shared$Validate$marketAvailable, t, $author$project$Shared$Market$Logic$maxAvailableForWithdraw, m);
													}
												}();
												var health = function (model) {
													var _v5 = _Utils_Tuple2(supply, hasBorrow);
													if ((((!_v5.a.$) && (!_v5.a.a.$)) && _v5.a.a.b) && _v5.b) {
														var _v6 = _v5.a.a;
														return A9($author$project$Shared$Validate$enoughHealth, t, $author$project$Withdraw$Logic$riskAfterWithdraw, overlapFactor, accountHealthThreshold, rates, markets, userData, m, model);
													} else {
														return $elm$core$Maybe$Nothing;
													}
												};
												var doesntExceedSupply = function (model) {
													var _v3 = _Utils_Tuple2(
														supply,
														A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ));
													if (_v3.a.$ === 1) {
														var _v4 = _v3.a;
														return $elm$core$Maybe$Just(
															$author$project$Translations$Home$Withdraw$cantWithdrawWithoutSupply(t));
													} else {
														if (!_v3.b.$) {
															var s = _v3.a.a;
															var amount = _v3.b.a;
															return (_Utils_cmp(
																amount,
																A2($author$project$Withdraw$Logic$all, m.f6, s)) > 0) ? $elm$core$Maybe$Just(
																$author$project$Translations$Home$Withdraw$cantWithdrawMoreThanSupplied(t)) : $elm$core$Maybe$Nothing;
														} else {
															return $elm$core$Maybe$Nothing;
														}
													}
												};
												var doesntExceedLimitOrProtected = function (model) {
													if (((!supply.$) && (!supply.a.$)) && (supply.a.c === 1)) {
														var _v1 = supply.a;
														var _v2 = _v1.c;
														return $elm$core$Maybe$Nothing;
													} else {
														return A3($author$project$Shared$Validate$doesntExceedLimit, m, userAvailable, model);
													}
												};
												return A2(
													$author$project$Common$Validate$and,
													A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, m.bh),
													A2(
														$author$project$Common$Validate$and,
														doesntExceedLimitOrProtected,
														A2(
															$author$project$Common$Validate$and,
															protectedOrMarketAvailable,
															A2(
																$author$project$Common$Validate$and,
																health,
																A2(
																	$author$project$Common$Validate$and,
																	doesntExceedSupply,
																	A2(
																		$author$project$Common$Validate$and,
																		A2($author$project$Shared$Validate$precision, t, m.bh),
																		$author$project$Shared$Validate$positiveAmount(t)))))));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Shared$KindReminder$warning = function (attrs) {
	return $author$project$Shared$KindReminder$view(
		A2($elm$core$List$cons, $author$project$Shared$KindReminder$c.gE, attrs));
};
var $author$project$Withdraw$View$tab = function (t) {
	return function (limitTimeframe) {
		return function (assets) {
			return function (timeZone) {
				return function (hh) {
					return function (height) {
						return function (user) {
							return function (overlapFactor) {
								return function (accountHealthThreshold) {
									return function (rates) {
										return function (markets) {
											return function (userData) {
												return function (supply) {
													return function (m) {
														return function (model) {
															var userAvailable = A3(
																$author$project$Shared$User$Logic$userAvailable,
																m,
																model.lo,
																$author$project$Shared$Market$Logic$utilization(m.f6));
															var supplied = A2(
																$elm$core$Maybe$withDefault,
																0,
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Shared$User$Logic$userTotalSupply(m.f6),
																	supply));
															var msg = A3($author$project$Shared$Dialog$ctaMsg, model, m.bh, $author$project$Withdraw$Msg$Withdraw);
															var marketAvailable = $author$project$Shared$Market$Logic$maxAvailableForWithdraw(m.f6);
															var hasBorrow = $author$project$Shared$Borrow$Logic$hasAnyBorrow(userData);
															var err = $author$project$Withdraw$Validate$validate(t)(assets)(overlapFactor)(accountHealthThreshold)(rates)(markets)(user)(userData)(m)(supply)(hasBorrow)(userAvailable)(model);
															var withdraw = A4(
																$author$project$Common$Dialog$ctaButton,
																msg,
																$author$project$Translations$Home$Withdraw$withdraw(t),
																model,
																A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, err));
															var canConvertToUSDN = (!marketAvailable) && m.iB;
															var information = function () {
																var userAvailableInfo = function () {
																	var _v2 = _Utils_Tuple2(canConvertToUSDN, userAvailable);
																	if ((!_v2.a) && (!_v2.b.$)) {
																		var ua = _v2.b.a;
																		return A6($author$project$Shared$Market$Info$limit, limitTimeframe, timeZone, hh, height, m.bh, ua);
																	} else {
																		return $author$project$Shared$Html$nothing;
																	}
																}();
																var marketAvailableInfo = canConvertToUSDN ? $author$project$Shared$Html$nothing : A3(
																	$author$project$Shared$Info$total,
																	m,
																	$author$project$Shared$Market$Logic$maxAvailableForWithdraw,
																	$author$project$Translations$Home$marketAvailable(t));
																var health = hasBorrow ? A2(
																	$author$project$Shared$Delta$View$health,
																	t,
																	A6($author$project$Withdraw$Logic$riskDelta, overlapFactor, userData, rates, markets, m, model)) : $author$project$Shared$Html$nothing;
																return A2(
																	$author$project$Shared$Info$view,
																	_List_Nil,
																	A2(
																		$elm$core$List$cons,
																		health,
																		_List_fromArray(
																			[
																				A3(
																				$author$project$Shared$Delta$View$supplied,
																				t,
																				m.bh,
																				A4($author$project$Shared$Suppy$Logic$supplyDelta, $elm$core$Basics$sub, userData, m, model)),
																				marketAvailableInfo,
																				userAvailableInfo,
																				A3(
																				$author$project$Shared$Delta$View$wallet,
																				t,
																				m.bh,
																				A4($author$project$Shared$Suppy$Logic$walletDelta, $elm$core$Basics$add, user.lh, m.bh, model)),
																				A7($author$project$Shared$Info$feeRow, t, assets, user, m.bh, $author$project$Shared$Transaction$Logic$fee.fT, $author$project$Withdraw$Msg$FeeAssetChanged, model.h1)
																			])));
															}();
															var amountInput = function () {
																var number = A4(
																	$author$project$Shared$Dialog$amount,
																	$author$project$Withdraw$View$enterWithdrawalAmount(t),
																	err,
																	$author$project$Withdraw$Msg$AmountChanged,
																	model);
																if (!supplied) {
																	return A2(
																		$author$project$Common$Form$field,
																		_List_Nil,
																		$elm$core$List$singleton(number));
																} else {
																	var maxBtn = function () {
																		var available = A2(
																			$elm$core$Maybe$withDefault,
																			marketAvailable,
																			A2(
																				$elm$core$Maybe$map,
																				$elm$core$Basics$min(marketAvailable),
																				userAvailable));
																		var btnOrMaxAvailable = F2(
																			function (amount, btn) {
																				return (_Utils_cmp(available, amount) < 0) ? A2($author$project$Withdraw$View$maxAvailableBtn, t, available) : btn;
																			});
																		var all = A2(
																			$elm$core$Maybe$withDefault,
																			0,
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Withdraw$Logic$all(m.f6),
																				supply));
																		var _v0 = _Utils_Tuple2(supply, hasBorrow);
																		if ((((!_v0.a.$) && (!_v0.a.a.$)) && _v0.a.a.b) && _v0.b) {
																			var _v1 = _v0.a.a;
																			var maxSafe = A5($author$project$Withdraw$Logic$maxSafe, overlapFactor, rates, markets, m, userData);
																			return (_Utils_cmp(maxSafe, all) < 0) ? A2(
																				btnOrMaxAvailable,
																				maxSafe,
																				A2(
																					$author$project$Common$Button$text,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$Common$Events$onClickOrDisabled,
																							$author$project$Withdraw$Msg$SetAmount(maxSafe),
																							maxSafe > 0)
																						]),
																					$author$project$Translations$Home$maxSafe(t))) : A2(
																				btnOrMaxAvailable,
																				all,
																				A2($author$project$Withdraw$View$allBtn, t, all));
																		} else {
																			return A2(
																				btnOrMaxAvailable,
																				all,
																				A2($author$project$Withdraw$View$allBtn, t, all));
																		}
																	}();
																	return A2(
																		$author$project$Common$Form$fieldWithAddon,
																		_List_Nil,
																		_List_fromArray(
																			[number, maxBtn]));
																}
															}();
															return _Utils_Tuple2(
																A2(
																	$author$project$Shared$Dialog$dirtySection,
																	model,
																	_List_fromArray(
																		[
																			canConvertToUSDN ? A2(
																			$author$project$Shared$KindReminder$warning,
																			_List_fromArray(
																				[
																					$elm$html$Html$Events$onClick($author$project$Withdraw$Msg$ConvertToUSDN)
																				]),
																			$elm$core$List$singleton(
																				A2(
																					$author$project$Common$Markdown$viewInDiv,
																					_List_Nil,
																					A2(
																						$author$project$Translations$Home$Withdraw$insufficientLiquidityMD,
																						t,
																						$author$project$Shared$Text$formatPercent($author$project$Home$Vesting$Shared$Logic$liquidationBonus))))) : amountInput,
																			information
																		])),
																withdraw);
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Withdraw$View$view = function (t) {
	return function (limitTimeframe) {
		return function (assets) {
			return function (timeZone) {
				return function (hh) {
					return function (height) {
						return function (user) {
							return function (overlapFactor) {
								return function (accountHealthThreshold) {
									return function (rates) {
										return function (markets) {
											return function (userData) {
												return function (supply) {
													return function (m) {
														return function (model) {
															var header = A2(
																$author$project$Common$Dialog$header,
																$author$project$Withdraw$Msg$Close,
																_List_fromArray(
																	[
																		A2($author$project$Shared$Market$View$iconWithText, t, m),
																		$elm$html$Html$text($author$project$Shared$Text$nbsp),
																		A2(
																		$elm$html$Html$strong,
																		_List_Nil,
																		$author$project$Shared$Html$texts(
																			$author$project$Translations$Home$Withdraw$withdraw(t)))
																	]));
															var _v0 = $author$project$Withdraw$View$tab(t)(limitTimeframe)(assets)(timeZone)(hh)(height)(user)(overlapFactor)(accountHealthThreshold)(rates)(markets)(userData)(supply)(m)(model);
															var body = _v0.a;
															var cta = _v0.b;
															return $author$project$Common$Dialog$view(
																_List_fromArray(
																	[
																		$author$project$Common$Dialog$background($author$project$Withdraw$Msg$Close),
																		A2(
																		$author$project$Common$Dialog$body,
																		_List_Nil,
																		_List_fromArray(
																			[
																				header,
																				A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				$elm$core$List$singleton(body)),
																				A2(
																				$author$project$Shared$Dialog$footer,
																				t,
																				A3(
																					$author$project$Common$Base$iff,
																					cta,
																					$author$project$Shared$Wallet$View$connect(t),
																					$author$project$User$Logic$isLoggedIn(user)))
																			]))
																	]));
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Common$Card$withTableCustomTitle = F3(
	function (title_, attrs, content_) {
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Card$c.aH,
				A2(
					$elm$core$List$cons,
					$author$project$Common$Card$c.aG,
					A2($elm$core$List$cons, $author$project$Common$Card$c.bk, attrs))),
			_List_fromArray(
				[
					$author$project$Common$Card$title(title_),
					A2(
					$elm$html$Html$div,
					$author$project$Common$Card$c.bs,
					$elm$core$List$singleton(content_))
				]));
	});
var $author$project$Home$View$view = function (t) {
	return function (limitTimeFrame) {
		return function (timeZone) {
			return function (hh) {
				return function (height) {
					return function (screen) {
						return function (vires) {
							return function (assets) {
								return function (overlapFactor) {
									return function (user) {
										return function (accountHealthThreshold) {
											return function (rates) {
												return function (newRates) {
													return function (markets) {
														return function (governance) {
															return function (model) {
																var isLoggedIn = $author$project$User$Logic$isLoggedIn(user);
																var fixedRates = A3($author$project$Shared$NewRate$toNewRates, vires, assets, newRates);
																var slide = function (idx) {
																	slide:
																	while (true) {
																		if (!idx) {
																			return $author$project$Shared$Html$texts(
																				$author$project$Translations$Home$Banners$protocol(t));
																		} else {
																			if (!governance.$) {
																				var gov = governance.a;
																				return $elm$core$List$singleton(
																					A2(
																						$elm$html$Html$a,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$href($author$project$Route$url.ic)
																							]),
																						$author$project$Shared$Html$texts(
																							A2(
																								$author$project$Translations$Home$Banners$earnVires,
																								t,
																								$author$project$Shared$Text$formatAPR(
																									$author$project$Common$Percent$round(
																										A4(
																											$author$project$Governance$Shared$Logic$governanceApr,
																											fixedRates(rates),
																											markets,
																											vires,
																											gov)))))));
																			} else {
																				var $temp$idx = -1;
																				idx = $temp$idx;
																				continue slide;
																			}
																		}
																	}
																};
																var card = F2(
																	function (title, class_) {
																		return A2($author$project$Common$Card$withTable, title, class_);
																	});
																var my = function (_v8) {
																	var vesting = A2(
																		$elm$core$List$map,
																		$elm$html$Html$map($author$project$Home$Msg$Vesting),
																		A6($author$project$Home$Vesting$View$view, t, assets, markets, user, model.k$, model.k6));
																	var supply = A3(
																		card,
																		$author$project$Translations$Home$MySupply$mySupply(t),
																		$author$project$Home$View$c.gb,
																		A2(
																			$elm$html$Html$map,
																			$author$project$Home$Msg$MySupply,
																			A2(
																				$author$project$Shared$Html$try,
																				$author$project$MySupply$View$view(t)(screen)(vires)(assets)(rates)(newRates)(markets)(governance)(user)(model.jf)(model.iA)(model.k$),
																				height)));
																	var borrow = $author$project$Shared$Borrow$Logic$hasAnyBorrow(model.k$) ? A3(
																		card,
																		$author$project$Translations$Home$MyBorrow$myBorrow(t),
																		$author$project$Home$View$c.dk,
																		A2(
																			$elm$html$Html$map,
																			$author$project$Home$Msg$MyBorrow,
																			A7($author$project$MyBorrow$View$view, t, overlapFactor, rates, markets, model.jf, model.iA, model.k$))) : $author$project$Shared$Html$nothing;
																	return A2(
																		$elm$core$List$cons,
																		supply,
																		_Utils_ap(
																			vesting,
																			_List_fromArray(
																				[borrow])));
																};
																var banner = A2(
																	$elm$html$Html$div,
																	$author$project$Home$View$c.dd,
																	_List_fromArray(
																		[
																			$author$project$Home$View$ellipse,
																			A2(
																			$elm$html$Html$map,
																			$author$project$Home$Msg$Slides,
																			A2(
																				$author$project$Common$Slides$view,
																				model,
																				slide(model.ah)))
																		]));
																var hero = _List_fromArray(
																	[
																		banner,
																		isLoggedIn ? A2(
																		$elm$html$Html$map,
																		$author$project$Home$Msg$MyVires,
																		A7(
																			$author$project$My$Vires$view,
																			t,
																			fixedRates(rates),
																			vires,
																			governance,
																			model.j$,
																			markets,
																			user)) : A2(
																		$elm$html$Html$a,
																		_List_fromArray(
																			[
																				$author$project$Home$View$c.dF,
																				$elm$html$Html$Attributes$href('#connect')
																			]),
																		$elm$core$List$singleton(
																			A2(
																				$author$project$Shared$Html$textSpan,
																				_List_Nil,
																				$author$project$Translations$Home$connectWalletToStart(t))))
																	]);
																var allMarkets = function () {
																	var title = _List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Translations$Home$AllMarkets$allMarkets(t)),
																			$author$project$Shared$Html$space,
																			A2(
																			$author$project$Common$Select$inline,
																			_List_fromArray(
																				[
																					$elm$html$Html$Events$onInput(
																					$elm$core$Basics$always($author$project$Home$Msg$GotoV2))
																				]),
																			_List_fromArray(
																				[
																					A2($author$project$Common$Select$option, _List_Nil, 'V1 (WXG)'),
																					A2($author$project$Common$Select$option, _List_Nil, 'V2 (PEPE)')
																				]))
																		]);
																	return A3(
																		$author$project$Common$Card$withTableCustomTitle,
																		title,
																		$author$project$Home$View$c.c1,
																		A2(
																			$elm$html$Html$map,
																			$author$project$Home$Msg$Markets,
																			$author$project$Markets$View$view(t)(screen)(vires)(assets)(markets)(rates)(newRates)(governance)(user.lh)(model.eY)));
																}();
																var activeOperation = function (op) {
																	var _v2 = _Utils_Tuple2(op, height);
																	_v2$4:
																	while (true) {
																		switch (_v2.a.$) {
																			case 3:
																				if (!_v2.b.$) {
																					var _v3 = _v2.a;
																					var m = _v3.a;
																					var m1 = _v3.b;
																					var h = _v2.b.a;
																					var supply = A2(
																						$elm$core$Maybe$andThen,
																						function ($) {
																							return $.gb;
																						},
																						A2($author$project$Shared$User$Logic$ofMarket, m, model.k$));
																					return A2(
																						$elm$html$Html$map,
																						$author$project$Home$Msg$Withdraw,
																						function () {
																							if ((!supply.$) && (supply.a.$ === 1)) {
																								var s = supply.a;
																								return $author$project$Withdraw$Unlock$view(t)(assets)(vires)(
																									fixedRates(rates))(timeZone)(hh)(h)(m)(user)(s)(m1);
																							} else {
																								return $author$project$Withdraw$View$view(t)(limitTimeFrame)(assets)(timeZone)(hh)(h)(user)(overlapFactor)(accountHealthThreshold)(rates)(markets)(model.k$)(supply)(m)(m1);
																							}
																						}());
																				} else {
																					break _v2$4;
																				}
																			case 0:
																				if (!_v2.b.$) {
																					var _v5 = _v2.a;
																					var m = _v5.a;
																					var m1 = _v5.b;
																					var h = _v2.b.a;
																					return A2(
																						$elm$html$Html$map,
																						$author$project$Home$Msg$Repay,
																						A9($author$project$Repay$View$view, t, assets, user, overlapFactor, rates, markets, model.k$, m, m1));
																				} else {
																					break _v2$4;
																				}
																			case 1:
																				var _v6 = _v2.a;
																				var m = _v6.a;
																				var m1 = _v6.b;
																				return A2(
																					$elm$html$Html$map,
																					$author$project$Home$Msg$ChangeCollateral,
																					$author$project$Home$ChangeCollateral$view(t)(assets)(user)(overlapFactor)(accountHealthThreshold)(rates)(markets)(model.k$)(m)(m1));
																			default:
																				var m1 = _v2.a.a;
																				if (!governance.$) {
																					var g = governance.a;
																					return A2(
																						$elm$html$Html$map,
																						$author$project$Home$Msg$Claim,
																						A9(
																							$author$project$Vires$View$view,
																							t,
																							markets,
																							fixedRates(rates),
																							user,
																							model.j$,
																							vires,
																							assets,
																							m1,
																							g));
																				} else {
																					return $author$project$Shared$Html$nothing;
																				}
																		}
																	}
																	return $author$project$Shared$Html$nothing;
																};
																var body = _List_fromArray(
																	[
																		A2($author$project$Shared$Layout$sectionN, $author$project$Home$View$c.aS, hero),
																		isLoggedIn ? A2(
																		$author$project$Shared$Layout$sectionN,
																		_List_fromArray(
																			[$author$project$Home$View$c.e6]),
																		my(0)) : $author$project$Shared$Html$nothing,
																		A2(
																		$author$project$Shared$Layout$section,
																		_List_fromArray(
																			[$author$project$Home$View$c.eY]),
																		allMarkets),
																		A2($author$project$Shared$Html$try, activeOperation, model.jl)
																	]);
																return {
																	dj: body,
																	kB: $author$project$Translations$Home$title(t)
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Msg$InfoMenuToggled = {$: 30};
var $author$project$Layout$View$c = {
	dj: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('body')
		]),
	du: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('check')
		]),
	dY: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('dot')
		]),
	d2: $elm$html$Html$Attributes$id('elm'),
	bM: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('has-bar')
		]),
	bN: $elm$html$Html$Attributes$class('has-nav'),
	eo: $elm$html$Html$Attributes$class('has-notifications'),
	iy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text')
		]),
	eN: $elm$html$Html$Attributes$class('left'),
	eT: $elm$html$Html$Attributes$class('logged-in'),
	eV: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('row login')
		]),
	fa: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('nav')
		]),
	fc: $elm$html$Html$Attributes$class('not-logged-in'),
	fe: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('notifications')
		]),
	jo: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('page')
		]),
	fO: $elm$html$Html$Attributes$class('right'),
	f1: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('social')
		]),
	a7: $elm$html$Html$Attributes$class('sticky'),
	kp: $elm$html$Html$Attributes$class('sticky-wrapper'),
	gc: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('support')
		]),
	cE: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('title text-logo'),
			$elm$html$Html$Attributes$href('/')
		]),
	gk: $elm$html$Html$Attributes$class('top')
};
var $author$project$Layout$View$activeCheck = A2($elm$html$Html$div, $author$project$Layout$View$c.du, _List_Nil);
var $lattyware$elm_fontawesome$FontAwesome$Solid$angleDown = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'angle-down',
	320,
	512,
	_List_fromArray(
		['M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$angleRight = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'angle-right',
	256,
	512,
	_List_fromArray(
		['M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z']));
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $author$project$Translations$Menu$bridge = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'menu.bridge');
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $lattyware$elm_fontawesome$FontAwesome$Styles$css = A3(
	$elm$html$Html$node,
	'style',
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('svg:not(:root).svg-inline--fa {  overflow: visible;}.svg-inline--fa {  display: inline-block;  font-size: inherit;  height: 1em;  overflow: visible;  vertical-align: -0.125em;}.svg-inline--fa.fa-lg {  vertical-align: -0.225em;}.svg-inline--fa.fa-w-1 {  width: 0.0625em;}.svg-inline--fa.fa-w-2 {  width: 0.125em;}.svg-inline--fa.fa-w-3 {  width: 0.1875em;}.svg-inline--fa.fa-w-4 {  width: 0.25em;}.svg-inline--fa.fa-w-5 {  width: 0.3125em;}.svg-inline--fa.fa-w-6 {  width: 0.375em;}.svg-inline--fa.fa-w-7 {  width: 0.4375em;}.svg-inline--fa.fa-w-8 {  width: 0.5em;}.svg-inline--fa.fa-w-9 {  width: 0.5625em;}.svg-inline--fa.fa-w-10 {  width: 0.625em;}.svg-inline--fa.fa-w-11 {  width: 0.6875em;}.svg-inline--fa.fa-w-12 {  width: 0.75em;}.svg-inline--fa.fa-w-13 {  width: 0.8125em;}.svg-inline--fa.fa-w-14 {  width: 0.875em;}.svg-inline--fa.fa-w-15 {  width: 0.9375em;}.svg-inline--fa.fa-w-16 {  width: 1em;}.svg-inline--fa.fa-w-17 {  width: 1.0625em;}.svg-inline--fa.fa-w-18 {  width: 1.125em;}.svg-inline--fa.fa-w-19 {  width: 1.1875em;}.svg-inline--fa.fa-w-20 {  width: 1.25em;}.svg-inline--fa.fa-pull-left {  margin-right: 0.3em;  width: auto;}.svg-inline--fa.fa-pull-right {  margin-left: 0.3em;  width: auto;}.svg-inline--fa.fa-border {  height: 1.5em;}.svg-inline--fa.fa-li {  width: 2em;}.svg-inline--fa.fa-fw {  width: 1.25em;}.fa-layers svg.svg-inline--fa {  bottom: 0;  left: 0;  margin: auto;  position: absolute;  right: 0;  top: 0;}.fa-layers {  display: inline-block;  height: 1em;  position: relative;  text-align: center;  vertical-align: -0.125em;  width: 1em;}.fa-layers svg.svg-inline--fa {  -webkit-transform-origin: center center;          transform-origin: center center;}.fa-layers-counter, .fa-layers-text {  display: inline-block;  position: absolute;  text-align: center;}.fa-layers-text {  left: 50%;  top: 50%;  -webkit-transform: translate(-50%, -50%);          transform: translate(-50%, -50%);  -webkit-transform-origin: center center;          transform-origin: center center;}.fa-layers-counter {  background-color: #ff253a;  border-radius: 1em;  -webkit-box-sizing: border-box;          box-sizing: border-box;  color: #fff;  height: 1.5em;  line-height: 1;  max-width: 5em;  min-width: 1.5em;  overflow: hidden;  padding: 0.25em;  right: 0;  text-overflow: ellipsis;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top right;          transform-origin: top right;}.fa-layers-bottom-right {  bottom: 0;  right: 0;  top: auto;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: bottom right;          transform-origin: bottom right;}.fa-layers-bottom-left {  bottom: 0;  left: 0;  right: auto;  top: auto;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: bottom left;          transform-origin: bottom left;}.fa-layers-top-right {  right: 0;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top right;          transform-origin: top right;}.fa-layers-top-left {  left: 0;  right: auto;  top: 0;  -webkit-transform: scale(0.25);          transform: scale(0.25);  -webkit-transform-origin: top left;          transform-origin: top left;}.fa-lg {  font-size: 1.3333333333em;  line-height: 0.75em;  vertical-align: -0.0667em;}.fa-xs {  font-size: 0.75em;}.fa-sm {  font-size: 0.875em;}.fa-1x {  font-size: 1em;}.fa-2x {  font-size: 2em;}.fa-3x {  font-size: 3em;}.fa-4x {  font-size: 4em;}.fa-5x {  font-size: 5em;}.fa-6x {  font-size: 6em;}.fa-7x {  font-size: 7em;}.fa-8x {  font-size: 8em;}.fa-9x {  font-size: 9em;}.fa-10x {  font-size: 10em;}.fa-fw {  text-align: center;  width: 1.25em;}.fa-ul {  list-style-type: none;  margin-left: 2.5em;  padding-left: 0;}.fa-ul > li {  position: relative;}.fa-li {  left: -2em;  position: absolute;  text-align: center;  width: 2em;  line-height: inherit;}.fa-border {  border: solid 0.08em #eee;  border-radius: 0.1em;  padding: 0.2em 0.25em 0.15em;}.fa-pull-left {  float: left;}.fa-pull-right {  float: right;}.fa.fa-pull-left,.fas.fa-pull-left,.far.fa-pull-left,.fal.fa-pull-left,.fab.fa-pull-left {  margin-right: 0.3em;}.fa.fa-pull-right,.fas.fa-pull-right,.far.fa-pull-right,.fal.fa-pull-right,.fab.fa-pull-right {  margin-left: 0.3em;}.fa-spin {  -webkit-animation: fa-spin 2s infinite linear;          animation: fa-spin 2s infinite linear;}.fa-pulse {  -webkit-animation: fa-spin 1s infinite steps(8);          animation: fa-spin 1s infinite steps(8);}@-webkit-keyframes fa-spin {  0% {    -webkit-transform: rotate(0deg);            transform: rotate(0deg);  }  100% {    -webkit-transform: rotate(360deg);            transform: rotate(360deg);  }}@keyframes fa-spin {  0% {    -webkit-transform: rotate(0deg);            transform: rotate(0deg);  }  100% {    -webkit-transform: rotate(360deg);            transform: rotate(360deg);  }}.fa-rotate-90 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";  -webkit-transform: rotate(90deg);          transform: rotate(90deg);}.fa-rotate-180 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";  -webkit-transform: rotate(180deg);          transform: rotate(180deg);}.fa-rotate-270 {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";  -webkit-transform: rotate(270deg);          transform: rotate(270deg);}.fa-flip-horizontal {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";  -webkit-transform: scale(-1, 1);          transform: scale(-1, 1);}.fa-flip-vertical {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";  -webkit-transform: scale(1, -1);          transform: scale(1, -1);}.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";  -webkit-transform: scale(-1, -1);          transform: scale(-1, -1);}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-flip-both {  -webkit-filter: none;          filter: none;}.fa-stack {  display: inline-block;  height: 2em;  position: relative;  width: 2.5em;}.fa-stack-1x,.fa-stack-2x {  bottom: 0;  left: 0;  margin: auto;  position: absolute;  right: 0;  top: 0;}.svg-inline--fa.fa-stack-1x {  height: 1em;  width: 1.25em;}.svg-inline--fa.fa-stack-2x {  height: 2em;  width: 2.5em;}.fa-inverse {  color: #fff;}.sr-only {  border: 0;  clip: rect(0, 0, 0, 0);  height: 1px;  margin: -1px;  overflow: hidden;  padding: 0;  position: absolute;  width: 1px;}.sr-only-focusable:active, .sr-only-focusable:focus {  clip: auto;  height: auto;  margin: 0;  overflow: visible;  position: static;  width: auto;}.svg-inline--fa .fa-primary {  fill: var(--fa-primary-color, currentColor);  opacity: 1;  opacity: var(--fa-primary-opacity, 1);}.svg-inline--fa .fa-secondary {  fill: var(--fa-secondary-color, currentColor);  opacity: 0.4;  opacity: var(--fa-secondary-opacity, 0.4);}.svg-inline--fa.fa-swap-opacity .fa-primary {  opacity: 0.4;  opacity: var(--fa-secondary-opacity, 0.4);}.svg-inline--fa.fa-swap-opacity .fa-secondary {  opacity: 1;  opacity: var(--fa-primary-opacity, 1);}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary {  fill: black;}.fad.fa-inverse {  color: #fff;}')
		]));
var $lattyware$elm_fontawesome$FontAwesome$Brands$ethereum = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'ethereum',
	320,
	512,
	_List_fromArray(
		['M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z']));
var $author$project$Shared$Layout$container = $elm$html$Html$div(
	_List_fromArray(
		[$author$project$Shared$Layout$c.dG]));
var $author$project$Shared$Layout$footer = $elm$html$Html$div($author$project$Shared$Layout$c.ec);
var $author$project$Shared$Waves$view = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('footer-powered'),
			A2($elm$html$Html$Attributes$attribute, 'height', '28'),
			$elm$svg$Svg$Attributes$viewBox('0 0 124 28'),
			A2($elm$html$Html$Attributes$attribute, 'width', '124'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M0 0h124v28H0z'),
							$elm$svg$Svg$Attributes$fill('none')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M117.413 1.19l6.576 6.576-6.6 6.6-6.576-6.577z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M28.925 7.392h-3.648l-.382.343-3.743 13.197h-.024L16.93 7.735l-.382-.343h-3.815l-.382.343L8.18 20.859l-.071-.05-.024-.024L4.34 7.735l-.382-.343H.238L0 7.735l5.842 18.584.406.367H9.92l.405-.367 4.173-13.296h.096L18.79 26.32l.405.367h3.72l.406-.367 5.842-18.584zM70.203 7.392h-3.672l-.406.343-5.127 13.736-.047.024-5.08-13.76-.405-.343h-3.744l-.238.343 7.32 18.584.43.367h3.386l.43-.367 7.392-18.584zM89.137 18.067l.358-.342v-.563c0-3.012-.835-5.608-2.48-7.42C85.369 7.93 83.152 7 80.433 7c-2.623 0-4.817 1.004-6.51 2.963-1.693 1.959-2.528 4.334-2.528 7.027 0 2.865.883 5.265 2.623 7.15 1.741 1.885 4.03 2.84 6.797 2.84 2.003 0 3.72-.49 5.103-1.493 1.383-.98 2.837-2.596 3.338-4.8l-.262-.367H85.56l-.477.367c-.858 1.763-2.17 2.596-4.34 2.596-1.407 0-2.67-.514-3.72-1.518-1.001-.955-1.574-2.106-1.717-3.746l13.83.048zM75.545 14.64c.596-2.278 2.456-3.967 4.888-3.967 3.22 0 4.555 2.35 4.936 3.967h-9.824zM45.522 7.392l-.357.367v1.91l-.072.073c-.477-.636-1.12-1.2-1.884-1.665a11.455 11.455 0 0 0-.548-.293c-1.026-.515-2.194-.76-3.458-.76-2.36 0-4.435.98-6.152 2.89-1.717 1.91-2.576 4.31-2.576 7.125 0 2.816.859 5.216 2.576 7.125 1.717 1.91 3.791 2.89 6.152 2.89 1.264 0 2.409-.245 3.434-.76.19-.097.405-.195.596-.318.74-.465 1.36-.98 1.836-1.591.024-.025.096.024.12 0v1.983l.357.367h3.124l.358-.367V7.735l-.358-.368h-3.148v.025zm-1.931 14.25c-1.05 1.151-2.313 1.714-3.84 1.714-1.478 0-2.575-.563-3.648-1.738-1.073-1.15-1.598-2.694-1.598-4.628 0-1.91.549-3.452 1.598-4.628 1.073-1.15 2.146-1.738 3.649-1.738 1.502 0 2.766.563 3.839 1.714.691.759 1.144 1.665 1.407 2.767v3.722c-.239 1.15-.716 2.08-1.407 2.815zM102.372 15.521s-2.051-.44-3.744-.833c-1.55-.367-2.337-.832-2.337-1.958 0-1.2 1.12-2.204 3.529-2.204 2.36 0 3.672 1.077 3.672 2.032l.406.368h3.434l.262-.343c0-2.522-2.122-5.534-7.679-5.534-5.794 0-7.607 3.501-7.607 5.754 0 1.885.668 4.114 5.104 5.167l3.815.881c1.931.44 2.742 1.126 2.742 2.277 0 1.053-1.025 2.326-3.696 2.326-2.48 0-3.982-1.224-4.054-2.669l-.429-.367h-3.505l-.263.367c.31 3.232 2.647 6.269 8.227 6.269 6.32 0 7.607-3.967 7.607-6.048 0-2.792-1.55-4.604-5.484-5.485z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Layout$View$footer = $author$project$Shared$Layout$footer(
	$elm$core$List$singleton(
		$author$project$Shared$Layout$container(
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('powered-by-waves')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Powered by'),
							$author$project$Shared$Html$space,
							$author$project$Shared$Waves$view
						]))))));
var $lattyware$elm_fontawesome$FontAwesome$Solid$home = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'home',
	576,
	512,
	_List_fromArray(
		['M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z']));
var $author$project$Translations$Menu$home = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'menu.home');
};
var $author$project$Shared$Html$hr = A2($elm$html$Html$hr, _List_Nil, _List_Nil);
var $author$project$Common$Screen$isWidescreen = function (_v0) {
	var width = _v0;
	return width >= 1216;
};
var $author$project$Common$Menu$c = {
	eK: _List_Nil,
	eR: $elm$html$Html$Attributes$class('menu-list'),
	eZ: $elm$html$Html$Attributes$class('menu')
};
var $author$project$Common$Menu$item = $elm$html$Html$li($author$project$Common$Menu$c.eK);
var $author$project$Msg$LanguageChanged = function (a) {
	return {$: 27, a: a};
};
var $author$project$Layout$Languages$languages = _List_fromArray(
	[
		_Utils_Tuple3('en', 'English', '🇬🇧'),
		_Utils_Tuple3('ru', 'Русский', '🇷🇺'),
		_Utils_Tuple3('es', 'Español', '🇪🇸'),
		_Utils_Tuple3('zh', '中文', '🇨🇳')
	]);
var $author$project$Common$Select$view = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$select(attributes),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$div($author$project$Common$Select$c.cj)));
};
var $author$project$Layout$View$languages = function (_v0) {
	var selectedLanguage = _v0;
	var lang = function (_v1) {
		var id = _v1.a;
		var title = _v1.b;
		var emoji = _v1.c;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(id),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(selectedLanguage, id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					_Utils_ap(
						emoji,
						_Utils_ap($author$project$Shared$Text$nbsp, title)))
				]));
	};
	return A2(
		$author$project$Common$Select$view,
		_List_fromArray(
			[
				$elm$html$Html$Events$onInput(
				A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Msg$LanguageChanged))
			]),
		A2($elm$core$List$map, lang, $author$project$Layout$Languages$languages));
};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $author$project$Common$Menu$link = F2(
	function (isActive_, attrs) {
		return $elm$html$Html$a(
			A2(
				$elm$core$List$cons,
				$author$project$Common$Attributes$is.gT(isActive_),
				attrs));
	});
var $author$project$Translations$Menu$docs = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'menu.docs');
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$file = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'file',
	384,
	512,
	_List_fromArray(
		['M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z']));
var $author$project$Translations$Menu$forum = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'menu.forum');
};
var $lattyware$elm_fontawesome$FontAwesome$Brands$github = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'github',
	496,
	512,
	_List_fromArray(
		['M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$questionCircle = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'question-circle',
	512,
	512,
	_List_fromArray(
		['M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$shieldAlt = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'shield-alt',
	512,
	512,
	_List_fromArray(
		['M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$userFriends = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'user-friends',
	640,
	512,
	_List_fromArray(
		['M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z']));
var $author$project$Translations$Menu$whitepaper = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'menu.whitepaper');
};
var $author$project$Layout$Links$links = function (t) {
	return _List_fromArray(
		[
			_Utils_Tuple3(
			$author$project$Translations$Menu$whitepaper(t),
			$lattyware$elm_fontawesome$FontAwesome$Solid$file,
			'https://github.com/viresfinance/protocol/blob/main/vires-finance-whitepaper-1.0.pdf'),
			_Utils_Tuple3('Github', $lattyware$elm_fontawesome$FontAwesome$Brands$github, 'https://github.com/viresfinance/protocol/'),
			_Utils_Tuple3('Security Audit', $lattyware$elm_fontawesome$FontAwesome$Solid$shieldAlt, 'https://github.com/deemru/viresfinance-audit/releases/download/audit/viresfinance-security-audit.en.pdf'),
			_Utils_Tuple3(
			$author$project$Translations$Menu$docs(t),
			$lattyware$elm_fontawesome$FontAwesome$Solid$questionCircle,
			'https://docs.vires.finance/'),
			_Utils_Tuple3(
			$author$project$Translations$Menu$forum(t),
			$lattyware$elm_fontawesome$FontAwesome$Solid$userFriends,
			'https://forum.vires.finance')
		]);
};
var $author$project$Common$Menu$list = function (attrs) {
	return $elm$html$Html$ul(
		A2($elm$core$List$cons, $author$project$Common$Menu$c.eR, attrs));
};
var $author$project$User$View$c = {
	eU: $elm$html$Html$Attributes$class('login'),
	gG: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('waves-address')
		])
};
var $author$project$User$Msg$Copy = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$Msg$Logout = {$: 1};
var $author$project$User$Msg$Open = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$Msg$SwitchAccount = {$: 5};
var $author$project$Common$DropDown$c = {
	dZ: $elm$html$Html$Attributes$class('dropdown'),
	d_: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('dropdown-content')
		]),
	d$: $elm$html$Html$Attributes$class('dropdown-item'),
	d0: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('dropdown-menu')
		]),
	d1: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('dropdown-trigger')
		])
};
var $author$project$Common$DropDown$content = $elm$html$Html$div($author$project$Common$DropDown$c.d_);
var $author$project$Translations$Wallet$copyAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'wallet.copyAddress');
};
var $author$project$Translations$Wallet$copyXAddress = F2(
	function (translations, addressType) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'wallet.copyXAddress',
			_List_fromArray(
				[
					_Utils_Tuple2('addressType', addressType)
				]));
	});
var $author$project$Translations$Wallet$eth = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'wallet.eth');
};
var $author$project$Common$DropDown$item = function (msg) {
	return $elm$html$Html$a(
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(msg),
				$author$project$Common$DropDown$c.d$
			]));
};
var $author$project$Translations$User$logout = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'user.logout');
};
var $author$project$Common$DropDown$menu = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$singleton,
	$elm$html$Html$div($author$project$Common$DropDown$c.d0));
var $lattyware$elm_fontawesome$FontAwesome$Solid$random = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'random',
	512,
	512,
	_List_fromArray(
		['M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z']));
var $lattyware$elm_fontawesome$FontAwesome$Solid$signOutAlt = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'sign-out-alt',
	512,
	512,
	_List_fromArray(
		['M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z']));
var $author$project$Translations$User$switchAccount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'user.switchAccount');
};
var $author$project$Common$DropDown$trigger = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$singleton,
	$elm$html$Html$div($author$project$Common$DropDown$c.d1));
var $author$project$Common$DropDown$view = function (isActive_) {
	return $elm$html$Html$div(
		_List_fromArray(
			[
				$author$project$Common$DropDown$c.dZ,
				$author$project$Common$Attributes$is.gT(isActive_)
			]));
};
var $author$project$Translations$Wallet$waves = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'wallet.waves');
};
var $author$project$User$View$view = F2(
	function (t, model) {
		var _v0 = model.gV;
		if (_v0.$ === 1) {
			return A3(
				$author$project$Common$Button$textLink,
				_List_fromArray(
					[$author$project$Common$Button$c.aL]),
				'#connect',
				$author$project$Translations$Wallet$connectWallet(t));
		} else {
			var address = _v0.a;
			var wavesAddress = address;
			var metamask = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, model.iN));
			var dropdown = function () {
				if (model.jk) {
					var item = F3(
						function (label, icon, msg) {
							return A2(
								$author$project$Common$DropDown$item,
								msg,
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(icon),
										$elm$html$Html$text(' '),
										$elm$html$Html$text(label)
									]));
						});
					var copyAddresses = function () {
						if (metamask) {
							var copy = F2(
								function (kind, adr) {
									return A2(
										$author$project$Common$DropDown$item,
										$author$project$User$Msg$Copy(adr),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$copy),
														$elm$html$Html$text(' ')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Translations$Wallet$copyXAddress, t, kind)),
														A2(
														$elm$html$Html$div,
														$author$project$User$View$c.gG,
														$author$project$Shared$Html$texts(
															A2($author$project$Shared$Text$ellipsis, 20, adr)))
													]))
											]));
								});
							return _List_fromArray(
								[
									A2(
									copy,
									$author$project$Translations$Wallet$eth(t),
									$author$project$Shared$Waves$Address$toEth(address)),
									A2(
									copy,
									$author$project$Translations$Wallet$waves(t),
									wavesAddress)
								]);
						} else {
							return $elm$core$List$singleton(
								A3(
									item,
									$author$project$Translations$Wallet$copyAddress(t),
									$lattyware$elm_fontawesome$FontAwesome$Solid$copy,
									$author$project$User$Msg$Copy(wavesAddress)));
						}
					}();
					return _List_fromArray(
						[
							$author$project$Common$Dialog$background(
							$author$project$User$Msg$Open(false)),
							$author$project$Common$DropDown$menu(
							$author$project$Common$DropDown$content(
								_Utils_ap(
									copyAddresses,
									_List_fromArray(
										[
											A3(
											item,
											$author$project$Translations$User$switchAccount(t),
											$lattyware$elm_fontawesome$FontAwesome$Solid$random,
											$author$project$User$Msg$SwitchAccount),
											A3(
											item,
											$author$project$Translations$User$logout(t),
											$lattyware$elm_fontawesome$FontAwesome$Solid$signOutAlt,
											$author$project$User$Msg$Logout)
										]))))
						]);
				} else {
					return _List_Nil;
				}
			}();
			return A2(
				$author$project$Common$DropDown$view,
				model.jk,
				A2(
					$elm$core$List$cons,
					$author$project$Common$DropDown$trigger(
						A2(
							$author$project$Common$Button$text,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$User$Msg$Open(!model.jk))
								]),
							A2(
								$author$project$Shared$Text$ellipsis,
								10,
								A2($author$project$Shared$Waves$View$displayAddress, metamask, address)))),
					dropdown));
		}
	});
var $author$project$Layout$View$login = function (t) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$User$View$view(t),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			A2(
				$elm$core$Basics$composeR,
				$elm$html$Html$div(
					_List_fromArray(
						[$author$project$User$View$c.eU])),
				$elm$html$Html$map($author$project$Msg$User))));
};
var $author$project$Msg$ToggleNavigation = function (a) {
	return {$: 20, a: a};
};
var $author$project$Common$Attributes$ariaExpandedFalse = A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false');
var $author$project$Common$Attributes$ariaExpandedTrue = A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'true');
var $author$project$Common$Attributes$aria = {
	hW: A2($author$project$Common$Base$iff, $author$project$Common$Attributes$ariaExpandedTrue, $author$project$Common$Attributes$ariaExpandedFalse),
	ig: A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
	iy: $elm$html$Html$Attributes$attribute('aria-label')
};
var $author$project$Common$Attributes$role = $elm$html$Html$Attributes$attribute('role');
var $author$project$Common$Navbar$c = {
	dl: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('navbar-brand')
		]),
	dm: _List_fromArray(
		[
			$author$project$Common$Attributes$role('button'),
			$elm$html$Html$Attributes$class('navbar-burger'),
			$author$project$Common$Attributes$aria.iy('menu')
		]),
	eK: $elm$html$Html$Attributes$class('navbar-item'),
	fa: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('navbar'),
			$author$project$Common$Attributes$role('navigation'),
			$author$project$Common$Attributes$aria.iy('main navigation')
		])
};
var $author$project$Common$Navbar$brand = $elm$html$Html$div($author$project$Common$Navbar$c.dl);
var $author$project$Common$Navbar$burgerBody = A2(
	$elm$core$List$repeat,
	3,
	A2(
		$elm$html$Html$span,
		_List_fromArray(
			[$author$project$Common$Attributes$aria.ig]),
		_List_Nil));
var $author$project$Common$Navbar$burger = F3(
	function (msg, attrs, expanded) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$author$project$Common$Attributes$aria.hW(expanded),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						msg(!expanded)),
					_Utils_ap(
						$author$project$Common$Navbar$c.dm,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Common$Attributes$is.gT(expanded)
								]),
							attrs)))),
			$author$project$Common$Navbar$burgerBody);
	});
var $author$project$Common$Navbar$item = function (attrs) {
	return $elm$html$Html$a(
		A2($elm$core$List$cons, $author$project$Common$Navbar$c.eK, attrs));
};
var $author$project$Layout$View$logoParts = _List_fromArray(
	['Vires', 'Finance']);
var $author$project$Layout$View$textLogo = function () {
	var _v0 = A2(
		$elm$core$List$map,
		$author$project$Shared$Html$textSpan(_List_Nil),
		$author$project$Layout$View$logoParts);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var vires = _v0.a;
		var _v1 = _v0.b;
		var finance = _v1.a;
		return _List_fromArray(
			[
				vires,
				A2($elm$html$Html$div, $author$project$Layout$View$c.dY, _List_Nil),
				$author$project$Shared$Html$newLine,
				finance
			]);
	} else {
		return _List_Nil;
	}
}();
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Common$Navbar$view = $elm$html$Html$nav($author$project$Common$Navbar$c.fa);
var $author$project$Layout$View$navbar = F2(
	function (right, model) {
		return $author$project$Common$Navbar$view(
			$elm$core$List$singleton(
				$author$project$Common$Navbar$brand(
					_List_fromArray(
						[
							A2($author$project$Common$Navbar$item, $author$project$Layout$View$c.cE, $author$project$Layout$View$textLogo),
							A2(
							$elm$html$Html$map,
							$author$project$Msg$User,
							A2(
								$author$project$Common$Navbar$item,
								_List_fromArray(
									[$author$project$User$View$c.eU]),
								$elm$core$List$singleton(
									A2($author$project$User$View$view, model.kT, model.kZ)))),
							A3($author$project$Common$Navbar$burger, $author$project$Msg$ToggleNavigation, _List_Nil, model.i7),
							A3(
							$author$project$Common$Base$iff,
							$author$project$Shared$Html$nothing,
							A2(
								$author$project$Shared$Html$try,
								$author$project$Governance$Voting$View$active(_List_Nil),
								model.cZ),
							model.i7),
							right
						]))));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $lattyware$elm_fontawesome$FontAwesome$Solid$slidersH = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'sliders-h',
	512,
	512,
	_List_fromArray(
		['M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z']));
var $lattyware$elm_fontawesome$FontAwesome$Brands$medium = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'medium',
	448,
	512,
	_List_fromArray(
		['M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z']));
var $lattyware$elm_fontawesome$FontAwesome$Brands$telegram = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'telegram',
	496,
	512,
	_List_fromArray(
		['M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z']));
var $lattyware$elm_fontawesome$FontAwesome$Brands$twitter = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'twitter',
	512,
	512,
	_List_fromArray(
		['M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z']));
var $author$project$Layout$Social$media = _List_fromArray(
	[
		_Utils_Tuple3(
		'Twitter',
		$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Brands$twitter),
		'https://twitter.com/viresfinance'),
		_Utils_Tuple3(
		'Medium',
		$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Brands$medium),
		'https://medium.com/vires-finance'),
		_Utils_Tuple3(
		'Telegram Announcements',
		$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Brands$telegram),
		'https://t.me/vf_announcements'),
		_Utils_Tuple3(
		'CoinGecko',
		A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon coin-gecko')
				]),
			_List_Nil),
		'https://www.coingecko.com/en/coins/vires-finance'),
		_Utils_Tuple3(
		'CoinMarketCap',
		A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon coin-market-cap')
				]),
			_List_Nil),
		'https://coinmarketcap.com/currencies/vires-finance/')
	]);
var $author$project$Layout$View$social = function () {
	var item = function (_v0) {
		var label = _v0.a;
		var icon = _v0.b;
		var url = _v0.c;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(url),
					$author$project$Common$Attributes$blank,
					$elm$html$Html$Attributes$title(label)
				]),
			$elm$core$List$singleton(icon));
	};
	return A2(
		$elm$html$Html$div,
		$author$project$Layout$View$c.f1,
		A2($elm$core$List$map, item, $author$project$Layout$Social$media));
}();
var $author$project$Layout$View$stickyTop = $elm$html$Html$div(
	_List_fromArray(
		[$author$project$Layout$View$c.gk, $author$project$Layout$View$c.a7]));
var $author$project$Layout$View$socialSeparator = $elm$html$Html$text($author$project$Shared$Text$nbsp + ('|' + $author$project$Shared$Text$nbsp));
var $author$project$Layout$Social$support = _List_fromArray(
	[
		_Utils_Tuple2('Eng', 'https://t.me/viresfinance'),
		_Utils_Tuple2('Esp', 'https://t.me/ViresFinanceESP'),
		_Utils_Tuple2('Ru', 'https://t.me/viresfinanceru')
	]);
var $author$project$Layout$View$support = function () {
	var item = function (_v0) {
		var lang = _v0.a;
		var link = _v0.b;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(link),
					$author$project$Common$Attributes$blank
				]),
			$author$project$Shared$Html$texts(lang));
	};
	return A2(
		$elm$html$Html$div,
		$author$project$Layout$View$c.gc,
		A2(
			$elm$core$List$cons,
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Brands$telegram),
			A2(
				$elm$core$List$intersperse,
				$author$project$Layout$View$socialSeparator,
				A2($elm$core$List$map, item, $author$project$Layout$Social$support))));
}();
var $author$project$Translations$VTokens$vTokens = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.vTokens');
};
var $author$project$Msg$CloseNotification = {$: 21};
var $author$project$Common$NotificationBar$c = {
	fd: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('notification')
		])
};
var $author$project$Common$NotificationBar$view = function (t) {
	return A2(
		$elm$html$Html$div,
		$author$project$Common$NotificationBar$c.fd,
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('close'),
						$elm$html$Html$Events$onClick($author$project$Msg$CloseNotification)
					]),
				_List_Nil),
			$author$project$Common$Markdown$view(
				$author$project$Translations$notificationBarMD(t))));
};
var $author$project$Common$Toast$c = {
	hS: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-error')
		]),
	ip: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-success')
		]),
	f9: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-success')
		])
};
var $author$project$Translations$Home$Borrow$borrow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.borrow.borrow');
};
var $author$project$Translations$VTokens$mint = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.mint');
};
var $author$project$Translations$VTokens$redeem = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.redeem');
};
var $author$project$Translations$Home$Repay$repayFromSupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.repay.repayFromSupply');
};
var $author$project$Translations$VTokens$replenish = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.replenish');
};
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$Toast$humanReadableCommand = F2(
	function (t, c) {
		switch (c) {
			case 'withdraw2':
				return $author$project$Translations$Home$Withdraw$withdraw(t);
			case 'borrow2':
				return $author$project$Translations$Home$Borrow$borrow(t);
			case 'deposit':
				return $author$project$Translations$Home$Supply$supply(t);
			case 'depositEarlyBirdRefBonus':
				return $author$project$Translations$Home$Supply$supply(t);
			case 'collapseDebt':
				return $author$project$Translations$Home$Repay$repayFromSupply(t);
			case 'claimEbReward':
				return $author$project$Translations$Home$Vires$claim(t);
			case 'claimReward':
				return $author$project$Translations$Home$Vires$claim(t);
			case 'withdrawAllPossibleVires':
				return $author$project$Translations$Governance$MyVires$withdrawUnlocked(t);
			case 'claimAllRewardsAndAllEbAvailable2':
				return $author$project$Translations$Home$Vires$claim(t);
			case 'mintAtoken':
				return $author$project$Translations$VTokens$mint(t);
			case 'replenishWithAtoken':
				return $author$project$Translations$VTokens$replenish(t);
			case 'redeemAtokens':
				return $author$project$Translations$VTokens$redeem(t);
			case 'lock':
				return $author$project$Translations$Governance$MyVires$lock(t);
			case 'claimProtocolProfitFrom':
				return $author$project$Translations$Governance$ClaimRevenue$claimRevenue(t);
			case 'setClaimDelegation':
				return $author$project$Translations$Governance$MyVires$delegateClaim(t);
			case 'removeClaimDelegation':
				return $author$project$Translations$Governance$Delegate$removeDelegation(t);
			case 'voteYes':
				return 'Yes';
			case 'voteNo':
				return 'No';
			case 'lockSupply':
				return 'Lock supply';
			case 'withdrawSlashedLockedLPTokens':
				return 'Premature unlock';
			case 'vestingAllClaimRewards':
				return 'Claim vesting rewards';
			case 'supplyUnlockedLPTokens':
				return 'Unlock supply';
			case 'withdrawVestedAllUSDN':
				return 'Withdraw Vested';
			case 'withdrawAsLP':
				return 'Withdraw Vested XTN as LP tokens';
			case 'withdrawVestedRegularToL2':
				return 'Withdraw L2MP';
			default:
				return $elm_community$string_extra$String$Extra$toSentenceCase(c);
		}
	});
var $author$project$Shared$Transaction$Explorer$waves = $elm$core$Basics$append('https://wavesexplorer.com/tx/');
var $author$project$Toast$link = function (_v0) {
	var id = _v0.bP;
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				$author$project$Shared$Transaction$Explorer$waves(id)),
				$author$project$Common$Attributes$blank
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Transaction id: ' + A2($author$project$Shared$Text$ellipsis, 10, id))
			]));
};
var $author$project$Common$Toast$c_ = {
	dG: $elm$html$Html$Attributes$class('toasty-container'),
	dH: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-content')
		]),
	ey: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-icon')
		]),
	e_: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-message')
		]),
	kB: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('toasty-title')
		])
};
var $author$project$Common$Toast$view = F3(
	function (title, attrs, body) {
		return A2(
			$elm$html$Html$div,
			A2($elm$core$List$cons, $author$project$Common$Toast$c_.dG, attrs),
			_List_fromArray(
				[
					A2($elm$html$Html$div, $author$project$Common$Toast$c_.ey, _List_Nil),
					A2(
					$elm$html$Html$div,
					$author$project$Common$Toast$c_.dH,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							$author$project$Common$Toast$c_.kB,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2($elm$html$Html$p, $author$project$Common$Toast$c_.e_, body)
						]))
				]));
	});
var $author$project$Common$Toast$succeed = A2($author$project$Common$Toast$view, 'Success', $author$project$Common$Toast$c.f9);
var $author$project$Gateway$Shared$Toast$amount = F2(
	function (assets, data) {
		return $elm$html$Html$text(
			function () {
				var _v0 = A2($author$project$Common$List$getById, data.g5, assets);
				if (!_v0.$) {
					var asset = _v0.a;
					return A2(
						$author$project$Shared$Text$formatCurrency,
						asset.ac,
						A2($author$project$Shared$Market$Logic$inOrig, asset, data.gZ));
				} else {
					return '(unknown asset)';
				}
			}());
	});
var $author$project$Gateway$Shared$Toast$view = F4(
	function (assets, data, caption, texts) {
		return A3(
			$author$project$Common$Toast$view,
			caption,
			$author$project$Common$Toast$c.f9,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('#gateway_history')
						]),
					A2(
						$elm$core$List$intersperse,
						$author$project$Shared$Html$newLine,
						A2(
							$elm$core$List$cons,
							A2($author$project$Gateway$Shared$Toast$amount, assets, data),
							A2(
								$elm$core$List$map,
								$elm$html$Html$text,
								_Utils_ap(
									texts,
									_List_fromArray(
										['Click for details']))))))));
	});
var $author$project$Gateway$Send$Toast$view = F2(
	function (assets, data) {
		return A4(
			$author$project$Gateway$Shared$Toast$view,
			assets,
			data,
			'Send Started',
			_List_fromArray(
				[
					'from ' + $author$project$Gateway$Shared$View$platformName('WAVES'),
					' to ' + $author$project$Gateway$Shared$View$platformName(data.ju)
				]));
	});
var $author$project$Gateway$Topup$Toast$view = F2(
	function (assets, data) {
		return A4(
			$author$project$Gateway$Shared$Toast$view,
			assets,
			data,
			'Top-up Started',
			_List_fromArray(
				[
					'from ' + $author$project$Gateway$Shared$View$platformName(data.ju),
					' to ' + $author$project$Gateway$Shared$View$platformName('WAVES')
				]));
	});
var $author$project$Gateway$Toast$view = F2(
	function (assets, toast) {
		if (!toast.$) {
			var t = toast.a;
			return A2($author$project$Gateway$Topup$Toast$view, assets, t);
		} else {
			var t = toast.a;
			return A2($author$project$Gateway$Send$Toast$view, assets, t);
		}
	});
var $author$project$Toast$view = F4(
	function (t, vires, assets, toast) {
		switch (toast.$) {
			case 0:
				var tx = toast.a;
				var commandLabel = A2($author$project$Toast$humanReadableCommand, t, tx.dD);
				var amountParts = function () {
					if (!tx.gZ) {
						return _List_Nil;
					} else {
						var amount = function () {
							var _v1 = _Utils_Tuple2(
								A2($author$project$Common$List$getById, tx.g5, assets),
								_Utils_eq(tx.g5, vires.bP));
							if (!_v1.a.$) {
								var asset = _v1.a.a;
								return A2(
									$author$project$Shared$Text$formatCurrency,
									asset.ac,
									A2($author$project$Shared$Market$Logic$inOrig, asset, tx.gZ));
							} else {
								if (_v1.b) {
									return A2(
										$author$project$Shared$Text$formatCurrency,
										vires.ac,
										A2($author$project$Shared$Market$Logic$inOrig, vires, tx.gZ));
								} else {
									return $elm$core$String$fromInt(tx.gZ);
								}
							}
						}();
						return _List_fromArray(
							['of', amount]);
					}
				}();
				return $author$project$Common$Toast$succeed(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($elm$core$List$cons, commandLabel, amountParts))),
							$author$project$Shared$Html$newLine,
							$author$project$Toast$link(tx)
						]));
			case 4:
				var err = toast.a;
				return A3(
					$author$project$Common$Toast$view,
					'Error',
					$author$project$Common$Toast$c.hS,
					_List_fromArray(
						[
							$elm$html$Html$text(err)
						]));
			case 1:
				var tx = toast.a;
				var asset = A2(
					$elm$core$Maybe$withDefault,
					'unknown',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ac;
						},
						A2($author$project$Common$List$getById, tx.g5, assets)));
				return $author$project$Common$Toast$succeed(
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Collateral\u00A0' + (A3($author$project$Common$Base$iff, 'enable', 'disabled', tx.r) + (' for ' + asset))),
							$author$project$Shared$Html$newLine,
							$author$project$Toast$link(tx)
						]));
			case 5:
				var string = toast.a;
				return A3(
					$author$project$Common$Toast$view,
					'Copied to clipboard',
					$author$project$Common$Toast$c.f9,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Shared$Text$ellipsis, 25, string))
						]));
			case 3:
				var toast_ = toast.a;
				return A2($author$project$Gateway$Toast$view, assets, toast_);
			default:
				var info = toast.a;
				return A3(
					$author$project$Common$Toast$view,
					'Info',
					$author$project$Common$Toast$c.ip,
					_List_fromArray(
						[
							$elm$html$Html$text(info)
						]));
		}
	});
var $pablen$toasty$Toasty$itemContainer = F4(
	function (_v0, tagger, _v1, toastView) {
		var cfg = _v0;
		var id = _v1.a;
		var status = _v1.b;
		var toast = _v1.c;
		var attrs = function () {
			if (!status) {
				return cfg.cI;
			} else {
				return cfg.cJ;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$String$fromInt(id),
			A2(
				$elm$html$Html$li,
				_Utils_ap(
					cfg.bY,
					_Utils_ap(
						attrs,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								tagger(
									$pablen$toasty$Toasty$TransitionOut(id)))
							]))),
				_List_fromArray(
					[
						toastView(toast)
					])));
	});
var $elm$html$Html$Keyed$ol = $elm$html$Html$Keyed$node('ol');
var $pablen$toasty$Toasty$view = F4(
	function (cfg, toastView, tagger, _v0) {
		var toasts = _v0.a;
		var seed = _v0.b;
		var _v1 = cfg;
		var c = _v1;
		return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$Keyed$ol,
			c.br,
			A2(
				$elm$core$List$map,
				function (toast) {
					return A4($pablen$toasty$Toasty$itemContainer, cfg, tagger, toast, toastView);
				},
				toasts));
	});
var $author$project$Layout$View$body = F4(
	function (t, model, map, pageBody) {
		var toasties = A4(
			$pablen$toasty$Toasty$view,
			$author$project$Common$Toast$config,
			A3($author$project$Toast$view, t, model.h3.k8, model.g6),
			$author$project$Msg$ToastyMsg,
			model.kJ);
		var page = A2(
			$elm$html$Html$div,
			$author$project$Layout$View$c.jo,
			A2(
				$elm$core$List$map,
				$elm$html$Html$map(map),
				pageBody));
		var menu = function (_v4) {
			var mainMenu = function () {
				var textLabel = A2(
					$elm$core$Basics$composeR,
					$author$project$Shared$Html$textSpan($author$project$Layout$View$c.iy),
					$elm$core$List$singleton);
				var item = F3(
					function (icon, url, label_) {
						var activeOrNot = function (ref) {
							return _Utils_eq(
								'/' + ref,
								$elm$core$String$toLower(url));
						};
						var isActive = function () {
							var _v3 = model.jo;
							switch (_v3.$) {
								case 2:
									return activeOrNot($author$project$Route$url.gD);
								case 0:
									return activeOrNot('');
								case 3:
									return activeOrNot($author$project$Route$url.ic);
								default:
									return false;
							}
						}();
						return $author$project$Common$Menu$item(
							$elm$core$List$singleton(
								A3(
									$author$project$Common$Menu$link,
									isActive,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$href(url),
										A3(
											$author$project$Common$Base$iff,
											_List_fromArray(
												[$author$project$Common$Attributes$blank]),
											_List_Nil,
											A2($elm$core$String$contains, '://', url))),
									A2(
										$elm$core$List$cons,
										A3($author$project$Common$Base$iff, $author$project$Layout$View$activeCheck, $author$project$Shared$Html$nothing, isActive),
										A2(
											$elm$core$List$cons,
											$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(icon),
											label_)))));
					});
				return _List_fromArray(
					[
						A3(
						item,
						$lattyware$elm_fontawesome$FontAwesome$Solid$home,
						$author$project$Route$url.ij,
						textLabel(
							$author$project$Translations$Menu$home(t))),
						A3(
						item,
						$lattyware$elm_fontawesome$FontAwesome$Brands$ethereum,
						'#gateway',
						textLabel(
							$author$project$Translations$Menu$bridge(t))),
						A3(
						item,
						$lattyware$elm_fontawesome$FontAwesome$Solid$slidersH,
						'/' + $author$project$Route$url.ic,
						_List_fromArray(
							[
								A2(
								$author$project$Shared$Html$textSpan,
								A2($elm$core$List$cons, $author$project$Layout$View$c.eo, $author$project$Layout$View$c.iy),
								$author$project$Translations$Governance$governance(t)),
								A2(
								$author$project$Shared$Html$try,
								$author$project$Governance$Voting$View$active($author$project$Layout$View$c.fe),
								model.cZ)
							])),
						A3(
						item,
						$lattyware$elm_fontawesome$FontAwesome$Solid$coins,
						'/' + $author$project$Route$url.gD,
						textLabel(
							$author$project$Translations$VTokens$vTokens(t)))
					]);
			}();
			var infoItemExpander = $author$project$Common$Menu$item(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Msg$InfoMenuToggled)
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(
								A3($author$project$Common$Base$iff, $lattyware$elm_fontawesome$FontAwesome$Solid$angleDown, $lattyware$elm_fontawesome$FontAwesome$Solid$angleRight, model.iq)),
								A2(
								$author$project$Shared$Html$textSpan,
								$author$project$Layout$View$c.iy,
								$author$project$Translations$info(t))
							]))
					]));
			var infoItem = function (_v2) {
				var label = _v2.a;
				var icon = _v2.b;
				var url = _v2.c;
				return $author$project$Common$Menu$item(
					_List_fromArray(
						[
							A3(
							$author$project$Common$Menu$link,
							false,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$author$project$Common$Attributes$blank
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon(icon),
									A2($author$project$Shared$Html$textSpan, $author$project$Layout$View$c.iy, label)
								]))
						]));
			};
			var moreItems = model.iq ? A2(
				$elm$core$List$cons,
				infoItemExpander,
				A2(
					$elm$core$List$map,
					infoItem,
					$author$project$Layout$Links$links(t))) : _List_fromArray(
				[infoItemExpander]);
			return A2(
				$elm$core$List$intersperse,
				$author$project$Shared$Html$hr,
				_List_fromArray(
					[
						A2(
						$author$project$Common$Menu$list,
						$author$project$Layout$View$c.fa,
						_Utils_ap(mainMenu, moreItems)),
						$author$project$Layout$View$support,
						$author$project$Layout$View$social,
						$author$project$Layout$View$languages(model.iz)
					]));
		};
		var isWidescreen = $author$project$Common$Screen$isWidescreen(model.j3);
		var marginTopAttrs = function () {
			var _v1 = _Utils_Tuple2(isWidescreen, model.je);
			if (_v1.a) {
				if (_v1.b) {
					return $author$project$Layout$View$c.bM;
				} else {
					return _List_Nil;
				}
			} else {
				if (_v1.b) {
					return A2($elm$core$List$cons, $author$project$Layout$View$c.bN, $author$project$Layout$View$c.bM);
				} else {
					return _List_fromArray(
						[$author$project$Layout$View$c.bN]);
				}
			}
		}();
		var main = A2(
			$elm$html$Html$div,
			A2($elm$core$List$cons, $author$project$Shared$Layout$c.dG, marginTopAttrs),
			isWidescreen ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					$author$project$Layout$View$c.dj,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$aside,
							_List_fromArray(
								[$author$project$Layout$View$c.eN, $author$project$Layout$View$c.a7]),
							_Utils_ap(
								_List_fromArray(
									[
										A2($elm$html$Html$a, $author$project$Layout$View$c.cE, $author$project$Layout$View$textLogo),
										A2(
										$elm$html$Html$div,
										$author$project$Layout$View$c.eV,
										$elm$core$List$singleton(
											A3($elm$html$Html$Lazy$lazy2, $author$project$Layout$View$login, model.kT, model.kZ)))
									]),
								menu(0))),
							page
						])),
					$author$project$Layout$View$footer
				]) : _List_fromArray(
				[page, $author$project$Layout$View$footer]));
		var right_ = model.i7 ? A2(
			$elm$html$Html$aside,
			A2(
				$elm$core$List$cons,
				$author$project$Layout$View$c.fO,
				A2($elm$core$List$cons, $author$project$Layout$View$c.a7, marginTopAttrs)),
			menu(0)) : $author$project$Shared$Html$nothing;
		var top = function () {
			var _v0 = _Utils_Tuple2(isWidescreen, model.je);
			if (_v0.a) {
				if (_v0.b) {
					return $author$project$Layout$View$stickyTop(
						$elm$core$List$singleton(
							$author$project$Common$NotificationBar$view(model.kT)));
				} else {
					return $author$project$Shared$Html$nothing;
				}
			} else {
				if (_v0.b) {
					return $author$project$Layout$View$stickyTop(
						_List_fromArray(
							[
								$author$project$Common$NotificationBar$view(model.kT),
								A2($author$project$Layout$View$navbar, right_, model)
							]));
				} else {
					return $author$project$Layout$View$stickyTop(
						$elm$core$List$singleton(
							A2($author$project$Layout$View$navbar, right_, model)));
				}
			}
		}();
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$author$project$Layout$View$c.d2,
					A3(
					$author$project$Common$Base$iff,
					$author$project$Layout$View$c.eT,
					$author$project$Layout$View$c.fc,
					$author$project$User$Logic$isLoggedIn(model.kZ))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2('css', $lattyware$elm_fontawesome$FontAwesome$Styles$css),
					_Utils_Tuple2('top', top),
					_Utils_Tuple2('main', main),
					_Utils_Tuple2('toasties', toasties)
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $author$project$Layout$View$viresFinance = A2($elm$core$String$join, '.', $author$project$Layout$View$logoParts);
var $author$project$Layout$View$view = F4(
	function (t, model, map, page) {
		return {
			dj: _List_fromArray(
				[
					A5($elm$html$Html$Lazy$lazy4, $author$project$Layout$View$body, t, model, map, page.dj)
				]),
			kB: page.kB + (' – ' + $author$project$Layout$View$viresFinance)
		};
	});
var $author$project$Loading$view = function (countDown) {
	return {
		dj: _List_fromArray(
			[
				$elm$html$Html$text(
				'Loading ' + $elm$core$String$fromInt(countDown))
			]),
		kB: 'Loading ' + ($elm$core$String$fromInt(countDown) + '...')
	};
};
var $author$project$MarketDetail$Msg$AddToMetaMask = function (a) {
	return {$: 4, a: a};
};
var $author$project$MarketDetail$Msg$ChangeShowApy = function (a) {
	return {$: 2, a: a};
};
var $author$project$MarketDetail$Msg$Copy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Translations$Market$adaptiveLimits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.adaptiveLimits');
};
var $author$project$Common$Maybe$always = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $elm$core$Maybe$map);
var $author$project$Translations$apy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'apy');
};
var $author$project$Translations$Market$assetId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.assetId');
};
var $author$project$Translations$toMain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'toMain');
};
var $author$project$MarketDetail$View$back = function (t) {
	return A2(
		$author$project$Common$Button$secondaryLink,
		'/',
		$author$project$Translations$toMain(t));
};
var $author$project$MarketDetail$View$c = {
	gT: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('active')
		]),
	c$: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('additional-infos')
		]),
	c5: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('switch')
		]),
	dn: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('buttons')
		]),
	hf: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('charts')
		]),
	eG: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('interest-rate-model')
		]),
	it: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('intervals')
		]),
	iC: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('limits')
		]),
	b1: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('market-details')
		]),
	e5: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('muted')
		]),
	fk: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('on-off')
		])
};
var $author$project$Translations$Market$collateralFactor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.collateralFactor');
};
var $author$project$Translations$Market$collateralFactorTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.collateralFactorTooltip');
};
var $author$project$Translations$Market$compounding = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.compounding');
};
var $author$project$Translations$Market$currentUtilization = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.currentUtilization');
};
var $author$project$Translations$Market$disabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.disabled');
};
var $author$project$Translations$Market$enabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.enabled');
};
var $author$project$Shared$Asset$View$info = F7(
	function (t, mm, attrs, title, addToMetaMaskMsg, copyMsg, asset) {
		var assetId = asset;
		var linkToExplorer = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://wavesexplorer.com/assets/' + assetId),
					$author$project$Common$Attributes$blank
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Shared$Text$ellipsis,
						10,
						A2($author$project$Shared$Waves$View$displayAsset, mm, asset)))
				]));
		var addToMetamask = (mm && (!$author$project$Shared$Asset$Model$isWaves(assetId))) ? A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					addToMetaMaskMsg(asset)),
					$elm$html$Html$Attributes$class('add-to metamask')
				]),
			_List_Nil) : $author$project$Shared$Html$nothing;
		return A3(
			$author$project$Shared$Info$rowN,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('asset'),
				attrs),
			title,
			_List_fromArray(
				[
					linkToExplorer,
					$author$project$Common$Copy$icon(
					copyMsg(assetId)),
					addToMetamask
				]));
	});
var $author$project$Common$Tooltip$infoWithLink = function (link) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(link),
				$author$project$Common$Attributes$blank
			]),
		$elm$core$List$singleton(
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$infoCircle)));
};
var $author$project$Translations$Market$interestRateModel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.interestRateModel');
};
var $author$project$Shared$Market$Logic$isPaused = F3(
	function (m, utilization_, map) {
		var _v0 = A2($elm$core$Maybe$andThen, map, m.kw);
		if (!_v0.$) {
			var th = _v0.a;
			return A3(
				$author$project$Common$Base$iff,
				$elm$core$Maybe$Just(th),
				$elm$core$Maybe$Nothing,
				_Utils_cmp(utilization_, th) > -1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$Market$leasingAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.leasingAPR');
};
var $author$project$Translations$Market$lendingAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.lendingAPR');
};
var $author$project$Translations$Market$lendingAPRTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.lendingAPRTooltip');
};
var $author$project$Translations$Market$lendingAPYTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.lendingAPYTooltip');
};
var $author$project$Translations$Market$liquidationPenalty = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.liquidationPenalty');
};
var $author$project$Translations$Market$liquidationPenaltyTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.liquidationPenaltyTooltip');
};
var $author$project$Translations$Market$liquidationThreshold = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.liquidationThreshold');
};
var $author$project$Translations$Market$liquidationThresholdTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.liquidationThresholdTooltip');
};
var $author$project$Translations$Market$market = F2(
	function (translations, asset) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'market.market',
			_List_fromArray(
				[
					_Utils_Tuple2('asset', asset)
				]));
	});
var $author$project$Translations$Market$off = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.off');
};
var $author$project$Translations$Market$on = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.on');
};
var $author$project$Translations$Market$paused = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.paused');
};
var $author$project$Translations$Market$reserveAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.reserveAddress');
};
var $author$project$Translations$Market$reserveFactor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.reserveFactor');
};
var $author$project$Translations$Market$reserveFactorTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.reserveFactorTooltip');
};
var $author$project$Translations$Market$stakingAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.stakingAPR');
};
var $author$project$Translations$Market$supplyAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.supplyAPR');
};
var $author$project$Common$Card$titleInside = $elm$html$Html$header($author$project$Common$Card$c.eD);
var $author$project$Translations$Market$totalAPRTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.totalAPRTooltip');
};
var $author$project$Translations$totalBorrowableSupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalBorrowableSupply');
};
var $author$project$Translations$totalBorrowableSupplyTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalBorrowableSupplyTooltip');
};
var $author$project$Translations$totalLockedSupply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalLockedSupply');
};
var $author$project$Translations$totalLockedSupplyTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalLockedSupplyTooltip');
};
var $author$project$Translations$totalProtectedCollateral = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalProtectedCollateral');
};
var $author$project$Translations$totalProtectedCollateralTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'totalProtectedCollateralTooltip');
};
var $author$project$Translations$Market$utilization = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.utilization');
};
var $author$project$Translations$Market$utilizationVsMD = F2(
	function (translations, apx) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'market.utilizationVsMD',
			_List_fromArray(
				[
					_Utils_Tuple2('apx', apx)
				]));
	});
var $author$project$Translations$Market$vTokenId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.vTokenId');
};
var $author$project$MarketDetail$Msg$ResetUtilization = {$: 1};
var $author$project$MarketDetail$Msg$SetUtilization = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$Apy$allStops = function (_v0) {
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$toFloat,
			$elm$core$Basics$mul(0.01)),
		A2($elm$core$List$range, 0, 100));
};
var $author$project$MarketDetail$InterestRateModel$c = {
	c6: $elm$svg$Svg$Attributes$class('apy'),
	dk: $elm$svg$Svg$Attributes$class('borrow'),
	bu: $elm$svg$Svg$Attributes$class('current'),
	dL: $elm$svg$Svg$Attributes$class('cursor'),
	aM: 'curves',
	dY: $elm$svg$Svg$Attributes$class('dot'),
	eQ: $elm$svg$Svg$Attributes$class('line'),
	fQ: $elm$svg$Svg$Attributes$class('ruler'),
	gb: $elm$svg$Svg$Attributes$class('supply'),
	k3: $elm$svg$Svg$Attributes$class('utilization')
};
var $author$project$MarketDetail$InterestRateModel$containerPredicate = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$eq($author$project$MarketDetail$InterestRateModel$c.aM),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
var $author$project$Shared$Apy$curve = F3(
	function (stops, fApr, model) {
		return A2(
			$elm$core$List$map,
			function (x) {
				return _Utils_Tuple2(
					x,
					A2(fApr, model, x));
			},
			stops(model));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $author$project$MarketDetail$InterestRateModel$defs_ = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A3(
			$elm$svg$Svg$node,
			'filter',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'height', '1'),
					$elm$svg$Svg$Attributes$id('solid'),
					A2($elm$html$Html$Attributes$attribute, 'width', '1'),
					A2($elm$html$Html$Attributes$attribute, 'x', '0'),
					A2($elm$html$Html$Attributes$attribute, 'y', '0')
				]),
			_List_fromArray(
				[
					A3(
					$elm$svg$Svg$node,
					'feFlood',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'flood-color', 'white'),
							A2($elm$html$Html$Attributes$attribute, 'result', 'bg')
						]),
					_List_Nil),
					A3(
					$elm$svg$Svg$node,
					'feMerge',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$svg$Svg$node,
							'feMergeNode',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'in', 'bg')
								]),
							_List_Nil),
							$elm$svg$Svg$text('        '),
							A3(
							$elm$svg$Svg$node,
							'feMergeNode',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'in', 'SourceGraphic')
								]),
							_List_Nil),
							$elm$svg$Svg$text('      ')
						]))
				]))
		]));
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$Shared$Market$Logic$totalSupplyAPR_ForUtilization = F2(
	function (u, info) {
		return A2(
			$author$project$Common$Maybe$addValue,
			A2($author$project$Shared$Market$Logic$leasingAPR_ForUtilization, u, info),
			A2(
				$author$project$Common$Maybe$addValue,
				A2($author$project$Shared$Market$Logic$stakingAPR_ForUtilization, u, info),
				A2($author$project$Shared$Market$Logic$basicSupplyAPR_ForUtilization, u, info)));
	});
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $author$project$Shared$MouseEvent$MouseEvent = F3(
	function (src, mouse, container) {
		return {dG: container, b4: mouse, cs: src};
	});
var $author$project$Shared$MouseEvent$Element = F4(
	function (offsetLeft, offsetWidth, offsetTop, offsetHeight) {
		return {fg: offsetHeight, b7: offsetLeft, b8: offsetTop, fh: offsetWidth};
	});
var $author$project$Shared$MouseEvent$accumulateViaOffsetParentDecoder = F2(
	function (valueDecoder, cumulated) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$author$project$Shared$MouseEvent$accumulateViaOffsetParentHelper(valueDecoder),
			A2(
				$elm$json$Json$Decode$map,
				function (value) {
					return cumulated + value;
				},
				valueDecoder));
	});
var $author$project$Shared$MouseEvent$accumulateViaOffsetParentHelper = F2(
	function (valueDecoder, cumulated) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return A2($author$project$Shared$MouseEvent$accumulateViaOffsetParentDecoder, valueDecoder, cumulated);
						})),
					$elm$json$Json$Decode$succeed(cumulated)
				]));
	});
var $author$project$Shared$MouseEvent$offsetLeftDecoder = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $author$project$Shared$MouseEvent$pageLeftDecoder = A2($author$project$Shared$MouseEvent$accumulateViaOffsetParentDecoder, $author$project$Shared$MouseEvent$offsetLeftDecoder, 0);
var $author$project$Shared$MouseEvent$offsetTopDecoder = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $author$project$Shared$MouseEvent$pageTopDecoder = A2($author$project$Shared$MouseEvent$accumulateViaOffsetParentDecoder, $author$project$Shared$MouseEvent$offsetTopDecoder, 0);
var $author$project$Shared$MouseEvent$elementDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Shared$MouseEvent$Element,
	$author$project$Shared$MouseEvent$pageLeftDecoder,
	A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float),
	$author$project$Shared$MouseEvent$pageTopDecoder,
	A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float));
var $author$project$Shared$MouseEvent$ifThen = F2(
	function (containerPredicate, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isTrue) {
				return isTrue ? decoder : $elm$json$Json$Decode$fail('no match');
			},
			containerPredicate);
	});
var $author$project$Shared$MouseEvent$containerValues = function (containerPredicate) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($author$project$Shared$MouseEvent$ifThen, containerPredicate, $author$project$Shared$MouseEvent$elementDecoder),
				A2(
				$elm$json$Json$Decode$field,
				'parentElement',
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Shared$MouseEvent$containerValues(containerPredicate);
					}))
			]));
};
var $author$project$Shared$MouseEvent$MousePosition = F2(
	function (offsetX, offsetY) {
		return {fi: offsetX, fj: offsetY};
	});
var $author$project$Shared$MouseEvent$mousePositionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Shared$MouseEvent$MousePosition,
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $author$project$Shared$MouseEvent$mouseEventDecoder = function (containerPredicate) {
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Shared$MouseEvent$MouseEvent,
		A2($elm$json$Json$Decode$field, 'target', $author$project$Shared$MouseEvent$elementDecoder),
		A2($elm$json$Json$Decode$at, _List_Nil, $author$project$Shared$MouseEvent$mousePositionDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'target',
			$author$project$Shared$MouseEvent$containerValues(containerPredicate)));
};
var $author$project$Shared$MouseEvent$relativeX = function (_v0) {
	var src = _v0.cs;
	var mouse = _v0.b4;
	var container = _v0.dG;
	return (src.b7 - container.b7) + mouse.fi;
};
var $author$project$Shared$MouseEvent$xPortion = function (mouseEvent) {
	return $author$project$Shared$MouseEvent$relativeX(mouseEvent) / mouseEvent.dG.fh;
};
var $author$project$Shared$MouseEvent$xAsPortionOf = function (containerPredicate) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Shared$MouseEvent$xPortion,
		$author$project$Shared$MouseEvent$mouseEventDecoder(containerPredicate));
};
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$MarketDetail$InterestRateModel$view = F3(
	function (aprTransform, m, selectedUtilization) {
		var marketUtilization = $author$project$Shared$Market$Logic$utilization(m.f6);
		var utilization = A2($elm$core$Maybe$withDefault, marketUtilization, selectedUtilization);
		var utilizationScale = function () {
			var x_ = $elm$core$String$fromFloat(marketUtilization);
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[$author$project$MarketDetail$InterestRateModel$c.k3]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$line,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x1('0'),
								$elm$svg$Svg$Attributes$y1('-0.28'),
								$elm$svg$Svg$Attributes$x2('1'),
								$elm$svg$Svg$Attributes$y2('-0.28'),
								$author$project$MarketDetail$InterestRateModel$c.eQ
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$line,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x1(x_),
								$elm$svg$Svg$Attributes$y1('-0.26'),
								$elm$svg$Svg$Attributes$x2(x_),
								$elm$svg$Svg$Attributes$y2('-0.16'),
								$author$project$MarketDetail$InterestRateModel$c.bu
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$text_,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x(x_),
								$elm$svg$Svg$Attributes$y('-0.15'),
								$author$project$MarketDetail$InterestRateModel$c.bu
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$text('Current')
							]))
					]));
		}();
		var fromDescartesY = function (y) {
			return 0.85 - y;
		};
		var curve = F3(
			function (stops, fApr, class1) {
				var points1 = A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$map,
						function (_v1) {
							var x = _v1.a;
							var y = _v1.b;
							return $elm$core$String$fromFloat(x) + (',' + $elm$core$String$fromFloat(
								fromDescartesY(y)));
						},
						A3(
							$author$project$Shared$Apy$curve,
							stops,
							F2(
								function (a, b) {
									return aprTransform(
										A2(fApr, a, b));
								}),
							m.ip.eG)));
				return A2(
					$elm$svg$Svg$polyline,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points(points1),
							class1,
							$elm$svg$Svg$Attributes$class('curve')
						]),
					_List_Nil);
			});
		var cursor = function () {
			var x_ = $elm$core$String$fromFloat(utilization);
			var ruler = function () {
				var y1_ = A2(
					$elm$core$Maybe$withDefault,
					'-0.13',
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always('-0.28'),
						selectedUtilization));
				return A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1(x_),
							$elm$svg$Svg$Attributes$y1(y1_),
							$elm$svg$Svg$Attributes$x2(x_),
							$elm$svg$Svg$Attributes$y2('1'),
							$author$project$MarketDetail$InterestRateModel$c.fQ
						]),
					_List_Nil);
			}();
			var dot = F4(
				function (y_, dy_, class_, percent) {
					var label = A2(
						$elm$svg$Svg$text_,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x(x_),
								$elm$svg$Svg$Attributes$y(
								$elm$core$String$fromFloat(y_)),
								class_,
								$author$project$MarketDetail$InterestRateModel$c.c6
							]),
						$elm$core$List$singleton(
							A2(
								$elm$svg$Svg$tspan,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dy(
										$elm$core$String$fromFloat(dy_))
									]),
								$elm$core$List$singleton(
									$elm$svg$Svg$text(
										$author$project$Shared$Text$formatPercentOrDash(percent))))));
					var dot_ = A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx(x_),
								$elm$svg$Svg$Attributes$cy(
								$elm$core$String$fromFloat(y_)),
								$elm$svg$Svg$Attributes$r('0.01'),
								$author$project$MarketDetail$InterestRateModel$c.dY,
								class_
							]),
						_List_Nil);
					return _List_fromArray(
						[dot_, label]);
				});
			var supplyApy_ = F3(
				function (apyValue, dy_, class_) {
					var y_ = fromDescartesY(apyValue);
					return A4(dot, y_, dy_, class_, apyValue);
				});
			var utilizationPoint = A4(dot, -0.28, -0.03, $author$project$MarketDetail$InterestRateModel$c.k3, utilization);
			var apys = function () {
				var totalApy = aprTransform(
					A2($author$project$Shared$Market$Logic$totalSupplyAPR_ForUtilization, utilization, m.ip));
				var borrowApr = aprTransform(
					A2($author$project$Shared$Apy$borrowAPR, m.ip.eG, utilization));
				return (_Utils_cmp(totalApy, borrowApr) < 0) ? _Utils_ap(
					A3(supplyApy_, totalApy, 0.06, $author$project$MarketDetail$InterestRateModel$c.gb),
					A3(supplyApy_, borrowApr, -0.03, $author$project$MarketDetail$InterestRateModel$c.dk)) : _Utils_ap(
					A3(supplyApy_, totalApy, -0.03, $author$project$MarketDetail$InterestRateModel$c.gb),
					A3(supplyApy_, borrowApr, 0.06, $author$project$MarketDetail$InterestRateModel$c.dk));
			}();
			var elements = _Utils_ap(utilizationPoint, apys);
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[$author$project$MarketDetail$InterestRateModel$c.dL]),
				A2($elm$core$List$cons, ruler, elements));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id($author$project$MarketDetail$InterestRateModel$c.aM),
					A2(
					$elm$html$Html$Events$on,
					'mousemove',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$MarketDetail$Msg$SetUtilization,
						$author$project$Shared$MouseEvent$xAsPortionOf($author$project$MarketDetail$InterestRateModel$containerPredicate))),
					$elm$html$Html$Events$onMouseOut($author$project$MarketDetail$Msg$ResetUtilization)
				]),
			$elm$core$List$singleton(
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$viewBox('-0.01 -0.33 1.02 1.14'),
							$elm$svg$Svg$Attributes$class($author$project$MarketDetail$InterestRateModel$c.aM)
						]),
					_List_fromArray(
						[
							$author$project$MarketDetail$InterestRateModel$defs_,
							utilizationScale,
							A3(curve, $author$project$Shared$Apy$allStops, $author$project$Shared$Apy$borrowAPR, $author$project$MarketDetail$InterestRateModel$c.dk),
							A3(
							curve,
							$author$project$Shared$Apy$allStops,
							F2(
								function (_v0, u) {
									return A2($author$project$Shared$Market$Logic$totalSupplyAPR_ForUtilization, u, m.ip);
								}),
							$author$project$MarketDetail$InterestRateModel$c.gb),
							cursor
						]))));
	});
var $author$project$Translations$Market$viresRewardsForLockedSupplyAPR = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'market.viresRewardsForLockedSupplyAPR');
};
var $author$project$MarketDetail$View$wavesInfo = function (t) {
	return A3(
		$author$project$Shared$Info$textRow,
		$author$project$Shared$Info$newSection,
		$author$project$Translations$Market$assetId(t),
		'WAVES');
};
var $author$project$MarketDetail$View$withDot = $elm$core$Basics$append('•\u00A0');
var $author$project$Common$Card$withTitle = F3(
	function (title_, attrs, content_) {
		return A2(
			$author$project$Common$Card$view,
			attrs,
			_List_fromArray(
				[
					$author$project$Common$Card$textTitle(title_),
					$author$project$Common$Card$content(
					$elm$core$List$singleton(content_))
				]));
	});
var $author$project$MarketDetail$View$view = F7(
	function (t, vires, rates, fixedRates, m, loginWith, model) {
		var utilization = $author$project$Shared$Market$Logic$utilization(m.f6);
		var mainDetails = function () {
			var supplyAPYs = function () {
				var totalAPR = $author$project$Shared$Market$Logic$totalSupplyAPR(m);
				var stakingAPR = $author$project$Shared$Market$Logic$stakingAPR(m);
				var mainAPR_APY = F3(
					function (aprTooltip, apyTooltip, apr) {
						return A3(
							$author$project$Shared$Info$row,
							$author$project$Shared$Info$newSection,
							_List_fromArray(
								[
									A2(
									$author$project$Common$Tooltip$abbr,
									aprTooltip,
									$author$project$Translations$Market$supplyAPR(t)),
									$elm$html$Html$text(' / '),
									A2(
									$author$project$Common$Tooltip$abbr,
									apyTooltip,
									$author$project$Translations$apy(t))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									$author$project$MarketDetail$View$c.e5,
									A2(
										$elm$core$List$map,
										$elm$html$Html$text,
										_List_fromArray(
											[
												$author$project$Shared$Text$formatPercentOrDash(apr),
												' / '
											]))),
									$elm$html$Html$text(
									$author$project$Shared$Text$formatPercentOrDash(
										$author$project$Shared$Market$Logic$aprToApy(apr)))
								]));
					});
				var leasingAPR = $author$project$Shared$Market$Logic$leasingAPR(m);
				if (_Utils_eq(leasingAPR, $elm$core$Maybe$Nothing) && _Utils_eq(stakingAPR, $elm$core$Maybe$Nothing)) {
					return _List_fromArray(
						[
							A3(
							mainAPR_APY,
							$author$project$Translations$Market$lendingAPRTooltip(t),
							$author$project$Translations$Market$lendingAPYTooltip(t),
							$author$project$Shared$Market$Logic$basicSupplyAPR(m))
						]);
				} else {
					var total = A3(
						mainAPR_APY,
						$author$project$Translations$Market$totalAPRTooltip(t),
						$author$project$Translations$totalAPYTooltip(t),
						totalAPR);
					var lending = function (additional) {
						return A4(
							$author$project$Shared$Info$rowWithTooltip,
							_List_Nil,
							$author$project$MarketDetail$View$withDot(
								$author$project$Translations$Market$lendingAPR(t)),
							$author$project$Translations$Market$lendingAPRTooltip(t),
							$author$project$Shared$Text$formatPercentOrDash(totalAPR - additional));
					};
					var _v2 = _Utils_Tuple2(leasingAPR, stakingAPR);
					_v2$2:
					while (true) {
						if (!_v2.a.$) {
							if (_v2.b.$ === 1) {
								var la = _v2.a.a;
								var _v3 = _v2.b;
								return _List_fromArray(
									[
										total,
										lending(la),
										A4(
										$author$project$Shared$Info$rowWithTooltip,
										_List_Nil,
										$author$project$MarketDetail$View$withDot(
											$author$project$Translations$Market$leasingAPR(t)),
										$author$project$Translations$Market$leasingAPRTooltip(t),
										$author$project$Shared$Text$formatPercentOrDash(la))
									]);
							} else {
								break _v2$2;
							}
						} else {
							if (!_v2.b.$) {
								var _v4 = _v2.a;
								var sa = _v2.b.a;
								return _List_fromArray(
									[
										total,
										lending(sa),
										A4(
										$author$project$Shared$Info$rowWithTooltip,
										_List_Nil,
										$author$project$MarketDetail$View$withDot(
											$author$project$Translations$Market$stakingAPR(t)),
										A2($author$project$Translations$Market$stakingAPRTooltip, t, m.bh.ac),
										$author$project$Shared$Text$formatPercentOrDash(sa))
									]);
							} else {
								break _v2$2;
							}
						}
					}
					return _List_Nil;
				}
			}();
			var mm = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$User$Logic$isMetaMask, loginWith));
			var hasProtected = m.f6.jD > 0;
			var supplyDetails = function () {
				if (hasProtected) {
					var borrowableSupply = A4(
						$author$project$Shared$Info$rowWithTooltip,
						_List_Nil,
						$author$project$MarketDetail$View$withDot(
							$author$project$Translations$totalBorrowableSupply(t)),
						$author$project$Translations$totalBorrowableSupplyTooltip(t),
						A2(
							$author$project$Shared$Text$formatCurrency2,
							m.bh.ac,
							A2($author$project$Shared$Market$Logic$inOrig, m.bh, m.f6.gb)));
					return _List_fromArray(
						[
							borrowableSupply,
							A4(
							$author$project$Shared$Info$rowWithTooltip,
							_List_Nil,
							$author$project$MarketDetail$View$withDot(
								$author$project$Translations$totalProtectedCollateral(t)),
							$author$project$Translations$totalProtectedCollateralTooltip(t),
							A2(
								$author$project$Shared$Text$formatCurrency2,
								m.bh.ac,
								A2($author$project$Shared$Market$Logic$inOrig, m.bh, m.f6.jD)))
						]);
				} else {
					return _List_Nil;
				}
			}();
			var hasLocked = m.f6.iL > 0;
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Shared$Info$rowWithTooltip,
							_List_Nil,
							$author$project$Translations$totalSupply(t),
							$author$project$Translations$totalSupplyTooltip(t),
							A2(
								$author$project$Shared$Text$formatCurrency2,
								m.bh.ac,
								A2(
									$author$project$Shared$Market$Logic$inOrig,
									m.bh,
									$author$project$Shared$Market$Logic$marketTotalSupply(m.f6))))
						]),
					_Utils_ap(
						supplyDetails,
						_Utils_ap(
							_List_fromArray(
								[
									A3(
									$author$project$Common$Base$iff,
									A4(
										$author$project$Shared$Info$rowWithTooltip,
										_List_Nil,
										$author$project$Translations$totalLockedSupply(t),
										$author$project$Translations$totalLockedSupplyTooltip(t),
										A2(
											$author$project$Shared$Text$formatCurrency2,
											m.bh.ac,
											A2($author$project$Shared$Market$Logic$inOrig, m.bh, m.f6.iL) * $author$project$VToken$Shared$Logic$price(m.f6))),
									$author$project$Shared$Html$nothing,
									hasLocked),
									A3($author$project$Common$Base$iff, $author$project$Shared$Html$newLine, $author$project$Shared$Html$nothing, hasLocked || hasProtected),
									A4(
									$author$project$Shared$Info$rowWithTooltip,
									_List_Nil,
									$author$project$Translations$totalDebt(t),
									$author$project$Translations$totalDebtTooltip(t),
									A2(
										$author$project$Shared$Text$formatCurrency2,
										m.bh.ac,
										A2(
											$author$project$Shared$Market$Logic$inOrig,
											m.bh,
											$author$project$Shared$Market$Logic$lendersDept(m.f6)))),
									A4(
									$author$project$Shared$Info$rowWithTooltip,
									_List_Nil,
									$author$project$Translations$Market$currentUtilization(t),
									$author$project$Translations$totalDebt(t) + (' / ' + A3($author$project$Common$Base$iff, $author$project$Translations$totalBorrowableSupply, $author$project$Translations$totalSupply, hasProtected)(t)),
									$author$project$Shared$Text$formatPercentOrDash(utilization))
								]),
							_Utils_ap(
								supplyAPYs,
								_List_fromArray(
									[
										A4(
										$author$project$Shared$Info$rowWithTooltip,
										_List_Nil,
										$author$project$Translations$Market$viresRewardsForSupplyAPR(t),
										$author$project$Translations$viresAPR(t),
										$author$project$Shared$Text$formatPercentOrDash(
											A3($author$project$Shared$Vires$Logic$nonLockedSupplyApr, vires, fixedRates, m))),
										A4(
										$author$project$Shared$Info$rowWithTooltip,
										_List_Nil,
										$author$project$Translations$Market$viresRewardsForLockedSupplyAPR(t),
										$author$project$Translations$viresAPR(t),
										$author$project$Shared$Text$formatPercentOrDash(
											A3($author$project$Shared$Vires$Logic$maxSupplyAprForecast, vires, fixedRates, m))),
										A5(
										$author$project$Shared$Waves$Address$View$info,
										mm,
										$author$project$Shared$Info$newSection,
										$author$project$Translations$Market$reserveAddress(t),
										$author$project$MarketDetail$Msg$Copy,
										m.jT),
										A3(
										$author$project$Common$Base$iff,
										$author$project$MarketDetail$View$wavesInfo(t),
										A7(
											$author$project$Shared$Asset$View$info,
											t,
											mm,
											_List_Nil,
											$author$project$Translations$Market$assetId(t),
											$author$project$MarketDetail$Msg$AddToMetaMask,
											$author$project$MarketDetail$Msg$Copy,
											m.bh.bP),
										$author$project$Shared$Asset$Model$isWaves(m.bh.bP)),
										A7(
										$author$project$Shared$Asset$View$info,
										t,
										mm,
										_List_Nil,
										$author$project$Translations$Market$vTokenId(t),
										$author$project$MarketDetail$Msg$AddToMetaMask,
										$author$project$MarketDetail$Msg$Copy,
										m.gO)
									]))))));
		}();
		var limits = function () {
			var row = function (isSelected) {
				return $author$project$Common$Table$row(
					A3($author$project$Common$Base$iff, $author$project$MarketDetail$View$c.gT, _List_Nil, isSelected));
			};
			var minRow = function () {
				var min = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$List$minimum(
						A2($elm$core$List$map, $elm$core$Tuple$first, m.iC)));
				return A2(
					row,
					_Utils_cmp(utilization, min) < 1,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Table$textCell,
							_List_Nil,
							'≤\u00A0' + $author$project$Shared$Text$formatPercent(min)),
							A2($author$project$Common$Table$textCell, _List_Nil, 'No Limit'),
							A2($author$project$Common$Table$textCell, _List_Nil, 'No Limit'),
							A2(
							$author$project$Common$Table$textCell,
							_List_Nil,
							$author$project$Translations$Market$enabled(t)),
							A2(
							$author$project$Common$Table$textCell,
							_List_Nil,
							$author$project$Translations$Market$enabled(t))
						]));
			}();
			var hundredRow = A2(
				row,
				utilization >= 1,
				_List_fromArray(
					[
						A2($author$project$Common$Table$textCell, _List_Nil, '100%'),
						A2(
						$author$project$Common$Table$textCell,
						_List_Nil,
						$author$project$Translations$Market$paused(t)),
						A2(
						$author$project$Common$Table$textCell,
						_List_Nil,
						$author$project$Translations$Market$paused(t)),
						A2(
						$author$project$Common$Table$textCell,
						_List_Nil,
						$author$project$Translations$Market$disabled(t)),
						A2(
						$author$project$Common$Table$textCell,
						_List_Nil,
						$author$project$Translations$Market$disabled(t))
					]));
			var head = A2(
				$elm$core$List$map,
				$author$project$Common$Table$header(_List_Nil),
				_List_fromArray(
					[
						$author$project$Translations$Market$utilization(t),
						$author$project$Translations$Home$Withdraw$withdraw(t),
						$author$project$Translations$Home$Borrow$borrow(t),
						'Replenish',
						'Redeem'
					]));
			var colDefs = F2(
				function (u, amount) {
					var lp = function (map) {
						return A2(
							$author$project$Common$Table$cellN,
							_List_Nil,
							$author$project$Shared$Html$texts(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Translations$Market$enabled(t),
									A2(
										$author$project$Common$Maybe$always,
										$author$project$Translations$Market$disabled(t),
										A3($author$project$Shared$Market$Logic$isPaused, m, u, map)))));
					};
					var limit = A2($author$project$Shared$Asset$Format$assetK, m.bh, amount);
					return _List_fromArray(
						[
							A2(
							$author$project$Common$Table$textCell,
							_List_Nil,
							'>\u00A0' + $author$project$Shared$Text$formatPercent(u)),
							A2($author$project$Common$Table$textCell, _List_Nil, limit),
							A2(
							$author$project$Common$Table$cellN,
							_List_Nil,
							$author$project$Shared$Html$texts(
								A2(
									$elm$core$Maybe$withDefault,
									limit,
									A2(
										$author$project$Common$Maybe$always,
										$author$project$Translations$Market$paused(t),
										A3(
											$author$project$Shared$Market$Logic$isPaused,
											m,
											u,
											function ($) {
												return $.dk;
											}))))),
							lp(
							function ($) {
								return $.$9;
							}),
							lp(
							function ($) {
								return $.jL;
							})
						]);
				});
			if ($elm$core$List$isEmpty(m.iC)) {
				return A3(
					$author$project$Common$Card$withTitle,
					$author$project$Translations$Market$adaptiveLimits(t),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-limits')
						]),
					$elm$html$Html$text('No Limits'));
			} else {
				var selected = function (rowU) {
					return (utilization !== 1) && A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$eq(rowU),
							$elm$core$List$maximum(
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$gt(utilization),
									A2($elm$core$List$map, $elm$core$Tuple$first, m.iC)))));
				};
				return A3(
					$author$project$Common$Card$withTable,
					$author$project$Translations$Market$adaptiveLimits(t),
					_List_Nil,
					A2(
						$author$project$Common$Table$view,
						$author$project$MarketDetail$View$c.iC,
						_List_fromArray(
							[
								$author$project$Common$Table$head(head),
								$author$project$Common$Table$body(
								A2(
									$elm$core$List$cons,
									hundredRow,
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (_v1) {
												var u_ = _v1.a;
												var a = _v1.b;
												return A2(
													row,
													selected(u_),
													A2(
														$elm$core$List$map,
														$elm$core$Basics$identity,
														A2(colDefs, u_, a)));
											},
											m.iC),
										_List_fromArray(
											[minRow]))))
							])));
			}
		}();
		var borrow = A2(
			$author$project$Shared$Info$view,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Shared$Info$textRow,
					_List_Nil,
					'Oracle Value',
					$author$project$Shared$Text$formatAsset(
						A2($author$project$Shared$Market$Logic$usdRate, rates, m.bh.bP))),
					A4(
					$author$project$Shared$Info$rowWithTooltip,
					$author$project$Shared$Info$newSection,
					$author$project$Translations$borrowAPR(t),
					$author$project$Translations$borrowAPRTooltip(t),
					$author$project$Shared$Text$formatPercentOrDash(
						$author$project$Shared$Market$Logic$borrowAPR(m))),
					A4(
					$author$project$Shared$Info$rowWithTooltip,
					$author$project$Shared$Info$newSection,
					$author$project$Translations$Market$collateralFactor(t),
					$author$project$Translations$Market$collateralFactorTooltip(t),
					$author$project$Shared$Text$formatPercent(m.ip.hm)),
					A4(
					$author$project$Shared$Info$rowWithTooltip,
					_List_Nil,
					$author$project$Translations$Market$liquidationThreshold(t),
					$author$project$Translations$Market$liquidationThresholdTooltip(t),
					$author$project$Shared$Text$formatPercent(m.ip.iF)),
					A4(
					$author$project$Shared$Info$rowWithTooltip,
					_List_Nil,
					$author$project$Translations$Market$liquidationPenalty(t),
					$author$project$Translations$Market$liquidationPenaltyTooltip(t),
					$author$project$Shared$Text$formatPercent(m.ip.iE)),
					A4(
					$author$project$Shared$Info$rowWithTooltip,
					_List_Nil,
					$author$project$Translations$Market$reserveFactor(t),
					$author$project$Translations$Market$reserveFactorTooltip(t),
					$author$project$Shared$Text$formatPercent(m.ip.jU))
				]));
		var _v0 = A3(
			$author$project$Common$Base$iff,
			_Utils_Tuple2(
				$author$project$Translations$apy(t),
				$author$project$Shared$Market$Logic$aprToApy),
			_Utils_Tuple2(
				$author$project$Translations$apr(t),
				$elm$core$Basics$identity),
			model.j9);
		var apX = _v0.a;
		var aprTransform = _v0.b;
		var interestRateModel = function () {
			var aprApySwitch = A2(
				$elm$html$Html$span,
				$author$project$MarketDetail$View$c.c5,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Market$compounding(t)),
						A2(
						$author$project$Shared$Html$textSpan,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick(
								$author$project$MarketDetail$Msg$ChangeShowApy(!model.j9)),
							$author$project$MarketDetail$View$c.fk),
						A3($author$project$Common$Base$iff, $author$project$Translations$Market$on, $author$project$Translations$Market$off, model.j9)(t)),
						$author$project$Common$Tooltip$infoWithLink('https://docs.vires.finance/knowledgebase/apy-vs-apr')
					]));
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$h5,
					_List_Nil,
					$author$project$Common$Markdown$view(
						A2($author$project$Translations$Market$utilizationVsMD, t, apX))),
					A3($author$project$MarketDetail$InterestRateModel$view, aprTransform, m, model.k3),
					aprApySwitch
				]);
		}();
		return {
			dj: _List_fromArray(
				[
					A2(
					$author$project$Shared$Layout$columnsMany,
					$author$project$MarketDetail$View$c.b1,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Card$view,
							$author$project$MarketDetail$View$c.b1,
							_List_fromArray(
								[
									$author$project$Common$Card$titleInside(
									$elm$core$List$singleton(
										A2($author$project$Shared$Market$View$iconWithText, t, m))),
									$author$project$Common$Card$content(
									$elm$core$List$singleton(mainDetails))
								])),
							A2(
							$author$project$Common$Card$view,
							$author$project$MarketDetail$View$c.eG,
							_List_fromArray(
								[
									$author$project$Common$Card$textTitle(
									$author$project$Translations$Market$interestRateModel(t)),
									$author$project$Common$Card$content(interestRateModel)
								]))
						])),
					A2(
					$author$project$Shared$Layout$section,
					_List_Nil,
					A2(
						$author$project$Shared$Layout$columnsMany,
						$author$project$MarketDetail$View$c.c$,
						_List_fromArray(
							[
								A3($author$project$Common$Card$withTitle, 'Borrow', _List_Nil, borrow),
								limits
							]))),
					A2(
					$author$project$Shared$Layout$section,
					$author$project$MarketDetail$View$c.dn,
					$author$project$MarketDetail$View$back(t))
				]),
			kB: A2($author$project$Translations$Market$market, t, m.bh.iP)
		};
	});
var $author$project$RaF$Msg$Close = {$: 0};
var $author$project$RaF$Msg$Copy = function (a) {
	return {$: 1, a: a};
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
	switch (i) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
	return _Utils_ap(
		$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)),
		_Utils_ap(
			$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)),
			_Utils_ap(
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)),
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
};
var $truqu$elm_base64$Base64$Encode$add = F2(
	function (_char, _v0) {
		var res = _v0.a;
		var count = _v0.b;
		var acc = _v0.c;
		var current = (acc << 8) | _char;
		if (count === 2) {
			return _Utils_Tuple3(
				_Utils_ap(
					res,
					$truqu$elm_base64$Base64$Encode$toBase64(current)),
				0,
				0);
		} else {
			return _Utils_Tuple3(res, count + 1, current);
		}
	});
var $truqu$elm_base64$Base64$Encode$chomp = F2(
	function (char_, acc) {
		var _char = $elm$core$Char$toCode(char_);
		return (_char < 128) ? A2($truqu$elm_base64$Base64$Encode$add, _char, acc) : ((_char < 2048) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2($truqu$elm_base64$Base64$Encode$add, 192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2($truqu$elm_base64$Base64$Encode$add, 224 | (_char >>> 12), acc))) : A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2(
					$truqu$elm_base64$Base64$Encode$add,
					128 | (63 & (_char >>> 12)),
					A2($truqu$elm_base64$Base64$Encode$add, 240 | (_char >>> 18), acc))))));
	});
var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3('', 0, 0);
var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
	var res = _v0.a;
	var cnt = _v0.b;
	var acc = _v0.c;
	switch (cnt) {
		case 1:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + '=='));
		case 2:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + '=')));
		default:
			return res;
	}
};
var $truqu$elm_base64$Base64$Encode$encode = function (input) {
	return $truqu$elm_base64$Base64$Encode$wrapUp(
		A3($elm$core$String$foldl, $truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
};
var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
var $author$project$RaF$Logic$encodeRef = function (_v0) {
	var a = _v0;
	return $truqu$elm_base64$Base64$encode(
		$elm$core$String$reverse(
			A2($elm$core$String$dropLeft, 2, a)));
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$RaF$Logic$link = function (a) {
	return A3(
		$elm$url$Url$Builder$crossOrigin,
		'https://vires.finance',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'ref',
				$author$project$RaF$Logic$encodeRef(a))
			]));
};
var $author$project$RaF$View$c = {
	jM: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('ref')
		]),
	cD: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text')
		])
};
var $author$project$RaF$View$p = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$text,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$p($author$project$RaF$View$c.cD)));
var $author$project$RaF$View$notes = A2(
	$elm$core$List$map,
	$author$project$RaF$View$p,
	_List_fromArray(
		['Vires.finance is kickstarting governance.', 'Participate in early-bird program by depositing assets and share your ref link to get extra x% of your referrals in governance token during launch event.', 'To make it fair, the referred accounts also receive extra x% of governance token on their deposits.']));
var $author$project$RaF$View$strong = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$text,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$strong(_List_Nil),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$html$Html$p($author$project$RaF$View$c.cD)))));
var $author$project$RaF$View$pleaseLogin = $author$project$RaF$View$strong('Please login to get your referral link');
var $author$project$RaF$View$view = F2(
	function (address, model) {
		var copyLink = function () {
			if (address.$ === 1) {
				return $author$project$RaF$View$pleaseLogin;
			} else {
				var a = address.a;
				return A2(
					$author$project$Common$Copy$viewWithCopy,
					$author$project$RaF$Msg$Copy,
					$author$project$RaF$Logic$link(a));
			}
		}();
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$RaF$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Common$Dialog$header,
							$author$project$RaF$Msg$Close,
							$author$project$Shared$Html$texts('Early-bird Referral Program')),
						_Utils_ap(
							$author$project$RaF$View$notes,
							_List_fromArray(
								[
									copyLink,
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(''),
											$author$project$Common$Attributes$blank
										]),
									$elm$core$List$singleton(
										$elm$html$Html$text('Click to read more')))
								]))))
				]));
	});
var $author$project$User$Connect$Msg$Close = {$: 4};
var $author$project$User$Connect$Msg$InstallWalletClicked = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$Connect$Msg$Login = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$Connect$Msg$TermsAcceptedChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$UserAgent$Chrome = 2;
var $author$project$Common$UserAgent$Edge = 4;
var $author$project$Common$UserAgent$Firefox = 1;
var $author$project$Common$UserAgent$Safari = 0;
var $author$project$Common$UserAgent$Unknown = 3;
var $author$project$Common$UserAgent$browser = function (_v0) {
	var agent = _v0;
	return A2($elm$core$String$contains, 'Edg', agent) ? 4 : (A2($elm$core$String$contains, 'Chrome', agent) ? 2 : (A2($elm$core$String$contains, 'Safari', agent) ? 0 : (A2($elm$core$String$contains, 'Firefox', agent) ? 1 : 3)));
};
var $author$project$User$Connect$View$c = {
	dE: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('connect')
		]),
	ao: $elm$html$Html$Attributes$class('keeper'),
	e$: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('methods')
		]),
	fI: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('reload')
		]),
	gh: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('terms')
		]),
	gH: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('waves-exchange-seed')
		])
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$envelopeOpen = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fas',
	'envelope-open',
	512,
	512,
	_List_fromArray(
		['M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z']));
var $author$project$Common$UserAgent$mobileAgents = _List_fromArray(
	['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone', 'playbook', 'silk']);
var $author$project$Common$UserAgent$handheld = function (_v0) {
	var agent = _v0;
	return A2(
		$elm$core$List$any,
		A2($Gizra$elm_compat_019$Basics018$flip, $elm$core$String$contains, agent),
		$author$project$Common$UserAgent$mobileAgents);
};
var $author$project$User$Ledger$body = 'M0 3C0 1.34315 1.34315 0 3 0H4.5V4.5H0V3ZM0 6.75V11.25H4.5V6.75H0ZM6.75 6.75V11.25H11.25H13.5H18V3C18 1.34315 16.6569 0 15 0H6.75V4.5V6.75ZM0 13.5H4.5V18H3C1.34315 18 0 16.6569 0 15V13.5ZM11.25 13.5H6.75V18H11.25V13.5ZM13.5 18V13.5H18V15C18 16.6569 16.6569 18 15 18H13.5Z';
var $author$project$User$Ledger$icon = A5(
	$lattyware$elm_fontawesome$FontAwesome$Icon$Icon,
	'fab',
	'early-bird',
	18,
	18,
	$elm$core$List$singleton($author$project$User$Ledger$body));
var $author$project$Translations$User$Connect$installKeeper = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'user.connect.installKeeper');
};
var $author$project$User$Connect$View$keeperInstallUrl = function (browser) {
	switch (browser) {
		case 1:
			return $elm$core$Maybe$Just('https://addons.mozilla.org/firefox/addon/waves-keeper/');
		case 2:
			return $elm$core$Maybe$Just('https://chrome.google.com/webstore/detail/waves-keeper/lpilbniiabackdjcionkobglmddfbcjo');
		case 4:
			return $elm$core$Maybe$Just('https://microsoftedge.microsoft.com/addons/detail/waves-keeper/hdpempkibblfcglmkkakkpnjmbnebaki');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Translations$User$Connect$kindReminder = F2(
	function (translations, wx) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'user.connect.kindReminder',
			_List_fromArray(
				[
					_Utils_Tuple2('wx', wx)
				]));
	});
var $author$project$User$Connect$View$metaMaskBrowserExtensionInstallUrl = function (browser) {
	switch (browser) {
		case 1:
			return $elm$core$Maybe$Just('https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/');
		case 2:
			return $elm$core$Maybe$Just('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn');
		case 4:
			return $elm$core$Maybe$Just('https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$User$Connect$View$metaMaskUrl = 'https://metamask.io/';
var $author$project$Translations$User$Connect$reloadAfterInstallationMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'user.connect.reloadAfterInstallationMD');
};
var $author$project$Common$CheckBox$standard = F2(
	function (msg, isChecked) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('checkbox'),
					$elm$html$Html$Attributes$checked(isChecked),
					$elm$html$Html$Events$onClick(
					msg(!isChecked))
				]),
			_List_Nil);
	});
var $author$project$Translations$User$Connect$termsMD = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'user.connect.termsMD');
};
var $author$project$User$Connect$View$w = {bE: 'Waves\u00A0Exchange', ao: 'Waves\u00A0Keeper', aX: 'MetaMask'};
var $author$project$User$Connect$View$view = F3(
	function (t, userAgent, model) {
		var terms = A2(
			$elm$html$Html$section,
			$author$project$User$Connect$View$c.gh,
			_List_fromArray(
				[
					A2($author$project$Common$CheckBox$standard, $author$project$User$Connect$Msg$TermsAcceptedChanged, model.ku),
					A2(
					$author$project$Common$Markdown$viewInDiv,
					_List_Nil,
					$author$project$Translations$User$Connect$termsMD(t))
				]));
		var requireChromiumOrFireFox = function (wallet) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[$author$project$Common$Button$c.aN, $author$project$Common$Attributes$disabled]),
				$author$project$Shared$Html$texts(wallet + ' requires Chromium browser or FireFox'));
		};
		var password = A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Common$Base$iff,
					$elm$html$Html$Events$onClick(
						$author$project$User$Connect$Msg$Login('passwordOnly')),
					$elm$html$Html$Attributes$class('disabled'),
					model.ku),
				$author$project$User$Connect$View$c.gH),
			$author$project$Shared$Html$texts('Use Waves.Exchange Seed'));
		var method = F4(
			function (method_, label, option, icon) {
				var clickOrDisabled = model.ku ? _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$User$Connect$Msg$Login(method_)),
						$author$project$Common$Button$c.aN
					]) : _List_fromArray(
					[$author$project$Common$Attributes$disabled, $author$project$Common$Button$c.aN]);
				return A2(
					$elm$html$Html$button,
					clickOrDisabled,
					_List_fromArray(
						[
							A2($author$project$Shared$Html$textSpan, _List_Nil, label),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(option),
									$author$project$Shared$Html$space,
									icon
								]))
						]));
			});
		var logo = function (class_) {
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('wallet'),
						$elm$html$Html$Attributes$class(class_)
					]),
				_List_Nil);
		};
		var loginWithMetaMask = A4(
			method,
			'metamask',
			$author$project$User$Connect$View$w.aX,
			'Seed',
			logo('metamask'));
		var loginWithKeeper = A4(
			method,
			'keeper',
			$author$project$User$Connect$View$w.ao,
			'Seed',
			logo('keeper'));
		var ledger = A4(
			method,
			'ledger',
			'Ledger',
			'Hardware',
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($author$project$User$Ledger$icon));
		var installWallet = F2(
			function (url, label) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$author$project$Common$Attributes$blank,
									$author$project$Common$Button$c.O,
									$author$project$Common$Button$c.aN,
									$elm$html$Html$Events$onClick(
									$author$project$User$Connect$Msg$InstallWalletClicked(url))
								]),
							$elm$core$List$singleton(
								A2($author$project$Shared$Html$textSpan, _List_Nil, label))),
							A2($elm$core$List$member, url, model.li) ? A2(
							$author$project$Common$Markdown$viewInDiv,
							$author$project$User$Connect$View$c.fI,
							$author$project$Translations$User$Connect$reloadAfterInstallationMD(t)) : $author$project$Shared$Html$nothing
						]));
			});
		var handheld = $author$project$Common$UserAgent$handheld(userAgent);
		var email = A4(
			method,
			'email',
			$author$project$User$Connect$View$w.bE,
			'Email',
			$lattyware$elm_fontawesome$FontAwesome$Icon$viewIcon($lattyware$elm_fontawesome$FontAwesome$Solid$envelopeOpen));
		var browser = $author$project$Common$UserAgent$browser(userAgent);
		var keeper = function () {
			if (handheld) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[$author$project$Common$Button$c.aN, $author$project$Common$Attributes$disabled]),
					$author$project$Shared$Html$texts($author$project$User$Connect$View$w.ao + ' requires desktop browser'));
			} else {
				if (model.iv) {
					return loginWithKeeper;
				} else {
					var _v1 = $author$project$User$Connect$View$keeperInstallUrl(browser);
					if (!_v1.$) {
						var url = _v1.a;
						return A2(
							installWallet,
							url,
							$author$project$Translations$User$Connect$installKeeper(t));
					} else {
						return requireChromiumOrFireFox($author$project$User$Connect$View$w.ao);
					}
				}
			}
		}();
		var metaMask = function () {
			if (model.iW) {
				return loginWithMetaMask;
			} else {
				if (handheld) {
					return A2(installWallet, $author$project$User$Connect$View$metaMaskUrl, 'Install ' + $author$project$User$Connect$View$w.aX);
				} else {
					var _v0 = $author$project$User$Connect$View$metaMaskBrowserExtensionInstallUrl(browser);
					if (!_v0.$) {
						var url = _v0.a;
						return A2(installWallet, url, 'Install ' + $author$project$User$Connect$View$w.aX);
					} else {
						return requireChromiumOrFireFox('MetaMask');
					}
				}
			}
		}();
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$User$Connect$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$User$Connect$View$c.dE,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Dialog$header,
							$author$project$User$Connect$Msg$Close,
							$author$project$Shared$Html$texts(
								$author$project$Translations$Wallet$connectWallet(t))),
							terms,
							A2(
							$elm$html$Html$section,
							$author$project$User$Connect$View$c.e$,
							_List_fromArray(
								[metaMask, ledger, keeper, email, password])),
							$author$project$Shared$KindReminder$text(
							A2($author$project$Translations$User$Connect$kindReminder, t, $author$project$User$Connect$View$w.bE))
						]))
				]));
	});
var $author$project$VToken$Msg$SetMyTokensOnly = function (a) {
	return {$: 6, a: a};
};
var $author$project$VToken$Msg$SpoilerTriggered = function (a) {
	return {$: 8, a: a};
};
var $author$project$Shared$Wallet$Logic$has = F2(
	function (assetId, walletData) {
		return ($author$project$Shared$Asset$Model$isWaves(assetId) && (!_Utils_eq(walletData.gF, $elm$core$Maybe$Nothing))) || A2($elm$core$Dict$member, assetId, walletData.g6);
	});
var $author$project$VToken$Logic$activeToken = F3(
	function (model, wallet, m) {
		return A2($author$project$Shared$Wallet$Logic$has, m.gO, wallet) || A2($elm$core$Dict$member, m.jT, model.kh);
	});
var $author$project$VToken$View$c = {
	gT: $elm$html$Html$Attributes$class('active'),
	bh: _List_fromArray(
		[$author$project$Shared$Asset$View$c.bh]),
	hl: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('collapse')
		]),
	aP: $elm$html$Html$Attributes$class('deprecated'),
	ip: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('info')
		]),
	b0: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('market')
		]),
	fk: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('on-off')
		]),
	ae: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('operations')
		]),
	cd: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('price')
		]),
	f3: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('staked')
		]),
	gd: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('switch')
		]),
	kL: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('total')
		]),
	cO: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('v-token-list')
		])
};
var $author$project$Translations$VTokens$exportable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.exportable');
};
var $author$project$Translations$VTokens$exportableTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.exportableTooltip');
};
var $author$project$VToken$Msg$SelectToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$VTokens$manage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.manage');
};
var $author$project$VToken$Vesting$Shared$View$tradeUrl = function (assetId) {
	return 'https://waves.exchange/trading/spot/' + (assetId + '_XTN');
};
var $author$project$VToken$Vesting$Shared$View$tradeBtn = function (m) {
	return A3(
		$author$project$Common$Button$textLink,
		_List_fromArray(
			[$author$project$Common$Attributes$blank, $author$project$Common$Button$c.ci]),
		$author$project$VToken$Vesting$Shared$View$tradeUrl(m),
		'Exchange');
};
var $author$project$VToken$Vesting$Shared$View$manageAndTrade = F3(
	function (t, msg, assetId) {
		return $author$project$Common$Button$group(
			_List_fromArray(
				[
					A3(
					$author$project$Common$Button$enabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cta')
						]),
					$author$project$Translations$VTokens$manage(t),
					msg),
					$author$project$VToken$Vesting$Shared$View$tradeBtn(assetId)
				]));
	});
var $author$project$VToken$View$manageAndTrade = F2(
	function (t, m) {
		return A3(
			$author$project$VToken$Vesting$Shared$View$manageAndTrade,
			t,
			$author$project$VToken$Msg$SelectToken(m),
			m.gO);
	});
var $author$project$VToken$Shared$View$marketAsset = F2(
	function (op, m) {
		return A3(
			$author$project$Shared$Info$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Shared$Asset$View$icon(m.bh.ac),
					$author$project$Shared$Html$space,
					$elm$html$Html$text(
					$author$project$VToken$Shared$Logic$name(m))
				]),
			op);
	});
var $author$project$Translations$VTokens$myOnly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.myOnly');
};
var $author$project$VToken$Shared$View$price = function (m) {
	return A2(
		$author$project$Shared$Text$formatCurrency,
		m.bh.ac,
		$author$project$VToken$Shared$Logic$price(m.f6));
};
var $author$project$Translations$VTokens$showTokens = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.showTokens');
};
var $author$project$Translations$VTokens$vTokenPrice = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.vTokenPrice');
};
var $author$project$Translations$VTokens$vTokenPriceTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.vTokenPriceTooltip');
};
var $author$project$Translations$VTokens$vTokensManagementConsole = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.vTokensManagementConsole');
};
var $author$project$VToken$Popup$Close = {$: 5};
var $author$project$VToken$Popup$FeeAssetChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$VToken$Popup$PausedAcknowledged = function (a) {
	return {$: 6, a: a};
};
var $author$project$VToken$Popup$TabChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$VToken$Popup$c = {
	gy: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('v-token')
		])
};
var $author$project$Shared$Market$Info$paused = F2(
	function (utilization, threshold) {
		return A3(
			$author$project$Shared$Info$rowN,
			_List_Nil,
			'Paused due to high market utilization',
			A3(
				$author$project$Shared$Delta$View$view,
				$author$project$Shared$Text$formatPercent,
				$author$project$Shared$Text$formatPercent,
				_List_fromArray(
					[utilization, threshold])));
	});
var $author$project$VToken$Shared$Logic$stakedDelta = F4(
	function (op, stakes, m, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, m.bh, model.gZ),
			A2($author$project$VToken$Shared$Logic$onContract, stakes, m));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var amount = _v0.a.a;
				var balance = _v0.b.a;
				return _List_fromArray(
					[
						balance,
						A2(op, balance, amount)
					]);
			} else {
				var amount = _v0.a.a;
				return _List_fromArray(
					[0, amount]);
			}
		} else {
			if (!_v0.b.$) {
				var balance = _v0.b.a;
				return _List_fromArray(
					[balance]);
			} else {
				return _List_fromArray(
					[0]);
			}
		}
	});
var $author$project$Common$CheckBox$standardWithTextLabel = F3(
	function (msg, label_, isChecked) {
		return A2(
			$author$project$Common$Form$fieldHorizontal,
			$author$project$Common$CheckBox$c.dv,
			_List_fromArray(
				[
					A2($author$project$Common$CheckBox$standard, msg, isChecked),
					$author$project$Common$Form$textLabel(label_)
				]));
	});
var $author$project$Common$Tabs$textTabs = F2(
	function (active, msg) {
		var tab_ = function (idx) {
			return A3($author$project$Common$Tabs$textTab, idx, active, msg);
		};
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$indexedMap(tab_),
			$author$project$Common$Tabs$view);
	});
var $author$project$Translations$VTokens$enterMintAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.enterMintAmount');
};
var $author$project$Translations$Validation$insufficientStakingBalance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'validation.insufficientStakingBalance');
};
var $author$project$Shared$Validate$stakingBalance = $author$project$Shared$Validate$balance($author$project$Translations$Validation$insufficientStakingBalance);
var $author$project$VToken$Mint$Validation$validate = F3(
	function (t, asset, staked) {
		return A2(
			$author$project$Common$Validate$and,
			A3($author$project$Shared$Validate$stakingBalance, t, asset, staked),
			A2(
				$author$project$Common$Validate$and,
				A2($author$project$Shared$Validate$precision, t, asset),
				$author$project$Shared$Validate$positiveAmount(t)));
	});
var $author$project$VToken$Shared$Msg$All = {$: 1};
var $author$project$VToken$Shared$Msg$AmountChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$VToken$Shared$Msg$Submit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$Html$classInvalid = function (maybeError) {
	if (maybeError.$ === 1) {
		return $elm$html$Html$Attributes$class('');
	} else {
		return $elm$html$Html$Attributes$class('invalid');
	}
};
var $author$project$VToken$Shared$View$amountInput = F6(
	function (t, msgAll, msgInput, err, placeholder_, model) {
		var number = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(model.gZ),
							$elm$html$Html$Events$onInput(msgInput),
							$elm$html$Html$Attributes$type_('number'),
							$elm$html$Html$Attributes$class('input'),
							$author$project$Shared$Html$classInvalid(err),
							$elm$html$Html$Attributes$placeholder(placeholder_)
						]),
					_List_Nil)
				]));
		var all = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(msgAll),
							$elm$html$Html$Attributes$class('button is-info')
						]),
					$elm$core$List$singleton(
						$elm$html$Html$text(
							$author$project$Translations$all(t))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field has-addons')
				]),
			_List_fromArray(
				[number, all]));
	});
var $author$project$VToken$Shared$View$view = F8(
	function (validate, label, placeholder, t, user, m, staked, model) {
		var err = A4(validate, t, m.bh, staked, model);
		var cta = A4(
			$author$project$Common$Dialog$ctaButton,
			A3($author$project$Shared$Dialog$ctaMsg, model, m.bh, $author$project$VToken$Shared$Msg$Submit),
			label(t),
			model,
			A4($author$project$Shared$Validate$loggedInAndNotLoading, t, user, model, err));
		var body = A6(
			$author$project$VToken$Shared$View$amountInput,
			t,
			$author$project$VToken$Shared$Msg$All,
			$author$project$VToken$Shared$Msg$AmountChanged,
			err,
			placeholder(t),
			model);
		return _Utils_Tuple2(body, cta);
	});
var $author$project$VToken$Mint$View$view = A3($author$project$VToken$Shared$View$view, $author$project$VToken$Mint$Validation$validate, $author$project$Translations$VTokens$mint, $author$project$Translations$VTokens$enterMintAmount);
var $author$project$Translations$VTokens$enterRedeemAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.enterRedeemAmount');
};
var $author$project$VToken$Redeem$Validation$validate = F3(
	function (t, asset, wallet) {
		return A2(
			$author$project$Common$Validate$and,
			A3($author$project$Shared$Validate$walletBalance, t, asset, wallet),
			A2(
				$author$project$Common$Validate$and,
				A2($author$project$Shared$Validate$precision, t, asset),
				$author$project$Shared$Validate$positiveAmount(t)));
	});
var $author$project$VToken$Redeem$View$view = A3($author$project$VToken$Shared$View$view, $author$project$VToken$Redeem$Validation$validate, $author$project$Translations$VTokens$redeem, $author$project$Translations$VTokens$enterRedeemAmount);
var $author$project$Translations$VTokens$enterReplenishAmount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'vTokens.enterReplenishAmount');
};
var $author$project$VToken$Replenish$Validation$validate = F3(
	function (t, asset, wallet) {
		return A2(
			$author$project$Common$Validate$and,
			A3($author$project$Shared$Validate$walletBalance, t, asset, wallet),
			A2(
				$author$project$Common$Validate$and,
				A2($author$project$Shared$Validate$precision, t, asset),
				$author$project$Shared$Validate$positiveAmount(t)));
	});
var $author$project$VToken$Replenish$View$view = A3($author$project$VToken$Shared$View$view, $author$project$VToken$Replenish$Validation$validate, $author$project$Translations$VTokens$replenish, $author$project$Translations$VTokens$enterReplenishAmount);
var $author$project$Shared$Delta$Logic$walletDelta = F4(
	function (op, wallets, asset, model) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Shared$Asset$Logic$tryToSatoshi, asset, model.gZ),
			A2($author$project$Shared$Wallet$Logic$wallet, asset.bP, wallets));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var amount = _v0.a.a;
				var balance = _v0.b.a;
				return _List_fromArray(
					[
						balance,
						A2(op, balance, amount)
					]);
			} else {
				var amount = _v0.a.a;
				var _v1 = _v0.b;
				return _List_fromArray(
					[
						0,
						A2(op, 0, amount)
					]);
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var balance = _v0.b.a;
				return _List_fromArray(
					[balance]);
			} else {
				return _List_fromArray(
					[0]);
			}
		}
	});
var $author$project$VToken$Popup$view = F7(
	function (t, user, assets, m, wallets, stakes, model) {
		var vTokenAsset = $author$project$VToken$Shared$Logic$toVToken(m);
		var walletInfoVToken = F2(
			function (op, model_) {
				return A3(
					$author$project$Shared$Delta$View$wallet,
					t,
					vTokenAsset,
					A4($author$project$Shared$Delta$Logic$walletDelta, op, wallets, vTokenAsset, model_));
			});
		var utilization = $author$project$Shared$Market$Logic$utilization(m.f6);
		var tabs = A3(
			$author$project$Common$Tabs$textTabs,
			model.kt,
			$author$project$VToken$Popup$TabChanged,
			_List_fromArray(
				[
					$author$project$Translations$VTokens$mint(t),
					$author$project$Translations$VTokens$replenish(t),
					$author$project$Translations$VTokens$redeem(t)
				]));
		var stakesInfo = F2(
			function (op, model_) {
				return A3(
					$author$project$Shared$Delta$View$funds,
					$author$project$Translations$VTokens$exportable(t),
					vTokenAsset,
					A4(
						$author$project$VToken$Shared$Logic$stakedDelta,
						op,
						stakes,
						_Utils_update(
							m,
							{bh: vTokenAsset}),
						model_));
			});
		var paused = A2(
			$elm$core$Basics$composeR,
			A2($author$project$Shared$Market$Logic$isPaused, m, utilization),
			$author$project$Shared$Html$try(
				$author$project$Shared$Market$Info$paused(utilization)));
		var inWallet = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Shared$Wallet$Logic$wallet, m.gO, wallets));
		var importAndRedeemPaused = m.iB ? false : A2(
			$elm$core$List$all,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			A2(
				$elm$core$List$map,
				A2($author$project$Shared$Market$Logic$isPaused, m, utilization),
				_List_fromArray(
					[
						function ($) {
						return $.$9;
					},
						function ($) {
						return $.jL;
					}
					])));
		var header = A2(
			$author$project$Common$Dialog$header,
			$author$project$VToken$Popup$Close,
			$author$project$Shared$Html$texts(
				$author$project$VToken$Shared$Logic$name(m)));
		var _v0 = function () {
			var _v2 = model.kt;
			switch (_v2) {
				case 0:
					var staked = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($author$project$VToken$Shared$Logic$onContract, stakes, m));
					var _v3 = A2(
						$author$project$Common$Tuple$map,
						$elm$html$Html$map($author$project$VToken$Popup$MintMsg),
						A5($author$project$VToken$Mint$View$view, t, user, m, staked, model.S));
					var content_ = _v3.a;
					var btn = _v3.b;
					var content = importAndRedeemPaused ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								content_,
								A3($author$project$Common$CheckBox$standardWithTextLabel, $author$project$VToken$Popup$PausedAcknowledged, 'I understand that importing and redeeming is paused', model.aw)
							])) : content_;
					return _Utils_Tuple2(
						_Utils_Tuple2(content, btn),
						_List_fromArray(
							[
								A2(walletInfoVToken, $elm$core$Basics$add, model.S),
								A2(stakesInfo, $elm$core$Basics$sub, model.S)
							]));
				case 1:
					return _Utils_Tuple2(
						A2(
							$author$project$Common$Tuple$map,
							$elm$html$Html$map($author$project$VToken$Popup$ReplenishMsg),
							A5($author$project$VToken$Replenish$View$view, t, user, m, inWallet, model.W)),
						_List_fromArray(
							[
								A2(walletInfoVToken, $elm$core$Basics$sub, model.W),
								A2(stakesInfo, $elm$core$Basics$add, model.W),
								paused(
								function ($) {
									return $.$9;
								})
							]));
				default:
					var newBalance = F2(
						function (oldAssetBalance, vTokensToRedeem) {
							return oldAssetBalance + $elm$core$Basics$round(
								vTokensToRedeem * $author$project$VToken$Shared$Logic$price(m.f6));
						});
					return _Utils_Tuple2(
						A2(
							$author$project$Common$Tuple$map,
							$elm$html$Html$map($author$project$VToken$Popup$RedeemMsg),
							A5($author$project$VToken$Redeem$View$view, t, user, m, inWallet, model.jL)),
						_List_fromArray(
							[
								A2(walletInfoVToken, $elm$core$Basics$sub, model.jL),
								A3(
								$author$project$Shared$Delta$View$funds,
								$author$project$Translations$walletBalance(t) + (', ' + m.bh.ac),
								m.bh,
								A4($author$project$Shared$Delta$Logic$walletDelta, newBalance, wallets, m.bh, model.jL)),
								paused(
								function ($) {
									return $.jL;
								})
							]));
			}
		}();
		var _v1 = _v0.a;
		var tabContent = _v1.a;
		var tabCta = _v1.b;
		var info_ = _v0.b;
		var info = A9(
			$author$project$Shared$Info$viewWithFee,
			t,
			_List_Nil,
			assets,
			user,
			m.bh,
			$author$project$Shared$Transaction$Logic$fee.fT,
			$author$project$VToken$Popup$FeeAssetChanged,
			model.h1,
			A2(
				$elm$core$List$cons,
				A4(
					$author$project$Shared$Info$rowWithTooltip,
					_List_Nil,
					$author$project$Translations$VTokens$vTokenPrice(t),
					$author$project$Translations$VTokens$vTokenPriceTooltip(t),
					$author$project$VToken$Shared$View$price(m)),
				info_));
		var footer = A2(
			$author$project$Shared$Dialog$footer,
			t,
			((!model.kt) && (importAndRedeemPaused && (!model.aw))) ? A2(
				$author$project$Common$Button$disabledCta,
				_List_Nil,
				$author$project$Translations$VTokens$mint(t)) : tabCta);
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$VToken$Popup$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$VToken$Popup$c.gy,
					_List_fromArray(
						[header, tabs, tabContent, info, footer]))
				]));
	});
var $author$project$VToken$Vesting$Msg$OpenManage = {$: 2};
var $author$project$VToken$Shared$View$asset = F2(
	function (op, a) {
		return A3(
			$author$project$Shared$Info$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Shared$Asset$View$icon(a.ac),
					$author$project$Shared$Html$space,
					$elm$html$Html$text(a.ac)
				]),
			op);
	});
var $author$project$VToken$Vesting$Manage$Msg$ChangeTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Vesting$Manage$Msg$Close = {$: 0};
var $author$project$VToken$Vesting$Manage$View$c_ = {
	dQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('withdraw-vested-dialog')
		]),
	gJ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('withdraw-vested')
		])
};
var $author$project$VToken$Vesting$Manage$Export$Msg$AgreedChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Msg$AmountChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Msg$Export = function (a) {
	return {$: 0, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Msg$FromChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$VToken$Vesting$Manage$Export$Msg$Max = function (a) {
	return {$: 4, a: a};
};
var $author$project$Translations$Home$Vesting$Export$iUnderstandImportLimit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$tf, translations, 'home.vesting.export.iUnderstandImportLimit');
};
var $author$project$VToken$Vesting$Shared$View$agreed = F2(
	function (t, msg) {
		return A2(
			$author$project$Common$CheckBox$standardWithTextLabel,
			msg,
			$author$project$Translations$Home$Vesting$Export$iUnderstandImportLimit(t));
	});
var $author$project$VToken$Vesting$Manage$Export$View$c = {
	gZ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('amount')
		]),
	dQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('export-vested')
		])
};
var $author$project$VToken$Shared$Validate$agreed = function (model) {
	return A3($author$project$Common$Base$iff, $elm$core$Maybe$Nothing, $author$project$Common$Validate$disabledCtaMessage, model.gX);
};
var $author$project$VToken$Vesting$Manage$Export$Validate$validate = F5(
	function (t, assets, user, regularVested, whaleVested) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, $author$project$Shared$Asset$Model$waves),
			A2(
				$author$project$Common$Validate$and,
				$author$project$VToken$Shared$Validate$agreed,
				A2(
					$author$project$Common$Validate$and,
					A3($author$project$Home$Vesting$Shared$Validate$exceed, t, regularVested, whaleVested),
					A2(
						$author$project$Common$Validate$and,
						A2($author$project$Shared$Validate$precision, t, $author$project$Home$Vesting$Shared$Data$vvxtnlp),
						$author$project$Shared$Validate$positiveAmount(t)))));
	});
var $author$project$VToken$Vesting$Manage$Export$View$view = F6(
	function (t, assets, user, regularVested, whaleVested, model) {
		var msg = A3($author$project$Shared$Dialog$ctaMsg, model, $author$project$Home$Vesting$Shared$Data$vvxtnlp, $author$project$VToken$Vesting$Manage$Export$Msg$Export);
		var info = function () {
			var exportAmount = A2(
				$elm$core$Basics$max,
				0,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($author$project$Shared$Asset$Logic$tryToSatoshi, $author$project$Home$Vesting$Shared$Data$vvxtnlp, model.gZ)));
			var inWallet = function () {
				var _v0 = A2($author$project$Shared$Wallet$Logic$wallet, $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP, user.lh);
				if (!_v0.$) {
					var now = _v0.a;
					return _List_fromArray(
						[now, now + exportAmount]);
				} else {
					return _List_fromArray(
						[0, exportAmount]);
				}
			}();
			var vested = F2(
				function (from, data) {
					var rest = $author$project$Home$Vesting$Shared$Logic$stillInVesting(data);
					return A3(
						$author$project$Shared$Delta$View$funds,
						from + ' vested',
						$author$project$Home$Vesting$Shared$Data$vvxtnlp,
						_Utils_eq(from, model.h8) ? _List_fromArray(
							[rest, rest - exportAmount]) : _List_fromArray(
							[rest]));
				});
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Shared$Html$try,
						vested($author$project$Home$Vesting$Shared$Data$whale),
						whaleVested),
						A2(
						$author$project$Shared$Html$try,
						vested($author$project$Home$Vesting$Shared$Data$regular),
						regularVested),
						A3($author$project$Shared$Delta$View$wallet, t, $author$project$Home$Vesting$Shared$Data$vvxtnlp, inWallet),
						A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$VToken$Vesting$Manage$Export$Msg$FeeAssetChanged, model.h1)
					]));
		}();
		var err = A6($author$project$VToken$Vesting$Manage$Export$Validate$validate, t, assets, user, regularVested, whaleVested, model);
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A4($author$project$Common$Dialog$ctaButton, msg, 'Export', model, err);
		var amount = function () {
			var number = A4(
				$author$project$Shared$Dialog$amount,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('Enter export amount')
					]),
				err,
				$author$project$VToken$Vesting$Manage$Export$Msg$AmountChanged,
				model);
			var maxBtn = A3(
				$author$project$Common$Button$enabled,
				_List_Nil,
				$author$project$Translations$Home$max(t),
				$author$project$VToken$Vesting$Manage$Export$Msg$Max(
					A3($author$project$Home$Vesting$Shared$Logic$maxVested, regularVested, whaleVested, model.h8)));
			var exportFrom = function () {
				var sources = $author$project$Common$List$just(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always($author$project$Home$Vesting$Shared$Data$regular),
							regularVested),
							A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always($author$project$Home$Vesting$Shared$Data$whale),
							whaleVested)
						]));
				return ($elm$core$List$length(sources) > 1) ? A2(
					$author$project$Common$Form$selectAddOn,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$VToken$Vesting$Manage$Export$Msg$FromChanged)
						]),
					A2(
						$elm$core$List$map,
						function (o) {
							return A2(
								$author$project$Common$Select$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(o)
									]),
								o);
						},
						sources)) : $author$project$Shared$Html$nothing;
			}();
			return A2(
				$author$project$Common$Form$fieldWithAddon,
				$author$project$VToken$Vesting$Manage$Export$View$c.gZ,
				_List_fromArray(
					[number, exportFrom, maxBtn]));
		}();
		var agreed = A3($author$project$VToken$Vesting$Shared$View$agreed, t, $author$project$VToken$Vesting$Manage$Export$Msg$AgreedChanged, model.gX);
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						amount,
						agreed,
						info,
						$author$project$Shared$KindReminder$text('You can export any amount of regular vesting and up to 750 000 from whale vesting')
					])),
			cta);
	});
var $author$project$VToken$Vesting$Manage$Import$Msg$AgreedChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$VToken$Vesting$Manage$Import$Msg$AmountChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$VToken$Vesting$Manage$Import$Msg$FeeAssetChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$VToken$Vesting$Manage$Import$Msg$Import = function (a) {
	return {$: 0, a: a};
};
var $author$project$VToken$Vesting$Manage$Import$Msg$Max = function (a) {
	return {$: 3, a: a};
};
var $author$project$VToken$Vesting$Manage$Import$View$c = {
	gZ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('amount')
		]),
	dQ: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('import-vested')
		])
};
var $author$project$VToken$Vesting$Manage$Import$Validate$validate = F4(
	function (t, assets, user, balance) {
		return A2(
			$author$project$Common$Validate$and,
			A5($author$project$Shared$Validate$enoughFee, t, $author$project$Shared$Transaction$Logic$fee.fT, assets, user, $author$project$Shared$Asset$Model$waves),
			A2(
				$author$project$Common$Validate$and,
				$author$project$VToken$Shared$Validate$agreed,
				A2(
					$author$project$Common$Validate$and,
					A3(
						$author$project$Shared$Validate$walletBalance,
						t,
						$author$project$Home$Vesting$Shared$Data$vvxtnlp,
						A2($elm$core$Maybe$withDefault, 0, balance)),
					A2(
						$author$project$Common$Validate$and,
						A2($author$project$Shared$Validate$precision, t, $author$project$Home$Vesting$Shared$Data$vvxtnlp),
						$author$project$Shared$Validate$positiveAmount(t)))));
	});
var $author$project$VToken$Vesting$Manage$Import$View$view = F6(
	function (t, assets, user, regularVested, whaleVested, model) {
		var msg = A3($author$project$Shared$Dialog$ctaMsg, model, $author$project$Home$Vesting$Shared$Data$vvxtnlp, $author$project$VToken$Vesting$Manage$Import$Msg$Import);
		var balance = A2($author$project$Shared$Wallet$Logic$wallet, $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP, user.lh);
		var err = A5($author$project$VToken$Vesting$Manage$Import$Validate$validate, t, assets, user, balance, model);
		var cta = $author$project$Shared$Model$isLoading(model) ? $author$project$Shared$Button$processingTransaction(t) : A4($author$project$Common$Dialog$ctaButton, msg, 'Import', model, err);
		var info = function () {
			var importAmount = A2(
				$elm$core$Basics$max,
				0,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($author$project$Shared$Asset$Logic$tryToSatoshi, $author$project$Home$Vesting$Shared$Data$vvxtnlp, model.gZ)));
			var inWallet = function () {
				if (!balance.$) {
					var now = balance.a;
					return _List_fromArray(
						[now, now - importAmount]);
				} else {
					return _List_fromArray(
						[0]);
				}
			}();
			var vested = F2(
				function (from, data) {
					var rest = $author$project$Home$Vesting$Shared$Logic$stillInVesting(data);
					return A3(
						$author$project$Shared$Delta$View$funds,
						from + ' vested',
						$author$project$Home$Vesting$Shared$Data$vvxtnlp,
						_Utils_eq(from, $author$project$Home$Vesting$Shared$Data$regular) ? _List_fromArray(
							[rest, rest + importAmount]) : _List_fromArray(
							[rest]));
				});
			return A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Shared$Html$try,
						vested($author$project$Home$Vesting$Shared$Data$whale),
						whaleVested),
						A2(
						$author$project$Shared$Html$try,
						vested($author$project$Home$Vesting$Shared$Data$regular),
						regularVested),
						A3($author$project$Shared$Delta$View$wallet, t, $author$project$Home$Vesting$Shared$Data$vvxtnlp, inWallet),
						A5($author$project$Shared$Info$feeRowSC, t, assets, user, $author$project$VToken$Vesting$Manage$Import$Msg$FeeAssetChanged, model.h1)
					]));
		}();
		var amount = function () {
			var number = A4(
				$author$project$Shared$Dialog$amount,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('Enter import amount')
					]),
				err,
				$author$project$VToken$Vesting$Manage$Import$Msg$AmountChanged,
				model);
			var maxBtn = A2(
				$author$project$Shared$Html$try,
				A2(
					$elm$core$Basics$composeR,
					$author$project$VToken$Vesting$Manage$Import$Msg$Max,
					A2(
						$author$project$Common$Button$enabled,
						_List_Nil,
						$author$project$Translations$Home$max(t))),
				balance);
			return A2(
				$author$project$Common$Form$fieldWithAddon,
				$author$project$VToken$Vesting$Manage$Import$View$c.gZ,
				_List_fromArray(
					[number, maxBtn]));
		}();
		var agreed = A3($author$project$VToken$Vesting$Shared$View$agreed, t, $author$project$VToken$Vesting$Manage$Import$Msg$AgreedChanged, model.gX);
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						amount,
						agreed,
						info,
						$author$project$Shared$KindReminder$text('You can import any amount of lp tokens into regular vesting')
					])),
			cta);
	});
var $author$project$VToken$Vesting$Manage$View$view = F6(
	function (t, assets, user, regular, whale, model) {
		var tabs = A3(
			$author$project$Common$Tabs$textTabs,
			model.kt,
			$author$project$VToken$Vesting$Manage$Msg$ChangeTab,
			_List_fromArray(
				['Export', 'Import']));
		var _v0 = function () {
			var _v1 = model.kt;
			if (!_v1) {
				return A2(
					$author$project$Common$Tuple$map,
					$elm$html$Html$map($author$project$VToken$Vesting$Manage$Msg$Export),
					A6($author$project$VToken$Vesting$Manage$Export$View$view, t, assets, user, regular, whale, model.hY));
			} else {
				return A2(
					$author$project$Common$Tuple$map,
					$elm$html$Html$map($author$project$VToken$Vesting$Manage$Msg$Import),
					A6($author$project$VToken$Vesting$Manage$Import$View$view, t, assets, user, regular, whale, model.$9));
			}
		}();
		var content = _v0.a;
		var btn = _v0.b;
		return $author$project$Common$Dialog$view(
			_List_fromArray(
				[
					$author$project$Common$Dialog$background($author$project$VToken$Vesting$Manage$Msg$Close),
					A2(
					$author$project$Common$Dialog$body,
					$author$project$VToken$Vesting$Manage$View$c_.dQ,
					_List_fromArray(
						[
							A2($author$project$Common$Dialog$textHeader, $author$project$VToken$Vesting$Manage$Msg$Close, $author$project$Home$Vesting$Shared$Data$vvxtnlp.ac),
							tabs,
							A2(
							$author$project$Common$Tabs$content,
							$author$project$VToken$Vesting$Manage$View$c_.gJ,
							$elm$core$List$singleton(content)),
							A2(
							$author$project$Shared$Dialog$footer,
							t,
							A3(
								$author$project$Common$Base$iff,
								btn,
								$author$project$Shared$Wallet$View$connect(t),
								$author$project$User$Logic$isLoggedIn(user)))
						]))
				]));
	});
var $author$project$VToken$Vesting$View$view = F5(
	function (t, screen, assets, user, model) {
		var format = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$author$project$Shared$Asset$Format$assetOnlyNums($author$project$Home$Vesting$Shared$Data$vvxtnlp)),
			$elm$core$Maybe$withDefault('—'));
		var row = function () {
			var inWallet = format(
				A2($author$project$Shared$Wallet$Logic$wallet, $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP, user.lh));
			var exportable = format(
				A2(
					$elm$core$Maybe$map,
					$author$project$Home$Vesting$Shared$Logic$stillInVesting,
					$author$project$Home$Vesting$Shared$Logic$totalVested(model)));
			return $author$project$Common$Screen$isMobile(screen) ? A2(
				$author$project$Shared$Info$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$VToken$Shared$View$asset,
						_List_fromArray(
							[
								A3($author$project$VToken$Vesting$Shared$View$manageAndTrade, t, $author$project$VToken$Vesting$Msg$OpenManage, $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP)
							]),
						$author$project$Home$Vesting$Shared$Data$vvxtnlp),
						A3(
						$author$project$Shared$Info$textRow,
						_List_Nil,
						$author$project$Translations$VTokens$exportable(t),
						exportable),
						A3(
						$author$project$Shared$Info$textRow,
						_List_Nil,
						$author$project$Translations$walletBalance(t),
						inWallet)
					])) : A2(
				$author$project$Common$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Shared$Asset$View$cell,
						_List_Nil,
						$author$project$Shared$Asset$View$iconWithText($author$project$Home$Vesting$Shared$Data$vvxtnlp)),
						$author$project$Common$Table$dash(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('price')
							])),
						A2(
						$author$project$Common$Table$cell,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('staked')
							]),
						$elm$html$Html$text(exportable)),
						A2(
						$author$project$Common$Table$cell,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('staked')
							]),
						$elm$html$Html$text(inWallet)),
						A2(
						$author$project$Common$Table$cell,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('operations')
							]),
						A3($author$project$VToken$Vesting$Shared$View$manageAndTrade, t, $author$project$VToken$Vesting$Msg$OpenManage, $author$project$Home$Vesting$Shared$Data$vvxtnlp.bP))
					]));
		}();
		var dialog = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				A5($author$project$VToken$Vesting$Manage$View$view, t, assets, user, model.jN, model.lk),
				$elm$html$Html$map($author$project$VToken$Vesting$Msg$Manage)),
			model.iR);
		return _Utils_Tuple2(row, dialog);
	});
var $author$project$VToken$View$view = F6(
	function (t, screen, user, assets, markets, model) {
		return {
			dj: function () {
				var mapMarkets = function (map) {
					return A2(
						$elm$core$List$map,
						map,
						A2(
							$elm$core$List$filter,
							function (m) {
								return (!model.kc) || A3($author$project$VToken$Logic$activeToken, model, user.lh, m);
							},
							markets));
				};
				var filter = A2(
					$elm$html$Html$span,
					$author$project$VToken$View$c.gd,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$VTokens$showTokens(t)),
							A2(
							$author$project$Shared$Html$textSpan,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onClick(
									$author$project$VToken$Msg$SetMyTokensOnly(!model.kc)),
								$author$project$VToken$View$c.fk),
							A3($author$project$Common$Base$iff, $author$project$Translations$VTokens$myOnly, $author$project$Translations$all, model.kc)(t))
						]));
				var faq = A2(
					$author$project$Shared$Html$try,
					A2($author$project$Shared$FAQ$View$view, model.kf, $author$project$VToken$Msg$SpoilerTriggered),
					model.h$);
				var _v0 = A5($author$project$VToken$Vesting$View$view, t, screen, assets, user, model.k6);
				var vesting = _v0.a;
				var vestingDialog = _v0.b;
				var desktopTable = function (_v10) {
					var row = function (m) {
						var vTokenAsset = $author$project$VToken$Shared$Logic$toVToken(m);
						var price = A2(
							$author$project$Common$Table$cellN,
							$author$project$VToken$View$c.cd,
							$author$project$Shared$Html$texts(
								$author$project$VToken$Shared$View$price(m)));
						var canBeDeprecatedClass = m.iB ? $author$project$VToken$View$c.aP : $elm$html$Html$Attributes$class('');
						var asset = A2(
							$author$project$Shared$Asset$View$cell,
							_List_Nil,
							A2(
								$author$project$Shared$Asset$View$iconWithTextName,
								m.bh,
								$author$project$VToken$Shared$Logic$name(m)));
						var _v7 = _Utils_Tuple2(
							A2($author$project$Shared$Wallet$Logic$wallet, m.gO, user.lh),
							A2($author$project$VToken$Shared$Logic$onContract, model.kh, m));
						if ((_v7.a.$ === 1) && (_v7.b.$ === 1)) {
							var _v8 = _v7.a;
							var _v9 = _v7.b;
							return A2(
								$author$project$Common$Table$row,
								A2($elm$core$List$cons, canBeDeprecatedClass, $author$project$VToken$View$c.b0),
								_List_fromArray(
									[
										asset,
										price,
										A2($author$project$Common$Table$textCell, $author$project$VToken$View$c.f3, '–'),
										A2($author$project$Common$Table$textCell, $author$project$VToken$View$c.f3, '–'),
										A2(
										$author$project$Common$Table$cell,
										$author$project$VToken$View$c.ae,
										$author$project$Common$Button$group(
											$elm$core$List$singleton(
												$author$project$VToken$Vesting$Shared$View$tradeBtn(m.gO))))
									]));
						} else {
							var w = _v7.a;
							var s = _v7.b;
							var wallet = A2($elm$core$Maybe$withDefault, 0, w);
							var walletBalance = A2(
								$author$project$Common$Table$cell,
								$author$project$VToken$View$c.f3,
								$elm$html$Html$text(
									$author$project$Shared$Text$formatAsset(
										A2($author$project$Shared$Market$Logic$inOrig, vTokenAsset, wallet))));
							var staked = A2($elm$core$Maybe$withDefault, 0, s);
							var exportable = A2(
								$author$project$Common$Table$cell,
								$author$project$VToken$View$c.kL,
								$elm$html$Html$text(
									$author$project$Shared$Text$formatAsset(
										A2($author$project$Shared$Market$Logic$inOrig, vTokenAsset, staked))));
							var cols = _List_fromArray(
								[
									asset,
									price,
									exportable,
									walletBalance,
									A2(
									$author$project$Common$Table$cell,
									$author$project$VToken$View$c.ae,
									A2($author$project$VToken$View$manageAndTrade, t, m))
								]);
							return A2(
								$author$project$Common$Table$row,
								A2(
									$elm$core$List$cons,
									$author$project$VToken$View$c.gT,
									A2($elm$core$List$cons, canBeDeprecatedClass, $author$project$VToken$View$c.b0)),
								cols);
						}
					};
					var head = $author$project$Common$Table$head(
						_List_fromArray(
							[
								A2(
								$author$project$Common$Table$header,
								$author$project$VToken$View$c.bh,
								$author$project$Translations$asset(t)),
								A3(
								$author$project$Common$Table$headerWithTooltip,
								$author$project$Translations$VTokens$vTokenPriceTooltip(t),
								$author$project$VToken$View$c.cd,
								$author$project$Translations$VTokens$vTokenPrice(t)),
								A3(
								$author$project$Common$Table$headerWithTooltip,
								$author$project$Translations$VTokens$exportableTooltip(t),
								$author$project$VToken$View$c.kL,
								$author$project$Translations$VTokens$exportable(t)),
								A3(
								$author$project$Common$Table$headerWithTooltip,
								$author$project$Translations$walletBalanceTooltip(t),
								$author$project$VToken$View$c.f3,
								$author$project$Translations$walletBalance(t)),
								A2($author$project$Common$Table$header, _List_Nil, '')
							]));
					return A2(
						$author$project$Common$Table$view,
						$author$project$VToken$View$c.cO,
						_List_fromArray(
							[
								head,
								$author$project$Common$Table$body(
								_Utils_ap(
									mapMarkets(row),
									_List_fromArray(
										[
											A2($elm$html$Html$map, $author$project$VToken$Msg$Vesting, vesting)
										])))
							]));
				};
				var mobileView = function (_v6) {
					var market = function (m) {
						var vTokenAsset = $author$project$VToken$Shared$Logic$toVToken(m);
						var price = $author$project$VToken$Shared$View$price(m);
						var a = m.bh;
						var _v3 = _Utils_Tuple2(
							A2($author$project$Shared$Wallet$Logic$wallet, m.gO, user.lh),
							A2($author$project$VToken$Shared$Logic$onContract, model.kh, m));
						if ((_v3.a.$ === 1) && (_v3.b.$ === 1)) {
							var _v4 = _v3.a;
							var _v5 = _v3.b;
							return _List_fromArray(
								[
									A2(
									$author$project$VToken$Shared$View$marketAsset,
									_List_fromArray(
										[
											$author$project$VToken$Vesting$Shared$View$tradeBtn(m.gO)
										]),
									m),
									A4(
									$author$project$Shared$Info$rowWithTooltip,
									_List_Nil,
									$author$project$Translations$VTokens$vTokenPrice(t),
									$author$project$Translations$VTokens$vTokenPriceTooltip(t),
									price)
								]);
						} else {
							var w = _v3.a;
							var s = _v3.b;
							return _List_fromArray(
								[
									A2(
									$author$project$VToken$Shared$View$marketAsset,
									_List_fromArray(
										[
											A2($author$project$VToken$View$manageAndTrade, t, m)
										]),
									m),
									A4(
									$author$project$Shared$Info$rowWithTooltip,
									_List_Nil,
									$author$project$Translations$VTokens$vTokenPrice(t),
									$author$project$Translations$VTokens$vTokenPriceTooltip(t),
									price),
									A2(
									$author$project$Shared$Html$try,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Shared$Asset$Format$assetOnlyNums(vTokenAsset),
										A2(
											$author$project$Shared$Info$textRow,
											_List_Nil,
											$author$project$Translations$VTokens$exportable(t))),
									s),
									A2(
									$author$project$Shared$Html$try,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Shared$Asset$Format$assetOnlyNums(vTokenAsset),
										A2(
											$author$project$Shared$Info$textRow,
											_List_Nil,
											$author$project$Translations$walletBalance(t))),
									w)
								]);
						}
					};
					return A2(
						$author$project$Shared$Layout$sectionN,
						$author$project$VToken$View$c.cO,
						_Utils_ap(
							mapMarkets(
								A2(
									$elm$core$Basics$composeR,
									market,
									$author$project$Shared$Info$view(_List_Nil))),
							_List_fromArray(
								[
									A2($elm$html$Html$map, $author$project$VToken$Msg$Vesting, vesting)
								])));
				};
				var list = $author$project$Common$Screen$isMobile(screen) ? mobileView(0) : desktopTable(0);
				var dialog = function () {
					var _v1 = _Utils_Tuple2(model.gT, vestingDialog);
					if (!_v1.a.$) {
						var _v2 = _v1.a.a;
						var m = _v2.a;
						var popup = _v2.b;
						return A2(
							$elm$html$Html$map,
							$author$project$VToken$Msg$PopupMsg,
							A7($author$project$VToken$Popup$view, t, user, assets, m, user.lh, model.kh, popup));
					} else {
						if (!_v1.b.$) {
							var v = _v1.b.a;
							return A2($elm$html$Html$map, $author$project$VToken$Msg$Vesting, v);
						} else {
							return $author$project$Shared$Html$nothing;
						}
					}
				}();
				return _List_fromArray(
					[
						A2(
						$author$project$Shared$Layout$sectionN,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v-tokens')
							]),
						_List_fromArray(
							[
								$author$project$Shared$Layout$textHeader(
								$author$project$Translations$VTokens$vTokensManagementConsole(t)),
								filter,
								list
							])),
						dialog,
						A2(
						$author$project$Shared$Layout$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v-tokens')
							]),
						faq)
					]);
			}(),
			kB: $author$project$Translations$VTokens$vTokensManagementConsole(t)
		};
	});
var $author$project$View$view = function (model) {
	var popup = function (p) {
		switch (p.$) {
			case 1:
				var m = p.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$RaF,
					A2($author$project$RaF$View$view, model.kZ.gV, m));
			case 2:
				var m = p.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$Gateway,
					$author$project$Gateway$View$view(model.kT));
			default:
				var m = p.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$Connect,
					A3($author$project$User$Connect$View$view, model.kT, model.k_, m));
		}
	};
	var fixedRates = A3($author$project$Shared$NewRate$toNewRates, model.h3.k8, model.g6, model.i9);
	var page = function () {
		var _v1 = model.jo;
		switch (_v1.$) {
			case 0:
				var h = _v1.a;
				return A4(
					$author$project$Layout$View$view,
					model.kT,
					model,
					$author$project$Msg$Home,
					$author$project$Home$View$view(model.kT)(model.hn.ln)(model.kx)(model.ii)(model.$8)(model.j3)(model.h3.k8)(model.g6)(model.hn.gQ)(model.kZ)(model.hn.gR)(model.jI)(model.i9)(model.eY)(model.ic)(h));
			case 1:
				var reserveId = _v1.a;
				var m = _v1.b;
				var _v2 = A3(
					$author$project$Common$List$getBy,
					function ($) {
						return $.jT;
					},
					reserveId,
					model.eY);
				if (!_v2.$) {
					var market = _v2.a;
					return A4(
						$author$project$Layout$View$view,
						model.kT,
						model,
						$author$project$Msg$Market,
						A7(
							$author$project$MarketDetail$View$view,
							model.kT,
							model.h3.k8,
							model.jI,
							fixedRates(model.jI),
							market,
							model.kZ.iN,
							m));
				} else {
					return $author$project$Loading$view(model.iG);
				}
			case 2:
				var m = _v1.a;
				return A4(
					$author$project$Layout$View$view,
					model.kT,
					model,
					$author$project$Msg$VToken,
					A6($author$project$VToken$View$view, model.kT, model.j3, model.kZ, model.g6, model.eY, m));
			case 4:
				return {dj: _List_Nil, kB: 'Empty'};
			default:
				var m = _v1.a;
				return A4(
					$author$project$Layout$View$view,
					model.kT,
					model,
					$author$project$Msg$Governance,
					$author$project$Governance$View$view(model.kT)(
						_Utils_Tuple2(model.kx, model.ky))(model.h3.k8)(model.g6)(model.ii)(model.$8)(model.eY)(model.ic)(
						fixedRates(model.jI))(model.kZ)(model.cZ)(m));
		}
	}();
	var _v0 = model.jv;
	if (_v0.$ === 1) {
		return page;
	} else {
		var p = _v0.a;
		return _Utils_update(
			page,
			{
				dj: A2(
					$elm$core$List$cons,
					popup(p),
					page.dj)
			});
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		ir: F3(
			function (flags, url, key) {
				return A2(
					$author$project$Navigation$navigate,
					$author$project$Route$route(url),
					A2($author$project$Init$init, flags, key));
			}),
		jh: A2($elm$core$Basics$composeR, $author$project$Route$route, $author$project$Msg$RouteChanged),
		ji: $author$project$Msg$LinkClicked,
		kq: $author$project$Sub$subscriptions,
		kX: $author$project$Update$update,
		k7: $author$project$View$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (width) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (viresAsset) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (userAgent) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (translations) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (sha) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (pathmappings) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (nodeApi) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (lock) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (language) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (hidden) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (ducksClosed) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (api) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (address) {
																											return $elm$json$Json$Decode$succeed(
																												{gV: address, g_: api, hM: ducksClosed, ig: hidden, iz: language, iI: lock, jb: nodeApi, jq: pathmappings, j8: sha, kT: translations, k_: userAgent, k8: viresAsset, ll: width});
																										},
																										A2(
																											$elm$json$Json$Decode$field,
																											'address',
																											$elm$json$Json$Decode$oneOf(
																												_List_fromArray(
																													[
																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																													]))));
																								},
																								A2($elm$json$Json$Decode$field, 'api', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'ducksClosed', $elm$json$Json$Decode$bool));
																				},
																				A2($elm$json$Json$Decode$field, 'hidden', $elm$json$Json$Decode$bool));
																		},
																		A2($elm$json$Json$Decode$field, 'language', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'lock', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'nodeApi', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'pathmappings', $elm$json$Json$Decode$value));
										},
										A2($elm$json$Json$Decode$field, 'sha', $elm$json$Json$Decode$string));
								},
								A2(
									$elm$json$Json$Decode$field,
									'translations',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$value)));
						},
						A2($elm$json$Json$Decode$field, 'userAgent', $elm$json$Json$Decode$string));
				},
				A2(
					$elm$json$Json$Decode$field,
					'viresAsset',
					A2(
						$elm$json$Json$Decode$andThen,
						function (stakingAPY) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (reserveAddress) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (name) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (longName) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (id) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (decimals) {
																	return $elm$json$Json$Decode$succeed(
																		{hC: decimals, bP: id, iP: longName, ac: name, jT: reserveAddress, kj: stakingAPY});
																},
																A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int));
														},
														A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'reserveAddress', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'stakingAPY', $elm$json$Json$Decode$float))));
		},
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)))(0)}});}(this));